<template>
  <div class="gallery-wrapper">
    <div class="container">
      <ResumeEditor
      :show="showEditor"
      :resumeData="editorResumeData"
      @close="handleEditorClose"
      @save-complete="handleSaveComplete"
      @error="handleEditorError"
    />

    <!-- NEW: ResumeReformatter -->
    <ResumeReformatter
      :show="showReformatter"
      :candidateId="reformatterCandidateId"
      :idType="reformatteridType"
      @close="handleReformatterClose"
      @generated="handleReformatGenerated"
      @export-complete="handleReformatExportComplete"
      @error="handleReformatterError"
    />
    <!-- Logo Editor Modal -->
    <div v-if="showLogoEditor" class="modal-overlay" @click.self="closeLogoEditor">
      <div class="modal-content">
        <button class="modal-close" @click="closeLogoEditor">×</button>
        <ResumeLogoEditor
          :candidate-id="logoEditorCandidateId"
          :idType="logoEditoridType"
          :pdf-url="logoEditorPdfUrl"
          @close="closeLogoEditor"
          @export-success="onLogoExportSuccess"
        />
      </div>
    </div>
   
    
      <!-- Gallery header with actions -->
      <div v-if="hasResults && !isLoading" class="gallery-header">
        <div class="gallery-title-section">
          <h2 class="gallery-title">
              
        
          </h2>
          
          <!-- REPLACE the sort-badge div with this sort dropdown -->
          
        </div>
        
        <div class="gallery-actions">
          <!-- Tag filter - LEFT -->
          <div v-if="allAvailableTags.length > 0" class="tag-filter-wrapper">
            <select v-model="selectedTagFilter" class="tag-filter-select">
              <option value="">All Tags</option>
              <option v-for="tag in allAvailableTags" :key="tag" :value="tag">
                {{ tag }} ({{ getCandidatesWithTag(tag).length }})
              </option>
            </select>
            <button 
              v-if="selectedTagFilter" 
              @click="selectedTagFilter = ''" 
              class="clear-tag-btn"
              title="Clear filter"
            >
              <i class="fas fa-times"></i>
            </button>
          </div>
          
          <!-- Spacer -->
          <div class="actions-spacer"></div>
          
          <!-- View toggle - RIGHT -->
          <button class="action-btn" @click="toggleView">
            <i :class="`fas fa-${viewMode === 'grid' ? 'list' : 'th'}`"></i>
            {{ viewMode === 'grid' ? 'List' : 'Grid' }}
          </button>

          <button class="action-btn" @click="toggleSelectMode" :class="{ 'select-active': selectMode }">
            <i :class="selectMode ? 'fas fa-check-square' : 'far fa-square'"></i>
            {{ selectMode ? `${selectedCandidates.size} sél.` : 'Sélect.' }}
          </button>
          <!-- Sort dropdown - RIGHT -->
          <div v-if="hasResults" class="sort-dropdown-wrapper" ref="sortDropdown">
            <button 
              @click.stop="toggleSortDropdown" 
              class="sort-dropdown-trigger"
              :class="{ active: sortDropdownOpen }"
            >
              <i :class="currentSortIcon"></i>
              <span>{{ currentSortLabel }}</span>
              <i class="fas fa-chevron-down chevron" :class="{ rotated: sortDropdownOpen }"></i>
            </button>
            
            <transition name="dropdown-fade">
              <div v-if="sortDropdownOpen" class="sort-dropdown-menu">
                <button
                  v-for="option in sortOptions"
                  :key="option.value"
                  @click.stop="selectSort(option.value)"
                  class="sort-option"
                  :class="{ selected: selectedSort === option.value }"
                >
                  <i :class="option.icon"></i>
                  <span>{{ option.label }}</span>
                  <i v-if="selectedSort === option.value" class="fas fa-check check-icon"></i>
                </button>
              </div>
            </transition>
          </div>
        </div>
      </div>
      
      <!-- Loading state -->
      <div v-if="isLoading" class="loading-state">
        <div class="loading-animation">
          <div class="loading-dot"></div>
          <div class="loading-dot"></div>
          <div class="loading-dot"></div>
        </div>
        <p>Finding the best candidates...</p>
      </div>

      <!-- Empty state - only show when not loading and no results -->
      <div v-else-if="!hasResults" class="empty-state">
        <i class="fas fa-search"></i>
        <h3>Start your search</h3>
        <p>Use the search bar above to find candidates</p>
      </div>

      <!-- Results grid/list -->
      <div v-else :class="`results-${viewMode}`">

        <div
          v-for="(result, index) in displayResults"
          :key="result.id || index"
          class="result-card"
          :class="{ 'recommended': isRecommendedCandidate(result)}"
        >
        <!-- NEW: Transition overlay -->
        <div v-if="isProjectTransitioning" class="project-transition-overlay">
          <i class="fas fa-spinner fa-spin"></i>
          <span>Switching projects...</span>
        </div>
        <div 
        v-if="hasCrossProjectConflict(getCandidateId(result))" 
        class="cross-project-warning"
      >
        <i class="fas fa-exclamation-triangle"></i>
        <span>
          Being screened for: {{ getCandidateConflictInfo(getCandidateId(result))?.project_name }}
        </span>
      </div>

        
        <!-- {{ debugCandidate(result) }} -->
          <!-- AI Badge for recommended candidates -->
          <div v-if="isRecommendedCandidate(result)" class="ai-recommendation">
            <i class="fas fa-star"></i>
            AI Recommended
          </div>

          <!-- Card header -->
            <!-- Card header -->
            <div class="card-header-content">
              <div v-if="selectMode" class="select-checkbox" @click.stop="toggleSelect(getCandidateId(result))">
                <i :class="selectedCandidates.has(getCandidateId(result)) ? 'fas fa-check-square' : 'far fa-square'"></i>
              </div>
              <!-- ROW 1: badges left, buttons right -->
              <div class="card-top-row">
                <div class="card-top-left">
                  <div v-if="hasBeenContacted(result)" class="contact-initiator">
                    <i class="fas fa-user-check"></i>
                    {{ getContactInitiator(result) }}
                  </div>
                  <div v-if="result.metadata && result.metadata.agent_email && userType === 'agent'" class="contact-initiator">
                    <i class="fas fa-user-plus"></i>
                    {{ result.metadata.agent_email.split('@')[0] }}
                  </div>
                </div>

                <div class="card-top-right">
                  <button v-if="!poolMode"
                    class="icon-btn bookmark-btn"
                    :class="{ bookmarked: isBookmarked(result) }"
                    @click="toggleBookmark(result, $event)"
                    :title="isBookmarked(result) ? 'Remove bookmark' : 'Bookmark'"
                  >
                    <i :class="isBookmarked(result) ? 'fas fa-bookmark' : 'far fa-bookmark'"></i>
                  </button>
                  <div style="position: relative;">

                  <button class="icon-btn" @click="toggleDownloadMenu(index, $event)" title="Download options">
                    <i class="fas fa-download"></i>
                  </button>

 <!-- Download dropdown -->
  
 <div class="download-section" v-if="downloadMenuOpen === index">
  <div class="download-options">
    <div class="options-header">
      <h4>Download Options</h4>
      <button @click="downloadMenuOpen = null" class="close-btn">
        <i class="fas fa-times"></i>
      </button>
    </div>
    <div class="checkbox-group"  @click="$event.stopPropagation()">
      
      
      <label class="checkbox-item" @click="$event.stopPropagation()">
        <input
          type="checkbox"
          v-model="downloadOptions.includeLogo"
          class="checkbox-input"
          @click="$event.stopPropagation()"
        >
        <span class="checkmark"></span>
        <div class="checkbox-content">
          <span class="checkbox-label">Include Logo</span>
          <span class="checkbox-description">Show company branding</span>
        </div>
      </label>
    
      <label class="checkbox-item" @click="$event.stopPropagation()">
        <input
          type="checkbox"
          v-model="downloadOptions.includeName"
          class="checkbox-input"
          :disabled="downloadOptions.includeContact"
          @click="$event.stopPropagation()"
        >
        <span class="checkmark"></span>
        <div class="checkbox-content">
          <span class="checkbox-label">Include Candidate Name</span>
          <span class="checkbox-description">
            Show candidate's full name
            <span v-if="downloadOptions.includeContact" class="auto-selected">(auto-selected)</span>
          </span>
        </div>
      </label>
    
      <label class="checkbox-item" @click="$event.stopPropagation()">
        <input
          type="checkbox"
          v-model="downloadOptions.includeContact"
          class="checkbox-input"
          @click="$event.stopPropagation()"
        >
        <span class="checkmark"></span>
        <div class="checkbox-content">
          <span class="checkbox-label">Include Contact Details</span>
          <span class="checkbox-description">Show email, phone, location (includes name)</span>
        </div>
      </label>


    </div>
    <div class="download-actions"  @click="$event.stopPropagation()">
      <button
        @click="downloadCustomResume(getCandidateId(result), getEsDocumentId(result))"
        class="download-btn primary"
      >
        <i class="fas fa-download"></i>
        Download PDF
      </button>

  <button
    @click="downloadResumeDOCX(getCandidateId(result), getEsDocumentId(result))"
    class="download-btn secondary"
  >
    <i class="fas fa-file-word"></i>
    Download DOCX (Editable)
  </button>
  <!--reforamting  -->
<!-- <button
  @click="downloadReformattedResume(getCandidateId(result))"
  class="download-btn reformat"
  :disabled="reformatLoading[getCandidateId(result)]"
>
  <i class="fas fa-magic"></i>
  {{ reformatLoading[getCandidateId(result)] ? 'Reformatting...' : 'Reformat' }}
</button> -->

<!-- Reformat Button -->
<!-- Reformat Section -->
<div class="reformat-section">
<button
@click="openReformatter(getCandidateId(result), getEsDocumentId(result))"
class="download-btn reformat"
>
<i class="fas fa-magic"></i>
Reformat with AI
</button>

<!-- Job Offer Checkbox -->
<!-- <label class="job-offer-checkbox">
<input 
type="checkbox" 
v-model="showJobOfferInput[getCandidateId(result)]"
@click.stop
/>
<span>With Job Description</span>
</label>

<!-- Textarea (only shows when checkbox is checked) -->
<!-- <textarea
v-if="showJobOfferInput[getCandidateId(result)]"
v-model="jobOfferInput[getCandidateId(result)]"
placeholder="Paste job description here..."
class="job-offer-textarea-inline"
rows="2"
@click.stop
></textarea> -->  
</div>

<!-- Loading Overlay (shows when reformatting) -->
<!-- <div 
v-if="reformatLoading[getCandidateId(result)]" 
class="reformat-loading-overlay"
>
<div class="loading-spinner"></div>
<p class="loading-text">AI is reformatting your resume...</p>
<p class="loading-subtext">This may take 30-60 seconds</p>
</div> -->
  <button @click="openLogoEditor(getCandidateId(result), getEsDocumentId(result))" class="btn-logo">
    📝 Add Company Logo
  </button>
      <button
        @click="downloadResume(getCandidateId(result), getEsDocumentId(result))"
        class="download-btn secondary"
      >
        <i class="fas fa-file-pdf"></i>
        Download Original
      </button>

      <button 
      @click="openResumeEditor(getCandidateId(result), getEsDocumentId(result))"
      class=" download-btn edit-export-btn"
    >
      <i class="fas fa-edit"></i>
      Edit & Export
    </button>
    </div>
  </div>
</div>
</div>
                  
                  <button class="icon-btn" @click="showResumeDetail(result)" title="View details">
                    <i class="fas fa-eye"></i>
                  </button>
                  <div style="position: relative;">
                    <button v-if="hasCandidateId(result)" class="icon-btn candidate-group-btn"
                      @click="toggleCandidateResumes(result, $event)"
                      :class="{ active: candidateResumesDropdown === getCandidateId(result) }"
                      title="Other resumes">
                      <i class="fas fa-user-circle"></i>
                    </button>
                    <!-- Candidate resumes dropdown -->
                    <div v-if="candidateResumesDropdown === getCandidateId(result)" class="candidate-resumes-dropdown" @click.stop>
                      <div v-if="loadingCandidateResumes" class="dropdown-loading"><i class="fas fa-spinner fa-spin"></i> Loading...</div>
                      <div v-else>
                        <div class="dropdown-header">{{ getCandidateResumeData(result).count }} Resume(s)</div>
                        <div v-for="resume in getCandidateResumeData(result).resumes" :key="resume.candidate_id"
                          class="dropdown-item" :class="{ current: resume.candidate_id === getCandidateId(result) }"
                          @click="viewSpecificResume(resume.candidate_id)">
                          <i class="fas fa-file-pdf"></i>
                          <div class="resume-info"><div class="resume-id">{{ resume.candidate_id }}</div><div class="resume-name">{{ resume.file_name }}</div></div>
                          <i v-if="resume.candidate_id === getCandidateId(result)" class="fas fa-check current-badge"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                  <button class="icon-btn" @click="toggleSection(index, 'main')" :disabled="!isCandidateDataReady"
                    :title="isExpanded(index, 'main') ? 'Collapse' : 'Expand'">
                    <i :class="`fas fa-chevron-${isExpanded(index, 'main') ? 'up' : 'down'}`"></i>
                  </button>
                </div>
              </div>

              <!-- ROW 2: Agent view chips (full width) -->
              <div v-if="agentViews[getCandidateId(result)]?.length && userType === 'agent'" class="agent-views-row">
                <template v-if="!agentViewsExpanded[getCandidateId(result)]">
                  <span v-for="(v, vi) in agentViews[getCandidateId(result)].slice(0, 3)" :key="vi"
                  :class="['agent-view-chip', v.role === 'client' ? 'chip-client-view' : '']"
                  :title="(v.role === 'client' ? 'Client' : 'Agent') + ' — viewed ' + timeAgoShort(v.viewed_at)">
                  <i :class="v.role === 'client' ? 'fas fa-building' : 'fas fa-eye'"></i> {{ v.agent_name }}
                
                  </span>
                  <button v-if="agentViews[getCandidateId(result)].length > 3"
                    class="agent-view-chip more" @click.stop="agentViewsExpanded[getCandidateId(result)] = true">
                    +{{ agentViews[getCandidateId(result)].length - 3 }} more
                  </button>
                </template>
                <template v-else>
                  <span v-for="(v, vi) in agentViews[getCandidateId(result)]" :key="vi"
                  :class="['agent-view-chip', v.role === 'client' ? 'chip-client-view' : '']"
                  :title="(v.role === 'client' ? 'Client' : 'Agent') + ' — viewed ' + timeAgoShort(v.viewed_at)">
                  <i :class="v.role === 'client' ? 'fas fa-building' : 'fas fa-eye'"></i> {{ v.agent_name }}                
                  </span>
                  <button class="agent-view-chip more" @click.stop="agentViewsExpanded[getCandidateId(result)] = false">
                    show less
                  </button>
                </template>
              </div>

              <!-- Download dropdown (positioned absolute, unchanged) -->
             
            <div class="card-header">
 

              <div class="candidate-info">
              <h3 class="candidate-name">
                <a 
              v-if="getLinkedInUrl(result)" 
              :href="getLinkedInUrl(result)" 
              target="_blank" 
              rel="noopener noreferrer"
              class="linkedin-link"
              v-tooltip.top="'View LinkedIn Profile'"
              @click.stop
            >
              <i class="fab fa-linkedin"></i>
            </a>
            {{ getCandidateDisplayName(result) }}
                <!-- {{ result.name || 'Anonymous' }} -->

                 <!-- LinkedIn link (ADD THIS) -->
              <br>
                <span v-if="hasLocation(result)" class="location">
                  ({{ formatLocation(result.location) }})
                </span>
              </h3>
             







              <p class="candidate-title">
                {{ result.job?.title || result.current_position || 'Position not specified' }}
                <span v-if="result.job?.company" class="at"><br>At </span>
                <span v-if="result.job?.company" class="jobby">{{ result.job.company }}</span>
              </p>
            </div>
        

          </div>
        </div>
<!-- Add this badge near candidate name in your result card -->



          <!-- Card metadata (add after card-header) -->
          <div class="card-metadata">
            <div class="candidate-id">
              <i class="fas fa-fingerprint"></i>
              <span>{{ getCandidateId(result) }}</span>
            </div>
            <div class="indexed-date" v-if="getIndexedDate(result)">
              <i class="fas fa-calendar-alt"></i>
              <span>{{ formatIndexedDate(getIndexedDate(result)) }}</span>
            </div>
          </div>

          <!-- Quick info -->
<!-- Quick info -->
<div class="quick-info">
  <div class="info-item" v-if="result.job?.employment_period">
    <i class="fas fa-briefcase"></i>
    <span><b>{{ formatExperience(result.job.employment_period) }}</b></span>
  </div>
  
  <div class="info-item" v-if="hasLocation(result)">
    <i class="fas fa-map-marker-alt"></i>
    <span>{{ formatLocation(result.location) }}</span>
  </div>
  
  <!-- MATCH SCORE DISPLAY -->
 <!-- Hot List Match (when viewing hot list) -->
 <div 
 v-if="result.hot_list_match && activeHotListId" 
 class="info-item match-score-item hot-list-container"
>
 <div 
   class="hot-list-content"
   @click="toggleMatchBreakdown(getCandidateId(result))"
   :class="{ expanded: isMatchBreakdownOpen(getCandidateId(result)) }"
 >
   <i class="fas fa-fire"></i>
   
   <!-- Show different text for manual vs auto-suggested -->
   <span v-if="result.match_metadata?.source_type === 'manual'" class="manual-add-badge">
     Added by Agent
   </span>
   <span v-else class="hot-list-score">
     {{ Math.round(result.hot_list_match * 100) }}% Hot List Match
   </span>
   
   <i v-if="result.match_metadata?.source_type !== 'manual'" 
      class="fas fa-chevron-down breakdown-chevron" 
      :class="{ rotated: isMatchBreakdownOpen(getCandidateId(result)) }"></i>
 </div>
 
 <button 
   class="hide-candidate-btn"
   @click.stop="hideFromHotList(result)"
   title="Remove from hot list"
 >
   <i class="fas fa-eye-slash"></i>
 </button>
</div>

<!-- Regular Match (with ADD TO HOT LIST button) -->
<div 
 v-else-if="result.score && !activeHotListId && userType === 'agent'" 
 class="info-item match-score-item match-with-actions"
>
 <!-- Match score (clickable for breakdown if metadata exists) -->
 <div 
   class="match-content"
   @click="result.match_metadata ? toggleMatchBreakdown(getCandidateId(result)) : null"
   :class="{ clickable: result.match_metadata }"
 >
   <i :class="result.match_metadata ? getMatchIcon(result.match_metadata.source_type) : 'fas fa-chart-line'"></i>
   <span class="match-score-text">
     {{ Math.round(result.score_percent ) }}% Match
     <i v-if="result.match_metadata" 
        class="fas fa-chevron-down breakdown-chevron" 
        :class="{ rotated: isMatchBreakdownOpen(getCandidateId(result)) }"></i>
   </span>
 </div>
 
 <!--to Hot List dropdown button -->
 <div class="add-to-hotlist-wrapper">
   <button 
     class="add-to-hotlist-btn"
     @click.stop="toggleHotListDropdown(getCandidateId(result))"
     :title="getHotListButtonTitle(result)"
   >
     <i :class="getCandidateHotListIcon(result)"></i>
   </button>
   
   <!-- Dropdown menu -->
   <transition name="dropdown-fade">
     <div 
       v-if="isHotListDropdownOpen(getCandidateId(result))"
       class="hotlist-dropdown"
       @click.stop
     >
       <div class="hotlist-dropdown-header">
         Add to Hot List
         <button class="close-dropdown" @click="closeHotListDropdown">
           <i class="fas fa-times"></i>
         </button>
       </div>
       
       <!-- Loading state -->
       <div v-if="loadingHotLists" class="dropdown-loading">
         <i class="fas fa-spinner fa-spin"></i> Loading...
       </div>
       
       <!-- Hot lists -->
       <div v-else-if="availableHotLists.length > 0" class="hotlist-options">
         <button
           v-for="hotList in availableHotLists"
           :key="hotList.hot_list_id"
           class="hotlist-option"
           :class="{ 
             'already-added': isInHotList(result, hotList.hot_list_id),
             'adding': addingToHotList[hotList.hot_list_id] 
           }"
           @click="addToHotList(result, hotList)"
           :disabled="isInHotList(result, hotList.hot_list_id) || addingToHotList[hotList.hot_list_id]"
         >
           <span class="hotlist-name">{{ hotList.name }}</span>
           <span v-if="isInHotList(result, hotList.hot_list_id)" class="status-badge">
             <i class="fas fa-check"></i> Added
           </span>
           <span v-else-if="addingToHotList[hotList.hot_list_id]" class="status-badge">
             <i class="fas fa-spinner fa-spin"></i>
           </span>
           <span v-else class="status-badge add-badge">
             <i class="fas fa-plus"></i> Add
           </span>
         </button>
       </div>
       
       <!-- Empty state -->
       <div v-else class="dropdown-empty">
         <i class="fas fa-inbox"></i>
         <p>No hot lists yet</p>
         <small>Create a hot list to start organizing candidates</small>
       </div>
     </div>
   </transition>
 </div>


 <!-- Push to Project dropdown button -->
<div class="add-to-hotlist-wrapper" v-if="userType === 'agent'">
  <button
    class="add-to-hotlist-btn-green"
    @click.stop="toggleProjectDropdown(getCandidateId(result))"
    :title="isInProject(getCandidateId(result), availableProjects[0]?.project_id) ? 'Manage projects' : 'Push to project'"
  >
    <i class="fas fa-folder-plus" style="color: #7eff9d;"></i>
  </button>

  <transition name="dropdown-fade">
    <div
      v-if="isProjectDropdownOpen(getCandidateId(result))"
      class="hotlist-dropdown"
      @click.stop
    >
      <div class="hotlist-dropdown-header">
        Push to Project
        <button class="close-dropdown" @click="closeProjectDropdown">
          <i class="fas fa-times"></i>
        </button>
      </div>

      <div v-if="loadingProjects || loadingProjectMemberships" class="dropdown-loading">
        <i class="fas fa-spinner fa-spin"></i> Loading...
      </div>

      <div v-else-if="availableProjects.length > 0" class="hotlist-options">
        <div
  v-for="project in availableProjects"
  :key="project.project_id"
  class="hotlist-option-wrapper"
>
  <span class="hotlist-name">{{ project.project_name }}</span>
  <div class="hotlist-actions-col">
    <button
      class="hotlist-action-btn"
      :class="{ 'already-added': isInProject(getCandidateId(result), project.project_id) }"
      @click.stop="isInProject(getCandidateId(result), project.project_id) ? removeFromProject(result, project) : addToProject(result, project)"
      :disabled="addingToProject[project.project_id] || removingFromProject[project.project_id]"
    >
      <i :class="addingToProject[project.project_id] || removingFromProject[project.project_id] ? 'fas fa-spinner fa-spin' : isInProject(getCandidateId(result), project.project_id) ? 'fas fa-minus' : 'fas fa-plus'"></i>
      {{ isInProject(getCandidateId(result), project.project_id) ? 'Remove' : 'Add' }}
    </button>
    <button
    v-if="isInProject(getCandidateId(result), project.project_id) && !hasScreeningStarted(getCandidateId(result), project.project_id)"
    class="hotlist-action-btn screening-btn"
      @click.stop="startScreeningFromDropdown(result, project)"
    >
      <i class="fas fa-clipboard-list"></i> Screen
    </button>
  </div>
</div>
    <!-- d -->
      </div>

      <div v-else class="dropdown-empty">
        <i class="fas fa-inbox"></i>
        <p>No projects assigned</p>
      </div>
    </div>
  </transition>
</div>




</div>

<!-- Fallback (clients or no score) -->
<div v-else-if="result.score" class="info-item">
 <i class="fas fa-chart-line"></i>
 <span>{{ result.score_percent ?? getPercent(result) }}% match</span>
</div>  

  <div class="info-item" v-if="result.job?.period">
    <i class="fas fa-calendar"></i>
    <span>{{ result.job.period }}</span>
  </div>
</div>

<!-- MATCH BREAKDOWN PANEL (appears below quick-info when clicked) -->
<transition name="breakdown-slide">
  <div 
    v-if="result.match_metadata && isMatchBreakdownOpen(getCandidateId(result))" 
    class="match-breakdown-panel"
  >
    <!-- Source Type Badge -->
    <div class="breakdown-header">
      <span class="source-badge" :class="'source-' + result.match_metadata.source_type">
        {{ formatSourceType(result.match_metadata.source_type) }}
      </span>
      <span class="breakdown-reason">{{ formatMatchReason(result.match_metadata.reason) }}</span>
    </div>
    
    <!-- Score Composition -->
    <div class="score-composition">
      <!-- Keyword Score -->
      <div v-if="result.match_metadata.keyword_score > 0" class="score-bar-container">
        <div class="score-label">
          <i class="fas fa-key"></i>
          <span>Keyword Match</span>
          <span class="score-value">{{ Math.round(result.match_metadata.keyword_score * 100) }}%</span>
        </div>
        <div class="score-bar">
          <div 
            class="score-fill keyword-fill" 
            :style="{ width: (result.match_metadata.keyword_score * 100) + '%' }"
          ></div>
        </div>
      </div>
      
      <!-- Semantic Score -->
      <div v-if="result.match_metadata.semantic_score > 0" class="score-bar-container">
        <div class="score-label">
          <i class="fas fa-brain"></i>
          <span>Semantic Match</span>
          <span class="score-value">{{ Math.round(result.match_metadata.semantic_score * 100) }}%</span>
        </div>
        <div class="score-bar">
          <div 
            class="score-fill semantic-fill" 
            :style="{ width: (result.match_metadata.semantic_score * 100) + '%' }"
          ></div>
        </div>
      </div>
    </div>
    
    <!-- Semantic Breakdown (if available) -->
    <div v-if="result.match_metadata.semantic_breakdown" class="semantic-breakdown">
      <div class="breakdown-title">
        <i class="fas fa-microscope"></i>
        Detailed Breakdown
      </div>
      <div class="breakdown-grid">
        <div 
          v-for="(score, key) in result.match_metadata.semantic_breakdown" 
          :key="key"
          class="breakdown-item"
        >
          <span class="breakdown-item-label">{{ formatBreakdownLabel(key) }}</span>
          <div class="breakdown-mini-bar">
            <div 
              class="breakdown-mini-fill" 
              :style="{ width: (score * 100) + '%' }"
            ></div>
          </div>
          <span class="breakdown-item-value">{{ Math.round(score * 100) }}%</span>
        </div>
      </div>
    </div>
  </div>
</transition>

          <!-- Skills preview -->
          <div v-if="hasSkills(result)" class="skills-preview">
            <div
              v-for="(skill, index) in getAllSkills(result).slice(0, 5)"
              :key="index"
              class="skill-chip"
            >
              {{ skill }}
            </div>
            <span v-if="getAllSkills(result).length > 5" class="more-skills">
              +{{ getAllSkills(result).length - 5 }} more 
            </span>
          </div>

<!-- loading  -->
<!-- <div class="candidate-card" :class="{ 'loading-card': !isCandidateDataReady }">
  <!-- Soft blur overlay -->
  <!-- <div v-if="!isCandidateDataReady" class="card-loading-blur"></div> -->  

<!-- Replace your candidate-tags-grouped div with this -->
 
<!-- Quick status badge (always visible, even when tags collapsed) -->
<div 
  v-if="projectContext && isTagsCollapsed(result)" 
  class="quick-status-badge"
  :class="getProjectStatusClass(result)"
>
  <i :class="getProjectStatusIcon(result)"></i>
  <span>{{ getProjectStatusDisplay(result) }}</span>
</div>
<!-- NEW: Fancy collapsible tags section -->
<div class="candidate-tags-section">
  <!-- Sleek toggle button -->
  <button 
    class="tags-toggle-btn"
    @click="toggleTagsCollapse(result)"
    :class="{ 'expanded': !isTagsCollapsed(result) }"
  >
    <div class="tags-toggle-content">
      <i class="fas fa-tags tags-icon"></i>
      <span class="tags-label">Tags & Notes</span>
      <i class="fas fa-chevron-down expand-icon"></i>
    </div>
  </button>
  
  <!-- Collapsible content -->
  <transition name="slide-fade">
    <div v-if="!isTagsCollapsed(result)" class="tags-content-wrapper">
      <!-- Loading state -->
      <div v-if="!candidateTags[getCandidateId(result)]" class="tags-loading-state">
        <div class="loading-spinner">
          <i class="fas fa-circle-notch fa-spin"></i>
        </div>
        <span class="loading-text ">Loading tags...</span>
      </div>
      
      <!-- Existing tags content -->
      <div v-else class="tags-content">



<!--  agent/client/workflows     -->

<!-- CLIENT WORKFLOW SECTION (Only for clients in project context) -->

<!-- Client Workflow - Replace the existing status !poolMode && display with this: -->
<div 
  v-if="userRole === 'client' && projectContext &&  projectStatus !== 'COMPLETED'" class="client-workflow-enhanced">
  
  
 
  <div class="workflow-header clickable-header":class="{'card-loading-shimmer': isCardLoading(result)}" @click="toggleStatusCollapse(result)">
    <div class="workflow-title">
      <i class="fas fa-tasks"></i>
      Project Workflow
    </div>
    
    <!-- Collapsed: show inline status -->
    <div v-if="getStatusCollapseState(result)" class="status-collapsed">
      <div class="status-badge-collapsed" :class="{ 'loading': isCardLoading(result) }">
        {{ isCardLoading(result) ? 'Loading...' : (getProjectStatusDisplay(result) || 'No status') }}
      </div>
    </div>
    
    <!-- Expanded: show expand icon -->
    <div v-else class="status-expanded-header">
      <i class="fas fa-chevron-up collapse-icon"></i>
    </div>
  </div>
  
  <!-- Collapsible content -->
  <div v-if="!getStatusCollapseState(result)" class="workflow-content">
    <!-- All your existing workflow content goes here -->
  



  <!-- Different states for clients -->
  
  <!-- STATE 1: No screening requested yet -->
 
  <div v-if="!getProjectStatus(result)" class="client-action-state">
    <!-- this to your CLIENT WORKFLOW SECTION, right BEFORE the "Request Screening" button -->

<!-- CLIENT PROMINENT NOTE (only show before screening is requested) -->
<div v-if="userRole === 'client' && projectContext && !getProjectStatus(result)" class="client-prominent-note">
  <div class="prominent-note-header">
    <h4>
      <i class="fas fa-sticky-note"></i>
      Project Requirements & Notes
    </h4>
    <p class="note-hint">Add specific requirements or context for our team before requesting screening</p>
  </div>
  
  <div class="note-input-container">
    <textarea 
      v-model="newScreeningNote[getCandidateId(result)]"
      placeholder="e.g., Must have React experience, available for remote work, budget $80-100k..."
      class="prominent-note-textarea"
      rows="3"
      maxlength="59"
    ></textarea>
     <!-- ✅ ADD CHARACTER COUNTER -->
     <div class="char-counter" :class="getCharCounterClass(getCandidateId(result))">
      {{ getCharCount(getCandidateId(result)) }} / 59
    </div>
    <button 
      @click="addScreeningNote(result)"
      :disabled="!newScreeningNote[getCandidateId(result)]?.trim()"
      class="prominent-add-note-btn"
    >
      <i class="fas fa-plus"></i>
      Add Project Note
    </button>
  </div>
  
  <!-- Show existing note if already added -->
  <div v-if="getScreeningNotesFromTags(result).length > 0" class="existing-note-preview">
    <div class="note-preview-header">
      <i class="fas fa-check-circle"></i>
      <span>Project note added:</span>
    </div>
    <div class="note-preview-content">
      {{ getScreeningNotesFromTags(result)[0].content }}
    </div>
    <button 
      @click="toggleNoteCollapse(result)" 
      class="collapse-note-btn"
    >
      <i class="fas fa-eye-slash"></i>
      Hide note
    </button>
  </div>
</div>

    <button 
      @click="requestScreening(result)"
      class="workflow-btn primary-action"
      :disabled="loadingProjectStatus"
    >
      <div class="btn-content">
        <i class="fas fa-search-plus"></i>
        <span>Request Screening</span>
      </div>
      <div class="btn-subtitle">Our team will evaluate this candidate</div>
    </button>
  </div>
  
  <!-- STATE 2: Screening requested, waiting for agent -->
  <div v-if="getProjectStatus(result) === 'request-screening'" class="client-waiting-state">
    <div class="status-card waiting">
      <div class="status-icon">
        <i class="fas fa-clock"></i>
      </div>
      <div class="status-content">
        <div class="status-title">Screening demandée</div>
        <div class="status-message">En attente du début de l’évaluation par notre équipe</div>
      </div>
    </div>
  </div>
  
  <!-- STATE 3: Screening in progress -->
  <div v-if="getProjectStatus(result) === 'screening-in-progress'" class="client-progress-state">
    <div class="status-card progress">
      <div class="status-icon">
        <i class="fas fa-cogs"></i>
      </div>
      <div class="status-content">
        <div class="status-title">Screening en cours</div>
        <div class="status-message">Notre équipe RH évalue ce candidat</div>
      </div>
    </div>
  </div>
  <!-- STATE 3b: Tech interview scheduled -->
  <div v-if="getProjectStatus(result) === 'tech-interview-scheduled'" class="client-progress-state">
    <div class="status-card tech-planned">
      <div class="status-icon"><i class="fas fa-calendar-check"></i></div>
      <div class="status-content">
        <div class="status-title">Entretien Technique RED TIC Planifié</div>
        <div class="status-message">L'entretien technique Red Tic avec notre équipe est programmé</div>
      </div>
    </div>
  </div>
    <!-- STATE 3b1: Tech interview scheduled -->
<div v-if="getProjectStatus(result) === 'tech-interview-requested'" class="client-progress-state">
  <div class="status-card progress">
    <div class="status-icon"><i class="fas fa-calendar-plus"></i></div>
    <div class="status-content">
      <div class="status-title">Entretien technique demandé</div>
      <div class="status-message">L'entretien technique Red Tic est en cours d'organisation</div>
    </div>
  </div>
</div>
  <!-- STATE 4: Screening completed - SHOW REPORT -->
  <div v-if="['screened', 'interview-scheduled', 'hired', 'rejected'].includes(getProjectStatus(result))" class="client-completed-state">
   <div class="status-card completed">
      <div class="status-icon">
        <i class="fas fa-check-circle"></i>
      </div>
      <div class="status-content">
        <div class="status-title">Screening Terminée</div>
        <div class="status-message">Le rapport de Screening est disponible</div>
      </div>
    </div>
    
    <!-- View Report Button -->
    <button 
      @click="viewScreeningReport(result)"
      class="workflow-btn secondary-action"
    >
      <div class="btn-content">
        <i class="fas fa-file-alt"></i>
        <span>View Screening Report</span>
      </div>
      <div class="btn-subtitle">See detailed evaluation results</div>
    </button>
    <!--   button after the existing "View Report" button -->
<!-- <button 
v-if="hasCompletedReportForCurrentProject(result)"
@click="downloadScreeningReport(result, getCompletedReportId(result))"
class="workflow-btn secondary-action"
style="margin-left: 0.5rem;"
>
<i class="fas fa-download"></i>
Download PDF
</button> -->
    <!-- Quick Report Preview (optional) -->
    <div v-if="getReportPreview(result)" class="report-preview">
      <div class="preview-header">
        <i class="fas fa-eye"></i>
        <span>Quick Preview</span>
      </div>
      <div class="preview-content">
        <div class="preview-item">
          <label>Recommendation:</label>
          <span :class="['rec-badge', 'rec-' + recToClass(getReportPreview(result).hr_section?.recommandation_hr || getReportPreview(result).recommendation)]">
            {{ getReportPreview(result).hr_section?.recommandation_hr || getReportPreview(result).recommendation || '—' }}
          </span>
        </div>
        <div class="preview-item">
          <label>Availability:</label>
          <span class="availables">{{ getReportPreview(result).hr_section?.disponibilite || formatAvailability(getReportPreview(result).availability) || '—' }}</span>
        </div>
      </div>
    </div>
    <!-- Interview scheduled banner — shows BELOW the report, not instead of it -->
    <div v-if="getProjectStatus(result) === 'interview-scheduled'" class="interview-scheduled-banner">
      <i class="fas fa-calendar-check"></i>
      <span>Entretien planifié</span>
      <span v-if="interviewDates[getCandidateId(result)]" class="interview-date">
        — {{ formatDate(interviewDates[getCandidateId(result)]) }}
      </span>
      <!-- Client: cancel and re-propose -->
      <button
        v-if="userRole === 'client'"
        @click="cancelInterview(result)"
        class="cancel-interview-btn"
        :disabled="loadingProjectStatus"
        title="Annuler et reproposer des dates"
      >
        <i class="fas fa-times-circle"></i> Annuler
      </button>
      <!-- <button @click="markInterviewDone(result)" class="action-btn secondary">
        <i class="fas fa-handshake"></i> Marquer comme effectué
      </button> -->
      <!-- Replace the existing Mark Done button -->
      <button @click="openInterviewFeedbackModal(result)" class="action-btn warning">
        <i class="fas fa-check-circle"></i> Marquer comme effectué
      </button>


    </div>

     <!-- Show hired status if candidate is hired -->
  <div v-if="isHired(result)" class="hired-status">
    <div class="hired-badge">
      <i class="fas fa-trophy"></i>
      <span>Candidate Hired</span>
    </div>
    <div class="hired-message">
      This candidate has been successfully hired for this project.
    </div>
  </div>
  
    <!-- Client Decision Actions -->
    <!--<div v-else-if="needsApproval(result)" class="client-decisions">
      <div class="decision-header">
        <i class="fas fa-handshake"></i>
        <span>Next Steps</span>
      </div>
       
      <div class="decision-actions">
        <button 
        @click="approveForHire(result)"
        class="workflow-btn success-action"
        :disabled="loadingProjectStatus"
      >
        <div class="btn-content">
          <i class="fas fa-handshake"></i>
          <span>Hire Candidate</span>   
        </div>
        <div class="btn-subtitle"></div>   
      </button>
        
        <button 
          @click="rejectCandidate(result)"
          class="workflow-btn tertiary-action"
          :disabled="loadingProjectStatus"
        >
          <div class="btn-content">
            <i class="fas fa-times-circle"></i>
            <span>Reject Candidate</span>
          </div>
        </button>
      </div> 
    </div>-->
    <div v-else-if="needsApproval(result) && !['hired', 'rejected'].includes(getProjectStatus(result))" class="client-decisions">
    <div class="decision-header">
    <i class="fas fa-calendar-check"></i>
    <span>Next Steps</span>
  </div>
  <div class="decision-actions">
    <button @click="openScheduleInterview(result)" class="workflow-btn success-action" :disabled="loadingProjectStatus">
      <div class="btn-content">
        <i class="fas fa-calendar-plus"></i>
        <span>Schedule Interview</span>
      </div>
      <div class="btn-subtitle">Move to interview stage</div>
    </button>
    <button @click="rejectCandidate(result)" class="workflow-btn tertiary-action" :disabled="loadingProjectStatus">
      <div class="btn-content">
        <i class="fas fa-times-circle"></i>
        <span>Not Selected</span>
      </div>
    </button>
  </div>
</div>
</div>
<!-- STATE 5: Interview Requested — client waiting for HR to confirm with candidate -->
<div v-if="getProjectStatus(result) === 'interview-requested'" class="client-interview-requested-state">
  <div class="status-card interview-requested">
    <div class="status-icon"><i class="fas fa-hourglass-half"></i></div>
    <div class="status-content">
      <div class="status-title">Entretien en attente de confirmation</div>
      <div class="status-message">Notre équipe RH contacte le candidat pour confirmer une date</div>
    </div>
  </div>
  <!-- Show proposed dates so client sees what was sent -->
  <div v-if="interviewSlotData[getCandidateId(result)]?.proposed_dates?.length" class="proposed-dates-preview">
    <div class="proposed-label"><i class="fas fa-calendar-alt"></i> Créneaux proposés :</div>
    <div v-for="(d, i) in interviewSlotData[getCandidateId(result)].proposed_dates" :key="i" class="proposed-date-item">
      <i class="fas fa-clock"></i> {{ formatDate(d) }}
    </div>
  </div>
  <!-- If all dates expired, allow client to re-propose -->
  <div v-if="allDatesExpired(result)" class="expired-dates-warning">
    <i class="fas fa-exclamation-triangle"></i>
    Toutes les dates proposées sont passées.
    <button @click="openScheduleInterview(result)" class="btn-link-inline">Proposer de nouveaux créneaux</button>
  </div>
  <!-- View report is still accessible -->
  <button @click="viewScreeningReport(result)" class="workflow-btn secondary-action" style="margin-top:10px">
    <div class="btn-content"><i class="fas fa-file-alt"></i><span>Voir le rapport de screening</span></div>
  </button>
</div>

<!-- STATE 6: Interview Done — awaiting final decision -->
<div v-if="getProjectStatus(result) === 'interview-done'" class="client-completed-state">
  <div class="status-card interview-done">
    <div class="status-icon"><i class="fas fa-handshake"></i></div>
    <div class="status-content">
      <div class="status-title">Entretien Terminé</div>
      <div class="status-message">L'entretien a eu lieu. Décision finale en cours.</div>
    </div>
  </div>
  <button @click="viewScreeningReport(result)" class="workflow-btn secondary-action" style="margin-bottom:10px">
    <div class="btn-content"><i class="fas fa-file-alt"></i><span>Voir le rapport</span></div>
  </button>
  <div class="client-decisions">
    <div class="decision-header"><i class="fas fa-gavel"></i><span>Décision finale</span></div>
    <div class="decision-actions">
      <button @click="approveForHire(result)" class="workflow-btn success-action" :disabled="loadingProjectStatus">
        <div class="btn-content"><i class="fas fa-trophy"></i><span>Embaucher</span></div>
      </button>
      <button @click="rejectCandidate(result)" class="workflow-btn tertiary-action" :disabled="loadingProjectStatus">
        <div class="btn-content"><i class="fas fa-times-circle"></i><span>Ne pas retenir</span></div>
      </button>
    </div>
  </div>
</div>

  
  <div v-if="getProjectStatus(result) === 'hired'" class="status-card hired-state">
    <div class="status-icon">
      <i class="fas fa-trophy"></i>
    </div>
    <div class="status-content">
      <div class="status-title">Candidate Hired</div>
      <div class="status-message">
        This candidate has been hired for this project.
      </div>
    </div>
  </div>
  <div v-if="getProjectStatus(result) === 'rejected'" class="status-card rejected-state">
    <div class="status-icon">
    <i class="fas fa-times-circle"></i>
  </div>
  <div class="status-content">
    <div class="status-title">Candidate Rejected</div>
    <div class="status-message">
      This candidate was not selected for this project.
    </div>
  </div>
</div>
<!-- <div v-else-if="getProjectStatus(result) === 'interview-scheduled'" class="status-card interview-state">
  <div class="status-icon"><i class="fas fa-calendar-check"></i></div>
  <div class="status-content">
    <div class="status-title">Interview Scheduled</div>
    <div class="status-message" v-if="result._interviewDate">
      {{ formatDate(result._interviewDate) }}
    </div>
  </div>
</div> -->

  
</div>
 


<!-- herrrreee  -->
</div>
<!-- ✅ NEW: Show simple status for completed projects -->
<div v-else-if="userRole === 'client' && projectContext && projectStatus === 'COMPLETED'" 
     class="project-completed-notice">
  <i class="fas fa-check-circle"></i>
  <span>Project Completed</span>
</div>
<!-- AGENT WORKFLOW SECTION (Only for agents in project context) -->
<div v-if="userRole === 'agent' && projectContext" class="agent-workflow-section">
  <h4 class="workflow-title">
    <i class="fas fa-tasks"></i>
    Screening Workflow
  </h4>
  
  <!-- Current Status -->
  <div class="current-status">
    <span class="status-label">Status:</span>
    <span class="status-badge" :data-candidate="getCandidateId(result)">
      {{ getProjectStatusDisplay(result) }}
    </span>
    </div>

  <!-- Agent Actions -->
  <!-- Agent Actions - Enhanced with Flow Enforcement -->

  <!-- Agent Actions -->
  <div class="agent-actions">
    <!-- Start Screening -->
    <button 
      v-if="needsScreening(result)"
      @click="startScreening(result)"
      class="action-btn info"
      :disabled="loadingProjectStatus"
    >
      <i class="fas fa-play"></i> Start Screening
    </button>
  
    <!-- Create Report: no report exists at all -->
    <button
      v-if="['screening-in-progress', 'tech-interview-scheduled', 'tech-interview-requested', 'tech-interview-confirmed'].includes(getProjectStatus(result))
            && !hasDraftForCurrentProject(result)
            && !hasCompletedReportForCurrentProject(result)"
      @click="openScreeningModal(result)"
      class="action-btn warning"
      :disabled="loadingProjectStatus"
    >
      <i class="fas fa-clipboard-check"></i> Create Report
    </button>
  
    <!-- Continue Draft: has draft but NOT completed, still in active screening state -->
    <button
      v-if="['screening-in-progress', 'tech-interview-scheduled', 'tech-interview-requested','tech-interview-done',  'tech-interview-confirmed'].includes(getProjectStatus(result))
            && hasDraftForCurrentProject(result)
            && !hasCompletedReportForCurrentProject(result)"
      @click="openScreeningModal(result)"
      class="action-btn warning"
      :disabled="loadingProjectStatus"
    >
      <i class="fas fa-clipboard-check"></i> Continue Report
    </button>
  
    <!-- Complete Screening: only for HR step, only when completed report exists -->
    <button
      v-if="getProjectStatus(result) === 'screening-in-progress' && hasCompletedReportForCurrentProject(result)"
      @click="completeScreeningWithReport(result)"
      class="action-btn success"
      :disabled="loadingProjectStatus"
    >
      <i class="fas fa-check"></i> Complete Screening
    </button>
  
    <!-- Edit Report: completed report exists OR status implies one was submitted
         (status fallback handles cache-miss after submit) -->
    <button
      v-if="hasCompletedReportForCurrentProject(result)
      || ['screened', 'tech-interview-scheduled', 'tech-interview-requested', 'tech-interview-confirmed','tech-interview-done', 'interview-scheduled', 'hired', 'rejected'].includes(getProjectStatus(result))"
      @click="openScreeningModal(result)"
      class="action-btn secondary"
      :disabled="loadingProjectStatus"
    >
      <i class="fas fa-edit"></i> Edit Report
    </button>
  
    <!-- Flow hint -->
    <div v-if="getProjectStatus(result) === 'screening-in-progress'
               && !hasDraftForCurrentProject(result)
               && !hasCompletedReportForCurrentProject(result)"
         class="flow-message">
      <i class="fas fa-info-circle"></i>
      <span>Create a screening report to complete the evaluation</span>
    </div>
  </div>
  <!-- Status Messages -->
    <div v-if="needsScreening(result)" class="status-message priority">
      <i class="fas fa-exclamation-triangle"></i>
      Client requested screening for this candidate
    </div>
<!-- Enhanced Notes Section - For Assigned Agents (Project-Scoped Notes) -->

<!-- Enhanced Project Notes Section - For Assigned Agents -->
<div v-if="userRole === 'agent' && projectContext && getScreeningNotesFromTags(result).length > 0" 
  class="agent-project-notes">
<div class="project-notes-header">
 <div class="notes-title">
   <i class="fas fa-clipboard-list"></i>
   <span>Client Project Notes</span>
 </div>
 <div class="notes-badge">{{ getScreeningNotesFromTags(result).length }}</div>
</div>

<div class="project-notes-content">
 <div v-for="note in getScreeningNotesFromTags(result)" 
      :key="note.id" 
      class="client-note-item">
   <div class="note-icon">
     <i class="fas fa-user-tie"></i>
   </div>
   <div class="note-body">
     <div class="note-text">{{ note.content }}</div>
     <div class="note-attribution">
       <i class="fas fa-calendar"></i>
       <span>Added by client • {{ formatDate(note.created_at) }}</span>
     </div>
   </div>
 </div>
 
 <div class="note-disclaimer">
   <i class="fas fa-info-circle"></i>
   <span>Client requirements for this screening. Use comments below for your replies.</span>
 </div>
</div>
</div>

  
<div v-if="getProjectStatus(result) === 'screening-in-progress'" class="status-message working">
  <i class="fas fa-cogs"></i>
  Complete your evaluation when ready
</div>
<!-- Agent: tech-interview-scheduled → HR agent proposes dates to tech agent -->
<!-- Agent: tech-interview-scheduled → any agent can propose dates -->
<!-- tech-interview-scheduled OR requested: check slot existence first -->
<div v-if="['tech-interview-scheduled', 'tech-interview-requested'].includes(getProjectStatus(result))" class="agent-confirm-interview">

  <!-- Slot already exists: show dates + confirm -->
  <template v-if="techInterviewSlotData[getCandidateId(result)]?.proposed_dates?.length">
    <div class="status-message working">
      <i class="fas fa-hourglass-half"></i> Créneaux proposés — confirmez une date
    </div>
    <div class="proposed-dates-preview">
      <div class="proposed-label">Créneaux disponibles :</div>
      <div v-for="(d, i) in techInterviewSlotData[getCandidateId(result)].proposed_dates" :key="i" class="proposed-date-item">
        <i class="fas fa-calendar"></i> {{ formatDate(d) }}
      </div>
    </div>
    <button @click="openTechConfirmInterview(result)" class="action-btn success" style="margin-top:10px">
      <i class="fas fa-calendar-check"></i> Confirmer la date
    </button>
  </template>

  <!-- No slot yet: anyone can propose -->
  <!-- <template v-else>
    <div class="status-message working">
      <i class="fas fa-laptop-code"></i> Entretien technique — proposez des créneaux
    </div>
    <div style="display:flex;gap:8px;margin-top:10px">
      <button @click="openTechConfirmInterview(result)" class="action-btn success">
        <i class="fas fa-calendar-check"></i> Confirmer
      </button>
      <button @click="cancelTechAndRepropose(result)" class="action-btn secondary">
        <i class="fas fa-redo"></i> Proposer d'autres créneaux
      </button>
    </div>
  </template> -->
  <template v-else>
    <div class="status-message working">
      <i class="fas fa-laptop-code"></i> Entretien technique — proposez des créneaux
    </div>
    <div style="margin-top:10px">
      <button @click="openTechProposeInterview(result)" class="action-btn success">
        <i class="fas fa-calendar-plus"></i> Proposer des créneaux
      </button>
    </div>
  </template>

</div>

<!-- Agent: tech-interview-confirmed → any agent marks done -->
<div v-if="getProjectStatus(result) === 'tech-interview-confirmed'" class="agent-confirm-interview">
  <div class="status-message working">
    <i class="fas fa-calendar-check"></i>
    Entretien tech planifié —
    <strong>{{ formatDate(techInterviewDates[getCandidateId(result)]) }}</strong>
  </div>
  <button @click="markTechInterviewDone(result)" class="action-btn secondary" style="margin-top:8px">
    <i class="fas fa-handshake"></i> Marquer comme effectué &amp; remplir le rapport
  </button>
  <button @click="cancelTechAndRepropose(result)" class="action-btn secondary">
    <i class="fas fa-redo"></i> Proposer d'autres créneaux
  </button>
</div>

<!-- Agent: interview-requested → show proposed dates + confirm button -->
<div v-if="getProjectStatus(result) === 'interview-requested'" class="agent-confirm-interview">
  <div class="status-message working">
    <i class="fas fa-hourglass-half"></i> Créneaux proposés — contactez le candidat et confirmez une date
  </div>
  <div v-if="interviewSlotData[getCandidateId(result)]?.proposed_dates?.length" class="proposed-dates-preview">
    <div class="proposed-label">Créneaux proposés par le client :</div>
    <div v-for="(d, i) in interviewSlotData[getCandidateId(result)].proposed_dates" :key="i" class="proposed-date-item">
      <i class="fas fa-calendar"></i> {{ formatDate(d) }}
    </div>
  </div>
  <button @click="openConfirmInterview(result)" class="action-btn success" style="margin-top:10px">
    <i class="fas fa-calendar-check"></i> Confirmer la date
  </button>
</div>

<!-- Agent: interview-scheduled → mark as done after interview happens -->
<div v-if="getProjectStatus(result) === 'interview-scheduled'" class="agent-confirm-interview">
  <div class="status-message working">
    <i class="fas fa-calendar-check"></i>
    Entretien planifié —         — {{ formatDate(interviewDates[getCandidateId(result)]) }} -    marquez-le comme effectué après l'entretien
  </div>
  <button @click="markInterviewDone(result)" class="action-btn secondary">
    <i class="fas fa-handshake"></i> Marquer comme effectué
  </button>
</div>


<!-- Agent: tech-interview-done → tech agent can now fill their report section -->
<div v-if="getProjectStatus(result) === 'tech-interview-done'" class="agent-confirm-interview">
  <div class="status-message working">
    <i class="fas fa-check-circle" style="color:#68d391"></i>
    Entretien technique effectué — complétez votre section dans le rapport
  </div>
  <!-- <button
    v-if="getProjectStatus(result) === 'tech-interview-done'"
    @click="openScreeningModal(result)"
    class="action-btn warning"
    :disabled="loadingProjectStatus"
  >
    <i class="fas fa-clipboard-check"></i>
    {{ hasDraftForCurrentProject(result) ? 'Continuer le rapport' : 'Remplir le rapport technique' }}
  </button> -->
</div>


</div>

 
<!-- hehere try even agent -->

<!-- Agent Pipeline (ONLY show for agents NOT in project context) -->
<div v-if="userRole === 'agent' && !projectContext" class="tag-group pipeline-always-visible">
  <h4 class="tag-group-title">Agent Pipeline</h4>
  <div class="timeline-tags">
    <button 
      v-for="(tag, index) in ['contacted', 'responded', 'screened', 'interviewed', 'offered', 'hired']"
      :key="tag"
      @click="setTimelineTag(result, tag)"
      :disabled="hasTagInCategory(result, 'pipeline_status', tag)"
      :class="[
        'tag-btn', 
        'pipeline-tag', 
        getTimelineTagClass(tag), 
        { 
          'active': hasTagInCategory(result, 'pipeline_status', tag),
          'completed-by-other': hasTagInCategory(result, 'pipeline_status', tag) && !isMyPipelineTag(result, tag)
        }
      ]"
      :title="getPipelineTooltip(result, tag)"
    >
      {{ tag }}
      <i v-if="hasTagInCategory(result, 'pipeline_status', tag) && !isMyPipelineTag(result, tag)" 
         class="fas fa-lock" 
         style="font-size: 0.6rem; margin-left: 4px;">
      </i>
    </button>
  </div>
</div>

<!-- Replace ALL other tag-group sections with conditional versions: -->

<!-- Project History Badge - Shows when data is available -->
<!-- <div 
  v-if="projectHistoryCache[getCandidateId(result)]?.unique_projects > 0" 
  class="project-history-badge"
>
  <button 
    @click.stop="showProjectHistory(getCandidateId(result))"
    class="badge-button"
    :title="`View ${getProjectCount(result)} project${getProjectCount(result) > 1 ? 's' : ''}`"
  >
    <i class="fas fa-briefcase"></i>
    <span class="badge-count">{{ getProjectCount(result) }}</span>
  </button>
</div> -->   
<!-- Project History Section (Show when data exists) -->
<div 
  v-if="projectHistoryCache[getCandidateId(result)]?.unique_projects > 0 && userRole === 'agent'" 
  class="tag-group project-history-section"
>
  <h4 class="tag-group-title">
    <i class="fas fa-briefcase"></i>
    Project History 
    <span class="count-badge">{{ projectHistoryCache[getCandidateId(result)].unique_projects }}</span>
  </h4>
  
  <div class="project-chips">
    <div 
      v-for="project in projectHistoryCache[getCandidateId(result)].projects_summary" 
      :key="project.project_id"
      class="project-chip"
    >
      <!-- Project Header -->
      <div class="project-chip-header">
        <div class="project-info">
          <span class="project-name">{{ project.project_name }}</span>
          <span class="project-meta">{{ project.job_title }} • {{ project.client_name }}</span>
        </div>
        <span :class="['project-status-pill', project.project_status.toLowerCase()]">
          {{ project.project_status }}
        </span>
      </div>
      
      <!-- Interactions -->
    <!-- Workflow Status Badge (similar to quick-status-badge) -->
<div class="project-workflow-status" v-if="project.workflow_status">
  <span 
    :class="['workflow-badge', 'status-' + project.workflow_status]"
  >
    <i :class="getWorkflowIcon(project.workflow_status)"></i>
    {{ formatWorkflowStatus(project.workflow_status) }}
  </span>
</div>
<div class="project-workflow-status" v-else>
  <span class="workflow-badge status-none">
    <i class="fas fa-clock"></i>
    No activity
  </span>
</div>
    </div>
  </div>
</div>
<!-- Status (ONLY show for agents) -->
<div v-if="userRole === 'agent'" class="tag-group">
  <h4 class="tag-group-title">Status</h4>
  <div class="multi-select-tags">
    <button 
      v-for="tag in [
        { value: 'blacklisted', label: 'Blacklisted' },
        { value: 'off-the-market', label: 'Off the Market' },
        { value: 'open-to-work', label: 'Open to Work' }
      ]"
      :key="tag.value"
      @click="toggleMultiSelectTag(result, 'candidate_status', tag.value)"
      :class="['tag-btn', 'status-tag', getStatusTagClass(tag.value), { 'active': hasTagInCategory(result, 'candidate_status', tag.value) }]"
    >
      {{ tag.label }}
    </button>
  </div>
</div>

<!-- Preferences (ONLY show for agents) -->
<div v-if="userRole === 'agent'" class="tag-group">
  <h4 class="tag-group-title">Preferences</h4>
  <div class="multi-select-tags">
    <button 
      v-for="tag in [
        { value: 'hybrid-role-only', label: 'Hybrid role only' },
        { value: 'remote-role-only', label: 'Remote role only' }
      ]"
      :key="tag.value"
      @click="toggleMultiSelectTag(result, 'work_preferences', tag.value)"
      :class="['tag-btn', 'preference-tag', { 'active': hasTagInCategory(result, 'work_preferences', tag.value) }]"
    >
      {{ tag.label }}
    </button>
  </div>
</div>

<!-- Restrictions (ONLY show for agents) -->
<div v-if="userRole === 'agent'" class="tag-group">
  <h4 class="tag-group-title">Restrictions</h4>
  <div class="multi-select-tags">
    <button 
      v-for="tag in [
        { value: 'no-cdi', label: 'No CDI' },
        { value: 'no-freelance', label: 'No Freelance' },
        { value: 'no-bank', label: 'No Bank' },
        { value: 'no-insurance', label: 'No Insurance' }
      ]"
      :key="tag.value"
      @click="toggleMultiSelectTag(result, 'restrictions', tag.value)"
      :class="['tag-btn', 'restriction-tag', { 'active': hasTagInCategory(result, 'restrictions', tag.value) }]"
    >
      {{ tag.label }}
    </button>
  </div>
</div>

<!-- Candidate Type (ONLY show for agents) -->
<div v-if="userRole === 'agent'" class="tag-group">
  <h4 class="tag-group-title">Type</h4>
  <div class="multi-select-tags">
    <button 
      v-for="tag in [
        { value: 'ex-red-tic', label: 'Ex RED TIC' },
        { value: 'consultant-red-tic', label: 'Consultant RED TIC' }
      ]"
      :key="tag.value"
      @click="toggleMultiSelectTag(result, 'candidate_type', tag.value)"
      :class="['tag-btn', 'type-tag', { 'active': hasTagInCategory(result, 'candidate_type', tag.value) }]"
    >
      {{ tag.label }}
    </button>
  </div>
</div>

<!-- Final Outcome (ONLY show for agents not in active pipeline) -->
<div v-if="userRole === 'agent' && !isInActivePipeline(result)" class="tag-group">
  <h4 class="tag-group-title">Final Outcome</h4>
  <div class="single-select-tags">
    <button 
      v-for="tag in ['declined-offer', 'withdrew', 'blacklisted']"
      :key="tag"
      @click="setSingleSelectTag(result, 'final_outcome', tag)"
      :class="['tag-btn', 'outcome-tag', { 'active': hasTagInCategory(result, 'final_outcome', tag) }]"
    >
      {{ tag.replace('-', ' ').replace(/\b\w/g, l => l.toUpperCase()) }}
    </button>
  </div>
</div>

<!-- Custom Tags (Show for everyone but with different labels) -->
<div v-if="userRole === 'agent'" class="tag-group custom-always-visible">
  <h4 class="tag-group-title">Custom Tags</h4>
  <div class="custom-tags">
    <span 
    v-for="tag in getCustomTags(result)" 
    :key="tag.tag_value"
    :class="['custom-tag', { 'not-mine': !tag.can_remove, 'new-tag': tag.isNew }]"
    @click="toggleMultiSelectTag(result, 'custom', tag.tag_value)"
    :title="tag.can_remove ? 'Click to remove (your tag)' : `Created by ${tag.agent_name} - cannot remove`"
  >
    {{ tag.tag_value }}
    <span v-if="tag.can_remove">×</span>
    <i v-else class="fas fa-lock" style="font-size: 0.6rem; margin-left: 4px;"></i>
  </span>
    
    <!-- custom tag input (show for both roles) -->
    <input 
      v-if="showCustomInput[getCandidateId(result)]"
      :ref="`tagInput-${getCandidateId(result)}`"
      v-model="customTagInput[getCandidateId(result)]"
      @keyup.enter="addCustomTag(result)"
      @blur="cancelCustomTag(result)"
      class="custom-tag-input"
      :placeholder="userRole === 'client' ? 'Add note...' : 'Add tag...'"
      maxlength="20"
    >
    <button 
      v-else
      @click="startCustomTag(result)"
      class="add-tag-btn"
    >
      +
    </button>
  </div>
</div>

<!-- Comments Section for Clients (Always Visible) -->
<div v-if="userRole === 'client'" class="comments-section">
  <h4 class="section-title">Comments ({{ candidateComments[getCandidateId(result)]?.length || 0 }})</h4>
  
  <!-- Existing comments display -->
  <div v-if="candidateComments[getCandidateId(result)]?.length" class="comments-list">
    <div v-for="comment in candidateComments[getCandidateId(result)]" 
    :key="comment.created_at" 
    :class="['comment-item', { 'new-comment': comment.isNew }]">
      <div class="comment-content">{{ comment.comment }}</div>
      <div class="comment-meta">
        {{ formatCommentDate(comment.created_at) }} by {{ comment.agent }}
        <span v-if="comment.project_name" class="project-context"> • Project: {{ comment.project_name }}</span>
        <span v-else-if="comment.project_id" class="project-context"> • Project ID: {{ comment.project_id }}</span>
        <button 
          v-if="comment.is_own"
          @click="deleteComment(comment.id)" 
          class="delete-x"
          :disabled="deletingCommentId === comment.id"
          title="Delete comment"
        >
          ×
        </button>
      </div>         
    </div>
  </div>
  
  <!--new comment - SEPARATE model -->
  <div class="add-comment-section">
    <textarea 
      v-model="newComment[getCandidateId(result)]"
      placeholder="Add a comment..."
      class="comment-textarea"
      rows="3"
    ></textarea>
    <button 
      @click="addComment(result)"
      :disabled="!newComment[getCandidateId(result)]?.trim()"
      class="add-comment-btn"
    >
      Add Comment
    </button>
  </div>
</div>
  
  <div v-show="isTagSectionOpen(getCandidateId(result))" class="tags-content">
    <div v-if="getPipelineTimeline(result).length > 0" class="section">
      <h4 @click="toggleSection(index, 'timeline')" class="collapsible">
        <i :class="`fas fa-chevron-${isExpanded(index, 'timeline') ? 'down' : 'right'}`"></i>
        Pipeline Timeline ({{ getPipelineTimeline(result).length }} actions)
      </h4>
      <div v-if="isExpanded(index, 'timeline')" class="timeline-list">
        <div v-for="(entry, i) in getPipelineTimeline(result)" :key="i" class="timeline-entry">
          <span class="timeline-stage">{{ entry.stage }}</span>
          <span class="timeline-agent">by {{ entry.agent }}</span>
          <span class="timeline-date">{{ entry.date }}</span>
        </div>
      </div>
    </div>
    <!-- Candidate Status -->
    <div class="tag-group">
      <h4 class="tag-group-title">Status</h4>
      <div class="single-select-tags">
        <button 
          v-for="tag in [
            { value: 'blacklisted', label: 'Blacklisted' },
            { value: 'off-the-market', label: 'Off the Market' },
            { value: 'open-to-work', label: 'Open to Work' }
          ]"
          :key="tag.value"
          @click="setSingleSelectTag(result, 'candidate_status', tag.value)"
          :class="['tag-btn', getStatusTagClass(tag.value), { 'active': hasTagInCategory(result, 'candidate_status', tag.value) }]"
        >
          {{ tag.label }}
        </button>
      </div>
    </div>

    <!-- Work Preferences -->
    <div class="tag-group">
      <h4 class="tag-group-title">Work Preferences</h4>
      <div class="multi-select-tags">
        <button 
          v-for="tag in [
            { value: 'hybrid-role-only', label: 'Hybrid role only' },
            { value: 'remote-role-only', label: 'Remote role only' }
          ]"
          :key="tag.value"
          @click="toggleMultiSelectTag(result, 'work_preferences', tag.value)"
          :class="['tag-btn', 'preference-tag', { 'active': hasTagInCategory(result, 'work_preferences', tag.value) }]"
        >
          {{ tag.label }}
        </button>
      </div>
    </div>

    <!-- Restrictions -->
    <div class="tag-group">
      <h4 class="tag-group-title">Restrictions</h4>
      <div class="multi-select-tags">
        <button 
          v-for="tag in [
            { value: 'no-cdi', label: 'No CDI' },
            { value: 'no-freelance', label: 'No Freelance' },
            { value: 'no-bank', label: 'No Bank' },
            { value: 'no-insurance', label: 'No Insurance' }
          ]"
          :key="tag.value"
          @click="toggleMultiSelectTag(result, 'restrictions', tag.value)"
          :class="['tag-btn', 'restriction-tag', { 'active': hasTagInCategory(result, 'restrictions', tag.value) }]"
        >
          {{ tag.label }}
        </button>
      </div>
    </div>

    <!-- Candidate Type -->
    <div class="tag-group">
      <h4 class="tag-group-title">Type</h4>
      <div class="multi-select-tags">
        <button 
          v-for="tag in [
            { value: 'ex-red-tic', label: 'Ex RED TIC' },
            { value: 'consultant-red-tic', label: 'Consultant RED TIC' }
          ]"
          :key="tag.value"
          @click="toggleMultiSelectTag(result, 'candidate_type', tag.value)"
          :class="['tag-btn', 'type-tag', { 'active': hasTagInCategory(result, 'candidate_type', tag.value) }]"
        >
          {{ tag.label }}
        </button>
      </div>
    </div>

    <!--this if candidate is not in active pipeline -->
<div v-if="!isInActivePipeline(result)" class="tag-group">
  <h4 class="tag-group-title">Final Outcome</h4>
  <div class="single-select-tags">
    <button 
      v-for="tag in ['declined-offer', 'withdrew', 'blacklisted']"
      :key="tag"
      @click="setSingleSelectTag(result, 'final_outcome', tag)"
      :class="['tag-btn', 'outcome-tag', { 'active': hasTagInCategory(result, 'final_outcome', tag) }]"
    >
      {{ tag.replace('-', ' ').replace(/\b\w/g, l => l.toUpperCase()) }}
    </button>
  </div>
</div>
  </div>
</div>
 <!-- loading  -->
<!-- </div> -->

              
 <!-- collapse  -->

</div> <!-- /tags-content-wrapper -->
</transition>
</div> <!-- /candidate-tags-section --> <!-- end of tags groupsed-->


          <!-- Expanded content -->
          <transition name="expand">
            <div v-if="isExpanded(index, 'main')" class="expanded-content">
              <!-- Summary -->
              <div v-if="hasProfessionalSummary(result)" class="section">
                <h4 @click="toggleSection(index, 'summary')" class="collapsible">
                  <i :class="`fas fa-chevron-${isExpanded(index, 'summary') ? 'down' : 'right'}`"></i>
                  Profile 
                </h4>
                <div v-if="isExpanded(index, 'summary')" class="profile-section">
                  <span
                     
                    
                  >
                  {{ result.professional_summary || result.candidate_summary  }}
                  </span>
                </div>
              </div>
            
              <!-- All Skills -->
              <div v-if="hasSkills(result)" class="section">
                <h4 @click="toggleSection(index, 'skills')" class="collapsible">
                  <i :class="`fas fa-chevron-${isExpanded(index, 'skills') ? 'down' : 'right'}`"></i>
                  All Skills ({{ getAllSkills(result).length }})
                </h4>
                <div v-if="isExpanded(index, 'skills')" class="all-skills">
                  <span
                    v-for="(skill, skillIndex) in getAllSkills(result)"
                    :key="skillIndex"
                    class="skill-chip"
                  >
                    {{ skill }}
                  </span>
                </div>
              </div>

              <!-- Responsibilities -->
              <div v-if="hasResponsibilities(result)" class="section">
                <h4 @click="toggleSection(index, 'responsibilities')" class="collapsible">
                  <i :class="`fas fa-chevron-${isExpanded(index, 'responsibilities') ? 'down' : 'right'}`"></i>
                  Key Responsibilities ({{ result.job.responsibilities.length }})
                </h4>
                <ul v-if="isExpanded(index, 'responsibilities')" class="responsibilities">
                  <li v-for="(resp, respIndex) in result.job.responsibilities" :key="respIndex">
                    {{ resp }}
                  </li>
                </ul>
              </div>
<!-- Sourcing Comments Section -->
<div v-if="userRole === 'agent'" class="expandable-section">
  <h4 
    @click="toggleSection(index, 'comments')" 
    :class="['collapsible', { 'disabled': !candidateComments[getCandidateId(result)] }]"
  >
    <i :class="`fas fa-chevron-${isExpanded(index, 'comments') ? 'down' : 'right'}`"></i>
    Sourcing Comments 
    <span v-if="candidateComments[getCandidateId(result)]">
      ({{ candidateComments[getCandidateId(result)].length }})
    </span>
    <span v-else class="loading-indicator">
      <i class="fas fa-spinner fa-spin"></i>
    </span>
  </h4>
  
  <div v-if="isExpanded(index, 'comments')" class="comments-content">
    <!-- Existing comments -->
    <div v-if="candidateComments[getCandidateId(result)]?.length" class="comments-list">
      <div v-for="comment in candidateComments[getCandidateId(result)]" 
      :key="comment.created_at" 
      :class="['comment-item', { 'new-comment': comment.isNew }]">
              <div class="comment-header">

        <button 
        @click="deleteComment(comment.id)" 
        class="delete-x"
        :disabled="deletingCommentId === comment.id"
        title="Delete comment"
      >
        ×
      </button>
    </div>

        <div class="comment-contentt">{{ comment.comment }}</div>
        <div class="comment-meta">
          {{ formatCommentDate(comment.created_at) }} by {{ comment.agent }}
          <span v-if="comment.project_name" class="project-context"> • Project: {{ comment.project_name }}</span>
          <span v-else-if="comment.project_id" class="project-context"> • Project ID: {{ comment.project_id }}</span>
        </div>         
      </div>
    </div>
    
    <!--new comment -->
    <div class="add-comment-section">
      <textarea 
        v-model="newComment[getCandidateId(result)]"
        placeholder="Add a sourcing comment..."
        class="comment-textarea"
        rows="3"
      ></textarea>
      <button 
        @click="addComment(result)"
        :disabled="!newComment[getCandidateId(result)]?.trim()"
        class="add-comment-btn"
      >
        Add Comment
      </button>
    </div>
  </div>
</div>
              <!-- AI Insights (if available) -->
              <div v-if="result.ai_insights" class="section ai-insights">
                <h4><i class="fas fa-robot"></i> AI Analysis</h4>
                <div class="insight-content">
                  <div v-if="result.ai_insights.strengths" class="insight-item">
                    <strong>Strengths:</strong>
                    <p>{{ result.ai_insights.strengths }}</p>
                  </div>
                  
                  <div v-if="result.ai_insights.fit_score" class="insight-item">
                    <strong>Fit Score:</strong>
                    <div class="fit-score-bar">
                      <div 
                        class="fit-score-fill" 
                        :style="{width: `${result.ai_insights.fit_score}%`}"
                      ></div>
                    </div>
                    <span>{{ result.ai_insights.fit_score }}%</span>
                  </div>
                </div>
              </div>

              <!-- Semantic matches (if available) -->
              <div v-if="result.matches && result.matches.length > 0" class="section matches">
                <h4>Relevant Matches</h4>
                <div
                  v-for="(match, matchIndex) in result.matches.slice(0, 3)"
                  :key="matchIndex"
                  class="match-item"
                >
                  <p class="match-text">{{ match.text }}</p>
                  <span class="match-score">{{ Math.round(match.score * 100) }}% relevant</span>
                </div>
              </div>
            </div>
          </transition>

          <div class="semantic-matches" v-if="result.semantic_matches">
            <div class="section-header">
              <h3 class="semantic-matches-title">
                <i class="fas fa-brain"></i>
                Semantic Matches
              </h3>
            </div>
            
            <!-- Summaries Section -->
            <div class="match-category" v-if="result.semantic_matches.summaries && result.semantic_matches.summaries.length">
              <div class="match-type-heading">
                <i class="fas fa-file-alt"></i>
                Summary Matches
              </div>
              
              <!-- Always show the top match -->
              <div class="match-item" v-if="getTopMatch(result.semantic_matches.summaries)">
                <div class="match-text">{{ getTopMatch(result.semantic_matches.summaries).text }}</div>
                <div class="match-meta">
                  <span class="match-score">{{ formatScore(getTopMatch(result.semantic_matches.summaries).score) }}</span>
                  <span class="match-type" v-if="getTopMatch(result.semantic_matches.summaries).type">
                    {{ getTopMatch(result.semantic_matches.summaries).type }}
                  </span>
                </div>
              </div>
              
              <!-- Show remaining matches if expanded -->
              <div v-if="isMatchSectionExpanded(index, 'summaries')">
                <div class="match-item" v-for="(match, matchIndex) in getRemainingMatches(result.semantic_matches.summaries)" :key="matchIndex">
                  <div class="match-text">{{ match.text }}</div>
                  <div class="match-meta">
                    <span class="match-score">{{ formatScore(match.score) }}</span>
                    <span class="match-type" v-if="match.type">{{ match.type }}</span>
                  </div>
                </div>
              </div>
              
              <!-- Toggle button only if there are more matches -->
              <button 
                v-if="hasMoreThanOneMatch(result.semantic_matches.summaries)" 
                @click="toggleMatchSection(index, 'summaries')" 
                class="toggle-matches-btn"
              >
                <i class="fas" :class="isMatchSectionExpanded(index, 'summaries') ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                {{ isMatchSectionExpanded(index, 'summaries') ? 'Show less' : 'Show more' }}
              </button>
            </div>
            
            <!-- Job Titles Section -->
            <div class="match-category" v-if="result.semantic_matches.job_titles && result.semantic_matches.job_titles.length">
              <div class="match-type-heading">
                <i class="fas fa-briefcase"></i>
                Job Title Matches
              </div>
              
              <!-- Always show the top match -->
              <div class="match-item" v-if="getTopMatch(result.semantic_matches.job_titles)">
                <div class="match-text">{{ getTopMatch(result.semantic_matches.job_titles).text }}</div>
                <div class="match-meta">
                  <span class="match-score">{{ formatScore(getTopMatch(result.semantic_matches.job_titles).score) }}</span>
                  <span class="match-context" v-if="getTopMatch(result.semantic_matches.job_titles).company">
                    at {{ getTopMatch(result.semantic_matches.job_titles).company }}
                  </span>
                </div>
              </div>
              
              <!-- Show remaining matches if expanded -->
              <div v-if="isMatchSectionExpanded(index, 'job_titles')">
                <div class="match-item" v-for="(match, matchIndex) in getRemainingMatches(result.semantic_matches.job_titles)" :key="matchIndex">
                  <div class="match-text">{{ match.text }}</div>
                  <div class="match-meta">
                    <span class="match-score">{{ formatScore(match.score) }}</span>
                    <span class="match-context" v-if="match.company">at {{ match.company }}</span>
                  </div>
                </div>
              </div>
              
              <!-- Toggle button only if there are more matches -->
              <button 
                v-if="hasMoreThanOneMatch(result.semantic_matches.job_titles)" 
                @click="toggleMatchSection(index, 'job_titles')" 
                class="toggle-matches-btn"
              >
                <i class="fas" :class="isMatchSectionExpanded(index, 'job_titles') ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                {{ isMatchSectionExpanded(index, 'job_titles') ? 'Show less' : 'Show more' }}
              </button>
            </div>
            
            <!-- Responsibilities Section -->
            <div class="match-category" v-if="result.semantic_matches.responsibilities && result.semantic_matches.responsibilities.length">
              <div class="match-type-heading">
                <i class="fas fa-tasks"></i>
                Job Responsibilities Matches
              </div>
              
              <!-- Always show the top match -->
              <div class="match-item" v-if="getTopMatch(result.semantic_matches.responsibilities)">
                <div class="match-text">
                  <span v-if="getTopMatch(result.semantic_matches.responsibilities).text">
                    {{ getTopMatch(result.semantic_matches.responsibilities).text }}
                  </span>
                  <span v-else class="responsibility-id">
                    ID: {{ getTopMatch(result.semantic_matches.responsibilities).id }}
                  </span>
                </div>
                <div class="match-meta">
                  <span class="match-score">{{ formatScore(getTopMatch(result.semantic_matches.responsibilities).score) }}</span>
                  <span class="match-context" v-if="getTopMatch(result.semantic_matches.responsibilities).job_title">
                    {{ getTopMatch(result.semantic_matches.responsibilities).job_title }}
                    <span v-if="getTopMatch(result.semantic_matches.responsibilities).company">
                      at {{ getTopMatch(result.semantic_matches.responsibilities).company }}
                    </span>
                  </span>
                </div>
              </div>
              
              <!-- Show remaining matches if expanded -->
              <div v-if="isMatchSectionExpanded(index, 'responsibilities')">
                <div class="match-item" v-for="(match, matchIndex) in getRemainingMatches(result.semantic_matches.responsibilities)" :key="matchIndex">
                  <div class="match-text">
                    <span v-if="match.text">{{ match.text }}</span>
                    <span v-else class="responsibility-id">ID: {{ match.id }}</span>
                  </div>
                  <div class="match-meta">
                    <span class="match-score">{{ formatScore(match.score) }}</span>
                    <span class="match-context" v-if="match.job_title">
                      {{ match.job_title }}
                      <span v-if="match.company"> at {{ match.company }}</span>
                    </span>
                  </div>
                </div>
              </div>
              
              <!-- Toggle button only if there are more matches -->
              <button 
                v-if="hasMoreThanOneMatch(result.semantic_matches.responsibilities)" 
                @click="toggleMatchSection(index, 'responsibilities')" 
                class="toggle-matches-btn"
              >
                <i class="fas" :class="isMatchSectionExpanded(index, 'responsibilities') ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                {{ isMatchSectionExpanded(index, 'responsibilities') ? 'Show less' : 'Show more' }}
              </button>
            </div>
            
            <!-- Skills Section -->
            <div class="match-category" v-if="result.semantic_matches.skills && result.semantic_matches.skills.length">
              <div class="match-type-heading">
                <i class="fas fa-tools"></i>
                Skills Matches
              </div>
              
              <!-- Always show the top match -->
              <div class="match-item" v-if="getTopMatch(result.semantic_matches.skills)">
                <div class="match-text">{{ getTopMatch(result.semantic_matches.skills).text }}</div>
                <div class="match-meta">
                  <span class="match-score">{{ formatScore(getTopMatch(result.semantic_matches.skills).score) }}</span>
                </div>
              </div>
              
              <!-- Show remaining matches if expanded -->
              <div v-if="isMatchSectionExpanded(index, 'skills')">
                <div class="match-item" v-for="(match, matchIndex) in getRemainingMatches(result.semantic_matches.skills)" :key="matchIndex">
                  <div class="match-text">{{ match.text }}</div>
                  <div class="match-meta">
                    <span class="match-score">{{ formatScore(match.score) }}</span>
                  </div>
                </div>
              </div>
              
              <!-- Toggle button only if there are more matches -->
              <button 
                v-if="hasMoreThanOneMatch(result.semantic_matches.skills)" 
                @click="toggleMatchSection(index, 'skills')" 
                class="toggle-matches-btn"
              >
                <i class="fas" :class="isMatchSectionExpanded(index, 'skills') ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                {{ isMatchSectionExpanded(index, 'skills') ? 'Show less' : 'Show more' }}
              </button>
            </div>
          </div>

        </div>
      </div>
           
      <!-- Pagination -->
      <div v-if="totalPages > 1 && !isLoading" class="pagination">
        <button
          class="page-btn"
          @click="previousPage"
          :disabled="currentPage === 1"
        >
          <i class="fas fa-chevron-left"></i>
        </button>
        
        <div class="page-numbers">
          <button
            v-for="page in visiblePages"
            :key="page"
            class="page-btn"
            :class="{ active: page === currentPage }"
            @click="goToPage(page)"
          >
            {{ page }}
          </button>
        </div>
        
        <button
          class="page-btn"
          @click="nextPage"
          :disabled="currentPage === totalPages"
        >
          <i class="fas fa-chevron-right"></i>
        </button>
      </div>

      
    </div>
  
   <!-- Batch add floating bar -->
   <transition name="float-bar">
    <div v-if="selectMode && selectedCandidates.size > 0" class="batch-float-bar">
      <span class="batch-count">{{ selectedCandidates.size }} candidat{{ selectedCandidates.size > 1 ? 's' : '' }}</span>
      <button @click="selectAllVisible" class="batch-btn batch-select-all">
        <i class="fas fa-check-double"></i> Tout sélect.
      </button>
      <button @click="openBatchBoardPicker" class="batch-btn batch-add-board">
        <i class="fas fa-columns"></i> Ajouter au board
      </button>
      <button @click="clearSelection" class="batch-btn batch-cancel">
        <i class="fas fa-times"></i>
      </button>

      <!-- Board picker dropdown -->
      <div v-if="showBoardPicker" class="batch-board-picker" @click.stop>
        <div v-if="!boardPickerBoards.length" class="bbp-loading"><i class="fas fa-spinner fa-spin"></i></div>
        <button v-for="b in boardPickerBoards" :key="b.id" class="bbp-option" @click="batchAddToBoard(b.id)">
          <span class="bbp-dot" :style="{ background: b.color || '#93c5fd' }"></span>
          {{ b.label }}
        </button>
      </div>
    </div>
  </transition> 

  
  </div>

  <!--a download status notification -->
<div v-if="downloadStatus.show" class="download-notification" :class="downloadStatus.type">
  <i :class="downloadStatus.icon"></i>
  <span>{{ downloadStatus.message }}</span>
  <button @click="downloadStatus.show = false" class="close-notification">
    <i class="fas fa-times"></i>
  </button>
</div>

<ResumeDetailView
  :show="showDetailView"
  :resumeData="selectedResume"
  @close="closeDetailView"
/>

<!-- SCREENING REPORT MODAL (for agents) -->
<!-- ===== STEP 8: FIX REPORT SELECTION MODAL ISSUES ===== -->
<!--this enhanced section to the top of your screening modal body: -->
<!-- TECH INTERVIEW PROPOSE MODAL (HR agent proposes to tech agent) -->
<div v-if="showTechProposeModal" class="modal-overlay" @click="showTechProposeModal = false">
  <div class="modal-content interview-schedule-modal" @click.stop>
    <div class="modal-header">
      <h3><i class="fas fa-laptop-code"></i> Proposer des créneaux — Entretien Technique</h3>
      <button @click="showTechProposeModal = false" class="close-btn">&times;</button>
    </div>
    <div class="modal-body">
      <p class="modal-hint">Proposez jusqu'à 3 créneaux. Le tech agent confirmera l'un d'eux.</p>
      <div v-for="(slot, idx) in techInterviewForm.proposed_dates" :key="idx" class="form-group date-slot">
        <label>
          Option {{ idx + 1 }}
          <span v-if="idx > 0" class="remove-date" @click="techInterviewForm.proposed_dates.splice(idx, 1)">✕ supprimer</span>
        </label>
        <input type="datetime-local" v-model="techInterviewForm.proposed_dates[idx]" class="form-input" />
      </div>
      <button v-if="techInterviewForm.proposed_dates.length < 3" type="button" class="btn-add-date" @click="techInterviewForm.proposed_dates.push('')">
        <i class="fas fa-plus"></i> Ajouter un créneau
      </button>
      <div class="form-group" style="margin-top:14px">
        <label>Notes (optionnel)</label>
        <textarea v-model="techInterviewForm.notes" class="form-input" rows="2" placeholder="Format, sujets à couvrir..."></textarea>
      </div>
    </div>
    <div class="modal-footer">
      <button @click="submitTechProposeInterview" class="btn btn-primary" :disabled="!techInterviewForm.proposed_dates.filter(d=>d).length">
        <i class="fas fa-paper-plane"></i> Envoyer au tech agent
      </button>
    </div>
  </div>
</div>

<!-- TECH INTERVIEW CONFIRM MODAL (tech agent confirms) -->
<div v-if="showTechConfirmModal" class="modal-overlay" @click="showTechConfirmModal = false">
  <div class="modal-content interview-schedule-modal" @click.stop>
    <div class="modal-header">
      <h3><i class="fas fa-calendar-check"></i> Confirmer votre date d'entretien technique</h3>
      <button @click="showTechConfirmModal = false" class="close-btn">&times;</button>
    </div>
    <div class="modal-body">
      <p class="modal-hint">Sélectionnez la date qui vous convient :</p>
      <div v-for="(date, idx) in techConfirmDates" :key="idx"
           :class="['date-option', { selected: techConfirmSelectedDate === date }]"
           @click="techConfirmSelectedDate = date">
        <i class="fas fa-calendar"></i> {{ formatDate(date) }}
        <i v-if="techConfirmSelectedDate === date" class="fas fa-check-circle" style="color:#68d391;float:right"></i>
      </div>
    </div>
    <div class="modal-footer">
      <button @click="submitTechConfirmInterview" class="btn btn-primary" :disabled="!techConfirmSelectedDate">
        <i class="fas fa-check"></i> Confirmer
      </button>
    </div>
  </div>
</div>

<!-- PROPOSE INTERVIEW MODAL (client proposes multiple dates) -->
<div v-if="showInterviewModal" class="modal-overlay" @click="showInterviewModal = false">
  <div class="modal-content interview-schedule-modal" @click.stop>
    <div class="modal-header">
      <h3><i class="fas fa-calendar-plus"></i> Proposer des dates d'entretien</h3>
      <button @click="showInterviewModal = false" class="close-btn">&times;</button>
    </div>
    <div class="modal-body">
      <p class="modal-hint">Proposez jusqu'à 10 créneaux. Notre équipe RH contactera le candidat et confirmera l'un d'eux.</p>
      <div v-for="(slot, idx) in interviewForm.proposed_dates" :key="idx" class="form-group date-slot">
        <label>
          Option {{ idx + 1 }}
          <span v-if="idx > 0" class="remove-date" @click="interviewForm.proposed_dates.splice(idx, 1)">✕ supprimer</span>
        </label>
        <input type="datetime-local" v-model="interviewForm.proposed_dates[idx]" class="form-input" />
      </div>
      <button
        v-if="interviewForm.proposed_dates.length < 10"
        type="button"
        class="btn-add-date"
        @click="interviewForm.proposed_dates.push('')"
      >
        <i class="fas fa-plus"></i> Ajouter un créneau
      </button>
      <div class="form-group" style="margin-top:14px">
        <label>Notes (optionnel)</label>
        <textarea v-model="interviewForm.notes" class="form-input" rows="2" placeholder="Lieu, format, instructions..."></textarea>
      </div>
    </div>
    <div class="modal-footer">
      <button
        @click="submitProposeInterview"
        class="btn btn-primary"
        :disabled="!interviewForm.proposed_dates.filter(d => d).length"
      >
        <i class="fas fa-paper-plane"></i> Envoyer à l'équipe RH
      </button>
    </div>
  </div>
</div>

<!-- AGENT CONFIRM DATE MODAL -->
<div v-if="showConfirmInterviewModal" class="modal-overlay" @click="showConfirmInterviewModal = false">
  <div class="modal-content interview-schedule-modal" @click.stop>
    <div class="modal-header">
      <h3><i class="fas fa-calendar-check"></i> Confirmer la date d'entretien</h3>
      <button @click="showConfirmInterviewModal = false" class="close-btn">&times;</button>
    </div>
    <div class="modal-body">
      <p class="modal-hint blackk">Sélectionnez la date confirmée avec le candidat :</p>
      <div
        v-for="(date, idx) in confirmInterviewDates"
        :key="idx"
        :class="['date-option', { selected: confirmSelectedDate === date }]"
        @click="confirmSelectedDate = date"
      >
        <i class="fas fa-calendar"></i>
        {{ formatDate(date) }}
        <i v-if="confirmSelectedDate === date" class="fas fa-check-circle" style="color:#68d391;float:right"></i>
      </div>
    </div>
    <div class="modal-footer">
      <button
        @click="submitConfirmInterview"
        class="btn btn-primary"
        :disabled="!confirmSelectedDate"
      >
        <i class="fas fa-check"></i> Confirmer & Notifier le client
      </button>
    </div>
  </div>
</div>
<!-- Enhanced Screening Modal with Report Selection -->
<div v-if="showScreeningModal" class="modal-overlay" @click="closeScreeningModal">
  <div class="modal-content screening-modal enhanced" @click.stop>
    <div v-if="loadingReport" class="modal-loading-overlay">
      <i class="fas fa-spinner fa-spin"></i>
    </div>
    <div class="modal-header">
      <h3><i class="fas fa-clipboard-check"></i> Screening Report</h3>
      <button @click="closeScreeningModal" class="close-btn">&times;</button>
    </div>
    
    <div class="modal-body">
      
      <!-- REPORT SELECTION SECTION (at top) -->
    
<!-- SCREENING STATUS BANNER -->
<div v-if="hrEditMode" class="screening-status-banner edit-mode">
  <i class="fas fa-edit"></i>
  Editing your HR section — changes will update the existing report
</div>
<div v-else-if="screeningStep === 'tech'" class="screening-status-banner tech-mode">
  <i class="fas fa-flask"></i>
  HR section complete — fill in your technical assessment below
</div>


      <!-- FORM SECTION (existing form) -->
      <div class="report-form-section">
        <div class="form-header" v-if="getCandidateReportOptions().length > 0">
          <h4>
            <i class="fas fa-edit"></i>
            {{ getFormTitle() }}
          </h4>
        </div>
        <!-- STEP INDICATOR (only shown for new modular reports) -->
<div v-if="screeningTemplate" class="screening-steps">
  <div class="step" :class="{ active: screeningStep === 'hr', done: screeningStep === 'tech' }">
    <i class="fas fa-user-tie"></i> HR Screening
  </div>
  <div class="step-arrow"><i class="fas fa-chevron-right"></i></div>
  <div class="step" :class="{ active: screeningStep === 'tech' }">
    <i class="fas fa-laptop-code"></i> Technical Interview
  </div>
</div>

<!-- DYNAMIC FORM (modular template) -->
<div v-if="screeningTemplate">
  <form @submit.prevent="screeningStep === 'hr' ? submitHRSection() : submitTechSection()">

    <!-- HR fields -->
<div v-if="screeningStep === 'hr'">
  <div v-for="field in screeningTemplate.hr_fields" :key="field.key" class="form-group">
    <label class="field-label-with-toggle">
      {{ field.label }}
      <button type="button"
        :class="['client-visibility-toggle', clientVisibleFields.includes(field.key) ? 'visible' : 'hidden']"
        @click="clientVisibleFields.includes(field.key)
          ? clientVisibleFields.splice(clientVisibleFields.indexOf(field.key), 1)
          : clientVisibleFields.push(field.key)"
        :title="clientVisibleFields.includes(field.key) ? 'Visible to client — click to hide' : 'Hidden from client — click to show'">
        <i :class="clientVisibleFields.includes(field.key) ? 'fas fa-eye' : 'fas fa-eye-slash'"></i>
      </button>
    </label>
    <textarea v-if="field.type === 'textarea'" v-model="hrFormData[field.key]" rows="3"></textarea>
    <input v-else-if="field.type === 'text'" type="text" v-model="hrFormData[field.key]" />
    <select v-else-if="field.type === 'select'" v-model="hrFormData[field.key]">
      <option value="">Select...</option>
      <option v-for="opt in field.options" :key="opt" :value="opt">{{ opt }}</option>
    </select>
    <div v-else-if="field.type === 'score'" class="score-input">
      <button v-for="n in (field.max || 5)" :key="n" type="button"
        class="score-pip" :class="{ active: hrFormData[field.key] >= n }"
        @click="hrFormData[field.key] = n">{{ n }}</button>
    </div>
  </div>
</div>

<!-- Tech fields -->
<div v-else>
  <!-- HR summary readonly -->
  <!-- <div v-if="Object.keys(hrFormData).length" class="hr-summary-readonly">
    <div class="section-header"><i class="fas fa-lock"></i> HR Section (read-only)</div>
    <div v-for="field in screeningTemplate.hr_fields" :key="field.key" class="readonly-field">
      <span class="field-label">{{ field.label }}:</span>
      <span class="field-value">{{ hrFormData[field.key] || '—' }}</span>
    </div>
  </div> -->

  <div v-for="field in screeningTemplate.tech_fields" :key="field.key" class="form-group">
    <label class="field-label-with-toggle">
      {{ field.label }}
      <button type="button"
        :class="['client-visibility-toggle', clientVisibleFields.includes(field.key) ? 'visible' : 'hidden']"
        @click="clientVisibleFields.includes(field.key)
          ? clientVisibleFields.splice(clientVisibleFields.indexOf(field.key), 1)
          : clientVisibleFields.push(field.key)"
        :title="clientVisibleFields.includes(field.key) ? 'Visible to client — click to hide' : 'Hidden from client — click to show'">
        <i :class="clientVisibleFields.includes(field.key) ? 'fas fa-eye' : 'fas fa-eye-slash'"></i>
      </button>
    </label>
    <textarea v-if="field.type === 'textarea'" v-model="techFormData[field.key]" rows="3"></textarea>
    <input v-else-if="field.type === 'text'" type="text" v-model="techFormData[field.key]" />
    <select v-else-if="field.type === 'select'" v-model="techFormData[field.key]">
      <option value="">Select...</option>
      <option v-for="opt in field.options" :key="opt" :value="opt">{{ opt }}</option>
    </select>
    <div v-else-if="field.type === 'score'" class="score-input">
      <button v-for="n in (field.max || 5)" :key="n" type="button"
        class="score-pip" :class="{ active: techFormData[field.key] >= n }"
        @click="techFormData[field.key] = n">{{ n }}</button>
    </div>
  </div>
</div> 

    <!-- HR: read-only view when on tech step -->
    <!-- HR: toggleable section when on tech step -->
<div v-if="screeningStep === 'tech' && Object.keys(hrFormData).length" class="hr-summary-readonly">
  <div class="section-header">
    <span><i :class="hrEditableByTech ? 'fas fa-unlock' : 'fas fa-lock'"></i> HR Section</span>
    <button type="button" class="btn-link" @click="hrEditableByTech = !hrEditableByTech">
      {{ hrEditableByTech ? '🔒 Lock HR' : '✏️ Edit HR Notes' }}
    </button>
  </div>

  <!-- Readonly mode -->
  <div v-if="!hrEditableByTech">
    <div v-for="field in screeningTemplate.hr_fields" :key="field.key" class="readonly-field">
      <span class="field-label">{{ field.label }}:</span>
      <span class="field-value">{{ hrFormData[field.key] || '—' }}</span>
    </div>
  </div>

  <!-- Editable mode -->
  <div v-else>
    <div v-for="field in screeningTemplate.hr_fields" :key="field.key" class="form-group">
      <label class="field-label-with-toggle">
        {{ field.label }}
        <button type="button"
          :class="['client-visibility-toggle', clientVisibleFields.includes(field.key) ? 'visible' : 'hidden']"
          @click="clientVisibleFields.includes(field.key)
            ? clientVisibleFields.splice(clientVisibleFields.indexOf(field.key), 1)
            : clientVisibleFields.push(field.key)"
          :title="clientVisibleFields.includes(field.key) ? 'Visible to client — click to hide' : 'Hidden from client — click to show'">
          <i :class="clientVisibleFields.includes(field.key) ? 'fas fa-eye' : 'fas fa-eye-slash'"></i>
        </button>
      </label>
      <input v-if="field.type === 'text'" v-model="hrFormData[field.key]" type="text" class="form-control" />
      <textarea v-else-if="field.type === 'textarea'" v-model="hrFormData[field.key]" class="form-control" rows="3"></textarea>
      <select v-else-if="field.type === 'select'" v-model="hrFormData[field.key]" class="form-control">
        <option value="">Sélectionner...</option>
        <option v-for="opt in field.options" :key="opt" :value="opt">{{ opt }}</option>
      </select>
      <div v-else-if="field.type === 'score'" class="score-input">
        <button v-for="n in field.max" :key="n" type="button"
          :class="['score-btn', { active: hrFormData[field.key] >= n }]"
          @click="hrFormData[field.key] = n">{{ n }}</button>
      </div>
    </div>
  </div>
</div>

    <div v-if="formStatus" class="form-status" :class="formStatus.type">
      <i :class="formStatus.icon"></i> {{ formStatus.message }}
    </div>

    <div class="modal-actions">
      <button v-if="screeningStep === 'hr'" type="button" @click="saveDraftReport" class="btn-secondary">
        <i class="fas fa-save"></i> Save Draft
      </button>
      <!-- Tech agent picker — only shown on HR step -->
<div v-if="screeningStep === 'hr' && projectAgents.length > 0" class="form-group">
  <label><i class="fas fa-user-check"></i> Assign Technical Interviewer *</label>
  <select v-model="selectedTechAgent" required>
    <option value="">Select tech agent...</option>
    <option v-for="agent in projectAgents" :key="agent.agent_id" :value="agent.agent_id">
      {{ agent.name }}
    </option>
  </select>
</div>
      <button type="submit" class="btn-primary" :disabled="loadingReport">
        <i class="fas fa-spinner fa-spin" v-if="loadingReport"></i>
        <i class="fas fa-check" v-else></i>
        {{ screeningStep === 'hr' ? 'Submit HR & Notify Tech Agent' : 'Complete Screening & Notify Client' }}
      </button>
    </div>
  </form>
</div>

<!-- FALLBACK: old hardcoded form if no template loaded -->
<div v-else>
        <form @submit.prevent="saveScreeningReport">
          
          <!-- Summary -->
          <div class="form-group">
            <label>Summary *</label>
            <textarea 
              v-model="screeningForm.summary" 
              placeholder="Brief summary of candidate evaluation..."
              rows="3"
              required
            ></textarea>
          </div>
          
          <!-- Availability & Rate -->
          <div class="form-row">
            <div class="form-group">
              <label>Availability *</label>
              <select v-model="screeningForm.availability" required>
                <option value="">Select availability</option>
                <option value="immediate">Immediate</option>
                <option value="30">Within 30 days</option>
                <option value="60+">60+ days</option>
              </select>
            </div>
            
            <div class="form-group">
              <label>Expected Rate *</label>
              <input 
                v-model="screeningForm.expected_rate" 
                type="text" 
                placeholder="e.g., $85/hour or $120k/year"
                required
              />
            </div>
          </div>
          
          <!-- Key Checks -->
          <div class="form-group">
            <label>Verification Checks (Set by Client)</label>
            <div class="checkboxes-group">
              <div class="checkbox-item">
                <input 
                  type="checkbox" 
                  id="skills_verified" 
                  v-model="screeningForm.key_checks.skills_verified"
                />
                <label for="skills_verified">Skills Verified</label>
              </div>
              <div class="checkbox-item">
                <input 
                  type="checkbox" 
                  id="references_contacted" 
                  v-model="screeningForm.key_checks.references_contacted"
                />
                <label for="references_contacted">References Contacted</label>
              </div>
              <div class="checkbox-item">
                <input 
                  type="checkbox" 
                  id="background_clear" 
                  v-model="screeningForm.key_checks.background_clear"
                />
                <label for="background_clear">Background Clear</label>
              </div>
            </div>
          </div>
          
          <!-- Recommendation -->
          <div class="form-group">
            <label>Recommendation *</label>
            <select v-model="screeningForm.recommendation" required>
              <option value="">Select recommendation</option>
              <option value="pass">Pass - Recommend for hire</option>
              <option value="consider">Consider - Has potential</option>
              <option value="reject">Reject - Not suitable</option>
            </select>
          </div>
          
          <!-- Notes -->
          <div class="form-group">
            <label>Additional Notes</label>
            <textarea 
              v-model="screeningForm.notes" 
              placeholder="Detailed notes about the candidate..."
              rows="4"
            ></textarea>
          </div>
          
          <!-- Form Status Display -->
          <div v-if="formStatus" class="form-status" :class="formStatus.type">
            <i :class="formStatus.icon"></i>
            <span>{{ formStatus.message }}</span>
          </div>
          
          <!-- Modal Actions -->
          <div class="modal-actions">
            <button type="button" @click="saveDraftReport" class="btn-secondary">
              <i class="fas fa-save"></i> 
              {{ currentReportId ? 'Update Draft' : 'Save Draft' }}
            </button>
            <button type="submit" class="btn-primary">
              <i class="fas fa-check"></i> 
              Complete & Submit Report
            </button>
          </div>
        </form>

      </div>

      </div>
    </div>
  </div>
</div>

<!-- EXISTING REPORTS MODAL -->
<div v-if="showExistingModal" class="modal-overlay" @click="closeExistingModal">
  <div class="modal-content existing-reports-modal" @click.stop>
    <div class="modal-header">
      <h3><i class="fas fa-history"></i> Previous Screening Reports</h3>
      <button @click="closeExistingModal" class="close-btn">&times;</button>
    </div>
    
    <div class="modal-body">
      <div v-if="existingReports.length === 0" class="no-reports">
        <i class="fas fa-file-alt"></i>
        <p>No previous reports found for this candidate</p>
      </div>
      
      <div v-else class="reports-list">
        <div 
          v-for="report in existingReports" 
          :key="report.id"
          class="report-item"
          @click="useExistingReport(report)"
        >
          <div class="report-header">
            <div class="report-project">{{ report.project_name }}</div>
            <div class="report-date">{{ formatDate(report.completed_at) }}</div>
          </div>
          <div class="report-summary">{{ report.report_data.summary }}</div>
          <div class="report-recommendation">
            <span :class="['rec-badge', 'rec-' + report.report_data.recommendation]">
              {{ report.report_data.recommendation }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- CLIENT REPORT VIEW MODAL -->
<!-- ===== ADD: Enhanced Client Report Modal ===== -->
<!-- UPDATE your existing client report modal with this enhanced version: -->

<!-- CLIENT REPORT VIEW MODAL -->
<div v-if="showClientReportModal" class="modal-overlay" @click="closeClientReportModal">
  <div class="modal-content client-report-modal enhanced" @click.stop>
    <div class="modal-header">
      <h3><i class="fas fa-clipboard-check"></i> Rapport de Screening</h3>
      <button @click="closeClientReportModal" class="close-btn">&times;</button>
    </div>
    <div class="modal-body" v-if="clientReport">

      <!-- LEGACY FORMAT -->
      <template v-if="!clientReport.report_data.hr_section && clientReport.report_data.summary !== undefined">
        <div class="legacy-report-banner"><i class="fas fa-archive"></i> Ancien format de rapport</div>
        <div class="client-report-top" v-if="clientReport.report_data.recommendation">
          <div :class="['recommendation-badge-large', 'rec-' + recToClass(clientReport.report_data.recommendation)]">
            <i class="fas fa-clipboard-check"></i> {{ clientReport.report_data.recommendation }}
          </div>
        </div>
        <div class="report-grid">
          <div class="grid-item" v-if="clientReport.report_data.availability">
            <div class="item-header"><i class="fas fa-clock"></i><label>Disponibilité</label></div>
            <div class="item-value">{{ clientReport.report_data.availability }} jours</div>
          </div>
          <div class="grid-item" v-if="clientReport.report_data.expected_rate">
            <div class="item-header"><i class="fas fa-tag"></i><label>Taux attendu</label></div>
            <div class="item-value">{{ clientReport.report_data.expected_rate }}</div>
          </div>
        </div>
        <div class="report-section" v-if="clientReport.report_data.summary">
          <h4><i class="fas fa-file-alt"></i> Résumé</h4>
          <pre class="legacy-summary">{{ clientReport.report_data.summary }}</pre>
        </div>
        <div class="report-section" v-if="clientReport.report_data.notes">
          <h4><i class="fas fa-sticky-note"></i> Notes</h4>
          <p class="legacy-notes">{{ clientReport.report_data.notes }}</p>
        </div>
      </template>

      <!-- NEW FORMAT -->
      <template v-else-if="clientReport.report_data.hr_section">

        <!-- HIGHLIGHTS STRIP — only fields in client_visible_fields, no duplicates below -->
        <div class="report-highlights">
          <template v-for="key in ['last_employer','annees_experience','tjm_propose','disponibilite']" :key="key">
            <div class="highlight-chip"
                 v-if="clientReport.report_data.hr_section[key] &&
                       (!clientReport.report_data.client_visible_fields || clientReport.report_data.client_visible_fields.includes(key))">
              <span class="chip-label">{{ highlightLabel(key) }}</span>
              <span class="chip-value">{{ clientReport.report_data.hr_section[key] }}</span>
            </div>
          </template>
          <!-- Presentation score chip -->
          <div class="highlight-chip score-chip"
               v-if="clientReport.report_data.hr_section.presentation_client &&
                     (!clientReport.report_data.client_visible_fields || clientReport.report_data.client_visible_fields.includes('presentation_client'))">
            <span class="chip-label">Présentation client</span>
            <span class="chip-score">
              <span v-for="n in 5" :key="n" class="score-pip-display"
                    :class="{ active: clientReport.report_data.hr_section.presentation_client >= n }">{{ n }}</span>
            </span>
          </div>
          <!-- Certificates as tags -->
          <div class="highlight-chip certs-chip"
               v-if="clientReport.report_data.hr_section.certificats &&
                     (!clientReport.report_data.client_visible_fields || clientReport.report_data.client_visible_fields.includes('certificats'))">
            <span class="chip-label"><i class="fas fa-certificate"></i> Certifications (cert1, cert2, cert3)</span>
            <div class="cert-tags">
              <span v-for="cert in clientReport.report_data.hr_section.certificats.split(/[,\n]+/).map(c => c.trim()).filter(Boolean)"
                    :key="cert" class="cert-tag">{{ cert }}</span>
            </div>
          </div>
        </div>
 
        <!-- HR SECTION -->
        <div class="report-section-block">
          <div class="section-block-header hr-header">
            <div class="section-block-title">
              <i class="fas fa-user-tie"></i>
              <span>Évaluation RH</span>
            </div>
            <div v-if="clientReport.report_data.hr_section.recommandation_hr"
                 :class="['section-rec-pill', 'rec-' + recToClass(clientReport.report_data.hr_section.recommandation_hr)]">
              {{ clientReport.report_data.hr_section.recommandation_hr }}
            </div>
          </div>

          <div class="modular-fields-grid" v-if="clientReportTemplate?.hr_fields">
            <template v-for="field in clientReportTemplate.hr_fields" :key="field.key">
              <!-- Skip highlight keys (already shown above) and recommendation (in header) -->
              <div :class="[
                'modular-field-item',
                { 'modular-field-item--full': field.key === 'notes_generales_hr' }
              ]"  
                   v-if="!['last_employer','annees_experience','tjm_propose','disponibilite','presentation_client','certificats','recommandation_hr'].includes(field.key)
                         && clientReport.report_data.hr_section[field.key] !== undefined
                         && clientReport.report_data.hr_section[field.key] !== ''
                         && (!clientReport.report_data.client_visible_fields || clientReport.report_data.client_visible_fields.includes(field.key))">
                <div class="field-label-client">{{ field.label }}</div>
                <div class="field-value-client">
                  <span v-if="field.type === 'score'" class="score-display">
                    <span v-for="n in (field.max || 5)" :key="n" class="score-pip-display"
                          :class="{ active: clientReport.report_data.hr_section[field.key] >= n }">{{ n }}</span>
                  </span>
                  <span v-else>{{ clientReport.report_data.hr_section[field.key] }}</span>
                </div>
              </div>
            </template>
          </div>
        </div>

        <!-- TECH SECTION -->
        <div class="report-section-block" v-if="clientReport.report_data.tech_section">
          <div class="section-block-header tech-header">
            <div class="section-block-title">
              <i class="fas fa-laptop-code"></i>
              <span>Évaluation Technique</span>
            </div>
            <div v-if="clientReport.report_data.tech_section.recommandation_tech"
                 :class="['section-rec-pill', 'rec-' + recToClass(clientReport.report_data.tech_section.recommandation_tech)]">
              {{ clientReport.report_data.tech_section.recommandation_tech }}
            </div>
          </div>

          <div class="modular-fields-grid" v-if="clientReportTemplate?.tech_fields">
            <template v-for="field in clientReportTemplate.tech_fields" :key="field.key">
              <div  :class="[
                'modular-field-item',
                { 'modular-field-item--full': field.key === 'notes_generales_tech' }
              ]"   
                   v-if="!['recommandation_tech'].includes(field.key)
                         && clientReport.report_data.tech_section[field.key] !== undefined
                         && clientReport.report_data.tech_section[field.key] !== ''
                         && (!clientReport.report_data.client_visible_fields || clientReport.report_data.client_visible_fields.includes(field.key))">
                <div class="field-label-client">{{ field.label }}</div>
                <div class="field-value-client">
                  <span v-if="field.type === 'score'" class="score-display">
                    <span v-for="n in (field.max || 5)" :key="n" class="score-pip-display"
                          :class="{ active: clientReport.report_data.tech_section[field.key] >= n }">{{ n }}</span>
                  </span>
                  <span v-else>{{ clientReport.report_data.tech_section[field.key] }}</span>
                </div>
              </div>
            </template>
          </div>
        </div>
        <div v-if="clientReport.report_data.client_feedback" class="client-feedback-section">
          <div class="client-feedback-section-header">
            <i class="fas fa-comment-alt"></i> Notes client post-entretien
          </div>
          <div class="client-feedback-section-body">
            <p>{{ clientReport.report_data.client_feedback.notes }}</p>
            <small>Soumis le {{ formatDate(clientReport.report_data.client_feedback.submitted_at) }}</small>
          </div>
        </div>

      </template>

      <div class="report-footer">
        <span>Complété le {{ formatDate(clientReport.completed_at) }}</span>
      </div>
    </div>
  </div>
</div>

<!-- exceeds cap -->
<div v-if="limitExceededModal" class="modal-overlay" @click="limitExceededModal = false">
  <div class="modal-content" @click.stop>
    <div class="modal-header">
      <h3><i class="fas fa-exclamation-triangle"></i> Limit Reached</h3>
    </div>
    <div class="modal-body">
      <p v-if="limitExceededType === 'consultation'">
        You have reached your consultation limit of {{ consultationLimits?.consultation_limit }} candidates.
        Contact your account manager to increase your limits.
      </p>
      <p v-else>
        You have reached your screening limit of {{ consultationLimits?.screening_limit }} candidates.
        Contact your account manager to increase your limits.
      </p>
    </div>
    <div class="modal-footer">
      <button @click="limitExceededModal = false" class="btn btn-primary">
        <i class="fas fa-check"></i> Understood
      </button>
    </div>
  </div>
</div>
<!-- Feedback Modal -->
<!-- <div v-if="interviewFeedbackModal" class="modal-overlay" @click.self="interviewFeedbackModal = false">
  <div class="modal-content">
    <h3>Interview Completed</h3>
    <p class="modal-subtitle">Optionally leave notes for your recruitment team.</p>
    <textarea
      v-model="interviewFeedbackNotes"
      placeholder="e.g. Strong technical background, needs to confirm availability, salary aligned..."
      rows="5"
      class="feedback-textarea"
    ></textarea>
    <div class="modal-actions">
      <button @click="interviewFeedbackModal = false" class="btn-secondary">Cancel</button>
      <button @click="confirmInterviewDoneWithFeedback()" class="btn-primary">
        {{ interviewFeedbackNotes.trim() ? 'Submit & Mark Done' : 'Mark Done (no notes)' }}
      </button>
    </div>
  </div>
</div> -->



<!-- Interview Feedback Modal -->
<div v-if="interviewFeedbackModal" class="modal-overlay" @click.self="interviewFeedbackModal = false">
  <div class="modal-content interview-schedule-modal" style="max-width: 520px;" @click.stop>
    <div class="modal-header">
      <h3><i class="fas fa-clipboard-check"></i> Retour post-entretien</h3>
      <button @click="interviewFeedbackModal = false" class="close-btn">&times;</button>
    </div>
    <div class="modal-body">
      <p class="modal-hint-black">Ajoutez vos observations. Ces notes seront transmises à l'équipe de recrutement et jointes au rapport.</p>
      <div class="form-group">
        <label>Notes d'entretien</label>
        <textarea
          v-model="interviewFeedbackNotes"
          placeholder="Ex : Profil solide, disponibilité à confirmer, prétentions salariales alignées..."
          rows="6"
          class="form-input"
        ></textarea>
      </div>
    </div>
    <div class="modal-footer">
      <button @click="interviewFeedbackModal = false" class="btn btn-secondary">
        <i class="fas fa-times"></i> Annuler
      </button>
      <button @click="confirmInterviewDoneWithFeedback()" class="btn btn-primary">
        <i class="fas fa-check"></i>
        {{ interviewFeedbackNotes.trim() ? 'Soumettre et marquer effectué' : 'Marquer effectué (sans notes)' }}
      </button>
    </div>
  </div>
</div>
</template>

<script>
import ResumeDetailView from "./ResumeDetailView.vue";
import axios from 'axios';
import ResumeEditor from '@/components/ResumeEditor.vue';
import ResumeLogoEditor from '@/components/ResumeLogoEditor.vue';
import ResumeReformatter from '@/components/ResumeReformatter.vue'; // NEW
import { useProjectStore } from '@/store/projectContext'


export default {
  inheritAttrs: false, // ← Add this to disable automatic attribute inheritance
  name: "GallerySection",
  components: {
    ResumeDetailView, 
    ResumeEditor,
    ResumeLogoEditor,
    ResumeReformatter, // NEW



  },
  setup() {
  const projectStore = useProjectStore()
  return { projectStore }
},
  props: {
    projectStatus: {
  type: String,
  default: null
},

    activeHotListId: {
      type: String,
      default: null
    },
    userType: String,  // NEW: 'agent' or 'client'

    searchResults: {
    type: Object,
    required: true,
  },
  // NEW: Project context prop
  projectContext: {
    type: Object,
    default: null
  },
  poolMode: {  // ✅ ADD THIS
    type: Boolean,
    default: false
  },
  ragRecommendations: {
    type: Array,
    default: () => []
  },
    isLoading: {
      type: Boolean,
      default: false
    },
     
  },
  data() {
    return {
    //add batch board
    batchAddLoading: false,
    selectMode: false,
      selectedCandidates: new Set(),
      showBoardPicker: false,
      boardPickerBoards: [],

      lastSearchQuery: '',

      loadingProjectMemberships: false,
      agentViewsExpanded: {},  // { candidateId: true/false }

    agentViews: {},  // { candidateId: [{agent_name, viewed_at}] }
    interviewFeedbackModal: false,
pendingDoneSlot: null,
interviewFeedbackNotes: '',
      showInterviewModal: false,
      interviewForm: { proposed_dates: [''], notes: '' },
      interviewTarget: null,
      showConfirmInterviewModal: false,
      confirmInterviewDates: [],
      confirmSelectedDate: null,
      confirmSlotId: null,
      interviewSlotData: {},
      interviewDates: {},
      //tech
      techInterviewSlotData: {},
      techInterviewDates: {},
      showTechProposeModal: false,
      showTechConfirmModal: false,
      techInterviewForm: { proposed_dates: [''], notes: '' },
      techConfirmDates: [],
      techConfirmSelectedDate: null,
      techConfirmSlotId: null,

      clientVisibleFields: [],
      hrEditableByTech: false,
      editableHRReportId: null, hrEditMode: false,
      techEditMode: false,

    clientReportTemplate: null,  // template schema for dynamic rendering

      currentUserId: null,

      projectAgents: [],        // agents available for tech assignment
      selectedTechAgent: '',    // picked by HR before submitting
      /// Modular screening
screeningTemplate: null,       // { hr_fields: [...], tech_fields: [...] }
screeningStep: 'hr',           // 'hr' | 'tech'
hrFormData: {},                // dynamic {key: value}
techFormData: {},              // dynamic {key: value}
pendingTechReportId: null,     // report awaiting tech section

// Dashboard
showScreeningDashboard: false,
projectScreenings: [],
loadingScreenings: false,


      // Project push state (mirrors hotlist pattern)
projectDropdownOpen: {},
availableProjects: [],
loadingProjects: false,
addingToProject: {},       // { project_id: boolean }
removingFromProject: {},   // { project_id: boolean }
candidateProjectMemberships: {}, // { candidate_id: [project_ids] }

      skipHeavyLoading: false,  // ✅ NEW: Flag to skip heavy loading
      projectHistoryCache: {},  // { candidateId: historyData }
    showHistoryModal: false,
    selectedCandidateHistory: null,
      tagsCollapsed: {},
      // Hot list dropdown state
      hotListDropdownOpen: {},
      availableHotLists: [],
      loadingHotLists: false,
      addingToHotList: {},  // { hot_list_id: boolean }
      candidateHotListMemberships: {},  // { candidate_id: [hot_list_ids] }

    isLoadingTags: false,      // ✅ ADD: Track tag loading
    isLoadingComments: false,  // ✅ ADD: Track comment loading
    isLoadingData: false,      // ✅ ADD: Track overall loading
    matchBreakdownOpen: {},  // Tracks which cards have breakdown open

      reformatLoading: {}, // Track loading per candidate
      jobOfferInput: {}, // Store job offer text per candidate
    showJobOfferInput: {}, // Toggle job offer dropdown per candidate
    reformatterCandidateId: '',  // ← Change from null to empty string
    reformatteridType :'',
    showReformatter: false,
    //reformatterCandidateId: null,
      //edit resumes
       showEditor: false,
      editorResumeData: null,
        showLogoEditor: false,
        logoEditorCandidateId: null,
        logoEditoridType: null,
        logoEditorPdfUrl: null,  // ← ADD THIS: store the PDF URL
        candidateResumesDropdown: null,  // Which card's dropdown is open
    candidateResumesData: {},        // Cache of fetched data
    loadingCandidateResumes: false,
      selectedSort: 'relevance',
      sortDropdownOpen: false,
      consultedCandidates: new Set(), // Track which candidates have been consulted
      // to your existing data properties
      consultationLimits: null,
      loadingLimits: false,
      limitExceededModal: false,
      limitExceededType: '', // 'consultation' or 'screening'

      // Initialization flags:
      statusCollapsed: {}, // Track collapsed state per candidate
      statusFetchAttempted: {}, // candidateId -> true when fetch attempted

    componentInitialized: false,
    isInitializing: true,


    selectedReportOption: 'new', // 'new', 'draft', or report.id
    loadingReport: false,
    formStatus: null ,// { type: 'success|warning|error', message: '', icon: '' }
 
      newComment: {}, // For COMMENTS ONLY
      newScreeningNote: {}, // NEW - For screening notes ONLY  
      collapsedNotes: {}, // Track which notes are collapsed

    // has agent logic
    projectHasAgent: null, // null = checking, true = has agent, false = no agent
    checkingAgentAssignment: true,
    
    //polling for comments/tags
    pollInterval: null,
    lastUpdateTimestamp: null,
    isPolling: false,

      downloadOptions: {
      includeName: false,      // NEW - just candidate name
      includeContact: false,
      includeLogo: true
    },
    openTagSections: {},

    bookmarkedCandidates: new Set(), 
    deletingCommentId: null,
    candidateComments: {}, 
    newComment: {}, // For textarea inputs
      selectedTagFilter: '', 

      candidateTags: {}, // cache: {es_id: [tags]}
    showCustomInput: {},
    customTagInput: {},
      matchSectionExpanded: {},
      viewMode: 'grid',
    currentPage: 1,
    itemsPerPage: 12,
      openQuestionsMap: {}, // To track which cards have open questions

      expandedMatchSections: {},

      expanded: {}, // Tracks expanded sections by index and section type
      showDetailView: false,
      existingReportsCache: {}, // Cache for existing reports per candidate
      selectedResume: null,
      searchTimestamp: 0,
      downloadMenuOpen: null, // Track which dropdown is open
      downloadStatus: {
        show: false,
        message: "",
        type: "info", // info, success, error
        icon: "fas fa-spinner fa-spin", // spinner, check, error
        timeout: null,

      },
    // NEW: Role and project detection (client/agent)
    userRole: null, // 'client' or 'agent'  
    // projectContext: null, // Will contain project info when in project context
    loadingProjectStatus: false,
    projectStatuses: {}, // Cache for project-specific statuses
    // Screening report data
    showScreeningModal: false,
    showExistingModal: false, 
    showClientReportModal: false,
    existingReports: [],
    clientReport: null,
    currentScreeningCandidate: null,
    currentReportId: null,
    
    // Screening form
    screeningForm: {
      summary: '',
      availability: '',
      expected_rate: '',
      key_checks: {
        skills_verified: false,
        references_contacted: false,
        background_clear: false
      },
      recommendation: '',
      notes: ''
    }
    };
  },
  computed: {
    // ✅ ADD: Check if candidate data is ready
  isCandidateDataReady() {
    return !this.isLoadingTags && !this.isLoadingComments;
  },
  
  // ✅ ADD: Safe comment access
  safeGetComments(candidateId) {
    return this.candidateComments[candidateId] || [];
  },
  
  // ✅ ADD: Safe tag access
  safeGetTags(candidateId) {
    return this.candidateTags[candidateId] || [];
  }, 
     hasResults() {
    return this.searchResults && this.searchResults.results && this.searchResults.results.length > 0;
  },
  
  canDownload() {
    return this.hasResults;
  },


  displayResults() {
    if (!this.searchResults || !this.searchResults.results) {
      return [];
    }
    
    let results = this.searchResults.results;
    
    // Apply tag filter if selected
    if (this.selectedTagFilter) {
      results = results.filter(candidate => {
        const esId = this.getCandidateId(candidate);
        return this.candidateTags[esId]?.some(tag => tag.tag_value === this.selectedTagFilter);
      });
    }
    
    // Apply pagination to filtered results
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    return results.slice(startIndex, endIndex);
  },
   isProjectTransitioning() {
    return this.projectStore.isTransitioning
  },
  
  // these computed properties for the filter
  allAvailableTags() {
  const tags = new Set();
  
  // Ensure candidateTags exists and is an object
  if (this.candidateTags && typeof this.candidateTags === 'object') {
    Object.values(this.candidateTags).forEach(candidateTagArray => {
      // Ensure candidateTagArray exists and is an array
      if (Array.isArray(candidateTagArray)) {
        candidateTagArray.forEach(tag => {
          // Ensure tag exists and has required properties
          if (tag && tag.tag_type !== 'bookmark' && tag.tag_value) {
            tags.add(tag.tag_value);
          }
        });
      }
    });
  }
  
  return Array.from(tags).sort();
},
  totalPages() {
    if (!this.hasResults) return 1;
    return Math.ceil(this.searchResults.results.length / this.itemsPerPage);
  },
  
  visiblePages() {
    const pages = [];
    const maxVisible = 5;
    
    let start = Math.max(1, this.currentPage - Math.floor(maxVisible / 2));
    let end = Math.min(this.totalPages, start + maxVisible - 1);
    
    if (end - start < maxVisible - 1) {
      start = Math.max(1, end - maxVisible + 1);
    }
    
    for (let i = start; i <= end; i++) {
      pages.push(i);
    }
    
    return pages;
  },
  
 
    results() {
      if (!this.searchResults || !this.searchResults.results) {
        return [];
      }
      return this.searchResults.results;
    },
     // sort: COMPUTED PROPERTY
     sortOptions() {
      return [
        { label: 'Relevance', value: 'relevance', icon: 'fas fa-star' },
        { label: 'Most Recent', value: 'recent', icon: 'fas fa-clock' }
      ];
    },
    
    currentSortLabel() {
      const option = this.sortOptions.find(opt => opt.value === this.selectedSort);
      return option ? option.label : 'Relevance';
    },
    
    currentSortIcon() {
      const option = this.sortOptions.find(opt => opt.value === this.selectedSort);
      return option ? option.icon : 'fas fa-star';
    }
  },
  watch: {
    searchResults() {
      this.availableHotLists = []; // Force reload on next open
    },
    // When contact is checked, auto-check name
  'downloadOptions.includeContact'(newVal) {
    if (newVal) {
      // If contact is checked, automatically check name too
      this.downloadOptions.includeName = true;
    }
  },
  
  // Prevent unchecking name when contact is still checked
  'downloadOptions.includeName'(newVal) {
    if (!newVal && this.downloadOptions.includeContact) {
      // If trying to uncheck name while contact is checked, prevent it
      this.$nextTick(() => {
        this.downloadOptions.includeName = true;
      });
      
      // Optional: Show a notification explaining why
      this.showNotification('Name must be included when contact details are selected', 'info');
    }
  },
    searchResults: {
      async handler(newResults) {
      if (!this.componentInitialized) return;


      if (newResults && newResults.timestamp) {
        // this.loadProjectStatus();

        this.searchTimestamp = newResults.timestamp;
        this.lastSearchQuery = newResults.searchQuery || '';
        this.expanded = {}; 


       // ✅ FIX: Run in parallel instead of sequential -- lazy loading
      //  await this.loadExistingReportsCache(); // Only reports for screening workflow

        // await Promise.all([
        //   this.loadCandidateTags(),
        //   this.loadCandidateComments(),
        //   this.loadExistingReportsCache()
        // ]);
        
        this.downloadMenuOpen = null;
        this.selectedTagFilter = ''; // Reset to "All candidates"
        this.currentPage = 1;
       



        this.currentPage = 1;
        // this.loadBookmarkStatuses();
        // FIX: Load project status when new results arrive in project context
        if (this.projectContext && newResults.results && newResults.results.length > 0) {
          console.log('📊 New results arrived, loading project statuses...');
          // Clear status tracking for fresh load
          this.statusFetchAttempted = {};
          this.projectStatuses = {};
          await this.loadProjectStatus(true);  // Force refresh
        }
       
       
       // ✅ NEW: Bookmarks load in background (non-blocking)
        this.$nextTick(() => {
            this.loadBookmarkStatuses();
            this.loadAgentViews();  // ← ADD HERE

          });


      }
    },

    immediate: false,
    deep: true

  },// ✅ NEW: Watch for navigation from notifications
  '$route.query.from'(newValue) {
  if (newValue === 'notification' && this.projectContext) {
    console.log('🔔 Navigation from notification detected - clearing caches and forcing refresh');
    
    // ✅ FIX: Clear ALL localStorage caches for this project FIRST
    const keysToRemove = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.startsWith('gallery:') && key.includes(this.projectContext.project_id)) {
        keysToRemove.push(key);
      }
    }
    keysToRemove.forEach(key => localStorage.removeItem(key));
    console.log(`🗑️ Cleared ${keysToRemove.length} cached entries`);
    
    // ✅ Clear in-memory state too
    this.projectStatuses = {};
    this.candidateTags = {};
    this.statusFetchAttempted = {};
    
    // Force refresh from server
    this.loadProjectStatus(true);
    this.loadCandidateTags(true);
  }
},
  
 // FIX: React to project context changes

 projectContext: {
  handler(newContext, oldContext) {
    if (!this.componentInitialized) return;

    console.log('🔄 Project context changed:', { 
      from: oldContext?.project_id || 'null', 
      to: newContext?.project_id || 'null' 
    });
    
    if (newContext && !oldContext) {
      // Project context just became available
      console.log('✅ Project context now available, reinitializing...');
      this.reinitializeWithProjectContext();
    } else if (!newContext && oldContext) {
      // Project context was removed
      console.log('❌ Project context removed, switching to global mode');
      this.switchToGlobalMode();
    } else if (newContext && oldContext && newContext.project_id !== oldContext.project_id) {
      // SWITCHING between different projects
      console.log('🔀 Switching projects from', oldContext.project_id, 'to', newContext.project_id);
      this.handleProjectSwitch(oldContext.project_id, newContext.project_id);
    }
  },
  immediate: false,
  deep: false
},  
  // ALSO watch user role changes
  userRole: {
    handler(newRole, oldRole) {
      if (!this.componentInitialized) return;

      console.log('👤 User role changed:', { from: oldRole, to: newRole });
      
      if (newRole && this.projectContext) {
        // Both role and context are available
        this.reinitializeWithProjectContext();
      }
    },
    immediate: false
  }




  },
  
  methods: {
    //batch add boards 
    toggleSelectMode() {
      this.selectMode = !this.selectMode;
      if (!this.selectMode) {
        this.selectedCandidates = new Set();
        this.showBoardPicker = false;
      }
    },

    toggleSelect(candidateId) {
      const next = new Set(this.selectedCandidates);
      if (next.has(candidateId)) next.delete(candidateId);
      else next.add(candidateId);
      this.selectedCandidates = next;
    },

    selectAllVisible() {
      const next = new Set(this.selectedCandidates);
      this.displayResults.forEach(r => {
        const cid = this.getCandidateId(r);
        if (cid) next.add(cid);
      });
      this.selectedCandidates = next;
    },

    clearSelection() {
      this.selectedCandidates = new Set();
      this.showBoardPicker = false;
    },

    async openBatchBoardPicker() {
      this.showBoardPicker = !this.showBoardPicker;
      if (this.showBoardPicker && !this.boardPickerBoards.length) {
        try {
          const res = await axios.get('/api/v1/my-history/favorite-groups');
          this.boardPickerBoards = res.data.groups || [];
        } catch (e) { /**/ }
      }
    },

    async batchAddToBoard(boardId) {
      const ids = Array.from(this.selectedCandidates);
      if (!ids.length) return;
      this.batchAddLoading = true;

      try {
        const res = await axios.post('/api/v1/my-board/batch-add', {
          board_id: boardId,
          candidate_ids: ids
        });
        const added = res.data.added || 0;
        const skipped = res.data.skipped || 0;
        const msg = skipped > 0
          ? `${added} ajouté(s), ${skipped} déjà présent(s)`
          : `${added} candidat(s) ajouté(s)`;
        alert(msg);
        this.selectedCandidates = new Set();
        this.selectMode = false;
        this.showBoardPicker = false;
      } catch (e) { console.error('Batch add failed:', e); }
       finally { this.batchAddLoading = false; }
    },
    // hasScreeningStarted(candidateId, projectId) {
    //   const tags = this.candidateTags[candidateId] || [];
    //   return tags.some(t => t.tag_type === 'project_status' && t.project_id === projectId);
    // },
    hasScreeningStarted(candidateId, projectId) {
      // Check local tracking first (set after successful startScreeningFromDropdown)
      if (this._screeningStarted?.has(`${candidateId}:${projectId}`)) return true;
      // Check loaded tags (works when in this project's context)
      const tags = this.candidateTags[candidateId] || [];
      return tags.some(t => t.tag_type === 'project_status' && t.project_id === projectId);
    },
    async startScreeningFromDropdown(result, project) {
      const esId = this.getCandidateId(result);
      this.closeProjectDropdown();
      try {
        await axios.post(`/api/v1/candidates/${esId}/tags`, {
          tag_type: 'project_status',
          tag_value: 'screening-in-progress',
          project_id: project.project_id
        });
        if (!this._screeningStarted) this._screeningStarted = new Set();
        this._screeningStarted.add(`${esId}:${project.project_id}`);

        this.showNotification(`Screening started for ${project.project_name}`, 'success');
        // If we're in this project's context, update local state + open modal
        if (this.projectContext?.project_id === project.project_id) {
          if (!this.projectStatuses) this.projectStatuses = {};
          this.projectStatuses[esId] = {
            tag_value: 'screening-in-progress',
            tag_type: 'project_status',
            project_id: project.project_id,
            created_at: new Date().toISOString()
          };
          const cacheKey = this._getCacheKey('project_status', esId, project.project_id);
          localStorage.removeItem(cacheKey);
          this.openScreeningModal(result);
        }
      } catch (e) {
        this.showNotification('Failed to start screening', 'error');
      }
    },
    // In client feedback interview
openInterviewFeedbackModal(candidate) {
  // candidate here is a search result object, not a slot
  // we need the slot ID — pull it from interviewSlotData which you already load
  const esId = this.getCandidateId(candidate);
  const slotData = this.interviewSlotData[esId];
  if (!slotData) {
    this.showNotification('Aucun créneau d\'entretien trouvé', 'error');
    return;
  }
  this.pendingDoneSlot = slotData;
  this.interviewFeedbackNotes = '';
  this.interviewFeedbackModal = true;
},

async confirmInterviewDoneWithFeedback() {
  const slot = this.pendingDoneSlot;
  if (!slot) return;

  try {
    await axios.put(`/api/v1/interviews/${slot.id}/done`);

    if (this.interviewFeedbackNotes.trim()) {
      await axios.put(`/api/v1/interviews/${slot.id}/feedback`, {
        notes: this.interviewFeedbackNotes.trim()
      });
    }

    this.interviewFeedbackModal = false;
    this.pendingDoneSlot = null;
    this.showNotification('Entretien marqué comme effectué', 'success');
    await this.loadProjectStatus();

  } catch (err) {
    console.error('Erreur:', err);
    this.showNotification('Échec de l\'enregistrement', 'error');
  }
},
    highlightLabel(key) {
  const map = {
    last_employer:    'Dernier employeur',
    annees_experience:'Expérience',
    tjm_propose:      'TJM proposé',
    disponibilite:    'Disponibilité',
  };
  return map[key] || key;
},
isTechAgentFor(candidate) {
  if (!this.currentUserId || !this.projectContext) return false;
  const esId = this.getCandidateId(candidate);
  const reports = this.existingReportsCache[esId] || [];
  return reports.some(r =>
    r.tech_agent_id === this.currentUserId &&
    r.project_id === this.projectContext.project_id
  );
},

isHRAgentFor(candidate) {
  if (!this.currentUserId || !this.projectContext) return false;
  const esId = this.getCandidateId(candidate);
  const reports = this.existingReportsCache[esId] || [];
  return reports.some(r =>
    r.agent_id === this.currentUserId &&
    r.project_id === this.projectContext.project_id
  );
},
openScheduleInterview(candidate) {
  this.interviewTarget = candidate;
  this.interviewForm = { proposed_dates: [''], notes: '' };
  this.showInterviewModal = true;
},
async cancelInterview(candidate) {
  const esId = this.getCandidateId(candidate);
  const slot = this.interviewSlotData[esId];
  if (!slot) { this.showNotification('Slot introuvable', 'error'); return; }

  try {
    await axios.delete(`/api/v1/interviews/${slot.id}/cancel`, {
      data: { project_id: this.projectContext.project_id }
    });
    // Clear local state
    // Clear local state — use spread to trigger Vue reactivity
    const { [esId]: _slot, ...restSlots } = this.interviewSlotData;
    this.interviewSlotData = restSlots;
    const { [esId]: _date, ...restDates } = this.interviewDates;
    this.interviewDates = restDates;
    const cacheKey = this._getCacheKey('project_status', esId, this.projectContext?.project_id);
    localStorage.removeItem(cacheKey);
    
    this.showNotification('Entretien annulé — proposez de nouveaux créneaux', 'info');
    await this.loadProjectStatus(true);
    // Reopen the propose modal immediately
    this.openScheduleInterview(candidate);
  } catch (e) {
    this.showNotification('Échec de l\'annulation', 'error');
  }
},
async submitProposeInterview() {
  const esId = this.getCandidateId(this.interviewTarget);
  const dates = this.interviewForm.proposed_dates.filter(d => d);
  if (!dates.length) return;
  try {
    const res = await axios.post(`/api/v1/interviews/propose`, {
      project_id: this.projectContext.project_id,
      elasticsearch_id: esId,
      proposed_dates: dates,
      notes: this.interviewForm.notes || null,
    });
    // this.interviewSlotData[esId] = {
    //   id: res.data.id,
    //   proposed_dates: res.data.proposed_dates,
    //   status: 'proposed'
    // };

    this.interviewSlotData = {
      ...this.interviewSlotData,
      [esId]: { id: res.data.id, proposed_dates: res.data.proposed_dates, status: 'proposed' }
    };

    const cacheKey = this._getCacheKey('project_status', esId, this.projectContext?.project_id);
    localStorage.removeItem(cacheKey);
    this.showInterviewModal = false;
    this.showNotification('Créneaux envoyés à l\'équipe RH', 'success');
    await this.loadProjectStatus(this.interviewTarget);
  } catch (e) {
    this.showNotification('Échec de l\'envoi', 'error');
  }
},
 
async openConfirmInterview(candidate) {
  const esId = this.getCandidateId(candidate);
  // Always fetch fresh — stale cache from old cancelled slots causes wrong slot ID
  try {
    const r = await axios.get(`/api/v1/interviews?project_id=${this.projectContext.project_id}`);
    const slot = (r.data.interviews || []).find(i => i.elasticsearch_id === esId && i.status === 'proposed');
    if (slot) {
      this.interviewSlotData = { ...this.interviewSlotData, [esId]: slot };
    }
  } catch (e) {}
  
  const slot = this.interviewSlotData[esId];
  if (!slot) { this.showNotification('Aucun créneau trouvé', 'error'); return; }
  this.confirmSlotId = slot.id;
  this.confirmInterviewDates = slot.proposed_dates || [];
  this.confirmSelectedDate = null;
  this.interviewTarget = candidate;
  this.showConfirmInterviewModal = true;
},

async submitConfirmInterview() {
  if (!this.confirmSelectedDate || !this.confirmSlotId) return;
  try {
    await axios.put(`/api/v1/interviews/${this.confirmSlotId}/confirm`, {
      confirmed_date: this.confirmSelectedDate
    });
    const esId = this.getCandidateId(this.interviewTarget);

    // this.interviewDates[esId] = this.confirmSelectedDate;
    // if (this.interviewSlotData[esId]) this.interviewSlotData[esId].status = 'confirmed';
    this.interviewDates = { ...this.interviewDates, [esId]: this.confirmSelectedDate };
    this.interviewSlotData = {
      ...this.interviewSlotData,
      [esId]: { ...this.interviewSlotData[esId], status: 'confirmed', confirmed_date: this.confirmSelectedDate }
    };

    const cacheKey = this._getCacheKey('project_status', esId, this.projectContext?.project_id);
    localStorage.removeItem(cacheKey);
    this.showConfirmInterviewModal = false;
    this.showNotification('Date confirmée — client notifié', 'success');
    await this.loadProjectStatus(this.interviewTarget);
  } catch (e) {
    this.showNotification('Échec de la confirmation', 'error');
  }
},

// async markInterviewDone(candidate) {
//   const esId = this.getCandidateId(candidate);
//   let slotId = this.interviewSlotData[esId]?.id;
//   if (!slotId) {
//     try {
//       const r = await axios.get(`/api/v1/interviews?project_id=${this.projectContext.project_id}`);
//       const slot = (r.data.interviews || []).find(i => i.elasticsearch_id === esId && i.status === 'confirmed');
//       if (slot) slotId = slot.id;
//     } catch (e) {}
//   }
//   if (!slotId) { this.showNotification('Slot introuvable', 'error'); return; }
//   try {
//     await axios.put(`/api/v1/interviews/${slotId}/done`);
//     const cacheKey = this._getCacheKey('project_status', esId, this.projectContext?.project_id);
//     localStorage.removeItem(cacheKey);
//     this.showNotification('Entretien marqué comme effectué', 'success');
//     await this.loadProjectStatus(candidate);
//   } catch (e) {
//     this.showNotification('Échec', 'error');
//   }
// },


openTechProposeInterview(candidate) {
  this.interviewTarget = candidate;
  this.techInterviewForm = { proposed_dates: [''], notes: '' };
  this.showTechProposeModal = true;
},

async submitTechProposeInterview() {
  const esId = this.getCandidateId(this.interviewTarget);
  const dates = this.techInterviewForm.proposed_dates.filter(d => d);
  if (!dates.length) return;
  try {
    const res = await axios.post(`/api/v1/interviews/propose`, {
      project_id: this.projectContext.project_id,
      elasticsearch_id: esId,
      proposed_dates: dates,
      notes: this.techInterviewForm.notes || null,
      interview_type: 'tech',
    });
    this.techInterviewSlotData = {
      ...this.techInterviewSlotData,
      [esId]: { id: res.data.id, proposed_dates: res.data.proposed_dates, status: 'proposed' }
    };
    const cacheKey = this._getCacheKey('project_status', esId, this.projectContext?.project_id);
    localStorage.removeItem(cacheKey);
    this.showTechProposeModal = false;
    this.showNotification('Créneaux envoyés au tech agent', 'success');
    await this.loadProjectStatus(true);
  } catch (e) {
    this.showNotification('Échec de l\'envoi', 'error');
  }
},

async openTechConfirmInterview(candidate) {
  const esId = this.getCandidateId(candidate);
  // Always fetch fresh
  try {
    const r = await axios.get(`/api/v1/interviews?project_id=${this.projectContext.project_id}&interview_type=tech`);
    const slot = (r.data.interviews || []).find(i => i.elasticsearch_id === esId && i.status === 'proposed');
    if (slot) this.techInterviewSlotData = { ...this.techInterviewSlotData, [esId]: slot };
  } catch (e) {}
  const slot = this.techInterviewSlotData[esId];
  if (!slot) { this.showNotification('Aucun créneau trouvé', 'error'); return; }
  this.techConfirmSlotId = slot.id;
  this.techConfirmDates = slot.proposed_dates || [];
  this.techConfirmSelectedDate = null;
  this.interviewTarget = candidate;
  this.showTechConfirmModal = true;
},

async submitTechConfirmInterview() {
  if (!this.techConfirmSelectedDate || !this.techConfirmSlotId) return;
  try {
    await axios.put(`/api/v1/interviews/${this.techConfirmSlotId}/confirm`, {
      confirmed_date: this.techConfirmSelectedDate
    });
    const esId = this.getCandidateId(this.interviewTarget);
    this.techInterviewDates = { ...this.techInterviewDates, [esId]: this.techConfirmSelectedDate };
    this.techInterviewSlotData = {
      ...this.techInterviewSlotData,
      [esId]: { ...this.techInterviewSlotData[esId], status: 'confirmed', confirmed_date: this.techConfirmSelectedDate }
    };
    const cacheKey = this._getCacheKey('project_status', esId, this.projectContext?.project_id);
    localStorage.removeItem(cacheKey);
    this.showTechConfirmModal = false;
    this.showNotification('Date confirmée', 'success');
    await this.loadProjectStatus(true);
  } catch (e) {
    this.showNotification('Échec de la confirmation', 'error');
  }
},

async markTechInterviewDone(candidate) {
  const esId = this.getCandidateId(candidate);
  let slotId = this.techInterviewSlotData[esId]?.id;
  if (!slotId) {
    try {
      const r = await axios.get(`/api/v1/interviews?project_id=${this.projectContext.project_id}&interview_type=tech`);
      const slot = (r.data.interviews || []).find(i => i.elasticsearch_id === esId && i.status === 'confirmed');
      if (slot) slotId = slot.id;
    } catch (e) {}
  }
  if (!slotId) { this.showNotification('Slot introuvable', 'error'); return; }
  try {
    await axios.put(`/api/v1/interviews/${slotId}/done`);
    const cacheKey = this._getCacheKey('project_status', esId, this.projectContext?.project_id);
    localStorage.removeItem(cacheKey);
    this.showNotification('Entretien tech effectué — remplissez votre section', 'success');
    await this.loadProjectStatus(true);
    // Open the screening modal so tech agent can fill their section immediately
    //this.openScreeningModal(candidate);
  } catch (e) {
    this.showNotification('Échec', 'error');
  }
},
async cancelTechAndRepropose(candidate) {
  const esId = this.getCandidateId(candidate);
  const slot = this.techInterviewSlotData[esId];
  if (!slot) { this.showNotification('Slot introuvable', 'error'); return; }
  try {
    // Reuse the cancel endpoint, pass interview_type so tag resets to tech-interview-scheduled
    await axios.delete(`/api/v1/interviews/${slot.id}/cancel`, {
      data: { project_id: this.projectContext.project_id }
    });
    const { [esId]: _, ...restSlots } = this.techInterviewSlotData;
    this.techInterviewSlotData = restSlots;
    const cacheKey = this._getCacheKey('project_status', esId, this.projectContext?.project_id);
    localStorage.removeItem(cacheKey);
    await this.loadProjectStatus(true);
    // Immediately open propose modal
    this.openTechProposeInterview(candidate);
  } catch (e) {
    this.showNotification('Échec', 'error');
  }
},
allDatesExpired(candidate) {
  const esId = this.getCandidateId(candidate);
  const slot = this.interviewSlotData[esId];
  if (!slot?.proposed_dates?.length) return false;
  return slot.proposed_dates.every(d => new Date(d) < new Date());
},

    recToClass(val) {
  if (!val) return '';
  if (val.includes('rejeter')) return 'reject';
  if (val.includes('considérer')) return 'consider';
  return 'pass';
},
    //pushing p
    async toggleProjectDropdown(candidateId) {
  const isOpen = this.projectDropdownOpen[candidateId];
  this.projectDropdownOpen = {};
  this.hotListDropdownOpen = {}; // close hotlist if open

  if (!isOpen) {
    this.projectDropdownOpen[candidateId] = true;
    await Promise.all([
      this.loadAvailableProjects(),
      this.loadCandidateProjectMemberships(candidateId)
    ]);
  }
},

isProjectDropdownOpen(candidateId) {
  return this.projectDropdownOpen[candidateId] || false;
},

closeProjectDropdown() {
  this.projectDropdownOpen = {};
},

async loadAvailableProjects() {
  if (this.availableProjects.length > 0) return;
  try {
    this.loadingProjects = true;
    const response = await axios.get('/api/v1/agent/my-projects');
    // Filter out hot lists — we only want real projects
    this.availableProjects = (response.data.projects || []).filter(p => !p.is_hot_list);
  } catch (error) {
    console.error('Failed to load projects:', error);
    this.availableProjects = [];
  } finally {
    this.loadingProjects = false;
  }
},
async loadCandidateProjectMemberships(candidateId) {
      this.loadingProjectMemberships = true;
      try {
        const [memberRes, tagRes] = await Promise.all([
          axios.get(`/api/v1/candidates/${candidateId}/project-memberships`),
          axios.get(`/api/v1/candidates/${candidateId}/tags`)
        ]);
        this.candidateProjectMemberships[candidateId] = memberRes.data.projects.map(p => p.project_id);
        if (!this._screeningStarted) this._screeningStarted = new Set();
        const allTags = Array.isArray(tagRes.data) ? tagRes.data : tagRes.data?.tags || [];
        allTags.filter(t => t.tag_type === 'project_status').forEach(t => {
          this._screeningStarted.add(`${candidateId}:${t.project_id}`);
        });
      } catch (error) {
        console.error('Failed to load project memberships:', error);
        this.candidateProjectMemberships[candidateId] = [];
      } finally {
        this.loadingProjectMemberships = false;
      }
    },

isInProject(candidateId, projectId) {
  return (this.candidateProjectMemberships[candidateId] || []).includes(projectId);
},

async addToProject(result, project) {
  const candidateId = this.getCandidateId(result);
  if (this.isInProject(candidateId, project.project_id)) return;

  try {
    this.addingToProject[project.project_id] = true;
    await axios.post(`/api/v1/projects/${project.project_id}/candidate_pool/add/`, {
      candidate_elasticsearch_id: candidateId,
      interaction_type: 'consulted'
    });

    if (!this.candidateProjectMemberships[candidateId]) {
      this.candidateProjectMemberships[candidateId] = [];
    }
    this.candidateProjectMemberships[candidateId].push(project.project_id);

    setTimeout(() => this.closeProjectDropdown(), 800);
  } catch (error) {
    console.error('Failed to add to project:', error);
    alert(`Failed to add candidate to "${project.project_name}"`);
  } finally {
    this.addingToProject[project.project_id] = false;
  }
},

async removeFromProject(result, project) {
  const candidateId = this.getCandidateId(result);
  try {
    this.removingFromProject[project.project_id] = true;
    await axios.post(`/api/v1/projects/${project.project_id}/candidates/${candidateId}/remove`);

    // Update local state
    this.candidateProjectMemberships[candidateId] = 
      (this.candidateProjectMemberships[candidateId] || [])
        .filter(id => id !== project.project_id);

  } catch (error) {
    console.error('Failed to remove from project:', error);
    alert(`Failed to remove candidate from "${project.project_name}"`);
  } finally {
    this.removingFromProject[project.project_id] = false;
  }
},
    // Add to methods:
getWorkflowIcon(status) {
  const iconMap = {
    'request-screening': 'fas fa-paper-plane',
    'screening-in-progress': 'fas fa-cogs',
    'screened': 'fas fa-check-circle',
    'hired': 'fas fa-trophy',
    'rejected': 'fas fa-times-circle',
    'validated': 'fas fa-star',
    'approve-for-hire': 'fas fa-thumbs-up'
  };
  return iconMap[status] || 'fas fa-question-circle';
},

formatWorkflowStatus(status) {
  const statusMap = {
    'request-screening': 'Screening Requested',
    'screening-in-progress': 'In Progress',
    'screened': 'Screening Complete',
    'hired': 'Hired',
    'rejected': 'Not Selected',
    'validated': 'Validated',
    'approve-for-hire': 'Approved'
  };
  return statusMap[status] || status;
},
    handleProjectSwitch(oldProjectId, newProjectId) {
      console.log('🔀 Handling project switch');
      // 1. Clear ONLY project-specific caches (NOT projectHistoryCache - it's candidate-specific)
      this.projectStatuses = {};
      this.existingReportsCache = {};
      this.statusFetchAttempted = {};
      this.tagsCollapsed = {};  // Reset to empty = all default to collapsed
  this.candidateTags = {};          // FIX: Clear stale tags from old project
  this.candidateComments = {};      // FIX: Clear stale comments from old project
      // 2. Clear localStorage cache for BOTH old and new projects (new project might have stale data from previous visit)
      const keysToRemove = [];
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key && key.startsWith('gallery:') && (key.includes(oldProjectId) || key.includes(newProjectId))) {
          keysToRemove.push(key);
        }
      }
      keysToRemove.forEach(k => localStorage.removeItem(k));
      console.log(`🧹 Cleared ${keysToRemove.length} localStorage entries for project switch`);
      
      // 3. Force reload status for any expanded candidates
      const expandedCandidateIds = [];
      if (this.results && this.expanded) {
        this.results.forEach((result, index) => {
          if (this.expanded[index]?.main) {
            const candidateId = this.getCandidateId(result);
            if (candidateId) {
              expandedCandidateIds.push(candidateId);
            }
          }
        });
      }
      
      // 4. Reload status for expanded candidates
      if (expandedCandidateIds.length > 0) {
        console.log(`🔄 Reloading status for ${expandedCandidateIds.length} expanded candidates`);
        expandedCandidateIds.forEach(esId => {
          this.loadSingleProjectStatus(esId);
        });
      }
      
      // 5. Reload bulk data if we have results
      // if (this.results && this.results.length > 0) {
      //   this.loadProjectStatus(true);  // FIX: Pass true to force refresh
      // }
    },
    clearProjectSpecificCaches() {
  console.log('🧹 Clearing project-specific caches');
  
  // Clear all project-specific data
  this.projectStatuses = {};
  this.existingReportsCache = {};
  this.projectHistoryCache = {};  // Clear history cache on project switch
  
  // Clear the localStorage cache entries for the old project
  // (optional but recommended for memory management)
  const keys = Object.keys(localStorage).filter(k => 
    k.startsWith('gallery:') && k.includes(':project_status:')
  );
  keys.forEach(k => localStorage.removeItem(k));
  
  // Collapse any expanded cards to force fresh data load
  this.expanded = {};
},
    formatProjectDate(dateString) {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-GB', { 
    day: '2-digit', 
    month: '2-digit', 
    year: 'numeric' 
  });
},
    getProjectCount(result) {
    const candidateId = this.getCandidateId(result);
    return this.projectHistoryCache[candidateId]?.unique_projects || 0;
  },

  async showProjectHistory(candidateId) {
    try {
      // Load if not cached
      if (!this.projectHistoryCache[candidateId]) {
        const response = await axios.get(`/api/v1/candidates/${candidateId}/project-history`);
        this.projectHistoryCache[candidateId] = response.data;
      }
      
      this.selectedCandidateHistory = this.projectHistoryCache[candidateId];
      this.showHistoryModal = true;
    } catch (error) {
      console.error('Failed to load project history:', error);
    }
  },

    // Add to methods section
getCandidateConflictInfo(candidateId) {
  return this.projectStore.getCandidateConflict(candidateId)
},

// Check if candidate is in a DIFFERENT project's pipeline
hasCrossProjectConflict(candidateId) {
  const conflict = this.projectStore.getCandidateConflict(candidateId)
  if (!conflict) return false
  
  // Only conflict if it's a DIFFERENT project
  return conflict.project_id !== this.projectStore.projectId
},
    // ✅ GET CHARACTER COUNT
  getCharCount(candidateId) {
    return (this.newScreeningNote[candidateId] || '').length;
  },
  
  // ✅ GET CSS CLASS BASED ON CHARACTER COUNT
  getCharCounterClass(candidateId) {
    const count = this.getCharCount(candidateId);
    if (count >= 30) return 'char-counter-over';
    if (count >= 45) return 'char-counter-warning';
    return 'char-counter-ok';
  },
    async ensureCandidateData(candidate) {
      const esId = this.getCandidateId(candidate);
  if (!esId) return;
  
  const fromNotification = this.$route.query.from === 'notification';
  
  // Check if already loaded (fast path) - but not if from notification
  // AND not if we need project status for a new project
  const needsProjectStatus = this.projectContext && !this.projectStatuses?.[esId];
  
  if (!fromNotification && !needsProjectStatus && 
      this.candidateTags[esId] && this.candidateComments[esId]) {
    return; // Already have data, no need to fetch
  }
  
  console.log(`🔄 Loading data on-demand for ${esId}`);
  
  
  // Load in parallel with cache-first strategy
  // await Promise.all([
  //   this.loadSingleCandidateTags(esId),
  //   this.loadSingleCandidateComments(esId),
  //   this.loadSingleCandidateBookmark(esId)
  // ]);
  // ✅ ADD PROJECT STATUS TO THE PARALLEL LOAD
  const promises = [
    this.loadSingleCandidateTags(esId),
    this.loadSingleCandidateComments(esId),
    this.loadSingleCandidateBookmark(esId),
    this.loadSingleProjectHistory(esId)  // ✅ ADD THIS LINE

  ];
  
  // Only load project status if in project context
  if (this.projectContext) {
    promises.push(this.loadSingleProjectStatus(esId));
  }
  // ✅ ADD: Load screening report on-demand
  if (this.userRole === 'agent' || this.userRole === 'client') {
    promises.push(this.loadSingleCandidateReport(esId));
  }
  
  await Promise.all(promises);
  // ✅ FIX: Mark status as attempted
  if (!this.statusFetchAttempted) this.statusFetchAttempted = {};
  this.statusFetchAttempted[esId] = true;
},
async loadSingleProjectStatus(esId) {
  if (!this.projectContext) return; // No project context, skip
  
  // Check if already loaded FOR THIS PROJECT (not just any status)
  const existingStatus = this.projectStatuses?.[esId];
  if (existingStatus && existingStatus.project_id === this.projectContext.project_id) {
    return; // Already have status for current project
  }

  // ✅ CHECK CACHE FIRST (30s TTL)
  const cacheKey = this._getCacheKey('project_status', esId, this.projectContext.project_id);
  const cached = this._readCache(cacheKey, 300);
  
  if (cached) {
    console.log(`💾 Cache hit: project_status for ${esId}`);
    if (!this.projectStatuses) this.projectStatuses = {};
    this.projectStatuses[esId] = cached;
    return;
  }
  
  // Cache miss - fetch from API
  try {
    const response = await axios.get(`/api/v1/candidates/${esId}/tags`, {
      params: { project_id: this.projectContext.project_id }
    });
    
  //   const tags = Array.isArray(response.data) ? response.data : response.data?.tags || [];
  //  // const tags = this.candidateTags[esId] || [];

  //   const projectStatusTags = tags.filter(t => 
  //     t.tag_type === 'project_status' && t.project_id === this.projectContext.project_id
  //   );
      const tags = Array.isArray(response.data) ? response.data : response.data?.tags || [];

      // DEBUG: Log what we're comparing
      console.log(`🔍 DEBUG loadSingleProjectStatus for ${esId}:`);
      console.log(`   projectContext.project_id:`, this.projectContext.project_id, `(type: ${typeof this.projectContext.project_id})`);
      console.log(`   Total tags fetched:`, tags.length);
      
      const statusTags = tags.filter(t => t.tag_type === 'project_status');
      console.log(`   project_status tags:`, statusTags.map(t => ({
        tag_value: t.tag_value,
        project_id: t.project_id,
        project_id_type: typeof t.project_id
      })));

      const projectStatusTags = tags.filter(t => 
        t.tag_type === 'project_status' && t.project_id === this.projectContext.project_id
      );
      
    console.log(`   Filtered tags (matching project_id):`, projectStatusTags.length);
    
    let selectedStatus = null;
    if (projectStatusTags.length > 0) {
//const precedence = ['hired', 'rejected', 'candidate-declined', 'interview-done', 'interview-scheduled', 'interview-requested', 'approve-for-hire', 'validated', 'screened', 'tech-interview-scheduled', 'screening-in-progress', 'request-screening'];
const precedence = ['hired', 'rejected', 'candidate-declined', 'interview-done', 'interview-scheduled', 'interview-requested', 'approve-for-hire', 'validated', 'screened', 'tech-interview-done', 'tech-interview-confirmed', 'tech-interview-requested', 'tech-interview-scheduled', 'screening-in-progress', 'request-screening'];
for (const status of precedence) {
        const found = projectStatusTags.find(t => t.tag_value === status);
        if (found) {
          selectedStatus = found;
          break;
        }
      }
    }
    
    if (!this.projectStatuses) this.projectStatuses = {};
    this.projectStatuses[esId] = selectedStatus;
    
    // ✅ WRITE TO CACHE
    this._writeCache(cacheKey, selectedStatus);
    
    console.log(`📊 Loaded project status for ${esId}:`, selectedStatus?.tag_value || 'none');
    
  } catch (error) {
    console.error(`❌ Error loading project status for ${esId}:`, error);
    if (!this.projectStatuses) this.projectStatuses = {};
    this.projectStatuses[esId] = null;
  }
},
async loadSingleCandidateTags(esId) {
  if (this.candidateTags[esId]) return; // Already loaded
  
  // ✅ CHECK CACHE FIRST
  const cacheKey = this._getCacheKey('tags', esId, this.projectContext?.project_id);
  const cached = this._readCache(cacheKey, 300);
  
  if (cached) {
    console.log(`💾 Cache hit: tags for ${esId}`);
    this.candidateTags[esId] = cached;
    return;
  }
  
  // Cache miss - fetch from API
  try {
    const params = this.projectContext ? 
      { project_id: this.projectContext.project_id } : {};
    
    const response = await axios.get(`/api/v1/candidates/${esId}/tags`, { params });
    const allTags = Array.isArray(response.data) ? response.data : response.data?.tags || [];
    
    let filteredTags = allTags;
    if (this.userRole === 'client' && this.projectContext) {
      filteredTags = allTags.filter(tag => 
        tag.tag_type === 'project_status' || 
        tag.tag_type === 'custom'
      );
    }
    
    this.candidateTags[esId] = filteredTags;
    this._writeCache(cacheKey, filteredTags);
    
  } catch (error) {
    console.error(`❌ Error loading tags for ${esId}:`, error);
    this.candidateTags[esId] = [];
  }
},
async loadSingleCandidateReport(esId) {
  if (this.existingReportsCache[esId]) return; // Already loaded
  
  // ✅ CHECK CACHE FIRST (120s TTL)
  const cacheKey = this._getCacheKey('reports', esId, this.projectContext?.project_id);
  const cached = this._readCache(cacheKey, 120);
  
  if (cached) {
    console.log(`💾 Cache hit: reports for ${esId}`);
    this.existingReportsCache[esId] = cached;
    return;
  }
  
  // Cache miss - fetch from API
  try {
    const response = await axios.get(`/api/v1/screening-reports/candidate/${esId}`);
    
    let reports = [];
    if (Array.isArray(response.data)) {
      reports = response.data;
    } else if (response.data && response.data.reports) {
      reports = response.data.reports;
    }
    
    this.existingReportsCache[esId] = reports;
    this._writeCache(cacheKey, reports);
    
    console.log(`📋 Loaded ${reports.length} reports for ${esId}`);
  } catch (error) {
    console.log(`ℹ️ No reports found for candidate ${esId}`);
    this.existingReportsCache[esId] = [];
    this._writeCache(cacheKey, []);
  }
},
async loadSingleProjectHistory(esId) {
  if (this.projectHistoryCache[esId]) return; // Already loaded
  
  try {
    const response = await axios.get(`/api/v1/candidates/${esId}/project-history`);
    this.projectHistoryCache[esId] = response.data;
    console.log(`📋 Loaded project history for ${esId}:`, response.data.unique_projects, 'projects');
  } catch (error) {
    console.error(`❌ Failed to load project history for ${esId}:`, error);
    // Set empty data to prevent repeated calls
    this.projectHistoryCache[esId] = {
      unique_projects: 0,
      total_interactions: 0,
      projects_summary: []
    };
  }
},
async loadSingleCandidateComments(esId) {
  if (this.candidateComments[esId]) return; // Already loaded
  
  // ✅ CHECK CACHE FIRST
  const cacheKey = this._getCacheKey('comments', esId, this.projectContext?.project_id);
  const cached = this._readCache(cacheKey, 300);
  
  if (cached) {
    console.log(`💾 Cache hit: comments for ${esId}`);
    this.candidateComments[esId] = cached;
    return;
  }
  
  // Cache miss - fetch from API
  try {
    const params = this.projectContext ? 
      { project_id: this.projectContext.project_id } : {};
    
    const response = await axios.get(`/api/v1/candidates/${esId}/comments`, { params });
    const comments = response.data.comments || response.data;
    
    this.candidateComments[esId] = comments;
    this._writeCache(cacheKey, comments);
    
  } catch (error) {
    console.error(`❌ Error loading comments for ${esId}:`, error);
    this.candidateComments[esId] = [];
  }
},

async loadSingleCandidateBookmark(esId) {
  if (this.bookmarkedCandidates.has(esId)) return; // Already checked
  
  // ✅ CHECK CACHE FIRST
  const cacheKey = this._getCacheKey('bookmark', esId, this.projectContext?.project_id);
  const cached = this._readCache(cacheKey, 300);
  
  if (cached !== null) {
    console.log(`💾 Cache hit: bookmark for ${esId}`);
    if (cached) {
      this.bookmarkedCandidates.add(esId);
    }
    return;
  }
  
  // Cache miss - fetch from API
  try {
    const response = await axios.get(`/api/v1/candidates/${esId}/bookmark/status`);
    const bookmarked = response.data.bookmarked;
    
    if (bookmarked) {
      this.bookmarkedCandidates.add(esId);
    }
    
    this._writeCache(cacheKey, bookmarked);
    
  } catch (error) {
    console.warn(`Failed to load bookmark for ${esId}:`, error);
    this._writeCache(cacheKey, false);
  }
}, 
    isTagsCollapsed(candidate) {
  const candidateId = this.getCandidateId(candidate);
  // Default to collapsed (true) for clean initial view
  return this.tagsCollapsed[candidateId] !== false;
},

async toggleTagsCollapse(candidate) {
  const candidateId = this.getCandidateId(candidate);
  const willExpand = this.isTagsCollapsed(candidate);
  
  // Toggle immediately for responsive UI
  this.tagsCollapsed[candidateId] = !willExpand;
  
  // If expanding, ensure data is loaded
  if (willExpand) {
    await this.ensureCandidateData(candidate);
  }
},
     async toggleHotListDropdown(candidateId) {
      const isOpen = this.hotListDropdownOpen[candidateId];
      
      // Close all other dropdowns
      this.hotListDropdownOpen = {};
      
      if (!isOpen) {
        // Open this dropdown
        this.hotListDropdownOpen[candidateId] = true;
        
        // Load hot lists and memberships
        await Promise.all([
          this.loadAvailableHotLists(),
          this.loadCandidateHotListMemberships(candidateId)
        ]);
      }
    },
    
    isHotListDropdownOpen(candidateId) {
      return this.hotListDropdownOpen[candidateId] || false;
    },
    
    closeHotListDropdown() {
      this.hotListDropdownOpen = {};
    },
    
    async loadAvailableHotLists() {
      if (this.availableHotLists.length > 0) {
        return; // Already loaded
      }
      
      try {
        this.loadingHotLists = true;
        const response = await axios.get('/api/v1/hot-lists');
        this.availableHotLists = response.data.hot_lists || [];
      } catch (error) {
        console.error('Failed to load hot lists:', error);
        this.availableHotLists = [];
      } finally {
        this.loadingHotLists = false;
      }
    },
    
    async loadCandidateHotListMemberships(candidateId) {
      try {
        const response = await axios.get(
          `/api/v1/candidates/${candidateId}/hot-list-memberships`
        );
        
        const hotListIds = response.data.hot_lists.map(hl => hl.hot_list_id);
        this.candidateHotListMemberships[candidateId] = hotListIds;
        
      } catch (error) {
        console.error('Failed to load memberships:', error);
        this.candidateHotListMemberships[candidateId] = [];
      }
    },
    
    isInHotList(result, hotListId) {
      const candidateId = this.getCandidateId(result);
      const memberships = this.candidateHotListMemberships[candidateId] || [];
      return memberships.includes(hotListId);
    },
    
    async addToHotList(result, hotList) {
  const candidateId = this.getCandidateId(result);
  
  if (this.isInHotList(result, hotList.hot_list_id)) {
    return; // Already added
  }
  
  try {
    // ✅ Vue 3: Direct assignment (no $set needed)
    this.addingToHotList[hotList.hot_list_id] = true;
    
    await axios.post(
      `/api/v1/hot-lists/${hotList.hot_list_id}/candidates/${candidateId}/add`
    );
    
    // ✅ Update local state (direct assignment)
    if (!this.candidateHotListMemberships[candidateId]) {
      this.candidateHotListMemberships[candidateId] = [];
    }
    this.candidateHotListMemberships[candidateId].push(hotList.hot_list_id);
    
    console.log(`✅ Added ${candidateId} to "${hotList.name}"`);
    
    // Show brief success feedback
    setTimeout(() => {
      this.closeHotListDropdown();
    }, 800);
    
  } catch (error) {
    console.error('Failed to add to hot list:', error);
    alert(`Failed to add candidate to "${hotList.name}"`);
  } finally {
    // ✅ Clean up loading state
    this.addingToHotList[hotList.hot_list_id] = false;
  }
},
    
    getCandidateHotListIcon(result) {
      const candidateId = this.getCandidateId(result);
      const memberships = this.candidateHotListMemberships[candidateId] || [];
      
      if (memberships.length > 0) {
        return 'fas fa-check-circle'; // Already in some hot lists
      }
      return 'fas fa-fire'; // Not in any hot lists
    },
    
    getHotListButtonTitle(result) {
      const candidateId = this.getCandidateId(result);
      const memberships = this.candidateHotListMemberships[candidateId] || [];
       
      if (memberships.length > 0) {
        return `In ${memberships.length} hot list${memberships.length > 1 ? 's' : ''}`;
      }
      return 'Add to hot list';
    },
    async hideFromHotList(result) {
      const candidateId = this.getCandidateId(result);
      
      if (!confirm(`Remove this candidate from your hot list?\n\nThey won't appear in future refreshes.`)) {
        return;
      }
      
      try {
        await axios.post(
          `/api/v1/hot-lists/${this.activeHotListId}/candidates/${candidateId}/hide`
        );
        
        // Optimistic update: remove from UI immediately
        this.$emit('candidate-hidden', candidateId);
        
        // Show success message
        this.$emit('show-toast', {
          message: 'Candidate removed from hot list',
          type: 'success'
        });
        
      } catch (error) {
        console.error('Failed to hide candidate:', error);
        this.$emit('show-toast', {
          message: 'Failed to remove candidate',
          type: 'error'
        });
      }
    },
// Match breakdown methods
// Match breakdown methods
toggleMatchBreakdown(candidateId) {
  console.log('🔍 Toggle breakdown for:', candidateId);
  console.log('🔍 Current state:', this.matchBreakdownOpen[candidateId]);
  
  // Vue 3: Direct assignment is reactive
  this.matchBreakdownOpen[candidateId] = !this.matchBreakdownOpen[candidateId];
  
  console.log('🔍 New state:', this.matchBreakdownOpen[candidateId]);
},

isMatchBreakdownOpen(candidateId) {
  return this.matchBreakdownOpen[candidateId] || false;
},

isMatchBreakdownOpen(candidateId) {
  return this.matchBreakdownOpen[candidateId] || false;
},
getMatchIcon(sourceType) {
  const icons = {
    'hybrid': 'fas fa-layer-group',
    'keyword': 'fas fa-key',
    'semantic': 'fas fa-brain'
  };
  return icons[sourceType] || 'fas fa-chart-line';
},

formatSourceType(sourceType) {
  const labels = {
    'hybrid': 'Hybrid Match',
    'keyword': 'Keyword Match',
    'semantic': 'Semantic Match'
  };
  return labels[sourceType] || sourceType;
},

formatMatchReason(reason) {
  // Parse "HYBRID-BOTH: kw=100%, sem=82%" into readable format
  if (!reason) return '';
  
  // Remove technical prefixes like "HYBRID-BOTH:", "HYBRID-SEMANTIC:"
  return reason.replace(/^[A-Z-]+:\s*/, '').trim();
},

formatBreakdownLabel(key) {
  const labels = {
    'job_title': 'Job Title',
    'responsibilities': 'Responsibilities',
    'required_skills': 'Required Skills',
    'nice_skills': 'Nice-to-Have Skills',
    'additional_context': 'Context Match'
  };
  return labels[key] || key.replace(/_/g, ' ');
},
// ============================================
// CACHE HELPERS (add to top of methods)
// ============================================
_getCacheKey(type, candidateId, projectId = null) {
  const base = `gallery:${type}:${candidateId}`;
  return projectId ? `${base}:${projectId}` : base;
},

_readCache(key, ttlSeconds = 30) {
  try {
    const cached = localStorage.getItem(key);
    if (!cached) return null;
    
    const { data, timestamp } = JSON.parse(cached);
    const age = (Date.now() - timestamp) / 1000;
    
    if (age > ttlSeconds) {
      localStorage.removeItem(key);
      return null;
    }
    
    return data;
  } catch {
    return null;
  }
},

_writeCache(key, data) {
  try {
    localStorage.setItem(key, JSON.stringify({
      data,
      timestamp: Date.now()
    }));
  } catch (error) {
    console.warn('Cache write failed:', error);
  }
},





    getCandidateResumeData(result) {
  const baseCandidateId = this.getBaseCandidateId(result);
  return this.candidateResumesData[baseCandidateId] || { count: 0, resumes: [] };
},

    openReformatter(candidateId,esDocumentId) {
      console.log("🎨 Opening Reformatter editor for:");
      console.log("   candidateId:", candidateId);
      console.log("   esDocumentId:", esDocumentId);
      
      
      // if (!candidateId) {
      //   this.showNotification('Cannot reformat: Missing candidate ID', 'error');
      //   return;
      // }
      if (!esDocumentId && !candidateId) {
        console.error("❌ No identifier available for reformat");
        this.showNotification('Cannot logo edit resume: Missing ID', 'error');
        return;
      }

      this.downloadMenuOpen = null; // Close dropdown
      const identifier = esDocumentId || candidateId;
      const idType = esDocumentId ? 'es_id' : 'candidate_id';
      this.reformatterCandidateId = identifier;
      this.reformatteridType = idType;
      this.showReformatter = true;
    },
    
    handleReformatterClose() {
      this.showReformatter = false;
      this.reformatterCandidateId = null;
       this.reformatterIdType = null;  // ✅ ADD THIS LINE

    },
    
    handleReformatGenerated() {
      this.showNotification('Resume generated! Review and export.', 'success');
    },
    
    handleReformatExportComplete() {
      this.showNotification('Reformatted resume exported successfully!', 'success');
      this.showReformatter = false;
    },
    
    handleReformatterError(message) {
      this.showNotification(`Reformat failed: ${message}`, 'error');
    },
  
 

 
    toggleJobOfferInput(candidateId) {
    if (this.reformatLoading[candidateId]) return; // Don't toggle while loading
    
    // Toggle the job offer input visibility
    this.showJobOfferInput[candidateId] = !this.showJobOfferInput[candidateId];
    
    // Close dropdown menu
    this.downloadMenuOpen = null;
  },
  
  cancelJobOfferInput(candidateId) {
    this.showJobOfferInput[candidateId] = false;
    this.jobOfferInput[candidateId] = '';
  },


  async startReformat(candidateId) {
    if (!candidateId) {
      this.showNotification('Cannot reformat: Missing candidate ID', 'error');
      return;
    }
    
    // Set loading state
    this.reformatLoading[candidateId] = true;
    
    this.showNotification('AI is reformatting your resume...', 'info');
    
    try {
      const params = new URLSearchParams();
      
      if (this.downloadOptions.includeContact) {
        params.append('include_contact', 'true');
      }
      if (this.downloadOptions.includeName) {
        params.append('include_name', 'true');
      }
      if (!this.downloadOptions.includeLogo) {
        params.append('include_logo', 'false');
      }
      
      // job description if checkbox is checked and text provided
      const jobOffer = this.jobOfferInput[candidateId];
      if (this.showJobOfferInput[candidateId] && jobOffer && jobOffer.trim()) {
        params.append('job_description', jobOffer.trim());
      }
      
      const apiBaseUrl = this.getApiBaseUrl();
      const url = `${apiBaseUrl}/api/v1/export_resume/${candidateId}/reformat${params.toString() ? '?' + params.toString() : ''}`;
      
      console.log('🔥 Reformat URL:', url);
      
      // Create download link
      const link = document.createElement('a');
      link.href = url;
      link.download = `resume_${candidateId}_reformatted.pdf`;
      link.style.display = 'none';
      
      document.body.appendChild(link);
      link.click();
      
      setTimeout(() => document.body.removeChild(link), 100);
      
      // Wait before showing success
      setTimeout(() => {
        this.showNotification('Reformatted resume download started!', 'success');
        this.reformatLoading[candidateId] = false;
        
        // Clear job offer input and uncheck after successful reformat
        this.jobOfferInput[candidateId] = '';
        this.showJobOfferInput[candidateId] = false;
      }, 3000);
      
    } catch (error) {
      console.error('❌ Reformat error:', error);
      this.showNotification('Reformatting failed', 'error');
      this.reformatLoading[candidateId] = false;
    }
  },
    async downloadReformattedResume(candidateId) {
    if (!candidateId) {
      this.showNotification('Cannot reformat: Missing candidate ID', 'error');
      return;
    }
    
    this.downloadMenuOpen = null;
    this.reformatLoading[candidateId] = true;

    // this.$set(this.reformatLoading, candidateId, true);
    
    this.showNotification('AI is reformatting your resume... (~30-60 seconds)', 'info');
    
    try {
      const params = new URLSearchParams();
      if (this.downloadOptions.includeContact) params.append('include_contact', 'true');
      if (this.downloadOptions.includeName) params.append('include_name', 'true');
      if (!this.downloadOptions.includeLogo) params.append('include_logo', 'false');
      
      const apiBaseUrl = this.getApiBaseUrl();
      const url = `${apiBaseUrl}/api/v1/export_resume/${candidateId}/reformat${params.toString() ? '?' + params.toString() : ''}`;
      
      const link = document.createElement('a');
      link.href = url;
      link.download = `resume_${candidateId}_reformatted.pdf`;
      link.style.display = 'none';
      
      document.body.appendChild(link);
      link.click();
      
      setTimeout(() => document.body.removeChild(link), 100);
      // Clean up
      // setTimeout(() => {
      //   document.body.removeChild(link);
      // }, 100);
      
      // Show success
      setTimeout(() => {
        this.showNotification('Reformatted resume download started!', 'success');
      }, 500);
      
      
    } catch (error) {
      console.error('❌ Reformat error:', error);
      this.showNotification('Reformatting failed', 'error');
      this.showNotification('Failed to download screening report', 'error');

      // this.$set(this.reformatLoading, candidateId, false);
    }
  },
    getPercent(result) {
  // Prefer backend-calculated percent
  if (result.score_percent !== undefined) {
    return result.score_percent;
  }
  
  // Fallback: Use max_score from searchResults
  const max_score = this.searchResults?.max_score || 1;
  const score = result.score || 0;
  
  if (max_score === 0) return 0;
  
  return Math.max(0, Math.min(100, Math.round((score / max_score) * 100)));
},

    async openLogoEditor(candidateId,esDocumentId) {
  console.log("🎨 Opening logo editor for:");
  console.log("   candidateId:", candidateId);
  console.log("   esDocumentId:", esDocumentId);
  
  if (!esDocumentId && !candidateId) {
    console.error("❌ No identifier available for download");
    this.showNotification('Cannot logo edit resume: Missing ID', 'error');
    return;
  }
  // Close download menu
  this.downloadMenuOpen = null;
  this.downloadMenuOpen = null;
if (this.userRole !== 'client') {axios.post(`/api/v1/agent-views/${candidateId || esDocumentId}`).catch(() => {});}
  // Show loading
  this.showNotification('Loading logo preview...', 'info');
  
  try {
    // Prefer ES ID (always unique), fallback to candidate_id
    const identifier = esDocumentId || candidateId;
    const idType = esDocumentId ? 'es_id' : 'candidate_id';
    // USE THE NEW PROXIED ENDPOINT (no CORS issues!)
    const apiBaseUrl = this.getApiBaseUrl();
    const pdfUrl = `${apiBaseUrl}/api/v1/resume/${encodeURIComponent(identifier)}/pdf-preview?id_type=${idType}`;  // ✅ ADDED id_type query param
    
    console.log('📄 Using proxied PDF URL:', pdfUrl);
    
    // Store candidate ID and proxied PDF URL
    this.logoEditorCandidateId = identifier;
    this.logoEditoridType = idType;            // ✅ ADD THIS LINE

    this.logoEditorPdfUrl = pdfUrl;
    
    // Show the editor (it will load the PDF from our proxied endpoint)
    this.showLogoEditor = true;
    
    console.log('✅ Logo editor opened with proxied PDF URL');
    
  } catch (error) {
    console.error('❌ Failed to open editor:', error);
    this.showNotification(`Failed to load PDF: ${error.message}`, 'error');
  }
},
  closeLogoEditor() {
    this.showLogoEditor = false;
    this.logoEditorCandidateId = null;
    this.logoEditoridType = null;  // ✅ ADD THIS LINE

    this.logoEditorPdfUrl = null;
  },
  
  onLogoExportSuccess() {
    console.log('✅ Logo export completed');
    this.showNotification('Resume with logo exported successfully!', 'success');
    this.closeLogoEditor();
  },
  
  getApiBaseUrl() {
    if (process.env.NODE_ENV === 'development') {
      return process.env.VUE_APP_API_BASE_URL || 'http://localhost:8000';
    }
    return ''; // Production uses nginx proxy
  },
  closeLogoEditor() {
    this.showLogoEditor = false;
    this.logoEditorCandidateId = null;
  },
  
  onLogoExportSuccess() {
    console.log('✅ Logo export completed');
    this.showNotification('Resume with logo exported successfully!', 'success');
    this.closeLogoEditor();
  },
     onLogoExportSuccess() {
      console.log('✅ Logo export completed');
      this.showNotification('Resume with logo exported successfully!', 'success');

    },
    
    downloadAnonymous() {
      // Your existing export logic
      window.open(`/api/v1/export_resume/${this.candidateId}?include_contact=false&include_logo=true`, '_blank');
    },
    //edit resumes 
    // new method to open editor
  async openResumeEditor(candidateId) {

  if (!candidateId) {
    console.error('❌ No candidate ID provided to editor');
    this.showNotification('Cannot open editor: Missing candidate ID', 'error');
    return;
  }

  // Close dropdown first
  this.downloadMenuOpen = null;
    try {
      this.showNotification('Loading resume for editing...', 'info');
      
      // Fetch full resume data from ES
      const apiBaseUrl = this.getApiBaseUrl();
      const response = await axios.get(`/api/v1/get_resume/${candidateId}/`);
      
      // if (!response.ok) {
      //   throw new Error('Failed to load resume');
      // }
      
      // const resumeData = await response.json();

      const resumeData = response.data
      console.log('✅ Resume loaded for editing:', candidateId);
    
      // Open editor with data
      this.editorResumeData = resumeData;
      this.showEditor = true;
      
    } catch (error) {
      console.error('Failed to open editor:', error);
      this.showNotification('Failed to load resume for editing', 'error');
    }
  },
  
  handleEditorClose() {
    this.showEditor = false;
    this.editorResumeData = null;
  },
  
  // handleExportComplete() {
    handleSaveComplete(message) {
    this.showNotification(message, 'success');
    // Optionally reload the candidate data
    // this.loadCandidateData();
 },

handleEditorError(message) {
    this.showNotification(`Export failed: ${message}`, 'error');
  },

  // consult cap methods  
  async loadConsultationLimits() {
  if (!this.projectContext?.project_id || this.userRole !== 'client') return;
  
  try {
    this.loadingLimits = true;
    
    // Load limits
    const response = await axios.get(`/api/v1/projects/${this.projectContext.project_id}/consultation_limits`);
    this.consultationLimits = response.data;
    
    // Load consulted candidates list
    const poolResponse = await axios.get(`/api/v1/projects/${this.projectContext.project_id}/candidate_pool/`);
    const poolData = poolResponse.data;
    
    // Update the consulted candidates set
    this.consultedCandidates = new Set(poolData.candidate_ids || []);
    
  } catch (error) {
    console.warn('Failed to load consultation limits:', error);
    this.consultationLimits = null;
    this.consultedCandidates = new Set();
  } finally {
    this.loadingLimits = false;
  }
},

async checkConsultationLimit(interactionType) {
  if (!this.consultationLimits) return true; // Allow if limits not loaded
  
  if (interactionType === 'consulted') {
    return this.consultationLimits.can_consult;
  } else if (interactionType === 'screened') {
    return this.consultationLimits.can_screen;
  }
  return true;
},

showLimitExceededMessage(type) {
  this.limitExceededType = type;
  this.limitExceededModal = true;
},

// getCandidateDisplayName(candidate) {
//   if (!this.projectContext || this.userRole !== 'client') {
//     // Show full name for agents or when no project context
//     return candidate.name || 'Unknown';
//   }
  
//   const candidateId = this.getCandidateId(candidate);
  
//   // Check if already consulted (synchronous check against local state)
//   const isConsulted = this.consultedCandidates && this.consultedCandidates.has(candidateId);
  
//   if (isConsulted) {
//     // Show full name if already consulted
//     return candidate.name || 'Unknown';
//   } else {
//     // Show masked name
//     const fullName = candidate.name || 'Unknown';
//     const nameParts = fullName.split(' ');
//     if (nameParts.length >= 2) {
//       return `${nameParts[0]} ${nameParts[nameParts.length - 1][0]}.`;
//     }
//     return nameParts[0] || 'Unknown';
//   }
// },
// ✅ SIMPLE VERSION:
getCandidateDisplayName(candidate) {
  // Backend now handles obscuring - just return the name
  return candidate.name || 'Unknown';
},

hasConsultedCandidate(candidateId) {
  // Check if this candidate was already consulted by checking candidate_pools
  if (!this.consultationLimits) return false;

  try {
    const response = axios.get(`/api/v1/projects/${this.projectContext.project_id}/candidate_pool/`);
    const consultedIds = response.data.candidate_ids || [];
    return consultedIds.includes(candidateId);
  } catch (error) {
    return false; // Safe default
  }
},


    getCompletedReportId(candidate) {
  const esId = this.getCandidateId(candidate);
  const reports = this.existingReportsCache[esId] || [];
  const completedReport = reports.find(r => 
    r.status === 'completed' && 
    r.project_id === this.projectContext?.project_id
  );
  return completedReport?.id;
},
  // to existing download methods in GallerySection.vue
// Replace the existing downloadScreeningReport method with this:
async downloadScreeningReport(candidate, reportId) {
  console.log(`📋 Downloading screening report ${reportId} for candidate:`, candidate);
  
  if (!reportId) {
    this.showNotification('Cannot download report: Missing report ID', 'error');
    return;
  }
  
  try {
    const apiBaseUrl = this.getApiBaseUrl();
    const url = `${apiBaseUrl}/api/v1/screening-reports/${reportId}/download`;
    
    console.log('📥 Screening report download URL:', url);
    
    this.showNotification('Preparing screening report download...', 'info');
    
    // Open in new tab (doesn't redirect current page)
    const link = document.createElement('a');
    link.href = url;
    link.target = '_blank';  // Open in new tab/window
    link.download = `screening_report_${reportId}.pdf`;
    link.style.display = 'none';
    
    document.body.appendChild(link);
    link.click();
    
    // Clean up
    setTimeout(() => {
      document.body.removeChild(link);
    }, 100);
    
    // Show success
    setTimeout(() => {
      this.showNotification('Screening report download started', 'success');
    }, 500);
    
  } catch (error) {
    console.error('Screening report download failed:', error);
    this.showNotification('Failed to download screening report', 'error');
  }
},


     isStatusCollapsed(candidate) {
    const candidateId = this.getCandidateId(candidate);
    return this.statusCollapsed[candidateId] || false;
  },
  
  toggleStatusCollapse(candidate) {
    const candidateId = this.getCandidateId(candidate);
    if (!this.statusCollapsed) this.statusCollapsed = {};
    this.statusCollapsed[candidateId] = !this.statusCollapsed[candidateId];
  },
  
  getStatusCollapseState(candidate) {
  const candidateId = this.getCandidateId(candidate);
  const isLoading = this.isCardLoading(candidate);
  
  if (isLoading) {
    // Auto-collapse during loading
    if (!this.statusCollapsed) this.statusCollapsed = {};
    this.statusCollapsed[candidateId] = true;
    return true;
  }
  
  // FIX: Only auto-uncollapse when we actually have status data
  if (this.statusFetchAttempted[candidateId] && 
      this.statusCollapsed[candidateId] === true && 
      this.projectStatuses.hasOwnProperty(candidateId)) {
    this.statusCollapsed[candidateId] = false;
    return false;
  }
  
  return this.statusCollapsed[candidateId] || false;
},
    isCardLoading(candidate) {
        // Show loading during global initialization
      if (this.isInitializing) return true;
      
      if (this.projectContext) {
        const candidateId = this.getCandidateId(candidate);
        // Only shimmer if we haven't attempted to fetch this candidate's status yet
        return !this.statusFetchAttempted[candidateId];
      }
      
      return false;
   },
    // Check if status is still loading for a specific candidate
  isStatusLoading(candidate) {
    return false;

    // if (!this.projectContext) return false;
    
    // const candidateId = this.getCandidateId(candidate);
    
    // // Status is loading if:
    // // 1. Component is still initializing, OR
    // // 2. We have project context but no status data for this candidate yet
    // return (
    //   this.isInitializing || 
    //   (this.projectContext && !this.projectStatuses[candidateId])
    // );
  },
  
  // Get display text for loading state
  getStatusDisplayText(candidate) {
    if (this.isStatusLoading(candidate)) {
      return 'Loading...';
    }
    return this.getProjectStatusDisplay(candidate);
  },
  
     // Reinitialize when project context becomes available
  // async reinitializeWithProjectContext() {
  //   if (!this.projectContext || !this.userRole) {
  //     console.log('⏳ Waiting for both context and role to be available');
  //     return;
  //   }
    
  //   console.log('🚀 Reinitializing with project context:', this.projectContext.project_id);
    
  //   try {
  //     // Clear any existing state that might be from global mode
  //     this.projectStatuses = {};
  //     this.existingReportsCache = {};
      
  //     // Reload project-specific data
  //     await this.loadProjectStatus();
  //     await this.loadExistingReportsCache();
  //     await this.loadCandidateTags();
  //     await this.loadCandidateComments();
      
  //     console.log('✅ Project context reinitialization complete');
      
  //   } catch (error) {
  //     console.error('❌ Error during project context reinitialization:', error);
  //   }
  // },
  async reinitializeWithProjectContext() {
  if (!this.projectContext || !this.userRole) {
    console.log('⏳ Waiting for both context and role to be available');
    return;
  }
  
  // ✅ FIX: Don't load candidate data if no results
  if (!this.results || this.results.length === 0) {
    console.log('📭 No search results yet, skipping candidate data load');
    // Clear any stale state
    this.projectStatuses = {};
    this.existingReportsCache = {};
    return;
  }
  
  console.log('🚀 Reinitializing with project context:', this.projectContext.project_id);
  
  try {
    // Clear stale state
    this.projectStatuses = {};
    this.existingReportsCache = {};
    this.projectHistoryCache = {};  // ADD THIS - clear history cache

      // ✅ FIX: Pool mode should NOT eager load - everything is lazy
    if (this.poolMode) {
      console.log('🏊 Pool mode detected - using fully lazy loading');
      // Only initialize empty structures, no API calls
      return;
    }
     // ✅ FIX: Skip workflow data if project is completed
     if (this.projectStatus === 'COMPLETED') {
      console.log('📁 Project COMPLETED - loading only comments');
      await this.loadCandidateComments();
      return;
    }
    // Load project-specific data ONLY if we have results
    console.log('⚡ Project ACTIVE - loading full workflow data');

    await this.loadProjectStatus();
        await this.loadCandidateComments();

    await this.loadCandidateTags();
        await this.loadExistingReportsCache();

    
    console.log('✅ Project context reinitialization complete');
    
  } catch (error) {
    console.error('❌ Error during project context reinitialization:', error);
  }
},
  
  // Switch to global mode when project context is removed
  switchToGlobalMode() {
    console.log('🌐 Switching to global mode');
    
    // Clear project-specific state
    this.projectStatuses = {};
    this.existingReportsCache = {};
    
    // Reload in global mode
    this.loadCandidateTags();
  },
    // Toggle note collapse for client
toggleNoteCollapse(candidate) {
  const esId = this.getCandidateId(candidate);
  this.collapsedNotes = {
    ...this.collapsedNotes,
    [esId]: !this.collapsedNotes[esId]
  };
},

// Check if note is collapsed
isNoteCollapsed(candidate) {
  const esId = this.getCandidateId(candidate);
  return this.collapsedNotes[esId] || false;
},
    getProjectStatusClass(candidate) {
  const status = this.getProjectStatus(candidate);
  const classMap = {
    'request-screening': 'status-requested',
    'screening-in-progress': 'status-progress', 
    'screened': 'status-completed',
    'contacted': 'status-contacted',
    'candidate-responded': 'status-responded',
    'rate-negotiation': 'status-negotiation',
    'validated': 'status-validated',
    'approve-for-hire': 'status-approved',
    'rejected': 'status-rejected',
    'hired': 'status-hired',
    'candidate-declined': 'status-declined',
'tech-interview-scheduled':  'status-tech-planned',
'tech-interview-requested':  'status-tech-requested',
'tech-interview-confirmed':  'status-tech-confirmed',
'tech-interview-done':       'status-tech-done',
    'interview-requested': 'status-interview-requested',
'interview-done':      'status-interview-done',

  };
  return classMap[status] || 'status-none';
},
    // this temporary debug method (you can remove it after fixing):
// async debugApiResponse(candidateId) {
//   try {
//     const response = await axios.get(`/api/v1/candidates/${candidateId}/tags`, {
//       params: { project_id: this.projectContext?.project_id }
//     });
    
//     console.log('🔍 API Response Debug for', candidateId);
//     console.log('Full response:', response);
//     console.log('response.data:', response.data);
//     console.log('response.data.tags:', response.data?.tags);
//     console.log('Is array?', Array.isArray(response.data));
//     console.log('Data type:', typeof response.data);
    
//   } catch (error) {
//     console.error('Debug API call failed:', error);
//   }
// },

// You can call this temporarily in mounted() to see what's happening:
// this.debugApiResponse('SOA-d310');
     // ===== SCREENING REPORT METHODS =====
  // Check if candidate has completed report for current project
hasCompletedReportForCurrentProject(candidate) {
  if (!this.projectContext) return false;
  
  const esId = this.getCandidateId(candidate);
  const reports = this.existingReportsCache[esId] || [];
  
  return reports.some(r => 
    r.status === 'completed' && 
    r.project_id === this.projectContext.project_id
  );
},
// Check if screening can be completed (has draft or completed report)
canCompleteScreening(candidate) {
  return this.hasDraftForCurrentProject(candidate) || 
         this.hasCompletedReportForCurrentProject(candidate);
},

// Enhanced complete screening that enforces report creation
async completeScreeningWithReport(candidate) {
  const esId = this.getCandidateId(candidate);
  
  // Check if there's a draft that needs to be completed first
  if (this.hasDraftForCurrentProject(candidate) && !this.hasCompletedReportForCurrentProject(candidate)) {
    this.showNotification('Please complete your draft report first', 'warning');
    this.openScreeningModal(candidate);
    return;
  }
  
  // If has completed report, proceed with screening completion
  if (this.hasCompletedReportForCurrentProject(candidate)) {
    try {
      this.loadingProjectStatus = true;
      
      // Update candidate tag to 'screened' (this will trigger the notification)
      await axios.post(`/api/v1/candidates/${esId}/tags`, {
        tag_type: 'project_status',
        tag_value: 'screened',
        project_id: this.projectContext.project_id
      });
      
      await this.loadProjectStatus();
      this.showNotification('Screening completed successfully!', 'success');
      
    } catch (error) {
      console.error('Error completing screening:', error);
      this.showNotification('Failed to complete screening', 'error');
    } finally {
      this.loadingProjectStatus = false;
    }
  } else {
    this.showNotification('Please create a screening report first', 'error');
  }
},
  // Check if candidate has existing reports
  hasExistingReports(candidate) {
  const esId = this.getCandidateId(candidate);
  const reports = this.existingReportsCache[esId] || [];
  // Check for any reports (drafts or completed) for this candidate
  return reports.length > 0;
},
getExistingReportsCount(candidate) {
  const esId = this.getCandidateId(candidate);
  const reports = this.existingReportsCache[esId] || [];
  const projectReports = reports.filter(r => r.project_id === this.projectContext?.project_id || true);
  return projectReports.length;
},
hasDraftForCurrentProject(candidate) {
  if (!this.projectContext) return false;
  
  const esId = this.getCandidateId(candidate);
  const reports = this.existingReportsCache[esId] || [];
  
  return reports.some(r => 
    r.status === 'draft' && 
    r.project_id === this.projectContext.project_id
  );
},
// async loadExistingReportsCache() {
//   if (!this.results || this.results.length === 0) return;
  
//   try {
//     // Get all candidate IDs
//     const candidateIds = this.results.map(r => this.getCandidateId(r));
    
//     // Load reports for each candidate
//     for (const candidateId of candidateIds) {
//       try {
//         const response = await axios.get(`/api/v1/screening-reports/candidate/${candidateId}`);
        
//         // FIX: Handle the actual API response structure
//         let reports = [];
//         if (Array.isArray(response.data)) {
//           reports = response.data;
//         } else if (response.data && response.data.reports) {
//           reports = response.data.reports;
//         } else {
//           reports = [];
//         }
        
//         this.existingReportsCache[candidateId] = reports;
//         console.log(`📋 Loaded ${reports.length} reports for candidate ${candidateId}`);
//       } catch (error) {
//         // Skip if no reports found for this candidate
//         this.existingReportsCache[candidateId] = [];
//         console.log(`ℹ️ No reports found for candidate ${candidateId}`);
//       }
//     }
//   } catch (error) {
//     console.error('Error loading existing reports cache:', error);
//   }
// },
 
// async loadExistingReportsCache() {
//   if (!this.results || this.results.length === 0) return;
//   console.log('📋 Loading screening reports with cache...');
  
//   const candidateIds = this.results.map(r => this.getCandidateId(r));
  
//   for (const candidateId of candidateIds) {
//     // ✅ CHECK CACHE FIRST (120s TTL for reports - they change rarely)
//     const cacheKey = this._getCacheKey('reports', candidateId, this.projectContext?.project_id);
//     const cached = this._readCache(cacheKey, 120);
    
//     if (cached) {
//       this.existingReportsCache[candidateId] = cached;
//       console.log(`💾 Cache hit: reports for ${candidateId}`);
//       continue;
//     }
    
//     // Cache miss - fetch from API
//     try {
//       const response = await axios.get(`/api/v1/screening-reports/candidate/${candidateId}`);
      
//       let reports = [];
//       if (Array.isArray(response.data)) {
//         reports = response.data;
//       } else if (response.data && response.data.reports) {
//         reports = response.data.reports;
//       }
      
//       this.existingReportsCache[candidateId] = reports;
      
//       // ✅ WRITE TO CACHE
//       this._writeCache(cacheKey, reports);
      
//       console.log(`📋 Loaded ${reports.length} reports for ${candidateId}`);
//     } catch (error) {
//       this.existingReportsCache[candidateId] = [];
//     }
//   }
// },
async loadExistingReportsCache() {
  if (!this.results || this.results.length === 0) return;
  if (this.skipHeavyLoading) {
    console.log('⏭️ Skipping screening reports in pool mode (will load on-demand)');
    return;
  }
  console.log('📋 Loading screening reports with cache...');
  
  const candidateIds = this.results.map(r => this.getCandidateId(r));
  
  // ✅ USE PROMISE.ALL FOR PARALLEL LOADING
  const reportPromises = candidateIds.map(async (candidateId) => {
    // ✅ CHECK CACHE FIRST (120s TTL)
    const cacheKey = this._getCacheKey('reports', candidateId, this.projectContext?.project_id);
    const cached = this._readCache(cacheKey, 120);
    
    if (cached) {
      console.log(`💾 Cache hit: reports for ${candidateId}`);
      return { candidateId, reports: cached };
    }
    
    // Cache miss - fetch from API
    try {
      const response = await axios.get(`/api/v1/screening-reports/candidate/${candidateId}`);
      
      let reports = [];
      if (Array.isArray(response.data)) {
        reports = response.data;
      } else if (response.data && response.data.reports) {
        reports = response.data.reports;
      }
      
      // ✅ WRITE TO CACHE
      this._writeCache(cacheKey, reports);
      
      console.log(`📋 Loaded ${reports.length} reports for ${candidateId}`);
      return { candidateId, reports };
    } catch (error) {
      console.log(`ℹ️ No reports found for candidate ${candidateId}`);
      // Cache empty array
      this._writeCache(cacheKey, []);
      return { candidateId, reports: [] };
    }
  });
  
  // ✅ WAIT FOR ALL TO COMPLETE IN PARALLEL
  const results = await Promise.all(reportPromises);
  
  // Store results
  results.forEach(({ candidateId, reports }) => {
    this.existingReportsCache[candidateId] = reports;
  });
  
  console.log(`📋 Loaded reports for ${results.length} candidates`);
},


  // Open screening modal
  async openScreeningModal(candidate) {
  this.currentScreeningCandidate = candidate;
  const esId = this.getCandidateId(candidate);

  this.showScreeningModal = true;
  this.loadingReport = true;
  this.selectedReportOption = 'new';
  this.formStatus = null;
  this.resetScreeningForm();
  this.currentReportId = null;
  this.screeningStep = 'hr';
  this.hrFormData = {};
  this.techFormData = {};
  this.pendingTechReportId = null;

  // Resolve current user ID if not already done
  if (!this.currentUserId) {
    try {
      const { authService } = await import('@/services/auth.js');
      const cognitoUser = await authService.getCurrentUser();
      this.currentUserId = cognitoUser?.userId || cognitoUser?.attributes?.sub || cognitoUser?.username || null;
    } catch (e) {
      console.warn('Could not resolve currentUserId', e);
    }
  }

  try {
    const [templateRes, reportsRes, agentsRes] = await Promise.all([
      axios.get(`/api/v1/screening-templates?project_id=${this.projectContext?.project_id}`).catch(() => null),
      axios.get(`/api/v1/screening-reports/candidate/${esId}`),
      this.projectContext?.project_id
        ? axios.get(`/api/v1/projects/${this.projectContext.project_id}/agents`).catch(() => null)
        : Promise.resolve(null)
    ]);

    // Template
    if (templateRes?.data?.schema) {
      this.screeningTemplate = templateRes.data.schema;
      this.hrFormData = Object.fromEntries(
        (this.screeningTemplate.hr_fields || []).map(f => [f.key, f.type === 'score' ? null : ''])
      );
      this.techFormData = Object.fromEntries(
        (this.screeningTemplate.tech_fields || []).map(f => [f.key, f.type === 'score' ? null : ''])
      );
    }

    // Agents for tech picker
    this.projectAgents = agentsRes?.data?.agents || [];
    if (this.projectAgents.length > 0) {
      this.selectedTechAgent = this.projectAgents[0].agent_id;
    }

    // Reports
    let allReports = Array.isArray(reportsRes.data) ? reportsRes.data : reportsRes.data?.reports || [];
    this.existingReportsCache[esId] = allReports;

    // Check if this user is the assigned tech agent on a pending report
    const pendingTech = allReports.find(r =>
      r.workflow_status === 'hr_completed' &&
      r.project_id === this.projectContext?.project_id &&
      r.tech_agent_id === this.currentUserId
    );
    // Default all fields visible
    const allKeys = [
      ...(this.screeningTemplate?.hr_fields || []).map(f => f.key),
      ...(this.screeningTemplate?.tech_fields || []).map(f => f.key)
    ];
    this.clientVisibleFields = [];   // default: all hidden, need-to-know basis
    if (pendingTech) {
      this.screeningStep = 'tech';
      this.pendingTechReportId = pendingTech.id;
      this.hrFormData = pendingTech.report_data?.hr_section || {};
      // inside the pendingTech block, after setting hrFormData:
      if (pendingTech.report_data?.client_visible_fields !== undefined) {
    this.clientVisibleFields = pendingTech.report_data.client_visible_fields;
  }
      this.setFormStatus('info', 'HR section complete — fill in your technical assessment', 'fas fa-flask');
    } else {
      const currentDraft = allReports.find(r =>
        r.status === 'draft' &&
        r.project_id === this.projectContext?.project_id
      );
      if (currentDraft) {
        this.selectedReportOption = 'draft';
        this.currentReportId = currentDraft.id;
        this.hrFormData = currentDraft.report_data?.hr_section || this.hrFormData;
        this.setFormStatus('info', 'Draft loaded', 'fas fa-edit');
      }
    }

// ← ADD THIS BLOCK right here, before the myHRReport block:
const myTechReport = allReports.find(r =>
  r.workflow_status === 'tech_completed' &&
  r.project_id === this.projectContext?.project_id &&
  r.tech_agent_id === this.currentUserId
);
if (myTechReport) {
  this.screeningStep = 'tech';
  this.pendingTechReportId = myTechReport.id;
  this.hrFormData = myTechReport.report_data?.hr_section || {};
  this.techFormData = myTechReport.report_data?.tech_section || {};
  if (myTechReport.report_data?.client_visible_fields!== undefined) {
  this.clientVisibleFields = myTechReport.report_data.client_visible_fields;
}
  this.techEditMode = true;  // ← ADD THIS
  this.setFormStatus('info', 'Editing your submitted technical assessment', 'fas fa-edit');
}
    // After the pendingTech and draft checks:
if (!pendingTech) {
  const myHRReport = allReports.find(r =>
    r.agent_id === this.currentUserId &&
    r.project_id === this.projectContext?.project_id &&
    ['hr_completed', 'tech_completed'].includes(r.workflow_status)
  );
  if (myHRReport) {
    this.editableHRReportId = myHRReport.id;
    this.hrFormData = myHRReport.report_data?.hr_section || this.hrFormData;
    if (myHRReport.report_data?.client_visible_fields !== undefined) {
    this.clientVisibleFields = myHRReport.report_data.client_visible_fields;
  }
    this.hrEditMode = true;
    this.setFormStatus('info', 'Editing your submitted HR section', 'fas fa-edit');
  }
}

  } catch (error) {
    console.error('Error opening screening modal:', error);
    this.setFormStatus('warning', 'Could not load screening data', 'fas fa-exclamation-triangle');
  } finally {
    this.loadingReport = false;
  }
},

async submitHRSection() {
  if (this.hrEditMode && this.editableHRReportId) {
  await axios.put(`/api/v1/screening-reports/${this.editableHRReportId}/edit-hr`, {
    hr_section: this.hrFormData,
    client_visible_fields: this.clientVisibleFields

  });
  this.showNotification('HR section updated', 'success');
  this.closeScreeningModal();
  return;
}
    if (!this.selectedTechAgent) {
    this.setFormStatus('error', 'Please assign a technical interviewer', 'fas fa-exclamation-triangle');
    return;
  }
  const requiredFields = (this.screeningTemplate?.hr_fields || []).filter(f => f.required);
  const missing = requiredFields.find(f => !this.hrFormData[f.key]);
  if (missing) {
    this.setFormStatus('error', `Please fill: ${missing.label}`, 'fas fa-exclamation-triangle');
    return;
  }

  this.loadingReport = true;
  try {
    const esId = this.getCandidateId(this.currentScreeningCandidate);
    const res = await axios.post('/api/v1/screening-reports/hr-submit', {
      elasticsearch_id: esId,
      project_id: this.projectContext.project_id,
      hr_section: this.hrFormData,
          tech_agent_id: this.selectedTechAgent, // ← add this
          client_visible_fields: this.clientVisibleFields


    });
    this.pendingTechReportId = res.data.report_id;
    this.screeningStep = 'tech';
    this.setFormStatus('success', 'HR section submitted — agents notified for tech interview', 'fas fa-check');
    await this.refreshCurrentCandidateReports(esId);
    await this.loadProjectStatus();
  } catch (error) {
    this.setFormStatus('error', 'Failed to submit HR section', 'fas fa-times');
  } finally {
    this.loadingReport = false;
  }
},

async submitTechSection() {
 // AFTER:
const requiredFields = (this.screeningTemplate?.tech_fields || []).filter(f => f.required);
const missing = requiredFields.find(f => !this.techFormData[f.key]);
if (missing) {
  this.setFormStatus('error', `Please fill: ${missing.label}`, 'fas fa-exclamation-triangle');
  return;
}
const hasAnyTechData = Object.values(this.techFormData).some(v => v !== null && v !== '' && v !== undefined);
if (!hasAnyTechData) {
  this.setFormStatus('error', 'Please fill at least one technical field before submitting', 'fas fa-exclamation-triangle');
  return;
}

  this.loadingReport = true;
  try {
    const esId = this.getCandidateId(this.currentScreeningCandidate);
    const reportId = this.pendingTechReportId || this.currentReportId;
    // AFTER:
    const endpoint = this.techEditMode
      ? `/api/v1/screening-reports/${reportId}/edit-tech`
      : `/api/v1/screening-reports/${reportId}/tech-submit`;

    await axios.put(endpoint, {
      tech_section: this.techFormData,
      hr_section: this.hrFormData,
      client_visible_fields: this.clientVisibleFields

    });
    const cacheKey = this._getCacheKey('reports', esId, this.projectContext?.project_id);
    localStorage.removeItem(cacheKey);
    await this.refreshCurrentCandidateReports(esId);
    await this.loadProjectStatus();
    this.closeScreeningModal();
    this.showNotification('Screening complete — client notified!', 'success');
  } catch (error) {
    this.setFormStatus('error', 'Failed to submit tech section', 'fas fa-times');
  } finally {
    this.loadingReport = false;
  }
},


// Get all report options for current candidate
// getCandidateReportOptions() {
//   if (!this.currentScreeningCandidate) {
//     console.log('❌ No currentScreeningCandidate set');
//     return [];
//   }
  
//   const esId = this.getCandidateId(this.currentScreeningCandidate);
//   const reports = this.existingReportsCache[esId] || [];
//   console.log(`📋 Report options for ${esId}:`, reports);
//   return reports;
// },
getCandidateReportOptions() {
  if (!this.currentScreeningCandidate) {
    return [];
  }
  
  const esId = this.getCandidateId(this.currentScreeningCandidate);
  return this.existingReportsCache[esId] || [];
},

// Get current project draft if exists
getCurrentProjectDraft() {
  if (!this.projectContext) return null;
  
  const reports = this.getCandidateReportOptions();
  const draft = reports.find(r => 
    r.status === 'draft' && 
    r.project_id === this.projectContext.project_id
  );
  console.log('🗂️ Current project draft:', draft);
  return draft;
},



// Get past completed reports as templates (exclude current project)
getPastReportTemplates() {
  if (!this.projectContext) return [];
  
  const reports = this.getCandidateReportOptions();
  const templates = reports
    .filter(r => 
      r.status === 'completed' && 
      r.project_id !== this.projectContext.project_id
    )
    .slice(0, 3) // Limit to 3 most recent
    .sort((a, b) => new Date(b.completed_at) - new Date(a.completed_at));
  
  console.log('📁 Past report templates:', templates);
  return templates;
},

// Select report option
selectReportOption(option) {
  this.selectedReportOption = option;
  this.formStatus = null;
  
  if (option === 'new') {
    this.resetScreeningForm();
    this.currentReportId = null;
    this.setFormStatus('info', 'Starting fresh report', 'fas fa-plus-circle');
  }
},

// Load selected report data
async loadSelectedReport() {
  if (!this.selectedReportOption || this.selectedReportOption === 'new') return;
  
  this.loadingReport = true;
  this.formStatus = null;
  
  try {
    const reports = this.getCandidateReportOptions();
    let reportToLoad = null;
    
    if (this.selectedReportOption === 'draft') {
      reportToLoad = this.getCurrentProjectDraft();
      this.currentReportId = reportToLoad.id;
      this.setFormStatus('success', 'Draft loaded successfully', 'fas fa-check');
    } else {
      // Loading template from past report
      reportToLoad = reports.find(r => r.id === this.selectedReportOption);
      this.currentReportId = null; // Start fresh with template data
      this.setFormStatus('success', 'Template loaded - you can modify all fields', 'fas fa-copy');
    }
    
    if (reportToLoad && reportToLoad.report_data) {
      // Deep copy to avoid reference issues
      this.screeningForm = {
        summary: reportToLoad.report_data.summary || '',
        availability: reportToLoad.report_data.availability || '',
        expected_rate: reportToLoad.report_data.expected_rate || '',
        key_checks: {
          skills_verified: reportToLoad.report_data.key_checks?.skills_verified || false,
          references_contacted: reportToLoad.report_data.key_checks?.references_contacted || false,
          background_clear: reportToLoad.report_data.key_checks?.background_clear || false
        },
        recommendation: reportToLoad.report_data.recommendation || '',
        notes: reportToLoad.report_data.notes || ''
      };
    }
    
  } catch (error) {
    console.error('Error loading report:', error);
    this.setFormStatus('error', 'Failed to load report', 'fas fa-exclamation-triangle');
  } finally {
    this.loadingReport = false;
  }
},

// Get form title based on current state
getFormTitle() {
  if (this.selectedReportOption === 'new') {
    return 'New Screening Report';
  } else if (this.selectedReportOption === 'draft') {
    return 'Continue Draft Report';
  } else {
    return 'Report from Template';
  }
},

// Set form status message
setFormStatus(type, message, icon) {
  this.formStatus = { type, message, icon };
  
  // Auto-clear success/info messages after 3 seconds
  if (type === 'success' || type === 'info') {
    setTimeout(() => {
      if (this.formStatus && this.formStatus.type === type) {
        this.formStatus = null;
      }
    }, 3000);
  }
},
timeAgoShort(iso) {
      if (!iso) return '';
      const m = Math.floor((Date.now() - new Date(iso).getTime()) / 60000);
      if (m < 60) return `${m}m ago`;
      const h = Math.floor(m / 60);
      if (h < 24) return `${h}h ago`;
      return `${Math.floor(h / 24)}d ago`;
    },
// Format time ago
formatTimeAgo(dateString) {
  if (!dateString) return '';
  
  const now = new Date();
  const date = new Date(dateString);
  const diffInMinutes = Math.floor((now - date) / (1000 * 60));
  
  if (diffInMinutes < 60) {
    return `${diffInMinutes}m ago`;
  } else if (diffInMinutes < 1440) { // 24 hours
    return `${Math.floor(diffInMinutes / 60)}h ago`;
  } else {
    return `${Math.floor(diffInMinutes / 1440)}d ago`;
  }
},

closeScreeningModal() {
  this.showScreeningModal = false;
  this.currentScreeningCandidate = null;
  this.selectedReportOption = 'new';
  this.formStatus = null;
  this.loadingReport = false;
  this.resetScreeningForm();
  this.hrEditableByTech = false; 
  this.hrEditMode = false; 
  this.techEditMode = false;   
  this.editableHRReportId = null;
  this.clientVisibleFields = [];

},


  resetScreeningForm() {
  this.screeningForm = {
    summary: '',
    availability: '',
    expected_rate: '',
    key_checks: {
      skills_verified: false,
      references_contacted: false,
      background_clear: false
    },
    recommendation: '',
    notes: ''
  };
  this.formStatus = null;
},
  
  // Save as draft
  async saveDraftReport() {
  if (!this.screeningForm.summary.trim()) {
    this.setFormStatus('error', 'Please add a summary before saving', 'fas fa-exclamation-triangle');
    return;
  }
  
  try {
    this.setFormStatus('info', 'Saving draft...', 'fas fa-spinner fa-spin');
    
    const esId = this.getCandidateId(this.currentScreeningCandidate);
    
    if (this.currentReportId) {
      // Update existing draft
      await axios.put(`/api/v1/screening-reports/${this.currentReportId}`, {
        report_data: this.screeningForm
      });
      const cacheKey = this._getCacheKey('reports', esId, this.projectContext?.project_id);
      localStorage.removeItem(cacheKey);
      this.setFormStatus('success', 'Draft updated successfully', 'fas fa-check');
    } else {
      // Create new draft
      const response = await axios.post('/api/v1/screening-reports', {
        elasticsearch_id: esId,
        project_id: this.projectContext.project_id,
        report_data: this.screeningForm
      });
      const cacheKey = this._getCacheKey('reports', esId, this.projectContext?.project_id);
      localStorage.removeItem(cacheKey);
      this.currentReportId = response.data.id;
      this.setFormStatus('success', 'Draft saved successfully', 'fas fa-check');
    }
    
    // Refresh the cache after saving
    await this.refreshCurrentCandidateReports(esId);
    
  } catch (error) {
    console.error('Error saving draft:', error);
    this.setFormStatus('error', 'Failed to save draft', 'fas fa-exclamation-triangle');
  }
},

//  method to refresh a specific candidate's reports:
async refreshCurrentCandidateReports(candidateId) {
  try {
    const response = await axios.get(`/api/v1/screening-reports/candidate/${candidateId}`);
    this.existingReportsCache[candidateId] = response.data.reports || [];
    console.log('🔄 Refreshed reports cache for candidate:', candidateId);
    
    // Force reactivity update
    this.$forceUpdate();
  } catch (error) {
    console.error('Error refreshing candidate reports:', error);
  }
},
  // Complete and submit report

// async saveScreeningReport() {
//   // Validate required fields
//   if (!this.screeningForm.summary.trim() || !this.screeningForm.availability || 
//       !this.screeningForm.expected_rate || !this.screeningForm.recommendation) {
//     this.showNotification('Please fill all required fields', 'error');
//     return;
//   }
  
//   try {
//     const esId = this.getCandidateId(this.currentScreeningCandidate);
    
//     // Save as draft first if not already saved
//     if (!this.currentReportId) {
//       const response = await axios.post('/api/v1/screening-reports', {
//         elasticsearch_id: esId,
//         project_id: this.projectContext.project_id,
//         report_data: this.screeningForm
//       });
      
//       this.currentReportId = response.data.id;
//     } else {
//       // Update existing draft
//       await axios.put(`/api/v1/screening-reports/${this.currentReportId}`, {
//         report_data: this.screeningForm
//       });
//     }
    
//     // Complete the report
//     await axios.post(`/api/v1/screening-reports/${this.currentReportId}/complete`);
//     const cacheKey = this._getCacheKey('reports', esId, this.projectContext?.project_id);
//     localStorage.removeItem(cacheKey);
//     // *** CRITICAL FIXES: Refresh state properly ***
//     await this.refreshCurrentCandidateReports(esId);
//     await this.loadProjectStatus();
    
//     this.closeScreeningModal();
//     this.showNotification('Screening report completed successfully!', 'success');
    
//   } catch (error) {
//     console.error('Error completing screening report:', error);
//     this.showNotification('Failed to complete screening report', 'error');
//   }
// },
// async saveScreeningReport() {
//   // Validate required fields
//   if (!this.screeningForm.summary.trim() || !this.screeningForm.availability || 
//       !this.screeningForm.expected_rate || !this.screeningForm.recommendation) {
//     this.showNotification('Please fill all required fields', 'error');
//     return;
//   }
  
//   // ✅ FIX 1: Prevent double submission
//   if (this.loadingReport) {
//     console.log('⏳ Already submitting report, ignoring duplicate click');
//     return;
//   }
  
//   this.loadingReport = true;
  
//   try {
//     const esId = this.getCandidateId(this.currentScreeningCandidate);
    
//     // ✅ FIX 2: Fetch current report status before attempting update
//     let currentStatus = 'draft';
//     if (this.currentReportId) {
//       try {
//         const statusCheck = await axios.get(`/api/v1/screening-reports/${this.currentReportId}`);
//         currentStatus = statusCheck.data.status;
        
//         if (currentStatus === 'completed') {
//           console.log('⚠️ Report already completed, skipping save');
//           this.showNotification('Report already submitted', 'info');
//           this.closeScreeningModal();
//           await this.refreshCurrentCandidateReports(esId);
//           await this.loadProjectStatus();
//           return;
//         }
//       } catch (statusError) {
//         console.warn('Could not check report status:', statusError);
//       }
//     }
    
//     // Save as draft first if not already saved
//     if (!this.currentReportId) {
//       const response = await axios.post('/api/v1/screening-reports', {
//         elasticsearch_id: esId,
//         project_id: this.projectContext.project_id,
//         report_data: this.screeningForm
//       });
      
//       this.currentReportId = response.data.id;
//     } else if (currentStatus === 'draft') {
//       // ✅ FIX 3: Only update if still draft
//       await axios.put(`/api/v1/screening-reports/${this.currentReportId}`, {
//         report_data: this.screeningForm
//       });
//     }
    
//     // Complete the report
//     await axios.post(`/api/v1/screening-reports/${this.currentReportId}/complete`);
    
//     const cacheKey = this._getCacheKey('reports', esId, this.projectContext?.project_id);
//     localStorage.removeItem(cacheKey);
    
//     // Refresh state properly
//     await this.refreshCurrentCandidateReports(esId);
//     await this.loadProjectStatus();
    
//     this.closeScreeningModal();
//     this.showNotification('Screening report completed successfully!', 'success');
    
//   } catch (error) {
//     console.error('Error completing screening report:', error);
    
//     // ✅ FIX 4: Better error handling
//     if (error.response?.status === 400) {
//       const detail = error.response.data?.detail || '';
//       if (detail.includes('Cannot modify completed report')) {
//         this.showNotification('Report already submitted', 'info');
//         this.closeScreeningModal();
//       } else {
//         this.showNotification('Invalid report data', 'error');
//       }
//     } else {
//       this.showNotification('Failed to complete screening report', 'error');
//     }
//   } finally {
//     // ✅ FIX 5: Always clear loading state
//     this.loadingReport = false;
//   }
// },

async saveScreeningReport() {
  // Validate required fields
  if (!this.screeningForm.summary.trim() || !this.screeningForm.availability || 
      !this.screeningForm.expected_rate || !this.screeningForm.recommendation) {
    this.showNotification('Please fill all required fields', 'error');
    return;
  }
  
  // ✅ FIX 1: Prevent double submission
  if (this.loadingReport) {
    console.log('⏳ Already submitting report, ignoring duplicate click');
    return;
  }
  
  this.loadingReport = true;
  
  try {
    const esId = this.getCandidateId(this.currentScreeningCandidate);
    
    // ✅ CRITICAL FIX: Always check for existing draft FIRST, bypassing cache
    // console.log('🔍 Checking for existing reports before creating...');
    // let existingDraft = null;
    
    // try {
    //   const freshReports = await axios.get(`/api/v1/screening-reports/candidate/${esId}`);
    //   const reports = Array.isArray(freshReports.data) ? freshReports.data : freshReports.data?.reports || [];
      
    //   // Find draft for THIS project
    //   existingDraft = reports.find(r => 
    //     r.status === 'draft' && 
    //     r.project_id === this.projectContext.project_id
    //   );
      
    //   console.log('📋 Existing draft found:', existingDraft?.id || 'none');
      
    //   // If we found a draft but currentReportId wasn't set, update it
    //   if (existingDraft && !this.currentReportId) {
    //     console.log('⚠️ Found existing draft that wasn\'t loaded properly, using it');
    //     this.currentReportId = existingDraft.id;
    //   }
      
    // } catch (fetchError) {
    //   console.warn('Could not fetch existing reports, will try to create:', fetchError);
    // }
    // Only re-fetch if we don't have a report ID
    // ✅ FIX: Always fetch fresh from server (no cache) for save operations
    if (!this.currentReportId) {
      console.log('🔍 No currentReportId, fetching fresh from server...');
      try {
        const freshReports = await axios.get(`/api/v1/screening-reports/candidate/${esId}`);
        const reports = Array.isArray(freshReports.data) ? freshReports.data : freshReports.data?.reports || [];
        
        const existingDraft = reports.find(r => 
          r.status === 'draft' && 
          r.project_id === this.projectContext.project_id
        );
        
        if (existingDraft) {
          console.log('📋 Found existing draft:', existingDraft.id);
          this.currentReportId = existingDraft.id;
        }
      } catch (fetchError) {
        console.warn('Could not fetch existing reports:', fetchError);
      }
    } else {
      console.log('📋 Using existing currentReportId:', this.currentReportId);
    }
    // ✅ FIX 2: Check status if we have a report ID
    let currentStatus = 'draft';
    if (this.currentReportId) {
      try {
        const statusCheck = await axios.get(`/api/v1/screening-reports/${this.currentReportId}`);
        currentStatus = statusCheck.data.status;
        
        if (currentStatus === 'completed') {
          console.log('⚠️ Report already completed, skipping save');
          this.showNotification('Report already submitted', 'info');
          this.closeScreeningModal();
          await this.refreshCurrentCandidateReports(esId);
          await this.loadProjectStatus();
          return;
        }
      } catch (statusError) {
        console.warn('Could not check report status:', statusError);
      }
    }
    
    // ✅ FIX 3: Save or update draft
    if (!this.currentReportId) {
      // Create new draft
      console.log('📝 Creating new screening report draft...');
      const response = await axios.post('/api/v1/screening-reports', {
        elasticsearch_id: esId,
        project_id: this.projectContext.project_id,
        report_data: this.screeningForm
      });
      
      this.currentReportId = response.data.id;
      console.log('✅ Created draft with ID:', this.currentReportId);
    } else if (currentStatus === 'draft') {
      // Update existing draft
      console.log('📝 Updating existing draft:', this.currentReportId);
      await axios.put(`/api/v1/screening-reports/${this.currentReportId}`, {
        report_data: this.screeningForm
      });
    }
    
    // ✅ FIX 4: Complete the report
    console.log('✅ Completing report:', this.currentReportId);
    await axios.post(`/api/v1/screening-reports/${this.currentReportId}/complete`);
    
    // ✅ FIX 5: Invalidate ALL related caches
    const reportCacheKey = this._getCacheKey('reports', esId, this.projectContext?.project_id);
    const statusCacheKey = this._getCacheKey('project_status', esId, this.projectContext?.project_id);
    localStorage.removeItem(reportCacheKey);
    localStorage.removeItem(statusCacheKey);
    
    console.log('🗑️ Invalidated caches for:', esId);
    
    // ✅ FIX 6: Refresh state with FORCE reload (bypass cache)
    await this.refreshCurrentCandidateReports(esId);
    await this.loadProjectStatus();  // This will reload project status from server
    
    this.closeScreeningModal();
    this.showNotification('Screening report completed successfully!', 'success');
    
  } catch (error) {
    console.error('❌ Error completing screening report:', error);
    console.error('Error details:', error.response?.data);
    
    // ✅ FIX 7: Better error handling
    if (error.response?.status === 400) {
      const detail = error.response.data?.detail || '';
      if (detail.includes('Cannot modify completed report')) {
        this.showNotification('Report already submitted', 'info');
        this.closeScreeningModal();
      } else if (detail.includes('already exists')) {
        this.showNotification('Draft already exists for this project', 'warning');
        // Try to find and load the existing draft
        await this.openScreeningModal(this.currentScreeningCandidate);
      } else {
        this.showNotification(`Error: ${detail}`, 'error');
      }
    } else if (error.response?.status === 500) {
      this.showNotification('Server error - please try again or contact support', 'error');
    } else {
      this.showNotification('Failed to complete screening report', 'error');
    }
  } finally {
    // ✅ FIX 8: Always clear loading state
    this.loadingReport = false;
  }
},
  // Show existing reports
  async showExistingReports(candidate) {
    const esId = this.getCandidateId(candidate);
    
    try {
      const response = await axios.get(`/api/v1/screening-reports/candidate/${esId}`);
      this.existingReports = response.data.reports;
      this.showExistingModal = true;
    } catch (error) {
      console.error('Error loading existing reports:', error);
      this.showNotification('Failed to load existing reports', 'error');
    }
  },
  
  closeExistingModal() {
    this.showExistingModal = false;
    this.existingReports = [];
  },
  
  // Use existing report as template
  useExistingReport(report) {
    // Copy report data to current form
    this.screeningForm = { ...report.report_data };
    this.closeExistingModal();
    
    // Show screening modal with populated data
    this.showScreeningModal = true;
    this.showNotification('Report template loaded. You can modify and save.', 'info');
  },
  // Get report preview for quick display
getReportPreview(candidate) {
  if (!this.projectContext) return null;
  
  const esId = this.getCandidateId(candidate);
  const reports = this.existingReportsCache[esId] || [];
  
  const completedReport = reports.find(r => 
    r.status === 'completed' && 
    r.project_id === this.projectContext.project_id
  );
  
  return completedReport ? completedReport.report_data : null;
},

  // Client view report
// Enhanced client report viewing with proper error handling
async viewScreeningReport(candidate) {
  const esId = this.getCandidateId(candidate);
  
  try {
    // First check cache
    const preview = this.getReportPreview(candidate);
    if (preview) {
      // Get full report details
      const reports = this.existingReportsCache[esId] || [];
      const completedReport = reports.find(r => 
        r.status === 'completed' && 
        r.project_id === this.projectContext.project_id
      );
      
      if (completedReport) {
        // Get detailed report data via API to ensure we have permissions
        try {
          const reportResponse = await axios.get(`/api/v1/screening-reports/${completedReport.id}`);
          this.clientReport = reportResponse.data;
          // Reuse already-loaded template or fetch it
          if (this.screeningTemplate) {
            this.clientReportTemplate = this.screeningTemplate;
          } else {
            try {
              const tRes = await axios.get(`/api/v1/screening-templates?project_id=${this.projectContext?.project_id}`);
              this.clientReportTemplate = tRes.data?.schema || null;
            } catch (e) { this.clientReportTemplate = null; }
          }
this.showClientReportModal = true;
          this.showClientReportModal = true;
          return;
        } catch (apiError) {
          console.warn('API fetch failed, using cached data:', apiError);
          // Fall back to cached data
          this.clientReport = {
            ...completedReport,
            report_data: preview
          };
          this.showClientReportModal = true;
          return;
        }
      }
    }
    
    // If no cache, fetch fresh
    // const response = await axios.get(`/api/v1/screening-reports/candidate/${esId}`);
    // const completedReports = response.data.reports.filter(r => 
    //   r.status === 'completed' && r.project_id === this.projectContext.project_id
    // );
    const response = await axios.get(`/api/v1/screening-reports/candidate/${esId}`);
    const reports = response.data?.reports || response.data || [];
    const reportsArray = Array.isArray(reports) ? reports : [];
    const completedReports = reportsArray.filter(r => 
      r && r.status === 'completed' && r.project_id === this.projectContext.project_id
    );
    
    if (completedReports.length === 0) {
      this.showNotification('No completed screening report found', 'warning');
      return;
    }
    
    // Update cache and show report
    this.existingReportsCache[esId] = reportsArray;
    
    // const reportResponse = await axios.get(`/api/v1/screening-reports/${completedReports[0].id}`);
    // this.clientReport = reportResponse.data;
    // this.showClientReportModal = true;
    const reportResponse = await axios.get(`/api/v1/screening-reports/${completedReports[0].id}`);
this.clientReport = reportResponse.data;
if (this.screeningTemplate) {
  this.clientReportTemplate = this.screeningTemplate;
} else {
  try {
    const tRes = await axios.get(`/api/v1/screening-templates?project_id=${this.projectContext?.project_id}`);
    this.clientReportTemplate = tRes.data?.schema || null;
  } catch (e) { this.clientReportTemplate = null; }
}
this.showClientReportModal = true;
    
  } catch (error) {
    console.error('Error loading screening report:', error);
    
    if (error.response?.status === 403) {
      this.showNotification('Report access denied. Please contact support.', 'error');
    } else if (error.response?.status === 404) {
      this.showNotification('Screening report not found', 'error');
    } else {
      this.showNotification('Failed to load screening report', 'error');
    }
  }
},

  closeClientReportModal() {
    this.showClientReportModal = false;
    this.clientReport = null;
  },
  
  // Utility formatters
  formatAvailability(availability) {
    const map = {
      'immediate': 'Immediately available',
      '30': 'Available within 30 days', 
      '60+': 'Available in 60+ days'
    };
    return map[availability] || availability;
  },
  
  formatRecommendation(recommendation) {
    const map = {
      'pass': 'Recommend for Hire',
      'consider': 'Consider with Reservations',
      'reject': 'Do Not Recommend'
    };
    return map[recommendation] || recommendation;
  },
  
  // formatDate(dateString) {
  //   if (!dateString) return '';
  //   return new Date(dateString).toLocaleDateString('en-US', {
  //     year: 'numeric',
  //     month: 'short', 
  //     day: 'numeric'
  //   });
  // },
  formatDate(iso) {
  if (!iso) return '';
  // Replace space separator with T for cross-browser compatibility
  const d = new Date(iso.replace(' ', 'T'));
  if (isNaN(d)) return iso;
  return d.toLocaleDateString('fr-FR', {
    day: '2-digit', month: 'short', year: 'numeric',
    hour: '2-digit', minute: '2-digit'
  });
},


    // STEP 1: Add NEW method for screening notes (DON'T touch addComment)
    getDisplayScreeningNotes(candidate) {
  if (this.userRole === 'client') {
    return this.getScreeningNotesFromTags(candidate);
  } else {
    // For agents, return regular comments
    return this.candidateComments[this.getCandidateId(candidate)] || [];
  }
},
// async addScreeningNote(candidate) {
//   const esId = this.getCandidateId(candidate);
//   const noteText = this.newScreeningNote[esId]?.trim(); // Use NEW model
  
//   if (!noteText) return;
  
//   try {
//     console.log('📝 Adding screening note as custom tag');
    
//     const projectId = this.projectContext?.project_id || 'unknown';
    
//     await axios.post(`/api/v1/candidates/${esId}/tags`, {
//       tag_type: 'custom',
//       tag_value: `${projectId}:${noteText}`, // Fixed format
//       project_id: this.projectContext?.project_id || null
//     });
//     const tagCacheKey = this._getCacheKey('tags', esId, this.projectContext?.project_id);
//   localStorage.removeItem(tagCacheKey);
//   // ✅ FIX: Optimistic local update instead of full reload
//   if (!this.candidateTags[esId]) {
//       this.candidateTags[esId] = [];
//     }
//     this.candidateTags[esId].push({
//       tag_value: `${projectId}:${noteText}`,
//       tag_type: 'custom',
//       created_at: new Date().toISOString(),
//       agent_name: 'You',
//       can_remove: true,
//       project_id: this.projectContext?.project_id
//     });
//     // Clear the SCREENING NOTE input (not comment input)
//     this.newScreeningNote = { ...this.newScreeningNote, [esId]: '' };
//     this.showNotification('Screening note added', 'success');
    
//   } catch (error) {
//     console.error('Failed to add screening note:', error);
//     this.showNotification('Failed to add screening note', 'error');
//   }
// },

async addScreeningNote(candidate) {
  const esId = this.getCandidateId(candidate);
  const noteText = this.newScreeningNote[esId]?.trim();
  
  if (!noteText) return;
  
  const projectId = this.projectContext?.project_id || 'unknown';
  
  // ✅ INSTANT: Optimistic UI update FIRST
  if (!this.candidateTags[esId]) {
    this.candidateTags[esId] = [];
  }
  
  const optimisticTag = {
    tag_value: `${projectId}:${noteText}`,
    tag_type: 'custom',
    created_at: new Date().toISOString(),
    agent_name: 'You',
    can_remove: true,
    project_id: this.projectContext?.project_id
  };
  
  this.candidateTags[esId].push(optimisticTag);
  
  // ✅ INSTANT: Clear input and show success
  this.newScreeningNote = { ...this.newScreeningNote, [esId]: '' };
  this.showNotification('Screening note added', 'success');
  
  // ✅ BACKGROUND: Non-blocking API call
  axios.post(`/api/v1/candidates/${esId}/tags`, {
    tag_type: 'custom',
    tag_value: `${projectId}:${noteText}`,
    project_id: this.projectContext?.project_id || null
  }).then(() => {
    // Invalidate cache for next load
    const tagCacheKey = this._getCacheKey('tags', esId, this.projectContext?.project_id);
    localStorage.removeItem(tagCacheKey);
    console.log('✅ Screening note saved to server');
  }).catch(error => {
    console.error('❌ Failed to save screening note:', error);
    // ✅ REVERT: Remove optimistic tag on failure
    this.candidateTags[esId] = this.candidateTags[esId].filter(
      t => t.tag_value !== optimisticTag.tag_value || t.created_at !== optimisticTag.created_at
    );
    this.showNotification('Failed to save screening note', 'error');
  });
},
// STEP 2: Add method to get screening notes from custom tags

getScreeningNotesFromTags(candidate) {
  const esId = this.getCandidateId(candidate);
  const customTags = this.candidateTags[esId]?.filter(t => t.tag_type === 'custom') || [];
  
  // FIX: Use project_id instead of project_name to match what we're saving
  const projectId = this.projectContext?.project_id || 'unknown';
  
  return customTags
    .filter(tag => tag.tag_value.startsWith(`${projectId}:`))  // FIXED - now uses project_id
    .map(tag => ({
      id: tag.tag_value,
      content: tag.tag_value.replace(`${projectId}:`, ''),     // FIXED - now uses project_id 
      created_at: tag.created_at,
      agent: tag.agent_name || 'You',
      is_own: tag.can_remove
    }))
    .sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
},

// STEP 3: Add method to delete screening notes (custom tags)

async deleteScreeningNote(candidate, tagValue) {
  const esId = this.getCandidateId(candidate);
  
  try {
    await axios.delete(`/api/v1/candidates/${esId}/tags/${encodeURIComponent(tagValue)}`);
    const tagCacheKey = this._getCacheKey('tags', esId, this.projectContext?.project_id);
    localStorage.removeItem(tagCacheKey);
    await this.loadCandidateTags(true);
    this.showNotification('Screening note deleted', 'success');
    
  } catch (error) {
    console.error('Failed to delete screening note:', error);
    this.showNotification('Failed to delete screening note', 'error');
  }
},

// KEEP addComment method UNCHANGED - it only creates comments, never tags
     // NEW: Check if project has assigned agents
  async checkProjectAgentAssignment() {
    if (!this.projectContext) {
      this.projectHasAgent = true; // Default to true if no project context
      this.checkingAgentAssignment = false;
      return;
    }

    try {
      console.log('🔍 Checking agent assignment for project:', this.projectContext.project_id);
      
      const response = await axios.get(`/api/v1/projects/${this.projectContext.project_id}/agent-assignment`);
      this.projectHasAgent = response.data.has_agent;
      
      console.log('✅ Agent assignment check:', this.projectHasAgent ? 'Has agent' : 'No agent');
      
    } catch (error) {
      console.error('❌ Error checking agent assignment:', error);
      this.projectHasAgent = true; // Default to true on error
    } finally {
      this.checkingAgentAssignment = false;
    }
  },
 // Simplified polling method - add console.log to debug
 async pollForUpdates() {
  if (this.isPolling) return;
  
  this.isPolling = true;
  
  try {
    const candidateIds = this.results.map(r => this.getCandidateId(r));
    
    const response = await axios.get('/api/v1/candidates/updates', {
      params: {
        candidate_ids: candidateIds.join(','),
        project_id: this.projectContext.project_id,
        since: this.lastUpdateTimestamp || new Date(Date.now() - 10000).toISOString()
      }
    });
    
    // ✅ ONLY log if there are updates
    if (response.data.updates.length > 0) {
      console.log('✨ Found updates:', response.data.updates);
      this.handleUpdates(response.data.updates);
    }
    
    this.lastUpdateTimestamp = response.data.current_timestamp;
    
  } catch (error) {
    console.error('❌ Polling error:', error);
  } finally {
    this.isPolling = false;
  }
},

// Simplified update handler
 
handleUpdates(updates) {
  updates.forEach(update => {
    console.log('🔥 Processing update:', update);
    
    if (update.type === 'comment') {
      // Refresh comments for this candidate with animation
      this.loadSingleCandidateComments(update.candidate_id);
    } else if (update.type === 'status') {
      console.log('📊 Status update:', update.new_status, 'for', update.candidate_id);

      // Spread replacement triggers Vue reactivity
      this.projectStatuses = {
        ...this.projectStatuses,
        [update.candidate_id]: {
          tag_value: update.new_status,
          tag_type: 'project_status',
          created_at: update.timestamp
        }
      };
 
      // Invalidate localStorage cache so next full load gets fresh data
      const cacheKey = this._getCacheKey('project_status', update.candidate_id, this.projectContext?.project_id);
      localStorage.removeItem(cacheKey);

      // Also refresh report cache so isTechAgentFor/isHRAgentFor work immediately
      const reportCacheKey = this._getCacheKey('reports', update.candidate_id, this.projectContext?.project_id);
      localStorage.removeItem(reportCacheKey);
      // If tech interview slots are now relevant, reload them
      if (['tech-interview-requested','tech-interview-scheduled', 'tech-interview-confirmed'].includes(update.new_status)) {
        axios.get(`/api/v1/interviews?project_id=${this.projectContext.project_id}&interview_type=tech`)
          .then(r => {
            const slots = r.data.interviews || [];
            const newSlotData = { ...this.techInterviewSlotData };
            const newDates = { ...this.techInterviewDates };
            slots.forEach(slot => {
              newSlotData[slot.elasticsearch_id] = slot;
              if (slot.confirmed_date) newDates[slot.elasticsearch_id] = slot.confirmed_date;
            });
            this.techInterviewSlotData = newSlotData;
            this.techInterviewDates = newDates;
          })
          .catch(() => {});
      }

      console.log('✅ Updated projectStatuses:', this.projectStatuses[update.candidate_id]);
      this.showStatusChangeAnimation(update.candidate_id, update.new_status);
    }
  });
},

// status change animation method
showStatusChangeAnimation(candidateId, newStatus) {
  // Find the status badge element and add a pulse effect
  const statusElement = document.querySelector(`[data-candidate="${candidateId}"] .status-badge`);
  if (statusElement) {
    statusElement.classList.add('status-updated');
    setTimeout(() => {
      statusElement.classList.remove('status-updated');
    }, 2000);
  }
},
// New method for loading single candidate comments
async loadSingleCandidateComments(candidateId) {
  try {
    console.log('💬 Reloading comments for:', candidateId);
    
    // Store current comment count
    const currentComments = this.candidateComments[candidateId] || [];
    const currentCount = currentComments.length;
    
    const response = await axios.get(`/api/v1/candidates/${candidateId}/comments`, {
      params: {
        project_id: this.projectContext?.project_id
      }
    });
    
    const newComments = response.data.comments || response.data;
    
    // Mark new comments for animation
    if (newComments.length > currentCount) {
      const newCount = newComments.length - currentCount;
      for (let i = 0; i < newCount; i++) {
        newComments[i].isNew = true;
      }
      
      // Remove the isNew flag after animation
      setTimeout(() => {
        newComments.forEach(comment => {
          delete comment.isNew;
        });
      }, 3000);
    }
    
    // Direct assignment in Vue 3
    this.candidateComments[candidateId] = newComments;
    console.log('✅ Comments updated for', candidateId);
    
  } catch (error) {
    console.error('❌ Failed to reload comments for', candidateId, ':', error);
  }
},
    debugProjectFlow() {
  console.log('📊 PROJECT CONTEXT FLOW DEBUG:');
  console.log('  - Props received:', this.$props);
  console.log('  - ProjectContext prop:', this.projectContext);
  console.log('  - UserRole:', this.userRole);
  console.log('  - Template condition result:', this.userRole === 'client' && this.projectContext);
  
  // Check HomeView state
  console.log('  - Route query params:', this.$route.query);
  
  return {
    propsReceived: this.$props,
    projectContextProp: this.projectContext,
    userRole: this.userRole,
    templateConditionResult: this.userRole === 'client' && this.projectContext
  };
},
    debugWorkflowVisibility(candidate) {
  const esId = this.getCandidateId(candidate);
  const debugInfo = {
    candidateId: esId,
    userRole: this.userRole,
    projectContext: this.projectContext,
    projectStatus: this.getProjectStatus(candidate),
    candidateTags: this.candidateTags[esId],
    projectStatuses: this.projectStatuses || {}, // Show full object, not just one candidate
    projectStatusForCandidate: this.projectStatuses?.[esId] || null,
    shouldShowClientWorkflow: this.userRole === 'client' && this.projectContext,
    shouldShowAgentWorkflow: this.userRole === 'agent' && this.projectContext,
    canRequestScreening: this.canClientRequestScreening && this.canClientRequestScreening(candidate),
    needsScreening: this.needsScreening && this.needsScreening(candidate)
  };
  
  console.log('🔍 Workflow Debug Info:', debugInfo);
  return debugInfo;
},
needsApproval(candidate) {
  const status = this.getProjectStatus(candidate);
  return ['screened', 'validated'].includes(status); // Client can hire from either state
},

  
  canClientReject(candidate) {
    const status = this.getProjectStatus(candidate);
    const rejectableStatuses = ['screened', 'rate-negotiation', 'validated', 'approve-for-hire'];
    return rejectableStatuses.includes(status);
  },
    //client/project Recruitment

    async approveForHire(candidate) {
  const esId = this.getCandidateId(candidate);
  
  // confirmation dialog since this directly hires the candidate
  if (!confirm(`Are you sure you want to hire this candidate? This will update the project progress and may complete the project.`)) {
    return;
  }
  
  try {
    this.loadingProjectStatus = true;
    
    // Set status directly to 'hired' instead of 'approve-for-hire'
    await axios.post(`/api/v1/candidates/${esId}/tags`, {
      tag_type: 'project_status',
      tag_value: 'hired',  // ← Changed from 'approve-for-hire' to 'hired'
      project_id: this.projectContext.project_id
    });
    const cacheKey = this._getCacheKey('project_status', esId, this.projectContext?.project_id);
    localStorage.removeItem(cacheKey);
        this.showNotification('Candidate hired successfully!', 'success');

    // Check if project is now completed
    // ✅ NEW: Redirect to project page after 2 seconds
    // setTimeout(() => {
    //   this.$router.push({
    //     name: 'client-landing',
    //     params: { project_id: this.projectContext.project_id }
    //   });
    // }, 2000);
    await this.checkProjectCompletion();
    
  } catch (error) {
    console.error('Error hiring candidate:', error);
    this.showNotification('Failed to hire candidate', 'error');
  } finally {
    this.loadingProjectStatus = false;
  }
},
   
// NEW: Method to mark candidate as hired (this is what triggers project completion)
async markCandidateHired(candidate) {
  const esId = this.getCandidateId(candidate);
  
  // confirmation dialog
  if (!confirm(`Are you sure you want to mark this candidate as hired? This will update the project progress and may complete the project.`)) {
    return;
  }
  
  try {
    this.loadingProjectStatus = true;
    
    // Mark candidate as hired
    await axios.post(`/api/v1/candidates/${esId}/tags`, {
      tag_type: 'project_status',
      tag_value: 'hired',
      project_id: this.projectContext.project_id
    });
    
    // Check if project is now completed
    await this.checkProjectCompletion();
    
  } catch (error) {
    console.error('Error marking candidate as hired:', error);
    this.showNotification('Failed to mark candidate as hired', 'error');
  } finally {
    this.loadingProjectStatus = false;
  }
},


async checkProjectCompletion() {
  try {
    // Fetch updated project data
    const response = await axios.get(`/api/v1/clients/projects/${this.projectContext.project_id}`);
    const project = response.data;
    
    // Update local project context directly
    this.projectContext.positions_filled = project.positions_filled;
    this.projectContext.status = project.status;
    
    if (project.status === 'COMPLETED') {
      this.showNotification(
        `🎉 Congratulations! Project "${project.project_name}" has been completed!`, 
        'success'
      );
      
      setTimeout(() => {
        this.$router.push({ 
          name: 'home', 
          query: { justCompleted: '1', project_id: this.projectContext.project_id } 
        });
        localStorage.removeItem('selectedProject');
      }, 3000);
      
    } else {
      this.showNotification('Candidate successfully hired! Project updated.', 'success');
      await this.loadProjectStatus();
    }
    
  } catch (error) {
    console.error('Error checking project completion:', error);
    this.showNotification('Candidate hired, but failed to check project status', 'warning');
  }
},


// Enhanced reject candidate with better feedback
// Enhanced reject candidate (existing but ensure it doesn't increment positions)
async rejectCandidate(candidate) {
  const esId = this.getCandidateId(candidate);
  
  if (!confirm('Are you sure you want to pass on this candidate? This action can be undone later.')) {
    return;
  }
  
  try {
    this.loadingProjectStatus = true;
    
    await axios.post(`/api/v1/candidates/${esId}/tags`, {
      tag_type: 'project_status',
      tag_value: 'rejected',
      project_id: this.projectContext.project_id
    });
    const cacheKey = this._getCacheKey('project_status', esId, this.projectContext?.project_id);
    localStorage.removeItem(cacheKey);
    await this.loadProjectStatus();
    this.showNotification('Candidate marked as not suitable for this project', 'info');
    
  } catch (error) {
    console.error('Error rejecting candidate:', error);
    this.showNotification('Failed to update candidate status', 'error');
  } finally {
    this.loadingProjectStatus = false;
  }
},

// method to check if candidate can be hired (has been approved)
canMarkAsHired(candidate) {
  const status = this.getProjectStatus(candidate);
  return status === 'approve-for-hire';
},

// method to check if candidate is already hired
isHired(candidate) {
  const status = this.getProjectStatus(candidate);
  return status === 'hired';
},
  //   async detectUserRole() {
  //   try {
  //     const response = await axios.get('/api/v1/clients/user/type');
  //     this.userRole = response.data.user_type;
  //     console.log('✅ User role detected:', this.userRole);
  //   } catch (error) {
  //     console.error('Error detecting user role:', error);
  //     this.userRole = 'agent'; // Default to agent
  //   }
  // },
  async detectUserRole() {
  try {
    const response = await axios.get('/api/v1/clients/user/type');
    this.userRole = response.data.user_type;
    console.log('✅ User role detected:', this.userRole);
  } catch (error) {
    console.error('Error detecting user role:', error);
    this.userRole = 'agent';
  }
  // Resolve currentUserId here so it's available for all card rendering
  if (!this.currentUserId) {
    try {
      const { authService } = await import('@/services/auth.js');
      const cognitoUser = await authService.getCurrentUser();
      this.currentUserId = cognitoUser?.userId || cognitoUser?.attributes?.sub || cognitoUser?.username || null;
      console.log('✅ currentUserId resolved:', this.currentUserId);
    } catch (e) {
      console.warn('Could not resolve currentUserId', e);
    }
  }
},
 // NEW: Project status methods
 getProjectStatus(candidate) {
    const esId = this.getCandidateId(candidate);
    return this.projectStatuses[esId]?.tag_value || null;
  },

  getProjectStatusDisplay(candidate) {
  const status = this.getProjectStatus(candidate);
  if (!status) {
    return 'No status'; // Show this when fetch completed but no status exists
  }
  console.log('-----------------',status)
  const statusMap = {
    
    'request-screening': 'Screening Requested',
    'screening-in-progress': 'Screening In Progress', 
    'screened': 'Screening Completed',
    'contacted': 'Contacted',
    'candidate-responded': 'Candidate Responded',
    'rate-negotiation': 'Rate Negotiation',
    'validated': 'Validated & Ready',
    'approve-for-hire': 'Approved for Hire',
    'rejected': 'Not Suitable',
    'hired': 'Hired',
    'candidate-declined': 'Candidate Declined',
'tech-interview-scheduled':  'Entretien Red Tic — En attente de planification',
'tech-interview-requested':  'Entretien Red Tic — Dates Proposées',
'tech-interview-confirmed':  'Entretien Red Tic Planifié',
'tech-interview-done':       'Entretien Red Tic Effectué',
    'interview-requested': 'Entretien Demandé',
'interview-done':      'Entretien Effectué',
'interview-scheduled': 'Entretien Planifié',

  };
  return statusMap[status] || 'No Status';
},
getExistingReportsInfo(candidate) {
  const esId = this.getCandidateId(candidate);
  const reports = this.existingReportsCache[esId] || [];
  
  const drafts = reports.filter(r => r.status === 'draft').length;
  const completed = reports.filter(r => r.status === 'completed').length;
  
  return {
    total: reports.length,
    drafts,
    completed,
    hasAny: reports.length > 0
  };
},

  // NEW: Load project-specific statuses

// Enhanced loadProjectStatus to include report cache refresh

// Replace the loadProjectStatus method in GallerySection.vue:

// async loadProjectStatus() {
//   if (!this.projectContext || !this.results) return;

//   try {
//     this.loadingProjectStatus = true;
    
//     const candidateIds = this.results.map(r => this.getCandidateId(r));
    
//     const promises = candidateIds.map(async candidateId => {
//       try {
//         const response = await axios.get(`/api/v1/candidates/${candidateId}/tags`, {
//           params: { project_id: this.projectContext.project_id }
//         });
        
//         const tags = Array.isArray(response.data) ? response.data : response.data?.tags || [];
        
//         // FIX: Find project_status tags and choose most terminal state
//         const projectStatusTags = tags.filter(t => 
//           t.tag_type === 'project_status' && t.project_id === this.projectContext.project_id
//         );
        
//         let selectedStatus = null;
//         if (projectStatusTags.length > 0) {
//           // Terminal states first (hired is most important)
//           const precedence = ['hired', 'rejected', 'candidate-declined', 'approve-for-hire', 'validated', 'screened', 'screening-in-progress', 'request-screening'];
          
//           for (const status of precedence) {
//             const found = projectStatusTags.find(t => t.tag_value === status);
//             if (found) {
//               selectedStatus = found;
//               break;
//             }
//           }
//         }
        
//         if (!this.projectStatuses) this.projectStatuses = {};
//         this.projectStatuses[candidateId] = selectedStatus;
        
//         return candidateId;
//       } catch (error) {
//         console.error(`Failed to load status for candidate ${candidateId}:`, error);
//         if (!this.projectStatuses) this.projectStatuses = {};
//         this.projectStatuses[candidateId] = null;
//         return candidateId;
//       }
//     });
    
//     await Promise.all(promises);
    
//     this.results.forEach(candidate => {
//       const candidateId = this.getCandidateId(candidate);
//       if (!this.statusFetchAttempted) this.statusFetchAttempted = {};
//       this.statusFetchAttempted[candidateId] = true;
//     });

//     if (this.userRole === 'client') {
//       await this.loadExistingReportsCache();
//     }

//     console.log('✅ Project statuses loaded:', this.projectStatuses);
    
//   } catch (error) {
//     console.error('❌ Error loading project statuses:', error);
//   } finally {
//     this.loadingProjectStatus = false;
//   }
// },

//cache

// async loadProjectStatus() {
//   if (!this.projectContext || !this.results) return;

//   try {
//     this.loadingProjectStatus = true;
    
//     const candidateIds = this.results.map(r => this.getCandidateId(r));
    
//     const promises = candidateIds.map(async candidateId => {
//       // ✅ CHECK CACHE FIRST (30s TTL)
//       const cacheKey = this._getCacheKey('project_status', candidateId, this.projectContext.project_id);
//       const cached = this._readCache(cacheKey, 300);
      
//       if (cached) {
//         console.log(`💾 Cache hit: project_status for ${candidateId}`);
//         if (!this.projectStatuses) this.projectStatuses = {};
//         this.projectStatuses[candidateId] = cached;
//         return candidateId;
//       }
      
//       // Cache miss - fetch from API
//       try {
//         const response = await axios.get(`/api/v1/candidates/${candidateId}/tags`, {
//           params: { project_id: this.projectContext.project_id }
//         });
        
//         const tags = Array.isArray(response.data) ? response.data : response.data?.tags || [];
        
//         const projectStatusTags = tags.filter(t => 
//           t.tag_type === 'project_status' && t.project_id === this.projectContext.project_id
//         );
        
//         let selectedStatus = null;
//         if (projectStatusTags.length > 0) {
//           const precedence = ['hired', 'rejected', 'candidate-declined', 'approve-for-hire', 'validated', 'screened', 'screening-in-progress', 'request-screening'];
          
//           for (const status of precedence) {
//             const found = projectStatusTags.find(t => t.tag_value === status);
//             if (found) {
//               selectedStatus = found;
//               break;
//             }
//           }
//         }
        
//         if (!this.projectStatuses) this.projectStatuses = {};
//         this.projectStatuses[candidateId] = selectedStatus;
        
//         // ✅ WRITE TO CACHE
//         this._writeCache(cacheKey, selectedStatus);
        
//         return candidateId;
//       } catch (error) {
//         console.error(`Failed to load status for candidate ${candidateId}:`, error);
//         if (!this.projectStatuses) this.projectStatuses = {};
//         this.projectStatuses[candidateId] = null;
//         return candidateId;
//       }
//     });
    
//     await Promise.all(promises);
    
//     this.results.forEach(candidate => {
//       const candidateId = this.getCandidateId(candidate);
//       if (!this.statusFetchAttempted) this.statusFetchAttempted = {};
//       this.statusFetchAttempted[candidateId] = true;
//     });

//     if (this.userRole === 'client') {
//       await this.loadExistingReportsCache();
//     }

//     console.log('✅ Project statuses loaded:', this.projectStatuses);
    
//   } catch (error) {
//     console.error('❌ Error loading project statuses:', error);
//   } finally {
//     this.loadingProjectStatus = false;
//   }
// },


async loadProjectStatus(forceRefresh = false) {
  if (!this.projectContext || !this.results) return;

  try {
    this.loadingProjectStatus = true;
    
    const candidateIds = this.results.map(r => this.getCandidateId(r));
    
    const promises = candidateIds.map(async candidateId => {
      // ✅ FIX: Skip cache if forceRefresh is true
      if (!forceRefresh) {
        // CHECK CACHE FIRST (only if not forcing refresh)
        const cacheKey = this._getCacheKey('project_status', candidateId, this.projectContext.project_id);
        const cached = this._readCache(cacheKey, 300);
        
        if (cached) {
          console.log(`💾 Cache hit: project_status for ${candidateId}`);
          if (!this.projectStatuses) this.projectStatuses = {};
          this.projectStatuses[candidateId] = cached;
          return candidateId;
        }
      } else {
        console.log(`🔄 Force refresh: skipping cache for ${candidateId}`);
      }
      
      // Cache miss OR force refresh - fetch from API
      try {
        const response = await axios.get(`/api/v1/candidates/${candidateId}/tags`, {
          params: { project_id: this.projectContext.project_id }
        });
        
        const tags = Array.isArray(response.data) ? response.data : response.data?.tags || [];
        
        const projectStatusTags = tags.filter(t => 
          t.tag_type === 'project_status' && t.project_id === this.projectContext.project_id
        );
        
        // let selectedStatus = null;
        // if (projectStatusTags.length > 0) {
        //   //1 const precedence = ['hired', 'rejected', 'candidate-declined', 'approve-for-hire', 'validated', 'screened', 'screening-in-progress', 'request-screening'];
        //   const precedence = ['hired', 'rejected', 'candidate-declined', 'interview-done', 'interview-scheduled', 'interview-requested', 'approve-for-hire', 'validated', 'screened', 'tech-interview-scheduled', 'screening-in-progress', 'request-screening'];            
        //   const found = projectStatusTags.find(t => t.tag_value === status);
        //     if (found) {
        //       selectedStatus = found;
        //       break;
        //     }
        //   }
        // }

        let selectedStatus = null;
        if (projectStatusTags.length > 0) {
          //1 const precedence = ['hired', 'rejected', 'candidate-declined', 'approve-for-hire', 'validated', 'screened', 'screening-in-progress', 'request-screening'];
         // const precedence = ['hired', 'rejected', 'candidate-declined', 'interview-done', 'interview-scheduled', 'interview-requested', 'approve-for-hire', 'validated', 'screened', 'tech-interview-scheduled', 'screening-in-progress', 'request-screening']; 
          const precedence = ['hired', 'rejected', 'candidate-declined', 'interview-done', 'interview-scheduled', 'interview-requested', 'approve-for-hire', 'validated', 'screened', 'tech-interview-done', 'tech-interview-confirmed', 'tech-interview-requested', 'tech-interview-scheduled', 'screening-in-progress', 'request-screening'];
          
          for (const status of precedence) {
            const found = projectStatusTags.find(t => t.tag_value === status);
            if (found) {
              selectedStatus = found;
              break;
            }
          }
        }
        
        if (!this.projectStatuses) this.projectStatuses = {};
        this.projectStatuses[candidateId] = selectedStatus;
        
        // ✅ WRITE TO CACHE (even on force refresh, update cache with fresh data)
        const cacheKey = this._getCacheKey('project_status', candidateId, this.projectContext.project_id);
        this._writeCache(cacheKey, selectedStatus);
        
        return candidateId;
      } catch (error) {
        console.error(`Failed to load status for candidate ${candidateId}:`, error);
        if (!this.projectStatuses) this.projectStatuses = {};
        this.projectStatuses[candidateId] = null;
        return candidateId;
      }
    });
    
    await Promise.all(promises);
    
    this.results.forEach(candidate => {
      const candidateId = this.getCandidateId(candidate);
      if (!this.statusFetchAttempted) this.statusFetchAttempted = {};
      this.statusFetchAttempted[candidateId] = true;
    });

    if (this.userRole === 'client' || (this.userRole === 'agent' && this.projectContext)) {
      await this.loadExistingReportsCache();
    }
    // Load confirmed interview dates for any candidate with interview-scheduled status
    const techStatuses = ['tech-interview-scheduled', 'tech-interview-requested', 'tech-interview-confirmed', 'tech-interview-done'];
    const clientStatuses = ['interview-scheduled', 'interview-requested'];

    const hasTechSlots = this.results.some(r => techStatuses.includes(this.projectStatuses[this.getCandidateId(r)]?.tag_value));
    const hasClientSlots = this.results.some(r => clientStatuses.includes(this.projectStatuses[this.getCandidateId(r)]?.tag_value));

    if (hasClientSlots) {
      try {
        const r = await axios.get(`/api/v1/interviews?project_id=${this.projectContext.project_id}&interview_type=client`);
        const slots = r.data.interviews || [];
        const newSlotData = { ...this.interviewSlotData };
        const newDates = { ...this.interviewDates };
        slots.forEach(slot => {
          newSlotData[slot.elasticsearch_id] = slot;
          if (slot.confirmed_date) newDates[slot.elasticsearch_id] = slot.confirmed_date;
        });
        this.interviewSlotData = newSlotData;
        this.interviewDates = newDates;
      } catch (e) { console.warn('Could not load client interview slots:', e); }
    }

    if (hasTechSlots) {
      try {
        const r = await axios.get(`/api/v1/interviews?project_id=${this.projectContext.project_id}&interview_type=tech`);
        const slots = r.data.interviews || [];
        const newSlotData = { ...this.techInterviewSlotData };
        const newDates = { ...this.techInterviewDates };
        slots.forEach(slot => {
          newSlotData[slot.elasticsearch_id] = slot;
          if (slot.confirmed_date) newDates[slot.elasticsearch_id] = slot.confirmed_date;
        });
        this.techInterviewSlotData = newSlotData;
        this.techInterviewDates = newDates;
      } catch (e) { console.warn('Could not load tech interview slots:', e); }
    }
    console.log('✅ Project statuses loaded:', this.projectStatuses);
    
  } catch (error) {
    console.error('❌ Error loading project statuses:', error);
  } finally {
    this.loadingProjectStatus = false;
  }
},

// Download report as PDF (placeholder - you can implement actual PDF generation)
async downloadReportPDF() {
  if (!this.clientReport) return;
  
  try {
    this.showNotification('PDF download will be implemented soon', 'info');
    // TODO: Implement PDF download
    // const response = await axios.get(`/api/v1/screening-reports/${this.clientReport.id}/pdf`, {
    //   responseType: 'blob'
    // });
    // 
    // const url = window.URL.createObjectURL(new Blob([response.data]));
    // const link = document.createElement('a');
    // link.href = url;
    // link.download = `screening-report-${this.clientReport.id}.pdf`;
    // link.click();
  } catch (error) {
    console.error('Error downloading PDF:', error);
    this.showNotification('Failed to download report', 'error');
  }
},

// Get recommendation icon
getRecommendationIcon(recommendation) {
  const iconMap = {
    'pass': 'fas fa-thumbs-up',
    'consider': 'fas fa-balance-scale',
    'reject': 'fas fa-thumbs-down'
  };
  return iconMap[recommendation] || 'fas fa-question';
},

// Enhanced proceed with candidate
async proceedWithCandidate() {
  if (!this.currentScreeningCandidate) return;
  
  try {
    await this.approveForHire(this.currentScreeningCandidate);
    this.closeClientReportModal();
  } catch (error) {
    console.error('Error proceeding with candidate:', error);
  }
},
  // NEW: Client workflow methods
  getProjectStatus(candidate) {
  const esId = this.getCandidateId(candidate);
  
  // SAFE ACCESS: Always ensure projectStatuses exists
  if (!this.projectStatuses || typeof this.projectStatuses !== 'object') {
    this.projectStatuses = {};
    return null;
  }
  
  const statusObj = this.projectStatuses[esId];
  return statusObj?.tag_value || null;
},

getProjectStatusIcon(candidate) {
  const status = this.getProjectStatus(candidate);
  const iconMap = {
    'request-screening': 'fas fa-paper-plane',
    'screening-in-progress': 'fas fa-cogs',
    'screened': 'fas fa-check-circle', 
    'rate-negotiation': 'fas fa-handshake',
    'validated': 'fas fa-star',
    'approve-for-hire': 'fas fa-thumbs-up',
    'rejected': 'fas fa-times-circle',
    'hired': 'fas fa-trophy',
    'candidate-declined': 'fas fa-user-times',
'tech-interview-scheduled': 'fas fa-laptop-code',
'tech-interview-requested': 'fas fa-hourglass-half',
'tech-interview-confirmed': 'fas fa-calendar-check',
'tech-interview-done':      'fas fa-handshake',
'interview-requested': 'fas fa-hourglass-half',
'interview-done':      'fas fa-handshake',
'interview-scheduled': 'fas fa-calendar-check',
  };
  return iconMap[status] || 'fas fa-question-circle';
},

  // ENHANCED: Request screening with visual feedback old slow one
//   async requestScreening(candidate) {
//   if (!this.projectContext) {
//     this.showNotification('No project context available', 'error');
//     return;
//   }

//   const esId = this.getCandidateId(candidate);
  
//   try {
//     console.log('🎯 Requesting screening for:', esId);
    
//     // Show immediate loading state
//     this.loadingProjectStatus = true;
    
//     await axios.post(`/api/v1/candidates/${esId}/tags`, {
//       tag_type: 'project_status',
//       tag_value: 'request-screening',
//       project_id: this.projectContext.project_id
//     });
//     const cacheKey = this._getCacheKey('project_status', esId, this.projectContext?.project_id);
//     localStorage.removeItem(cacheKey);
//      // ENSURE projectStatuses exists before updating
//      if (!this.projectStatuses || typeof this.projectStatuses !== 'object') {
//       this.projectStatuses = {};
//     }
//     // IMPORTANT: Update the local state immediately for instant UI feedback
//     this.projectStatuses[esId] = {
//       tag_value: 'request-screening',
//       tag_type: 'project_status',
//       created_at: new Date().toISOString()
//     };

//       // TRIGGER 2: Add to pool when requesting screening
//     await this.addCandidateToPool(candidate, 'screened');
    
     
//     // Reload project status to get server state
//     await this.loadProjectStatus();
    
//     // Success feedback
//     this.showNotification('Screening request submitted successfully! Our team will begin evaluation.', 'success');
    
//   } catch (error) {
//     console.error('Error requesting screening:', error);
//     this.showNotification('Failed to submit screening request', 'error');
//   } finally {
//     this.loadingProjectStatus = false;
//   }
// },
//using optimistic ui
// async requestScreening(candidate) {
//   const esId = this.getCandidateId(candidate);
  
//   try {
//     console.log('🎯 Requesting screening for:', esId);
    
//     // ✅ INSTANT: Show notification immediately for UX
//     this.showNotification('Screening request submitted successfully! Our team will begin evaluation.', 'success');
    
//     // ✅ INSTANT: Optimistic UI update
//     if (!this.projectStatuses || typeof this.projectStatuses !== 'object') {
//       this.projectStatuses = {};
//     }
//     this.projectStatuses[esId] = {
//       tag_value: 'request-screening',
//       tag_type: 'project_status',
//       created_at: new Date().toISOString()
//     };
    
//     // Background API call (don't block UI)
//     axios.post(`/api/v1/candidates/${esId}/tags`, {
//       tag_type: 'project_status',
//       tag_value: 'request-screening',
//       project_id: this.projectContext.project_id
//     }).then(() => {
//       // Invalidate cache after success
//       const cacheKey = this._getCacheKey('project_status', esId, this.projectContext?.project_id);
//       localStorage.removeItem(cacheKey);
//     }).catch(error => {
//       console.error('Tag creation failed:', error);
//       // Revert optimistic update
//       this.projectStatuses[esId] = null;
//       this.showNotification('Failed to submit screening request', 'error');
//     });
    
//     // Background pool addition (non-blocking, non-critical)
//     this.addCandidateToPool(candidate, 'screened').catch(err => {
//       console.warn('Pool addition failed (non-critical):', err);
//     });
    
//     // ✅ REMOVED: await this.loadProjectStatus() - no longer needed!
    
//   } catch (error) {
//     console.error('Error requesting screening:', error);
//     this.showNotification('Failed to submit screening request', 'error');
//   }
// },
 

async requestScreening(candidate) {
  const esId = this.getCandidateId(candidate);
  
  try {
    console.log('🎯 Requesting screening for:', esId);
    
    // ✅ FIX: Invalidate cache BEFORE making changes
    const statusCacheKey = this._getCacheKey('project_status', esId, this.projectContext?.project_id);
    localStorage.removeItem(statusCacheKey);
    console.log('🗑️ Cleared status cache before update');
    
    // ✅ INSTANT: Show notification immediately for UX
    this.showNotification('Screening request submitted successfully! Our team will begin evaluation.', 'success');
    
    // ✅ INSTANT: Optimistic UI update
    if (!this.projectStatuses || typeof this.projectStatuses !== 'object') {
      this.projectStatuses = {};
    }
    this.projectStatuses[esId] = {
      tag_value: 'request-screening',
      tag_type: 'project_status',
      project_id: this.projectContext.project_id,  // FIX: Include project_id for proper tracking
      created_at: new Date().toISOString()
    };
    
    // Background API call (don't block UI)
    axios.post(`/api/v1/candidates/${esId}/tags`, {
      tag_type: 'project_status',
      tag_value: 'request-screening',
      project_id: this.projectContext.project_id
    }).then(() => {
      console.log('✅ Tag created successfully');
      // Force refresh to get accurate server state
      this.loadProjectStatus(true);  // ← Pass true to force refresh
    }).catch(error => {
      console.error('Tag creation failed:', error);
      // Revert optimistic update
      this.projectStatuses[esId] = null;
      this.showNotification('Failed to submit screening request', 'error');
    });
    
    // Background pool addition (non-blocking, non-critical)
    this.addCandidateToPool(candidate, 'screened').catch(err => {
      console.warn('Pool addition failed (non-critical):', err);
    });
    
  } catch (error) {
    console.error('Error requesting screening:', error);
    this.showNotification('Failed to submit screening request', 'error');
  }
},

// NEW: Animate status change
  animateStatusChange(candidateId) {
    // Find status badge and animate it
    setTimeout(() => {
      const statusBadge = document.querySelector(`[data-candidate="${candidateId}"] .status-badge-enhanced`);
      if (statusBadge) {
        statusBadge.classList.add('status-updated');
        setTimeout(() => {
          statusBadge.classList.remove('status-updated');
        }, 2000);
      }
    }, 100);
  },

 // Enhanced start screening method
// async startScreening(candidate) {
//   const esId = this.getCandidateId(candidate);
  
//   try {
//     this.loadingProjectStatus = true;
    
//     await axios.post(`/api/v1/candidates/${esId}/tags`, {
//       tag_type: 'project_status',
//       tag_value: 'screening-in-progress',
//       project_id: this.projectContext.project_id
//     });
//     const cacheKey = this._getCacheKey('project_status', esId, this.projectContext?.project_id);
//     localStorage.removeItem(cacheKey);
//     await this.addCandidateToPool(candidate, 'screened');

//     await this.loadProjectStatus();
//     this.showNotification('Screening started! Please create a report.', 'success');
    
//     // Auto-open screening modal to encourage report creation
//     setTimeout(() => {
//       this.openScreeningModal(candidate);
//     }, 1000);
    
//   } catch (error) {
//     console.error('Error starting screening:', error);
//     this.showNotification('Failed to start screening', 'error');
//   } finally {
//     this.loadingProjectStatus = false;
//   }
// },
async startScreening(candidate) {
  const esId = this.getCandidateId(candidate);
  
  // ✅ FIX: Invalidate cache FIRST
  const cacheKey = this._getCacheKey('project_status', esId, this.projectContext?.project_id);
  localStorage.removeItem(cacheKey);
  
  // ✅ FIX: Optimistic UI update IMMEDIATELY
  if (!this.projectStatuses) this.projectStatuses = {};
  this.projectStatuses[esId] = {
    tag_value: 'screening-in-progress',
    tag_type: 'project_status',
    project_id: this.projectContext.project_id,  // FIX: Include project_id for proper tracking
    created_at: new Date().toISOString()
  };
  
  // ✅ FIX: Open modal IMMEDIATELY (no waiting)
  this.openScreeningModal(candidate);
  this.showNotification('Screening started! Please create a report.', 'success');
  
  // ✅ Background API calls (non-blocking)
  axios.post(`/api/v1/candidates/${esId}/tags`, {
    tag_type: 'project_status',
    tag_value: 'screening-in-progress',
    project_id: this.projectContext.project_id
  }).then(() => {
    // Sync with server state
    this.loadProjectStatus(true);
  }).catch(error => {
    console.error('Error starting screening:', error);
    // Revert optimistic update
    this.projectStatuses[esId] = {
      tag_value: 'request-screening',
      tag_type: 'project_status',
      project_id: this.projectContext.project_id,  // FIX: Include project_id
      created_at: new Date().toISOString()
    };
    this.showNotification('Failed to start screening', 'error');
  });
  
  // Background pool addition (non-blocking)
  this.addCandidateToPool(candidate, 'screened').catch(err => {
    console.warn('Pool addition failed (non-critical):', err);
  });
},

  async completeScreening(candidate) {
    const esId = this.getCandidateId(candidate);
    
    try {
      await axios.post(`/api/v1/candidates/${esId}/tags`, {
        tag_type: 'project_status',
        tag_value: 'screened',
        project_id: this.projectContext.project_id
      });
      
      await this.loadProjectStatus();
      this.showNotification('Screening completed', 'success');
    } catch (error) {
      console.error('Error completing screening:', error);
      this.showNotification('Failed to complete screening', 'error');
    }
  },

  // NEW: Check if candidate needs screening (for agents)
  needsScreening(candidate) {
    const status = this.getProjectStatus(candidate);
    return status === 'request-screening';
  },

  // NEW: Client permission checks
  canClientRequestScreening(candidate) {
    const status = this.getProjectStatus(candidate);
    return !status || status === 'rejected';
  },

  canClientApproveHire(candidate) {
    const status = this.getProjectStatus(candidate);
    return status === 'validated';
  },



//Vue methods
getPipelineTimeline(candidate) {
  const esId = this.getCandidateId(candidate);
  const pipelineTags = this.candidateTags[esId]?.filter(t => t.tag_type === 'pipeline_status') || [];
  
  // Sort by created date to show chronological order
  const sortedTags = pipelineTags.sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
  
  return sortedTags.map(tag => ({
    stage: tag.tag_value,
    agent: tag.agent_name,
    date: new Date(tag.created_at).toLocaleDateString()
  }));
},
// to your Vue methods
isMyPipelineTag(candidate, tagValue) {
  const esId = this.getCandidateId(candidate);
  const tagObj = this.candidateTags[esId]?.find(t => 
    t.tag_type === 'pipeline_status' && t.tag_value === tagValue
  );
  return tagObj?.can_remove || false;
},

getPipelineTooltip(candidate, tagValue) {
  const esId = this.getCandidateId(candidate);
  const tagObj = this.candidateTags[esId]?.find(t => 
    t.tag_type === 'pipeline_status' && t.tag_value === tagValue
  );
  
  if (!tagObj) {
    return `Click to mark as ${tagValue}`;
  } else if (tagObj.can_remove) {
    return `Completed by you on ${new Date(tagObj.created_at).toLocaleDateString()}`;
  } else {
    return `Already completed by ${tagObj.agent_name} on ${new Date(tagObj.created_at).toLocaleDateString()}`;
  }
},





// Update contact initiator to show first contact
getContactInitiator(candidate) {
  const timeline = this.getPipelineTimeline(candidate);
  const contactedEntry = timeline.find(entry => entry.stage === 'contacted');
  return contactedEntry ? contactedEntry.agent : null;
},
hasBeenContacted(candidate) {
  return this.getContactInitiator(candidate) !== null;
},
    


// Show latest stage and who did it
getLatestPipelineAction(candidate) {
  const timeline = this.getPipelineTimeline(candidate);
  if (timeline.length === 0) return null;
  
  const latest = timeline[timeline.length - 1];
  return `${latest.stage} by ${latest.agent}`;
},
    

// Update your toggleMultiSelectTag to handle permission denied
async toggleMultiSelectTag(candidate, category, tagValue) {
  const esId = this.getCandidateId(candidate);
  
  if (this.hasTagInCategory(candidate, category, tagValue)) {
    // Remove tag
    const params = this.projectContext ? 
      { project_id: this.projectContext.project_id } : {};
    
    await axios.delete(`/api/v1/candidates/${esId}/tags/${category}/${tagValue}`, { params });
  } else {
    // tag - FIXED: Always pass project_id when available
    const requestBody = {
      tag_type: category,
      tag_value: tagValue
    };
    
    // CRITICAL FIX: Add project_id to the request body
    if (this.projectContext) {
      requestBody.project_id = this.projectContext.project_id;
    }
    
    await axios.post(`/api/v1/candidates/${esId}/tags`, requestBody);
  }
  // ✅ INVALIDATE CACHE
  const cacheKey = this._getCacheKey('tags', esId, this.projectContext?.project_id);
  localStorage.removeItem(cacheKey);
  
  await this.loadCandidateTags();
  await this.loadProjectStatus(); // Reload project status too
},
// these methods to your Vue component
getActiveCollapsedTags(candidate) {
  const esId = this.getCandidateId(candidate);
  const allTags = this.candidateTags[esId] || [];
  const activeSections = [];

  // Define the tag mappings with labels
  const tagMappings = {
    candidate_status: {
      label: 'Status',
      cssClass: 'status-tag',
      tags: {
        'blacklisted': 'Blacklisted',
        'off-the-market': 'Off the Market', 
        'open-to-work': 'Open to Work'
      }
    },
    work_preferences: {
      label: 'Preferences',
      cssClass: 'preference-tag',
      tags: {
        'hybrid-role-only': 'Hybrid role only',
        'remote-role-only': 'Remote role only'
      }
    },
    restrictions: {
      label: 'Restrictions',
      cssClass: 'restriction-tag',
      tags: {
        'no-cdi': 'No CDI',
        'no-freelance': 'No Freelance',
        'no-bank': 'No Bank',
        'no-insurance': 'No Insurance'
      }
    },
    candidate_type: {
      label: 'Type',
      cssClass: 'type-tag',
      tags: {
        'ex-red-tic': 'Ex RED TIC',
        'consultant-red-tic': 'Consultant RED TIC'
      }
    }
  };

  // Check each category for active tags
  Object.keys(tagMappings).forEach(category => {
    const activeTags = allTags
      .filter(tag => tag.tag_type === category)
      .map(tag => ({
        value: tag.tag_value,
        label: tagMappings[category].tags[tag.tag_value] || tag.tag_value
      }))
      .filter(tag => tag.label); // Only include tags we have labels for

    if (activeTags.length > 0) {
      activeSections.push({
        category: category,
        label: tagMappings[category].label,
        cssClass: tagMappings[category].cssClass,
        tags: activeTags
      });
    }
  });

  return activeSections;
},

async toggleTagFromActive(candidate, category, tagValue) {
  // Handle removing tag from the active display
  const esId = this.getCandidateId(candidate);
  
  try {
    await axios.delete(`/api/v1/candidates/${esId}/tags/${tagValue}`);
    const cacheKey = this._getCacheKey('tags', esId, this.projectContext?.project_id);
  localStorage.removeItem(cacheKey);

    await this.loadCandidateTags(true);
  } catch (error) {
    console.error('Remove tag from active failed:', error);
    this.showNotification(`Failed to remove tag: ${tagValue}`, 'error');
  }
},

// Update getOtherTagCount to exclude custom tags too
getOtherTagCount(candidate) {
  const esId = this.getCandidateId(candidate);
  const allTags = this.candidateTags[esId] || [];
  return allTags.filter(t => t.tag_type !== 'pipeline_status' && t.tag_type !== 'custom').length;
},
    // to your methods section
getTimelineTagClass(tag) {
  const colorMap = {
    'contacted': 'tag-contacted',
    'responded': 'tag-responded', 
    'screened': 'tag-screened',
    'interviewed': 'tag-interviewed',
    'offered': 'tag-offered',
    'hired': 'tag-hired'
  };
  return colorMap[tag] || '';
},

getStatusTagClass(tag) {
  const colorMap = {
    'blacklisted': 'tag-blacklisted',
    'off-the-market': 'tag-off-market',
    'open-to-work': 'tag-open-work'
  };
  return colorMap[tag] || '';
},

async setTimelineTag(candidate, tagValue) {
  const esId = this.getCandidateId(candidate);
  
  try {
    const tagData = {
      tag_value: tagValue,
      tag_type: 'pipeline_status'
    };
    
    // CRITICAL FIX: Include project_id when agent is in project context
    if (this.projectContext && this.userRole === 'agent') {
      tagData.project_id = this.projectContext.project_id;
    }
    
    await axios.post(`/api/v1/candidates/${esId}/tags`, tagData);
    const cacheKey = this._getCacheKey('tags', esId, this.projectContext?.project_id);
    localStorage.removeItem(cacheKey);
  
    await this.loadCandidateTags();
    
    this.showNotification(`Pipeline status set to ${tagValue}`, 'success');
    
  } catch (error) {
    console.error('Pipeline tag operation failed:', error);
    this.showNotification(`Failed to set pipeline status: ${tagValue}`, 'error');
  }
},
getOtherTagCount(candidate) {
  const esId = this.getCandidateId(candidate);
  const allTags = this.candidateTags[esId] || [];
  return allTags.filter(t => t.tag_type !== 'pipeline_status').length;
},



    isTagSectionOpen(candidateId) {
  return this.openTagSections[candidateId] || false;
},

toggleTagSection(candidateId) {
  this.openTagSections = {
    ...this.openTagSections,
    [candidateId]: !this.openTagSections[candidateId]
  };
},

hasTagInCategory(candidate, category, tagValue) {
  const esId = this.getCandidateId(candidate);
  return this.candidateTags[esId]?.some(t => 
    t.tag_type === category && t.tag_value === tagValue
  ) || false;
},

async setSingleSelectTag(candidate, category, tagValue) {
  const esId = this.getCandidateId(candidate);
  
  // Check if already selected
  if (this.hasTagInCategory(candidate, category, tagValue)) {
    // Remove it (deselect)
    await axios.delete(`/api/v1/candidates/${esId}/tags/${tagValue}`);
  } else {
    // it (will replace existing in this category due to backend logic)
    await axios.post(`/api/v1/candidates/${esId}/tags`, {
      tag_value: tagValue,
      tag_type: category
    });
  }
  const cacheKey = this._getCacheKey('tags', esId, this.projectContext?.project_id);
  localStorage.removeItem(cacheKey);
  await this.loadCandidateTags(true);
},

async toggleMultiSelectTag(candidate, category, tagValue) {
  // Same as your current toggleTag but with category parameter
  await this.toggleTag(candidate, tagValue, category);
},

isInActivePipeline(candidate) {
  // Check if candidate has any active pipeline status
  const esId = this.getCandidateId(candidate);
  const pipelineStatuses = ['contacted', 'responded', 'screened', 'interviewed', 'offered'];
  return this.candidateTags[esId]?.some(t => 
    t.tag_type === 'pipeline_status' && pipelineStatuses.includes(t.tag_value)
  ) || false;
},

getTotalTagCount(candidate) {
  const esId = this.getCandidateId(candidate);
  return this.candidateTags[esId]?.length || 0;
},
   // Check if candidate is bookmarked
  isBookmarked(candidate) {
    const candidateId = this.getCandidateId(candidate);
    return this.bookmarkedCandidates.has(candidateId);
  },

  // Toggle bookmark status
  async toggleBookmark(candidate, event) {
    event.stopPropagation(); // Prevent card click if you have card click handlers
    
    const candidateId = this.getCandidateId(candidate);
    if (!candidateId) {
      console.error('No candidate ID found');
      return;
    }

    const isCurrentlyBookmarked = this.isBookmarked(candidate);
    
    try {
      if (isCurrentlyBookmarked) {
        // Remove bookmark
        await axios.delete(`/api/v1/candidates/${candidateId}/bookmark`);
        this.bookmarkedCandidates.delete(candidateId);
        this.showNotification('Bookmark removed', 'success');
        console.log(`✅ Removed bookmark for ${candidateId}`);
      } else {
        // bookmark
        await axios.post(`/api/v1/candidates/${candidateId}/bookmark`);
        this.bookmarkedCandidates.add(candidateId);
        this.showNotification('Candidate bookmarked!', 'success');
        console.log(`✅ Added bookmark for ${candidateId}`);
      }
      // ✅ INVALIDATE CACHE  
      const cacheKey = this._getCacheKey('bookmark', candidateId, this.projectContext?.project_id);
      localStorage.removeItem(cacheKey);
    } catch (error) {
      console.error('Bookmark error:', error);
      
      if (error.response?.status === 400 && error.response?.data?.detail?.includes('already bookmarked')) {
        // Already bookmarked, just update local state
        this.bookmarkedCandidates.add(candidateId);
      } else if (error.response?.status === 404 && error.response?.data?.detail?.includes('not bookmarked')) {
        // Not bookmarked, just update local state
        this.bookmarkedCandidates.delete(candidateId);
      } else {
        this.showNotification('Bookmark operation failed', 'error');
      }
    }
  },

  // // Load bookmark status for all visible candidates
  // async loadBookmarkStatuses() {
  //   if (!this.hasResults) return;
    
  //   const candidateIds = this.displayResults.map(item => this.getCandidateId(item)).filter(Boolean);
    
  //   try {
  //     // Check bookmark status for each candidate 2n+1
  //     const bookmarkPromises = candidateIds.map(async (candidateId) => {
  //       try {
  //         const response = await axios.get(`/api/v1/candidates/${candidateId}/bookmark/status`);
  //         return { candidateId, bookmarked: response.data.bookmarked };
  //       } catch (error) {
  //         console.warn(`Failed to get bookmark status for ${candidateId}:`, error);
  //         return { candidateId, bookmarked: false };
  //       }
  //     });

  //     const results = await Promise.all(bookmarkPromises);
      
  //     // Update local bookmark state
  //     results.forEach(({ candidateId, bookmarked }) => {
  //       if (bookmarked) {
  //         this.bookmarkedCandidates.add(candidateId);
  //       } else {
  //         this.bookmarkedCandidates.delete(candidateId);
  //       }
  //     });

  //     console.log(`📑 Loaded bookmark status for ${results.length} candidates`);
  //   } catch (error) {
  //     console.error('Failed to load bookmark statuses:', error);
  //   }
  // },

  async loadBookmarkStatuses() {
  if (!this.hasResults) return;
  console.log('🔖 Loading bookmark statuses (batch)...');
  
  const candidateIds = this.displayResults.map(item => this.getCandidateId(item)).filter(Boolean);
  if (!candidateIds.length) return;

  try {
    const res = await axios.post('/api/v1/candidates/bookmarks/batch', candidateIds);
    const bookmarks = res.data.bookmarks || {};
    
    Object.entries(bookmarks).forEach(([cid, isBookmarked]) => {
      if (isBookmarked) {
        this.bookmarkedCandidates.add(cid);
      } else {
        this.bookmarkedCandidates.delete(cid);
      }
    });
    
    console.log(`🔖 Batch loaded bookmarks for ${candidateIds.length} candidates`);
  } catch (e) {
    console.warn('Batch bookmark load failed, falling back:', e);
    // Silent fail — bookmarks just won't show until individual load
  }
},
//   async loadBookmarkStatuses() {
//   if (!this.hasResults) return;
//   console.log('🔖 Loading bookmark statuses with cache...');
  
//   const candidateIds = this.displayResults.map(item => this.getCandidateId(item)).filter(Boolean);
  
//   const bookmarkPromises = candidateIds.map(async (candidateId) => {
//     // ✅ CHECK CACHE FIRST (60s TTL)
//     const cacheKey = this._getCacheKey('bookmark', candidateId, this.projectContext?.project_id);
//     const cached = this._readCache(cacheKey, 60);
    
//     if (cached !== null) {
//       console.log(`💾 Cache hit: bookmark for ${candidateId}`);
//       return { candidateId, bookmarked: cached };
//     }
    
//     // Cache miss - fetch from API
//     try {
//       const response = await axios.get(`/api/v1/candidates/${candidateId}/bookmark/status`);
//       const bookmarked = response.data.bookmarked;
      
//       // ✅ WRITE TO CACHE
//       this._writeCache(cacheKey, bookmarked);
      
//       return { candidateId, bookmarked };
//     } catch (error) {
//       console.warn(`Failed to get bookmark status for ${candidateId}:`, error);
//       // Cache the failure as false
//       this._writeCache(cacheKey, false);
//       return { candidateId, bookmarked: false };
//     }
//   });

//   const results = await Promise.all(bookmarkPromises);
  
//   results.forEach(({ candidateId, bookmarked }) => {
//     if (bookmarked) {
//       this.bookmarkedCandidates.add(candidateId);
//     } else {
//       this.bookmarkedCandidates.delete(candidateId);
//     }
//   });

//   console.log(`🔖 Loaded bookmark statuses for ${results.length} candidates`);
// },
 
    
  async deleteComment(commentId) {
  this.deletingCommentId = commentId;
  
  try {
    // COMPLETE: Pass project context for safety
    const params = this.projectContext ? 
      { project_id: this.projectContext.project_id } : {};
    
    await axios.delete(`/api/v1/candidates/comments/${commentId}`, { params });
    
    // Remove comment from ALL candidates' comment arrays
    Object.keys(this.candidateComments).forEach(esId => {
      this.candidateComments[esId] = this.candidateComments[esId].filter(c => c.id !== commentId);
      const cacheKey = this._getCacheKey('comments', esId, this.projectContext?.project_id);
      localStorage.removeItem(cacheKey);
    });
    
    console.log(`✅ Deleted comment ${commentId}`);
  } catch (error) {
    if (error.response?.status === 403) {
      console.error('Authentication failed for deleting comment:', error);
    } else {
      console.error('Error deleting comment:', error);
    }
  } finally {
    this.deletingCommentId = null;
  }
},


// Method 2: Fix loadCandidateComments

// async loadCandidateComments() {
//   console.log('💬 Loading candidate comments in parallel...');
//   this.isLoadingComments = true; // ✅ ADD loading state
  
//   // ✅ FIX: Load ALL candidates in parallel
//   const commentPromises = this.displayResults.map(async (candidate) => {
//     const esId = this.getCandidateId(candidate);
    
//     // Skip if already loaded
//     if (this.candidateComments[esId]) {
//       return { esId, comments: this.candidateComments[esId] };
//     }
    
//     try {
//       const params = this.projectContext ? 
//         { project_id: this.projectContext.project_id } : {};
      
//       const response = await axios.get(`/api/v1/candidates/${esId}/comments`, { params });
//       return { esId, comments: response.data.comments || response.data };
//     } catch (error) {
//       if (error.response?.status === 403) {
//         console.error(`Authentication failed for comments ${esId}:`, error);
//       } else {
//         console.error(`Failed to load comments for ${esId}:`, error);
//       }
//       return { esId, comments: [] };
//     }
//   });
  
//   // Wait for ALL to complete
//   const results = await Promise.all(commentPromises);
  
//   // Store results
//   results.forEach(({ esId, comments }) => {
//     this.candidateComments[esId] = comments;
//   });
  
//   this.isLoadingComments = false; // ✅ Clear loading state
//   console.log(`💬 Loaded comments for ${results.length} candidates in parallel`);
// },

//cahche 

async loadCandidateComments() {
  console.log('💬 Loading candidate comments with cache...');
  this.isLoadingComments = true;
  
  const commentPromises = this.displayResults.map(async (candidate) => {
    const esId = this.getCandidateId(candidate);
    
    // ✅ CHECK CACHE FIRST (60s TTL for comments)
    const cacheKey = this._getCacheKey('comments', esId, this.projectContext?.project_id);
    const cached = this._readCache(cacheKey, 60);
    
    if (cached) {
      console.log(`💾 Cache hit: comments for ${esId}`);
      return { esId, comments: cached };
    }
    
    // Cache miss - fetch from API
    try {
      const params = this.projectContext ? 
        { project_id: this.projectContext.project_id } : {};
      
      const response = await axios.get(`/api/v1/candidates/${esId}/comments`, { params });
      const comments = response.data.comments || response.data;
      
      // ✅ WRITE TO CACHE
      this._writeCache(cacheKey, comments);
      
      return { esId, comments };
    } catch (error) {
      if (error.response?.status === 403) {
        console.error(`Authentication failed for comments ${esId}:`, error);
      } else {
        console.error(`Failed to load comments for ${esId}:`, error);
      }
      return { esId, comments: [] };
    }
  });
  
  const results = await Promise.all(commentPromises);
  
  results.forEach(({ esId, comments }) => {
    this.candidateComments[esId] = comments;
  });
  
  this.isLoadingComments = false;
  console.log(`💬 Loaded comments for ${results.length} candidates`);
},


//NEW: Add candidate to pool (background operation)
async addCandidateToPool(candidate, interactionType) {
  if (!this.projectContext?.project_id || this.userRole !== 'client') {
    // Only add to pool if client is in project context
    return;
  }

  const candidateId = this.getCandidateId(candidate);
  
  try {
    await axios.post(`/api/v1/projects/${this.projectContext.project_id}/candidate_pool/add/`, {
      candidate_elasticsearch_id: candidateId,
      interaction_type: interactionType
    });
    // Track consulted candidates locally for immediate UI updates
    if (interactionType === 'consulted') {
      this.consultedCandidates.add(candidateId);
    }
    
    console.log(`✅ Added candidate ${candidateId} to pool (${interactionType})`);
  } catch (error) {
    // Silent fail - this is background functionality
    console.warn('Failed to add candidate to pool:', error);
  }
},


// // UPDATE: Add pool integration to showResume method
// showResume(result) {
//   console.log('📄 Opening resume view for:', this.getCandidateId(result));
  
//   // TRIGGER 1: Add to pool when viewing resume details
//   this.addCandidateToPool(result, 'consulted');
  
//   // Your existing resume display logic
//   this.selectedResume = result;
//   this.showDetailView = true;
// },


// Method 3: Fix addComment
// async addComment(candidate) {
//   const esId = this.getCandidateId(candidate);
//   const comment = this.newComment[esId]?.trim();
  
//   if (!comment) return;
  
//   try {
//     const commentData = {
//       comment: comment
//     };
    
//     // project_id if we have project context
//     if (this.projectContext) {
//       commentData.project_id = this.projectContext.project_id;
//     }
    
//     const response = await axios.post(`/api/v1/candidates/${esId}/comments`, commentData);
    
//     // ✅ INSTANT LOCAL UPDATE (this was the key!)
//     if (!this.candidateComments[esId]) {
//       this.candidateComments[esId] = [];
//     }
    
//     // the new comment with animation flag
//     const newCommentWithAnimation = {
//       ...response.data,
//       isNew: true  // Mark for animation
//     };
    
//     this.candidateComments[esId].unshift(newCommentWithAnimation);
    
//     // Remove animation flag after 3 seconds
//     setTimeout(() => {
//       delete newCommentWithAnimation.isNew;
//     }, 3000);
    
//     // Clear input
//     this.newComment = { ...this.newComment, [esId]: '' };
    
//     console.log(`✅ Added comment to ${esId}`);
//   } catch (error) {
//     console.error('Error adding comment:', error);
//     this.showNotification('Failed to add comment', 'error');
//   }
// },
// async addComment(candidate) {
//   const esId = this.getCandidateId(candidate);
//   const comment = this.newComment[esId]?.trim();
  
//   if (!comment) return;
  
//   try {
//     const commentData = { comment };
//     if (this.projectContext) {
//       commentData.project_id = this.projectContext.project_id;
//     }
    
//     const response = await axios.post(`/api/v1/candidates/${esId}/comments`, commentData);
    
//     // ✅ INVALIDATE CACHE
//     const cacheKey = this._getCacheKey('comments', esId, this.projectContext?.project_id);
//     localStorage.removeItem(cacheKey);
    
//     // Update local state immediately
//     if (!this.candidateComments[esId]) {
//       this.candidateComments[esId] = [];
//     }
//     this.candidateComments[esId].unshift({ ...response.data, isNew: true });
    
//     this.newComment = { ...this.newComment, [esId]: '' };
//   } catch (error) {
//     console.error('Error adding comment:', error);
//     this.showNotification('Failed to add comment', 'error');
//   }
// },

async addComment(candidate) {
  const esId = this.getCandidateId(candidate);
  const comment = this.newComment[esId]?.trim();
  
  if (!comment) return;
  
  // ✅ OPTIMISTIC UI: Create temporary comment object
  const tempComment = {
    id: `temp-${Date.now()}`,
    content: comment,
    created_at: new Date().toISOString(),
    agent_name: 'You',
    is_own: true,
    isNew: true  // For animation
  };
  
  // ✅ INSTANT: Update UI immediately
  if (!this.candidateComments[esId]) {
    this.candidateComments[esId] = [];
  }
  this.candidateComments[esId].unshift(tempComment);
  
  // ✅ INSTANT: Clear input immediately
  this.newComment = { ...this.newComment, [esId]: '' };
  
  // ✅ BACKGROUND: Save to server
  try {
    const commentData = { comment };
    if (this.projectContext) {
      commentData.project_id = this.projectContext.project_id;
    }
    
    const response = await axios.post(`/api/v1/candidates/${esId}/comments`, commentData);
    
    // Replace temp comment with real one
    const index = this.candidateComments[esId].findIndex(c => c.id === tempComment.id);
    if (index >= 0) {
      this.candidateComments[esId][index] = { ...response.data, isNew: true };
    }
    
    // Invalidate cache
    const cacheKey = this._getCacheKey('comments', esId, this.projectContext?.project_id);
    localStorage.removeItem(cacheKey);
    
  } catch (error) {
    console.error('Error adding comment:', error);
    // ✅ REVERT: Remove temp comment on error
    this.candidateComments[esId] = this.candidateComments[esId].filter(c => c.id !== tempComment.id);
    this.showNotification('Failed to add comment', 'error');
  }
},
  formatCommentDate(dateString) {
    return new Date(dateString).toLocaleString();
  },
// Then use it in methods:
downloadCustomResume(candidateId, esDocumentId) {
    const identifier = esDocumentId || candidateId;
  const idType = esDocumentId ? 'es_id' : 'candidate_id';
  
  console.log(`🔍 Custom download using ${idType}: ${identifier}`);

    console.log(`🔍 Downloading custom resume for: ${candidateId}`, {
      includeContact: this.downloadOptions.includeContact,
      includeLogo: this.downloadOptions.includeLogo
    });
    

    if (!identifier) {
      this.showNotification('Cannot download resume: Missing ${idType} ID', 'error');
      return;
    }
    
    // Close options panel
    this.downloadMenuOpen = null;
    
    // Build URL with both parameters
    const apiBaseUrl = this.getApiBaseUrl();
    const params = new URLSearchParams({ id_type: idType});
    
    if (this.downloadOptions.includeContact) {
      params.append('include_contact', 'true');
    }
    if (this.downloadOptions.includeName) {
      params.append('include_name', 'true');
    }
    if (!this.downloadOptions.includeLogo) {
      params.append('include_logo', 'false');
    }
    
    const url = `${apiBaseUrl}/api/v1/export_resume/${identifier}${params.toString() ? '?' + params.toString() : ''}`;
    
    console.log('📥 Full download URL:', url);
    
    // Generate descriptive notification
    const contactText = this.downloadOptions.includeContact ? 'with contact info' : 'anonymous';
    const logoText = this.downloadOptions.includeLogo ? 'with logo' : 'without logo';
    
    this.showNotification(`Preparing ${contactText} resume ${logoText}...`, 'info');
    
    // Download
    try {
      const link = document.createElement('a');
      link.href = url;
      link.download = `resume_${candidateId}_${contactText}_${logoText.replace(' ', '_')}.pdf`;
      link.style.display = 'none';
      
      document.body.appendChild(link);
      link.click();
      
      // Clean up
      setTimeout(() => {
        document.body.removeChild(link);
      }, 100);
      
      // Show success
      setTimeout(() => {
        this.showNotification(`Resume download started (${contactText}, ${logoText})`, 'success');
      }, 500);
      
    } catch (error) {
      console.error('❌ Download error:', error);
      this.showNotification(`Download failed: ${error.message}`, 'error');
    }
  },

  getCandidatesWithTag(tagValue) {
    return this.searchResults.results.filter(candidate => {
        const esId = this.getCandidateId(candidate);
        return this.candidateTags[esId]?.some(tag => 
      tag.tag_value === tagValue && tag.tag_type !== 'bookmark'
    );
  });
},


// Replace your toggleTag method with this axios version:

// Method 4: Fix toggleTag to handle correct data structure
async toggleTag(candidate, tagValue, tagType) {
  const esId = this.getCandidateId(candidate);
  
  if (!esId) {
    console.error('No candidate ID found');
    return;
  }
  
  const has = this.hasTag(candidate, tagValue);
  
  try {
    if (has) {
      // DELETE request using axios
      await axios.delete(`/api/v1/candidates/${esId}/tags/${tagValue}`);
      
      // Remove from local state using correct field name
      if (this.candidateTags[esId]) {
        this.candidateTags[esId] = this.candidateTags[esId].filter(t => t.tag_value !== tagValue);
      }
      const cacheKey = this._getCacheKey('tags', esId, this.projectContext?.project_id);
      localStorage.removeItem(cacheKey);
      
      console.log(`✅ Removed tag "${tagValue}" from ${esId}`);
    } else {
      // POST request using axios
      const payload = {
        tag_value: tagValue,
        tag_type: tagType
      };
      
      await axios.post(`/api/v1/candidates/${esId}/tags`, payload);
      
      // Instead of manually adding to local state, reload from server to get correct format
      const cacheKey = this._getCacheKey('tags', esId, this.projectContext?.project_id);
      localStorage.removeItem(cacheKey);
      await this.loadCandidateTags(true); // Force reload
      
      console.log(`✅ Added tag "${tagValue}" to ${esId}`);
    }
  } catch (error) {
    if (error.response?.status === 400 && error.response?.data?.detail?.includes('already exists')) {
      console.log('Tag already exists, reloading tags...');
      await this.loadCandidateTags(true); // Force reload to sync state
      return;
    }
    
    if (error.response?.status === 403) {
      console.error('Authentication failed for tag operation:', error);
      this.showNotification('Authentication failed. Please refresh and try again.', 'error');
    } else {
      console.error('Tag operation failed:', error);
      this.showNotification(`Failed to ${has ? 'remove' : 'add'} tag: ${tagValue}`, 'error');
    }
  }
},


hasTag(candidate, tagValue) {
    const esId = this.getCandidateId(candidate);
    return this.candidateTags[esId]?.some(t => t.tag_value === tagValue) || false; // ✅ Correctly uses tag_value
},
// Update your existing getCustomTags method

getCustomTags(candidate) {
  const esId = this.getCandidateId(candidate);
  let customTags = this.candidateTags[esId]?.filter(t => t.tag_type === 'custom') || [];
  
  // ✅ FILTER PROJECT-SCOPED TAGS - hide project_id: prefixed tags for assigned agents
  if (this.userRole === 'agent' && this.projectContext) {
    const projectId = this.projectContext.project_id;
    customTags = customTags.filter(tag => !tag.tag_value.startsWith(`${projectId}:`));
  }
  
  return customTags;
},

 


// custom tag functionality back
async addCustomTag(candidate) {
  const esId = this.getCandidateId(candidate);
  const tag = this.customTagInput[esId]?.trim().toLowerCase();
  
  if (tag && tag.length > 0) {
    try {
      // ✅ INCLUDE PROJECT_ID - ensure it's saved to database with project context
      const tagData = {
        tag_value: tag,
        tag_type: 'custom'
      };
      
      // project_id when we have project context
      if (this.projectContext?.project_id) {
        tagData.project_id = this.projectContext.project_id;
      }
      
      const response = await axios.post(`/api/v1/candidates/${esId}/tags`, tagData);
      const cacheKey = this._getCacheKey('tags', esId, this.projectContext?.project_id);
      localStorage.removeItem(cacheKey);
      // ✅ INSTANT LOCAL UPDATE - add new tag immediately for UI feedback
      if (!this.candidateTags[esId]) {
        this.candidateTags[esId] = [];
      }
      this.candidateTags[esId].push({
        tag_value: tag,
        tag_type: 'custom',
        created_at: new Date().toISOString(),
        agent_name: 'You',
        can_remove: true,
        isNew: true  // Mark for animation
      });
      
      // ✅ KEEP SERVER SYNC - reload to ensure we have complete server state
     // await this.loadCandidateTags(true);
      
      // Remove animation flag after 3 seconds
      setTimeout(() => {
        const tagIndex = this.candidateTags[esId]?.findIndex(t => t.tag_value === tag);
        if (tagIndex >= 0 && this.candidateTags[esId][tagIndex]) {
          delete this.candidateTags[esId][tagIndex].isNew;
        }
      }, 3000);
      
    } catch (error) {
      console.error('Custom tag add failed:', error);
      this.showNotification(`Failed to add custom tag: ${tag}`, 'error');
    }
  }
  this.cancelCustomTag(candidate);
},

  startCustomTag(candidate) {
  const esId = this.getCandidateId(candidate);
  this.showCustomInput = { ...this.showCustomInput, [esId]: true };
  
  this.$nextTick(() => {
    const input = this.$refs[`tagInput-${esId}`];
    
    if (input) {
      // Handle different possible ref types
      if (Array.isArray(input)) {
        // If ref returns array, take the first element
        const element = input[0];
        if (element && element.focus) {
          element.focus();
        }
      } else if (input.focus) {
        // Direct DOM element
        input.focus();
      } else if (input.$el && input.$el.focus) {
        // Vue component wrapper
        input.$el.focus();
      } else {
        // Try to find the actual input element
        const actualInput = input.querySelector ? input.querySelector('input') : null;
        if (actualInput && actualInput.focus) {
          actualInput.focus();
        }
      }
    }
  });
},


  cancelCustomTag(candidate) {
    const esId = this.getCandidateId(candidate);
    this.showCustomInput = { ...this.showCustomInput, [esId]: false };
    this.customTagInput = { ...this.customTagInput, [esId]: '' };
  },

 


// Method 1: Fix loadCandidateTags to reload when needed
// async loadCandidateTags() {
//   console.log('🏷️ Loading candidate tags...');
//   this.candidateTags = {};
  
//   for (const result of this.displayResults) {
//     const esId = this.getCandidateId(result);
    
//     try {
//       // Include project_id parameter if we have project context
//       const params = this.projectContext ? 
//         { project_id: this.projectContext.project_id } : {};
      
//       const response = await axios.get(`/api/v1/candidates/${esId}/tags`, { params });
      
//       // Handle response data properly
//       const allTags = Array.isArray(response.data) ? response.data : response.data?.tags || [];
      
//       // Filter tags based on user role and context
//       let filteredTags = allTags;
      
//       if (this.userRole === 'client' && this.projectContext) {
//         // Clients should only see project-related tags and custom tags for this specific project
//         filteredTags = allTags.filter(tag => 
//           tag.tag_type === 'project_status' || 
//           tag.tag_type === 'custom'
//         );
//       }
      
//       this.candidateTags[esId] = filteredTags;
      
//     } catch (error) {
//       console.error(`❌ Error loading tags for ${esId}:`, error);
//       this.candidateTags[esId] = [];
//     }
//   }
  
//   console.log('🏷️ Final candidate tags loaded:', this.candidateTags);
// },
// async loadCandidateTags() {
//   console.log('🏷️ Loading candidate tags in parallel...');
//   this.candidateTags = {};
//   this.isLoadingTags = true; // ✅ ADD loading state
  
//   // ✅ FIX: Load ALL candidates in parallel with Promise.all()
//   const tagPromises = this.displayResults.map(async (result) => {
//     const esId = this.getCandidateId(result);
    
//     try {
//       const params = this.projectContext ? 
//         { project_id: this.projectContext.project_id } : {};
      
//       const response = await axios.get(`/api/v1/candidates/${esId}/tags`, { params });
//       const allTags = Array.isArray(response.data) ? response.data : response.data?.tags || [];
      
//       let filteredTags = allTags;
//       if (this.userRole === 'client' && this.projectContext) {
//         filteredTags = allTags.filter(tag => 
//           tag.tag_type === 'project_status' || 
//           tag.tag_type === 'custom'
//         );
//       }
      
//       return { esId, tags: filteredTags };
//     } catch (error) {
//       console.error(`❌ Error loading tags for ${esId}:`, error);
//       return { esId, tags: [] };
//     }
//   });
  
//   // Wait for ALL to complete
//   const results = await Promise.all(tagPromises);
  
//   // Store results
//   results.forEach(({ esId, tags }) => {
//     this.candidateTags[esId] = tags;
//   });
  
//   this.isLoadingTags = false; // ✅ Clear loading state
//   console.log(`🏷️ Loaded tags for ${results.length} candidates in parallel`);
// },

//CACHE
// async loadCandidateTags() {
//   console.log('🏷️ Loading candidate tags with cache...');
//   this.isLoadingTags = true;
  
//   const tagPromises = this.displayResults.map(async (result) => {
//     const esId = this.getCandidateId(result);
    
//     // ✅ CHECK CACHE FIRST (30s TTL)
//     const cacheKey = this._getCacheKey('tags', esId, this.projectContext?.project_id);
//     const cached = this._readCache(cacheKey, 30);
    
//     if (cached) {
//       console.log(`💾 Cache hit: tags for ${esId}`);
//       return { esId, tags: cached };
//     }
    
//     // Cache miss - fetch from API
//     try {
//       const params = this.projectContext ? 
//         { project_id: this.projectContext.project_id } : {};
      
//       const response = await axios.get(`/api/v1/candidates/${esId}/tags`, { params });
//       const allTags = Array.isArray(response.data) ? response.data : response.data?.tags || [];
      
//       let filteredTags = allTags;
//       if (this.userRole === 'client' && this.projectContext) {
//         filteredTags = allTags.filter(tag => 
//           tag.tag_type === 'project_status' || 
//           tag.tag_type === 'custom'
//         );
//       }
      
//       // ✅ WRITE TO CACHE
//       this._writeCache(cacheKey, filteredTags);
      
//       return { esId, tags: filteredTags };
//     } catch (error) {
//       console.error(`❌ Error loading tags for ${esId}:`, error);
//       return { esId, tags: [] };
//     }
//   });
  
//   const results = await Promise.all(tagPromises);
  
//   results.forEach(({ esId, tags }) => {
//     this.candidateTags[esId] = tags;
//   });
  
//   this.isLoadingTags = false;
//   console.log(`🏷️ Loaded tags for ${results.length} candidates`);
// },
// async loadCandidateTags() {
//   console.log('🏷️ Loading candidate tags with cache...');
//   this.isLoadingTags = true;
  
//   const tagPromises = this.displayResults.map(async (result) => {
//     const esId = this.getCandidateId(result);
    
//     // ✅ CHECK CACHE FIRST
//     const cacheKey = this._getCacheKey('tags', esId, this.projectContext?.project_id);
//     const cached = this._readCache(cacheKey, 300);
    
//     if (cached) {
//       console.log(`💾 Cache hit: tags for ${esId}`);
//       return { esId, tags: cached };
//     }
    
//     // Cache miss - fetch from API
//     try {
//       const params = this.projectContext ? 
//         { project_id: this.projectContext.project_id } : {};
      
//       const response = await axios.get(`/api/v1/candidates/${esId}/tags`, { params });
//       const allTags = Array.isArray(response.data) ? response.data : response.data?.tags || [];
      
//       let filteredTags = allTags;
//       if (this.userRole === 'client' && this.projectContext) {
//         filteredTags = allTags.filter(tag => 
//           tag.tag_type === 'project_status' || 
//           tag.tag_type === 'custom'
//         );
//       }
      
//       // ✅ WRITE TO CACHE
//       this._writeCache(cacheKey, filteredTags);
      
//       return { esId, tags: filteredTags };
//     } catch (error) {
//       console.error(`❌ Error loading tags for ${esId}:`, error);
//       return { esId, tags: [] };
//     }
//   });
  
//   const results = await Promise.all(tagPromises);
  
//   results.forEach(({ esId, tags }) => {
//     this.candidateTags[esId] = tags;
//   });
  
//   this.isLoadingTags = false;
//   console.log(`🏷️ Loaded tags for ${results.length} candidates`);
// },


async loadCandidateTags(forceRefresh = false) {
  console.log('🏷️ Loading candidate tags with cache...', forceRefresh ? '(FORCE REFRESH)' : '');
   // ✅ SKIP in pool mode unless explicitly requested
   if (this.skipHeavyLoading && !forceRefresh) {
    console.log('⏭️ Skipping tags load in pool mode');
    return;
  }
  this.isLoadingTags = true;
  
  const tagPromises = this.displayResults.map(async (result) => {
    const esId = this.getCandidateId(result);
    
    if (!forceRefresh) {
      // ✅ CHECK CACHE FIRST (only if not forcing refresh)
      const cacheKey = this._getCacheKey('tags', esId, this.projectContext?.project_id);
      const cached = this._readCache(cacheKey, 300);
      
      if (cached) {
        console.log(`💾 Cache hit: tags for ${esId}`);
        return { esId, tags: cached };
      }
    } else {
      console.log(`🔄 Force refresh: skipping cache for ${esId}`);
    }
    
    // Cache miss OR force refresh - fetch from API
    try {
      const params = this.projectContext ? 
        { project_id: this.projectContext.project_id } : {};
      
      const response = await axios.get(`/api/v1/candidates/${esId}/tags`, { params });
      const allTags = Array.isArray(response.data) ? response.data : response.data?.tags || [];
      
      let filteredTags = allTags;
      if (this.userRole === 'client' && this.projectContext) {
        filteredTags = allTags.filter(tag => 
          tag.tag_type === 'project_status' || 
          tag.tag_type === 'custom'
        );
      }
      
      // ✅ WRITE TO CACHE (even on force refresh)
      const cacheKey = this._getCacheKey('tags', esId, this.projectContext?.project_id);
      this._writeCache(cacheKey, filteredTags);
      
      return { esId, tags: filteredTags };
    } catch (error) {
      console.error(`❌ Error loading tags for ${esId}:`, error);
      return { esId, tags: [] };
    }
  });
  
  const results = await Promise.all(tagPromises);
  
  results.forEach(({ esId, tags }) => {
    this.candidateTags[esId] = tags;
  });

  this.isLoadingTags = false;
  console.log(`🏷️ Loaded tags for ${results.length} candidates`);
},
async loadAgentViews() {
      if (this.userRole === 'client') return;
      const ids = this.results.map(r => this.getCandidateId(r)).filter(Boolean);
      if (!ids.length) return;
      try {
        const res = await axios.post('/api/v1/agent-views/batch', ids);
        this.agentViews = { ...this.agentViews, ...res.data.views };
      } catch (e) { /* silent */ }
    },
// method to determine which tag sections to show:
shouldShowTagSection(sectionType) {
  if (this.userRole === 'client') {
    // Clients only see workflow section and custom tags
    if (this.projectContext) {
      return ['workflow', 'custom'].includes(sectionType);
    } else {
      return sectionType === 'custom';
    }
  } else if (this.userRole === 'agent') {
    // Agents see everything
    return true;
  }
  return true; // Default to showing all sections
},
 
  

     getLinkedInUrl(item) {
  // Check multiple possible paths for LinkedIn data
  let linkedinArray;
  
  if (item._source && item._source.personal_information) {
    linkedinArray = item._source.personal_information.linkedin;
  } else if (item.contact) {
    linkedinArray = item.contact.linkedin;
  } else if (item.linkedin) {
    linkedinArray = Array.isArray(item.linkedin) ? item.linkedin : [item.linkedin];
  }
  
  if (linkedinArray && Array.isArray(linkedinArray) && linkedinArray.length > 0) {
    let url = linkedinArray[0];
    
    // test url : url="dddddd"
    

    url = url.trim();
    if (!url || typeof url !== 'string') return null;

    if (!url) return null;
    
    let profileId = null;
    
    // Case 1: Already a proper LinkedIn URL with /in/
    let match = url.match(/linkedin\.com\/in\/([^\/?#]+)/i);
    if (match && match[1]) {
      profileId = match[1];
    }
    // Case 2: Malformed LinkedIn URL without /in/ (extract username after last /)
    else if (url.includes('linkedin.com')) {
      // Extract everything after linkedin.com/
      match = url.match(/linkedin\.com\/([^\/?#]+)/i);
      if (match && match[1]) {
        profileId = match[1];
      }
    }
    // Case 3: URLs with just "linkedin" (like linkedin/@username)
  else if (url.includes('linkedin/')) {
    // Extract everything after linkedin/
    match = url.match(/linkedin\/([^\/?#]+)/i);
    if (match && match[1]) {
      profileId = match[1].replace(/^@+/, ''); // Remove @ if present
    }
  }
    // Case 3: Just the username (with or without @)
    else {
      // Remove @ symbol and any leading/trailing junk
      profileId = url.replace(/^@+/, '').replace(/[^\w\-]/g, '');
    }
    
    if (profileId) {
      // Clean the profile ID (allow only alphanumeric, underscore, hyphen)
      profileId = profileId.replace(/[^\w\-]/g, '');
      return profileId ? `https://www.linkedin.com/in/${profileId}` : null;
    }
    
    return null;
  }
},
// Semantic match helper methods
getTopMatch(matches) {
  return matches && matches.length > 0 ? matches[0] : null;
},

getRemainingMatches(matches) {
  return matches && matches.length > 1 ? matches.slice(1) : [];
},

hasMoreThanOneMatch(matches) {
  return matches && matches.length > 1;
},

toggleMatchSection(index, sectionType) {
  if (!this.matchSectionExpanded[index]) {
    this.$set(this.matchSectionExpanded, index, {});
  }
  this.$set(
    this.matchSectionExpanded[index], 
    sectionType, 
    !this.matchSectionExpanded[index][sectionType]
  );
},

isMatchSectionExpanded(index, sectionType) {
  return this.matchSectionExpanded[index] && this.matchSectionExpanded[index][sectionType];
},

formatScore(score) {
  // Convert cosine similarity (1-2 scale) to percentage
  const percentage = Math.min(Math.max(Math.round((score - 1.0) * 100), 0), 100);
  return `${percentage}% match`;
},
  toggleView() {
    this.viewMode = this.viewMode === 'grid' ? 'list' : 'grid';
  },
  
  toggleDownloadMenu(index, event) {
    if (event) event.stopPropagation();
    this.downloadMenuOpen = this.downloadMenuOpen === index ? null : index;
  },
  
  closeDropdowns(event) {
  const insideDropdown = event.target.closest('.download-section');
  console.log('Click event target:', event.target);
  console.log('Inside dropdown:', insideDropdown);
  if (!insideDropdown) {
    this.downloadMenuOpen = null;
  }
},
  
  previousPage() {
    if (this.currentPage > 1) this.currentPage--;
  },
  
  nextPage() {
    if (this.currentPage < this.totalPages) this.currentPage++;
  },
  
  goToPage(page) {
    this.currentPage = page;
  },
// getLinkedInUrl(item) {
//   //console.log('Full item structure:', JSON.stringify(item, null, 2));
//  // Check multiple possible paths for LinkedIn data
//  let linkedinArray;
  
//   if (item._source && item._source.personal_information) {
//     linkedinArray = item._source.personal_information.linkedin;
//   } else if (item.contact) {
//     linkedinArray = item.contact.linkedin;
//   } else if (item.linkedin) {
//     linkedinArray = Array.isArray(item.linkedin) ? item.linkedin : [item.linkedin];
//   }
  
//   if (linkedinArray && Array.isArray(linkedinArray) && linkedinArray.length > 0) {
//     let url = linkedinArray[0];
    
//     if (!url) return null;
    
//     // If it already contains linkedin.com, just ensure proper protocol
//     if (url.includes('linkedin.com')) {
//       return url.startsWith('http') ? url : `https://${url}`;
//     }
    
//     // If it's just a username/suffix, build the full URL
//     const cleanSuffix = url.replace(/^\/+/, ''); // Remove leading slashes
//     return `https://www.linkedin.com/in/${cleanSuffix}`;
//   }
  
//   return null;
// },

getIndexedDate(item) {
  // Check multiple possible paths for timestamp
  let timestamp;
  
  
  timestamp = item.metadata.indexed_at;
  
  
  // console.log('Timestamp data for item:', timestamp); // Debug log
  return timestamp;
},

formatIndexedDate(timestamp) {
  if (!timestamp) return '';
  
  try {
    const date = new Date(timestamp);
    // Format as "Jan 15, 2024"
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  } catch (error) {
    console.warn('Error formatting indexed date:', error);
    return '';
  }
},
    // Helper function to get API base URL
  getApiBaseUrl() {
    if (process.env.NODE_ENV === 'development') {
      return process.env.VUE_APP_API_BASE_URL || 'http://localhost:8000';
    }
    return ''; // Production uses nginx proxy
  },
   getEsDocumentId(item) {
    return item._id || item.UID?._id || null;
  },
  getCandidateId(item) {
    const candidateId = item?.metadata?.candidate_id || 
                      item?.UID?.candidate_id || 
                      item?.candidate_id ||
                      item?._source?.metadata?.candidate_id;
    // console.log('getCandidateId for item:', candidateId);
    return candidateId;
  },
  

  hasCandidateId(item) {
    //return !!(result.metadata.base_candidate_id || result.candidate_id);

    const candidateId = ( item?.UID?.base_candidate_id || 
    item?.UID?.candidate_id );
    
    // console.log('getCandidateId for item:', candidateId);
    // console.log("tem?.UID?.candidate_id:", item?.UID?.candidate_id);
    // console.log("tem?.UID?.es:", item?.UID?._id);
    // console.log("tem?.UID?.base_candidate_id:", item?.UID?.base_candidate_id);


    return !!(candidateId)

     
  },
  /**
   * Extracts base_candidate_id for grouping resumes by candidate
   * Handles flattened result structure from ES
   */
   getBaseCandidateId(item) {
    // Result is flattened - metadata fields are at root level
    const baseId = item?.UID?.base_candidate_id || item?.UID?.candidate_id?.split('_')[0];
    console.log('getBaseCandidateId item for item:', baseId);

    return baseId || null;
  },
  async toggleCandidateResumes(result, event) {
    event?.stopPropagation();
    
    const candidateId = this.getCandidateId(result);
    
    // Close if already open
    if (this.candidateResumesDropdown === candidateId) {
      this.candidateResumesDropdown = null;
      return;
    }
    
    // Get base candidate ID
    const baseCandidateId = this.getBaseCandidateId(result);
    if (!baseCandidateId) {
      console.warn('No base_candidate_id found');
      return;
    }
    
    // Open dropdown
    this.candidateResumesDropdown = candidateId;
    
    // Fetch data if not cached
    if (!this.candidateResumesData[baseCandidateId]) {
      this.loadingCandidateResumes = true;
      try {
        const response = await axios.get(
          `/api/v1/candidates/${baseCandidateId}/resumes`
        );
        this.candidateResumesData[baseCandidateId] = response.data;
      } catch (error) {
        console.error('Error fetching candidate resumes:', error);
        this.candidateResumesData[baseCandidateId] = { count: 0, resumes: [] };
      } finally {
        this.loadingCandidateResumes = false;
      }
    }
  },
  viewSpecificResume(candidateId) {
    // Navigate to specific resume (exact match)
    this.$router.push({
      path: '/',
      query: {
        candidate_id: candidateId,
        auto_search: 'true'
      }
    });
  },
  /**
   * Navigate to search filtered by this candidate's base ID
   * Uses router similar to admin dashboard drill-down
   */
   async viewCandidateResumes(result, event) {
  event?.stopPropagation();
  
  const baseCandidateId = this.getBaseCandidateId(result);
  
  if (!baseCandidateId) {
    console.warn('No base_candidate_id found for result:', result);
    return;
  }
  
  console.log(`🔍 Viewing all resumes for candidate: ${baseCandidateId}`);
  
  // Navigate with clean state - only candidate_id and from flag
  this.$router.push({
    path: '/',
    query: {
      es_id: resume.es_id,  // NEW: Use ES document ID
      auto_search: 'true'
    }
  });
},
debugCandidate(candidate) {
  console.log('=== CANDIDATE DEBUG ===');
  console.log('Keys:', Object.keys(candidate));
  console.log('document_id:', candidate.document_id);
  console.log('_id:', candidate._id);
  console.log('Full object:', candidate);
  console.log('=== END DEBUG ===');
},
     // Core dropdown functionality
     toggleDownloadMenu(index, event) {
    if (event) {
      event.stopPropagation();
    }
    console.log('Toggling download menu for index:', index);
    console.log('Current downloadMenuOpen:', this.downloadMenuOpen);
    this.downloadMenuOpen = this.downloadMenuOpen === index ? null : index;
    console.log('New downloadMenuOpen:', this.downloadMenuOpen);
  },

  // Update closeDropdowns to check if click is inside dropdown
  closeDropdowns(event) {
    // Don't close if clicking inside a dropdown
    if (event.target.closest('.download-dropdown')) {
      return;
    }
    this.downloadMenuOpen = null;
  },

  // Update your download methods to ensure dropdown closes after action
 

  // Updated download method with proper URL handling
  downloadAnonymizedResume(candidateId, includeContact = false) {
  console.log(`🔍 Downloading ${includeContact ? 'named' : 'anonymized'} resume for:`, candidateId);
  
  if (!candidateId) {
    this.showNotification('Cannot download resume: Missing candidate ID', 'error');
    return;
  }
  
  // Close dropdown
  this.downloadMenuOpen = null;
  
  // Build the full URL with base URL
  const apiBaseUrl = this.getApiBaseUrl();
  const contactParam = includeContact ? 'include_contact=true' : '';
  const url = `${apiBaseUrl}/api/v1/export_resume/${candidateId}${contactParam ? '?' + contactParam : ''}`;
  
  console.log('📥 Full download URL:', url);
  
  this.showNotification('Preparing your download...', 'info');
  
  // Simple direct download approach
  try {
    const link = document.createElement('a');
    link.href = url;
    link.download = `resume_${candidateId}_${includeContact ? 'named' : 'anonymous'}.pdf`;
    link.style.display = 'none';
    
    document.body.appendChild(link);
    link.click();
    
    // Clean up
    setTimeout(() => {
      document.body.removeChild(link);
    }, 100);
    
    // Show success after a short delay
    setTimeout(() => {
      const type = includeContact ? 'named' : 'anonymized';
      this.showNotification(`${type} resume download started`, 'success');
    }, 500);
    
  } catch (error) {
    console.error('❌ Download error:', error);
    this.showNotification(`Download failed: ${error.message}`, 'error');
  }
},
// this method to your methods section:

async downloadResumeDOCX(candidateId,esDocumentId) {
  console.log("🔍 ==> DOCX downloadResume started");
  console.log("   candidateId:", candidateId);
  console.log("   esDocumentId:", esDocumentId);
  console.log("🔍 ==> downloadResume started for candidateId:", candidateId);
  // if (!candidateId) {
  //   this.showNotification('Cannot download: Missing candidate ID', 'error');
  //   return;
  // }
  if (!esDocumentId && !candidateId) {
    console.error("❌ No identifier available for download");
    this.showNotification('Cannot download resume: Missing ID', 'error');
    return;
  }
  
  // Close dropdown
  this.downloadMenuOpen = null;
  
  this.showNotification('Preparing editable resume...', 'info');
  
  try {
    // Prefer ES ID (always unique), fallback to candidate_id
    const identifier = esDocumentId || candidateId;
    const idType = esDocumentId ? 'es_id' : 'candidate_id';
    
    console.log(`🔍 Using ${idType}: ${identifier}`);
    
    // Use the same options as PDF export
    const params = new URLSearchParams();
    
    if (this.downloadOptions.includeContact) {
      params.append('include_contact', 'true');
    }
    if (this.downloadOptions.includeName) {
      params.append('include_name', 'true');
    }
    if (!this.downloadOptions.includeLogo) {
     params.append('include_logo', 'false');
   }
   
   params.append('id_type', idType);

    // const url = `/api/v1/export_resume/${candidateId}/docx${params.toString() ? '?' + params.toString() : ''}`;
    // Build URL exactly like PDF download (with apiBaseUrl for dev)
    const apiBaseUrl = this.getApiBaseUrl();
    const url = `${apiBaseUrl}/api/v1/export_resume/${identifier}/docx${params.toString() ? '?' + params.toString() : ''}`;
    console.log('📥 Full DOCX download URL:', url);

    // Trigger download
    // const link = document.createElement('a');
    // link.href = url;
    // link.download = `resume_${candidateId}.docx`;
    // link.style.display = 'none';
    
    // document.body.appendChild(link);
    // link.click();
    
    // setTimeout(() => {
    //   document.body.removeChild(link);
    //   this.showNotification('DOCX download started!', 'success');
    // }, 100);
    // Use window.open for backend file downloads
    // window.open(url, '_blank');

    // EXACT SAME PATTERN as downloadCustomResume (PDF)
    const link = document.createElement('a');
    link.href = url;
    link.download = `resume_${identifier}.docx`;
    link.style.display = 'none';
    
    document.body.appendChild(link);
    link.click();
    
    // Clean up
    setTimeout(() => {
      document.body.removeChild(link);
    }, 100);
    
    // Show success immediately
    setTimeout(() => {
      this.showNotification('DOCX download started!', 'success');
    }, 500);
    
  } catch (error) {
    console.error('❌ DOCX download error:', error);
    this.showNotification('DOCX download failed', 'error');
  }
},
// Also update getApiBaseUrl if not already present
getApiBaseUrl() {
  if (process.env.NODE_ENV === 'development') {
    return process.env.VUE_APP_API_BASE_URL || 'http://localhost:8000';
  }
  return ''; // Production uses nginx proxy
},
// async downloadResume(candidateId) {
//   console.log("🔍 ==> downloadResume started for candidateId:", candidateId);
  
//   if (!candidateId) {
//     console.error("❌ No candidate ID available for download");
//     this.showNotification('Cannot download resume: Missing candidate ID', 'error');
//     return;
//   }
  
//   // Close dropdown
//   this.downloadMenuOpen = null;
  
//   // Show loading notification
//   this.showNotification('Fetching original resume...', 'info');
  
//   try {
//     const apiBaseUrl = this.getApiBaseUrl();
    
//     // Use the new endpoint that reuses the working export logic
//     const url = `${apiBaseUrl}/api/v1/s3/download-original/${encodeURIComponent(candidateId)}`;
    
//     console.log("🌐 Making request to:", url);
    
//     const response = await fetch(url, {
//       method: 'GET',
//       headers: {
//         'Accept': 'application/json',
//       },
//     });
    
//     console.log("📡 Response status:", response.status);
    
//     if (!response.ok) {
//       const errorText = await response.text();
//       console.error("❌ Response error:", errorText);
//       throw new Error(`HTTP ${response.status}: ${response.statusText} - ${errorText}`);
//     }
    
//     const data = await response.json();
//     console.log("📦 Response data:", data);
    
//     if (data.success && data.download_url) {
//       // Create a temporary link to trigger download
//       const link = document.createElement('a');
//       link.href = data.download_url;
//       link.target = '_blank';
//       link.download = data.original_filename || `original_resume_${candidateId}.pdf`;
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
      
//       console.log("✅ Download triggered successfully");
//       this.showNotification('Original resume download started!', 'success');
//     } else {
//       throw new Error('No download URL received from server');
//     }
    
//   } catch (error) {
//     console.error('❌ Download error:', error);
//     this.showNotification(`Failed to download original resume: ${error.message}`, 'error');
//   }
// },

 
  showNotification(message, type = 'info', duration = 3000) {
    if (this.downloadStatus.timeout) {
      clearTimeout(this.downloadStatus.timeout);
    }
    
    let icon = 'fas fa-spinner fa-spin';
    if (type === 'success') icon = 'fas fa-check-circle';
    if (type === 'error') icon = 'fas fa-exclamation-circle';
    
    this.downloadStatus = {
      show: true,
      message,
      type,
      icon,
      timeout: null
    };
    
    if (duration > 0) {
      this.downloadStatus.timeout = setTimeout(() => {
        this.downloadStatus.show = false;
      }, duration);
    }
  },

    


    isRecommendedCandidate(item) {
      if (!this.ragRecommendations || !this.ragRecommendations.length) {
        return false;
      }
      
      const candidateId = this.getCandidateId(item);
      if (!candidateId) {
        return false;
      }
      
      return this.ragRecommendations.some(rec => 
        String(rec.elasticsearch_id) === String(candidateId)
      );
    },
    
    getCandidateRank(item) {
      if (!this.ragRecommendations || !this.ragRecommendations.length) {
        return '';
      }
      
      const candidateId = this.getCandidateId(item);
      if (!candidateId) {
        return '';
      }
      
      const recommendation = this.ragRecommendations.find(rec => 
        String(rec.elasticsearch_id) === String(candidateId)
      );
      
      return recommendation ? recommendation.rank : '';
    },
    
    getCandidateOverallScore(item) {
      if (!this.ragRecommendations || !this.ragRecommendations.length) {
        return null;
      }
      
      const candidateId = this.getCandidateId(item);
      if (!candidateId) {
        return null;
      }
      
      const recommendation = this.ragRecommendations.find(rec => 
        String(rec.elasticsearch_id) === String(candidateId)
      );
      
      return recommendation ? recommendation.overall_match_score : null;
    },
    
    hasCandidateMetrics(item) {
      return this.getCandidateMetrics(item) !== null;
    },
    
    getCandidateMetrics(item) {
      if (!this.ragRecommendations || !this.ragRecommendations.length) {
        return null;
      }
      
      const candidateId = this.getCandidateId(item);
      if (!candidateId) {
        return null;
      }
      
      const recommendation = this.ragRecommendations.find(rec => 
        String(rec.elasticsearch_id) === String(candidateId)
      );
      
      if (!recommendation) return null;
      
      return {
        skill_match: recommendation.skill_match,
        experience_relevance: recommendation.experience_relevance
      };
    },
    
    getCandidateRecommendation(item) {
      if (!this.ragRecommendations || !this.ragRecommendations.length) {
        return '';
      }
      
      const candidateId = this.getCandidateId(item);
      if (!candidateId) {
        return '';
      }
      
      const recommendation = this.ragRecommendations.find(rec => 
        String(rec.elasticsearch_id) === String(candidateId)
      );
      
      return recommendation ? recommendation.hiring_recommendation : '';
    },
    
    getRecommendationClass(item) {
      const recommendation = this.getCandidateRecommendation(item);
      if (!recommendation) return '';
      
      const rec = recommendation.toLowerCase();
      
      if (rec.includes('vivement') || rec.includes('strong') || rec.includes('fort')) {
        return 'recommendation-strong';
      }
      if (rec.includes('recommandé') || rec.includes('yes') || rec.includes('oui')) {
        return 'recommendation-yes';
      }
      if (rec.includes('peut') || rec.includes('maybe') || rec.includes('possible')) {
        return 'recommendation-maybe';
      }
      if (rec.includes('non') || rec.includes('no')) {
        return 'recommendation-no';
      }
      
      return '';
    },
    
    formatRecommendation(recommendation) {
      if (!recommendation) return '';
      
      // Map possible values to standardized shortened French terms
      const map = {
        'recommandé vivement': 'Vivement recommandé',
        'recommandé': 'Recommandé',
        'peut-être': 'Peut-être',
        'non recommandé': 'Non recommandé',
        'strong yes': 'Vivement recommandé',
        'yes': 'Recommandé',
        'maybe': 'Peut-être',
        'no': 'Non recommandé'
      };
      
      // Case-insensitive lookup
      const key = Object.keys(map).find(k => 
        recommendation.toLowerCase().includes(k.toLowerCase())
      );
      
      return key ? map[key] : recommendation;
    },
    
    getCandidateStrengths(item) {
      if (!this.ragRecommendations || !this.ragRecommendations.length) {
        return '';
      }
      
      const candidateId = this.getCandidateId(item);
      if (!candidateId) {
        return '';
      }
      
      const recommendation = this.ragRecommendations.find(rec => 
        String(rec.elasticsearch_id) === String(candidateId)
      );
      
      return recommendation ? recommendation.key_strengths : '';
    },
    
    hasMissingSkills(item) {
      const skills = this.getMissingSkills(item);
      return skills && skills.length > 0;
    },
    
    getMissingSkills(item) {
      if (!this.ragRecommendations || !this.ragRecommendations.length) {
        return [];
      }
      
      const candidateId = this.getCandidateId(item);
      if (!candidateId) {
        return [];
      }
      
      const recommendation = this.ragRecommendations.find(rec => 
        String(rec.elasticsearch_id) === String(candidateId)
      );
      
      return recommendation && recommendation.missing_critical_skills ? 
        recommendation.missing_critical_skills : [];
    },
    
    hasInterviewQuestions(item) {
      const questions = this.getInterviewQuestions(item);
      return questions && questions.length > 0;
    },
    
    getInterviewQuestions(item) {
      if (!this.ragRecommendations || !this.ragRecommendations.length) {
        return [];
      }
      
      const candidateId = this.getCandidateId(item);
      if (!candidateId) {
        return [];
      }
      
      const recommendation = this.ragRecommendations.find(rec => 
        String(rec.elasticsearch_id) === String(candidateId)
      );
      
      return recommendation && recommendation.interview_questions ? 
        recommendation.interview_questions : [];
    },
    
    toggleInterviewQuestions(item) {
      const candidateId = this.getCandidateId(item);
      if (!candidateId) return;
      
      this.openQuestionsMap[candidateId] = !this.openQuestionsMap[candidateId];
      this.$forceUpdate(); // Force update to reflect the change
    },
    
    isQuestionsOpen(item) {
      const candidateId = this.getCandidateId(item);
      return candidateId ? !!this.openQuestionsMap[candidateId] : false;
    },
    
    getScoreColor(score) {
      // Convert the score to a color from red to green
      if (score >= 85) return '#4CAF50'; // Green for high scores
      if (score >= 70) return '#8BC34A'; // Light green
      if (score >= 60) return '#CDDC39'; // Lime
      if (score >= 50) return '#FFEB3B'; // Yellow
      if (score >= 40) return '#FFC107'; // Amber
      if (score >= 30) return '#FF9800'; // Orange
      return '#F44336'; // Red for low scores
    },

    getTopMatch(matches) {
    if (!matches || !matches.length) return null;
    
    // Return the highest scoring match
    return [...matches].sort((a, b) => b.score - a.score)[0];
  },
  
  getRemainingMatches(matches) {
    if (!matches || matches.length <= 1) return [];
    
    // Sort by score and return all but the first
    return [...matches]
      .sort((a, b) => b.score - a.score)
      .slice(1);
  },
  
  hasMoreThanOneMatch(matches) {
    return matches && matches.length > 1;
  },
  
  isMatchSectionExpanded(index, section) {
    if (!this.expandedMatchSections[index]) return false;
    return this.expandedMatchSections[index][section] === true;
  },
  
  toggleMatchSection(index, section) {
    if (!this.expandedMatchSections[index]) {
      this.expandedMatchSections[index] = {};
    }
    
    // Toggle the expansion state
    this.expandedMatchSections[index][section] = !this.expandedMatchSections[index][section];
  },
   
        
    getCandidateRank(item) {
      // Get the rank of this candidate in recommendations
      if (!this.ragRecommendations || !this.ragRecommendations.length) return '';
      
      const candidateId = this.getCandidateId(item);
      if (!candidateId) return '';
      
      const recommendation = this.ragRecommendations.find(rec => 
        String(rec.candidate_id) === String(candidateId)
      );
      
      return recommendation ? recommendation.rank : '';
    },
    
    getCandidateComment(item) {
  // Return empty string if no recommendations
  if (!this.ragRecommendations || !this.ragRecommendations.length) {
    return "";
  }
  
  // Get the ElasticSearch candidate ID
  const candidateId = this.getCandidateId(item); 
  if (!candidateId) {
    return "";
  }
  
  console.log(`Looking for match with ID: ${candidateId}`);
  
  // Find the recommendation with matching ElasticSearch ID
  const recommendation = this.ragRecommendations.find(rec => 
    String(rec.elasticsearch_id) === String(candidateId)
  );
  
  // If found and it's a top recommendation, return the explanation
  if (recommendation && recommendation.rank <= 4) {
    console.log(`Found match: ${recommendation.elasticsearch_id}, rank ${recommendation.rank}`);
    return recommendation.explanation;
  }
  
  // No match found or not in top 4
  return "";
},

    // Helper method to format comments to reasonable length
    _formatComment(comment) {
      if (!comment) return "";
      
      // If comment is already short enough, return it as is
      if (comment.length <= 150) return comment;
      
      // Try to find a sentence break near 150 characters
      const lastPeriod = comment.indexOf('.', 100);
      if (lastPeriod > 0 && lastPeriod < 200) {
        return comment.substring(0, lastPeriod + 1);
      }
      
      // If no good sentence break, truncate with ellipsis
      return comment.substring(0, 147) + '...';
    },

    // Generate a generic comment when no specific analysis is found
     
    // Helper to find candidate ID regardless of data structure
    // Helper to find candidate ID regardless of data structure
    // getCandidateId(item) {
    //     if (!item) return null;
        
    //     // Try different possible paths to find candidate ID
    //     if (item.metadata && item.metadata.candidate_id) {
    //       return item.metadata.candidate_id;
    //     }
        
    //     if (item._source && item._source.metadata && item._source.metadata.candidate_id) {
    //       return item._source.metadata.candidate_id;
    //     }
        
    //     if (item.UID && item.UID.candidate_id) {
    //       return item.UID.candidate_id;
    //     }
        
    //     return null;
    //   },
formatFieldType(fieldType) {
    const map = {
      'summaries': 'Summary',
      'job_titles': 'Job Titles',
      'responsibilities': 'Responsibilities',
      'skills': 'Skills'
    };
    return map[fieldType] || fieldType;
  },

  
  formatScore(score) {
    // Convert cosine similarity (1-2 scale) to percentage
    const percentage = Math.min(Math.max(Math.round((score - 1.0) * 100), 0), 100);
    return `${percentage}% match`;
  },
    
    // Format and display helpers
    formatExperience(months) {
      if (!months && months !== 0) return "Unknown experience";
      const years = Math.floor(months / 12);
      const remainingMonths = months % 12;
      
      if (years > 0) {
        return `${years}+ ${years === 1 ? 'year' : 'years'} of experience`;
      } else {
        return `${months} ${months === 1 ? 'month' : 'months'} of experience`;
      }
    },
    
    formatLocation(location) {
      if (!location) return "";
      
      const city = location.city;
      const country = location.country;
      
      if (city && country) {
        return `${city}, ${country}`;
      } else if (city) {
        return city;
      } else if (country) {
        return country;
      }
      
      return "";
    },
    
    // Toggle section expansion
    async toggleSection(index, sectionType) {
      const candidateId = this.getCandidateId(this.searchResults.results[index]);
  
      // Prevent opening comments if not loaded yet
      if (sectionType === 'comments' && !this.candidateComments[candidateId]) {
        console.log('Comments not loaded yet for', candidateId);
        return;
      }
      if (!this.expanded[index]) {
        this.expanded[index] = {};
      }
      this.expanded[index][sectionType] = !this.expanded[index][sectionType];
      if (sectionType === 'details' && !this.expandedSections[index]?.details) {
      const candidateId = this.getCandidateId(this.searchResults.results[index]);
      
      // Preload project history
      if (!this.projectHistoryCache[candidateId]) {
        try {
          const response = await axios.get(`/api/v1/candidates/${candidateId}/project-history`);
          this.projectHistoryCache[candidateId] = response.data;
        } catch (error) {
          console.error('Failed to preload project history:', error);
        }
      }
    }
  
    },
    
    isExpanded(index, sectionType) {
      return this.expanded[index] && this.expanded[index][sectionType];
    },
    
    // Data existence checkers
    hasLocation(item) {
      return item.location && (item.location.city || item.location.country);
    },
    
    hasSkills(item) {
      return item.skills && (
        (item.skills.technical && item.skills.technical.length > 0) ||
        (item.skills.inferred && item.skills.inferred.length > 0)
      );
    },
    hasProfessionalSummary(item) {
  return item.professional_summary && item.professional_summary.trim().length > 0 || item.candidate_summary;
},
    
    hasResponsibilities(item) {
      return item.job && item.job.responsibilities && item.job.responsibilities.length > 0;
    },
    
    // Data aggregation helper
    getAllSkills(item) {
      if (!item.skills) return [];
      
      // Combine technical and inferred skills, limit to a reasonable number
      const technical = item.skills.technical || [];
      const inferred = item.skills.inferred || [];
      
      // Combine and remove duplicates
      const allSkills = [...new Set([...technical, ...inferred])];
      
      // Limit to first 30 skills
      return allSkills.slice(0, 30);
    },
    
    // Resume detail view

// ✅ WORKING VERSION (copy this exact method):
async showResumeDetail(resume) {
  // const getApiBaseUrl = () => {
  //   if (process.env.NODE_ENV === 'development') {
  //     return process.env.VUE_APP_API_BASE_URL || 'http://localhost:8000';
  //   }
  //   return ''; // Production uses nginx proxy
  // };
  
  // // Create the API URL
  // const apiBaseUrl = getApiBaseUrl();

  if (this.userRole === 'client' && this.projectContext) {
    const canConsult = await this.checkConsultationLimit('consulted');
    if (!canConsult) {
      this.showLimitExceededMessage('consultation');
      return; // Stop here - don't show resume or add to pool
    }
  }
  
  // If we get here, either no limits apply or limit not exceeded
  await this.addCandidateToPool(resume, 'consulted');
    // Track view for all users (agents and clients)
  const cid = this.getCandidateId(resume);
  
    if (cid) {
    // axios.post(`/api/v1/agent-views/${cid}`).catch(() => {});
    axios.post(`/api/v1/agent-views/${cid}`, {
      project_id: this.projectContext?.project_id || null,
      search_query: this.lastSearchQuery || null
    }).catch(() => {});
    console.log('querryyyyyyy is ', this.lastSearchQuery );
    if (!this.agentViews[cid]) this.agentViews[cid] = [];
    const myName = 'You';
    const myRole = this.userRole || 'agent';
    if (!this.agentViews[cid].some(v => v.agent_name === myName)) {
      this.agentViews[cid].unshift({ agent_name: myName, viewed_at: new Date().toISOString(), role: myRole });
    }
  }

  // Track agent view (fire-and-forget, project-insensitive)
   
  try {

    // Get candidate ID
    const candidateId = this.getCandidateId(resume);
    const esDocumentId = this.getEsDocumentId(resume);
    const identifier = esDocumentId || candidateId;
    const idType = esDocumentId ? 'es_id' : 'candidate_id';
    
    console.log(`🔍 Loading resume using ${idType}: ${identifier}`);
    
    if (!identifier) {
      this.showNotification('Cannot display details: Missing ID', 'error');
      return;
    }
    // if (!candidateId) {
    //   this.showNotification('Cannot display details: Missing candidate ID', 'error');
    //   return;
    // }
     // KEY FIX: Add to consulted set immediately for UI reactivity
    this.consultedCandidates.add(candidateId);
    // Show loading notification
    this.showNotification('Loading resume details...', 'info');
    
    // Fetch the full resume data
    // const response = await fetch(`${apiBaseUrl}/api/v1/get_resume/${candidateId}/`);
    //const response = await axios.get(`/api/v1/get_resume/${candidateId}/`);
    const response = await axios.get(`/api/v1/get_resume/${identifier}/`, {
      params: { id_type: idType }  // ✅ NEW: Pass id_type as query param
    });

    // if (!response.ok) {
    //   throw new Error(`Server returned ${response.status}: ${await response.text() || 'Unknown error'}`);
    // }
    
    //const fullResumeData = await response.json();
    const fullResumeData = response.data; // axios puts response in .data

    // Clear loading notification
    this.showNotification('', '', 0);
    
    // Format the data for ResumeDetailView
    this.selectedResume = {
      _source: fullResumeData
    };
    
    // Show the detail view
    this.showDetailView = true;
    // Refresh limits to update UI
    if (this.userRole === 'client') {
      await this.loadConsultationLimits();
    }
    
    this.showNotification('Resume loaded successfully', 'success');


  } catch (error) {
    console.error("Error showing resume details:", error);
    this.showNotification("Unable to display resume details: " + error.message, "error");
  }
},

closeDetailView() {
  this.showDetailView = false;
},


    showNotification(message, type = 'info', duration = 3000) {
      // Clear any existing timeout
      if (this.downloadStatus.timeout) {
        clearTimeout(this.downloadStatus.timeout);
      }
      
      // Set icon based on type
      let icon = 'fas fa-spinner fa-spin';
      if (type === 'success') icon = 'fas fa-check-circle';
      if (type === 'error') icon = 'fas fa-exclamation-circle';
      
      // Update notification state
      this.downloadStatus = {
        show: true,
        message,
        type,
        icon,
        timeout: null
      };
      
      // Auto-hide after duration
      if (duration > 0) {
        this.downloadStatus.timeout = setTimeout(() => {
          this.downloadStatus.show = false;
        }, duration);
      }
    },
    
     // Complete implementation for downloading original resume from S3
     
     async downloadResume(candidateId,esDocumentId) {
      console.log("🔍 ==> downloadResume started");
  console.log("   candidateId:", candidateId);
  console.log("   esDocumentId:", esDocumentId);
  console.log("🔍 ==> downloadResume started for candidateId:", candidateId);
  
  // if (!candidateId) {
  //   console.error("❌ No candidate ID available for download");
  //   this.showNotification('Cannot download resume: Missing candidate ID', 'error');
  //   return;
  // }
    
  if (!esDocumentId && !candidateId) {
    console.error("❌ No identifier available for download");
    this.showNotification('Cannot download resume: Missing ID', 'error');
    return;
  }
  
  
  // Close dropdown
  this.downloadMenuOpen = null;
  if (this.userRole !== 'client'){
    //  axios.post(`/api/v1/agent-views/${candidateId || esDocumentId}`).catch(() => {});}
     axios.post(`/api/v1/agent-views/${candidateId || esDocumentId}`, {
      project_id: this.projectContext?.project_id || null,
      search_query: this.lastSearchQuery || null
    }).catch(() => {});

    }

  // Show loading notification
  this.showNotification('Fetching original resume...', 'info');
  
  try {
    // Prefer ES ID (always unique), fallback to candidate_id
    const identifier = esDocumentId || candidateId;
    const idType = esDocumentId ? 'es_id' : 'candidate_id';
    
    console.log(`🔍 Using ${idType}: ${identifier}`);
    
    const response = await axios.get(
      `/api/v1/s3/download-original/${encodeURIComponent(identifier)}`,
      {
        params: { id_type: idType },  // NEW: Pass id_type parameter
        headers: { 'Accept': 'application/json' }
      }
    );
    
    console.log("📡 Response status:", response.status);
    console.log("📦 Response data:", response.data);
    
    
    const data = response.data; // axios puts response in .data
    console.log("📦 Response data:", data);
    
    if (data.success && data.download_url) {
      // Create a temporary link to trigger download
      const link = document.createElement('a');
      link.href = data.download_url;
      link.target = '_blank';  // ← ADD THIS LINE
      link.download = data.original_filename || `original_resume_${candidateId}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      console.log("✅ Download triggered successfully");
      this.showNotification('Original resume download started!', 'success');
    } else {
      throw new Error('No download URL received from server');
    }
    
  } catch (error) {
  if (error.response) {
    console.error("❌ Response error:", error.response.status, error.response.statusText);
    console.error("🪵 Response data:", error.response.data);
    throw new Error(`HTTP ${error.response.status}: ${error.response.statusText} - ${JSON.stringify(error.response.data)}`);
  } else {
    console.error("❌ Network or setup error:", error.message);
    throw error;
  }}
},
       

    
    // // a method for batch download if needed
    // downloadMultipleResumes(candidateIds) {
    //   if (!candidateIds || candidateIds.length === 0) {
    //     this.showNotification('No candidates selected for download', 'error');
    //     return;
    //   }
      
    //   this.showNotification('Preparing batch download...', 'info');
    //    // Create the API URL
    //    const getApiBaseUrl = () => {
    //     if (process.env.NODE_ENV === 'development') {
    //       return process.env.VUE_APP_API_BASE_URL || 'http://localhost:8000';
    //     }
    //     return ''; // Production uses nginx proxy
    //   };
      
    //   // Create the API URL
    //   const apiBaseUrl = getApiBaseUrl();
    //   const url = `${apiBaseUrl}/api/v1/export_resumes/batch?candidate_ids=${candidateIds.join(',')}/`;

       
    //   console.log("Download URL:", url);
    //   try {
    //     //const apiBaseUrl = '';
        
    //     // Same approach as single download
    //     const link = document.createElement('a');
    //     link.href = url;
    //     link.setAttribute('download', 'Candidates_Export.zip');
    //     link.setAttribute('target', '_blank');
    //     document.body.appendChild(link);
        
    //     // Track success
    //     link.onclick = () => {
    //       setTimeout(() => {
    //         this.showNotification('Batch download started!', 'success');
    //       }, 1000);
    //     };
        
    //     link.click();
    //     setTimeout(() => document.body.removeChild(link), 100);
    //   } catch (error) {
    //     console.error('Batch download error:', error);
    //     this.showNotification('Failed to download resumes', 'error');
    //   }
    // },,
 
 
  // THREE METHODS : Sorting by recency
  toggleSortDropdown() {
      this.sortDropdownOpen = !this.sortDropdownOpen;
    },
    
    selectSort(value) {
      this.selectedSort = value;
      this.sortDropdownOpen = false;
      
      // Emit to parent to trigger new search with this sort
      this.$emit('sort-changed', value);
    },
    
    closeSortDropdown(e) {
      // Close dropdown when clicking outside
      if (!this.$refs.sortDropdown?.contains(e.target)) {
        this.sortDropdownOpen = false;
      }
    }
  },
   // click outside listener
async mounted() {
    document.addEventListener('click', this.closeSortDropdown);

    console.log('🚀 GallerySection mounted - starting initialization...');
    // ✅ NEW: Skip heavy loading in pool mode
    if (this.$route.path.includes('/pool')) {
      console.log('🏊 Pool mode - skipping heavy initialization');
      this.skipHeavyLoading = true;
      await this.detectUserRole();
      // ✅ CRITICAL: Still need project context for workflow
      if (this.projectContext) {
        console.log('📋 Loading project status for pool candidates');
        await this.loadProjectStatus();
      }
      this.componentInitialized = true;
      this.isInitializing = false;
      console.log('✅ GallerySection initialization complete (pool mode - minimal)');
      return;
    }
   // this.isInitializing = true;

    // this.debugApiResponse('SOA-d310');
  
  // CRITICAL: Ensure core objects are initialized
  if (!this.projectStatuses) this.projectStatuses = {};
  if (!this.candidateTags) this.candidateTags = {};
  if (!this.existingReportsCache) this.existingReportsCache = {};
  
  console.log('🚀 Component mounted, initializing state...');
 


  console.log('🚀 GallerySection mounted - starting initialization...');
  
  // STEP 1: Detect user role first (critical for filtering)
  await this.detectUserRole();
  console.log('👤 User role detected:', this.userRole);
  
  // STEP 2: Get project context from props if available
 
  
  // STEP 3: Set up event listeners
  document.addEventListener('click', this.closeDropdowns);

  // STEP 4: Load all candidate data in the right order ---- lazy loading ffrom now
  // await this.loadCandidateTags();
  // await this.loadCandidateComments();
  // this.loadBookmarkStatuses();
  
  // STEP 5: Load project status if in project context
  
 // If we have search results, start loading data
 
  if (this.projectContext) {
    console.log('📋 Project context available:', this.projectContext);
    // ✅ Check if navigating from notification
    const fromNotification = this.$route.query.from === 'notification';
    console.log('🔔 From notification:', fromNotification);

    await this.checkProjectAgentAssignment();
    await this.loadProjectStatus(fromNotification);
    // await this.loadExistingReportsCache();

  } else {
    console.log('📋 No project context - global mode');
  }
  
  this.currentPage = 1;
  this.componentInitialized = true;
  this.isInitializing = false;
  console.log('✅ GallerySection initialization complete');
    // Start simple polling like notifications - 2 second interval
 this.pollInterval = setInterval(() => {
    if (!this.isPolling && this.results.length > 0 && this.projectContext) {
      this.pollForUpdates();
    }
  }, 10000);
  if (this.userRole === 'client' && this.projectContext) {
  await this.loadConsultationLimits();
}

  // if (this.searchResults && this.searchResults.results) {
  //     if (this.projectContext) {
  //       console.log('✅ Both context and results available, loading project data');
  //       await this.reinitializeWithProjectContext();
  //     } else {
  //       console.log('🌐 No project context, loading in global mode');
  //       await this.loadCandidateTags();
  //     }
  //   }
  // ✅ FIX: Only load if we actually have results
    if (this.searchResults && this.searchResults.results && this.searchResults.results.length > 0) {
      if (this.projectContext) {
        console.log('✅ Both context and results available, loading project data');
        await this.reinitializeWithProjectContext();
      } else {
        console.log('🌐 No project context, loading in global mode');
        //await this.loadCandidateTags();
      }
    } else {
      console.log('📭 No search results on mount, data will load when search executes');
    }
  document.addEventListener('click', this.handleOutsideClick);

},
  
  beforeUnmount() {
    document.removeEventListener('click', this.closeSortDropdown);
    document.removeEventListener('click', this.closeDropdowns);
    document.removeEventListener('click', this.handleOutsideClick);

    if (this.pollInterval) {
    clearInterval(this.pollInterval);
  }
  }
};
</script>


<style scoped>
:root{
  --card-min: 300px;
  --gap: 1.5rem;
}
.gallery-wrapper {
  padding: 2rem 0;
  min-height: 60vh;
}

/* Gallery header */
.gallery-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
}

.gallery-actions {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.actions-spacer {
  flex: 1;
  min-width: 1rem;
}
/* Tag Filter - Compact Design */
.tag-filter-wrapper {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  max-width: 250px; /* THIS IS KEY - limits width */
}



.action-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  background: var(--surface-color);
  border: 1px solid var(--border-color);
  border-radius: 0.5rem;
  color: var(--text-color);
  font-size: 0.875rem;
  cursor: pointer;
  transition: all 0.2s ease;
}

.action-btn:hover {
  border-color: var(--primary-color);
  background: var(--hover-color);
}

.action-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Loading state */
.loading-state {
  text-align: center;
  padding: 4rem 2rem;
}

.loading-animation {
  display: flex;
  justify-content: center;
  gap: 0.5rem;
  margin-bottom: 1rem;
}

.loading-dot {
  width: 0.75rem;
  height: 0.75rem;
  background: var(--primary-color);
  border-radius: 50%;
  animation: pulse 1.4s infinite ease-in-out both;
}

.loading-dot:nth-child(1) { animation-delay: -0.32s; }
.loading-dot:nth-child(2) { animation-delay: -0.16s; }

@keyframes pulse {
  0%, 80%, 100% {
    transform: scale(0);
    opacity: 0.5;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
}

/* Empty state */
.empty-state {
  text-align: center;
  padding: 4rem 2rem;
  color: rgba(250, 249, 246, 0.6);
}

.empty-state i {
  font-size: 3rem;
  margin-bottom: 1rem;
  opacity: 0.3;
}

.empty-state h3 {
  font-size: 1.25rem;
  margin-bottom: 0.5rem;
}

/* Results layouts */
.results-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 1.5rem;
}


.results-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.result-card {
  background: var(--surface-color);
  border: 1px solid var(--border-color);
  border-radius: 0.75rem;
  padding: 1rem; /* Reduced from 1.5rem */
  transition: all 0.2s ease;
  position: relative;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: start;
  margin-bottom: 0.75rem; /* Reduced from 1rem */
  position: relative; /* Make sure this is set */

}

.contact-initiator {
  

  color: #28a745;
  border-radius: 12px;
  font-size: 0.7rem;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 4px;
  z-index: 2;
}

.contact-initiator i {
  font-size: 0.6rem;
}
.result-card:hover {
  border-color: rgba(250, 249, 246, 0.2);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.result-card.recommended {
  border-color: var(--primary-color);
}

/* AI Recommendation badge */
.ai-recommendation {
  position: absolute;
  top: -1px;
  right: -1px;
  background: var(--primary-color);
  color: white;
  padding: 0.25rem 0.75rem;
  border-radius: 0 0.75rem 0 0.75rem;
  font-size: 0.75rem;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 0.25rem;
}




.candidate-info {
  flex: 1;
}
 
.location {
  font-size: 0.875rem;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.5);
}
 
.candidate-name {
  font-size: 1.25rem; /* Reduced from 1.5rem */
  font-weight: 900;
  color: #ffffff;
  margin: 0 0 0.25rem;
  line-height: 1.2;
}

.candidate-title {
  font-size: 0.95rem; /* Reduced from 1.05rem */
  font-weight: 600;
  color: rgba(255, 255, 255, 0.85);
  margin-bottom: 0.2rem;
  line-height: 1.3;
}

.at {
  font-size: 0.8rem; /* Reduced from 0.9rem */
  font-weight: 900;
  font-style: italic;
  color: rgba(250, 249, 246, 0.694);
}

.jobby {
  font-size: 0.85rem; /* Reduced from 0.95rem */
  font-style: italic;
  font-weight: 500;
  margin-top: 0.2rem;
  color: rgba(255, 255, 255, 0.6);
}

.card-actions {
  display: flex;
  gap: 0.5rem;
}

.icon-btn {
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: 1px solid var(--border-color);
  border-radius: 0.5rem;
  color: var(--text-color);
  cursor: pointer;
  transition: all 0.2s ease;
}

.icon-btn:hover {
  border-color: var(--primary-color);
  color: var(--primary-color);
  background: var(--hover-color);
}
.icon-btn.candidate-group-btn:hover {
  border-color: #667eea;
  color: #667eea;
  background: rgba(102, 126, 234, 0.1);
}
/* Download dropdown */
.download-dropdown {
  position: relative;
}

.dropdown-content {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 0.5rem;
  background: var(--surface-color);
  border: 1px solid var(--border-color);
  border-radius: 0.5rem;
  min-width: 250px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1000;
}

.dropdown-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  width: 100%;
  padding: 0.75rem 1rem;
  background: none;
  border: none;
  color: var(--text-color);
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: left;
}

.dropdown-item:hover {
  background: var(--hover-color);
}

.dropdown-item i {
  width: 1.25rem;
  color: var(--primary-color);
}

.dropdown-item-content {
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
}

.dropdown-item-title {
  font-size: 0.875rem;
  font-weight: 500;
}

.dropdown-item-desc {
  font-size: 0.75rem;
  color: rgba(250, 249, 246, 0.6);
}

/* Quick info */
.quick-info {
  display: flex;
  gap: 1.5rem;
  margin-bottom: 1rem;
  font-size: 0.875rem;
  color: rgba(250, 249, 246, 0.8);
  flex-wrap: wrap;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.info-item i {
  color: var(--primary-color);
  width: 1rem;
}

/* Skills preview */
.skills-preview {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  align-items: center;
}

.skill-chip {
  padding: 0.25rem 0.75rem;
  background: rgba(212, 47, 61, 0.1);
  border: 1px solid rgba(212, 47, 61, 0.2);
  border-radius: 1rem;
  font-size: 0.813rem;
  color: var(--text-color);
}

.more-skills {
  font-size: 0.813rem;
  color: rgba(250, 249, 246, 0.6);
  font-style: italic;
}

/* Expanded content */
.expanded-content {
  margin-top: 1.5rem;
  padding-top: 1.5rem;
  border-top: 1px solid var(--border-color);
}

.section {
  margin-bottom: 1.5rem;
}

.section:last-child {
  margin-bottom: 0;
}

.section h4 {
  font-size: 1rem;
  font-weight: 600;
  margin: 0 0 0.75rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: var(--text-color);
}

.collapsible {
  cursor: pointer;
  user-select: none;
}

.collapsible:hover {
  color: var(--primary-color);
}

.all-skills {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}
/* Profile section styling - card format */
.summary-text, .profile-content {
  background: rgba(250, 249, 246, 0.03);
  border: 1px solid rgba(250, 249, 246, 0.1);
  border-radius: 0.5rem;
  padding: 1rem;
  line-height: 1.6;
  color: rgba(250, 249, 246, 0.9);
  margin: 0;
  font-size: 0.875rem;
}

/* Responsibilities styling - card format with chips */
.responsibilities {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.profile-section {
  font-size: 0.85rem; /* Reduced from 0.95rem */
  font-style: italic;
  font-weight: 500;
  margin-top: 0.2rem;
  color: rgba(255, 255, 255, 0.6);
  padding-left:10px;
}
.responsibilities li {
  background: rgba(250, 249, 246, 0.05);
  border: 1px solid rgba(250, 249, 246, 0.1);
  border-radius: 0.375rem;
  padding: 0.75rem;
  line-height: 1.5;
  color: rgba(250, 249, 246, 0.9);
  font-size: 0.675rem;
  position: relative;
  transition: all 0.2s ease;
}

.responsibilities li:hover {
  background: rgba(250, 249, 246, 0.08);
  border-color: rgba(250, 249, 246, 0.2);
}

.responsibilities li::before {
  content: '▸';
  color: var(--primary-color);
  font-weight: bold;
  margin-right: 0.5rem;
}

/* AI Insights */
.ai-insights {
  background: rgba(212, 47, 61, 0.05);
  padding: 1rem;
  border-radius: 0.5rem;
  border: 1px solid rgba(212, 47, 61, 0.1);
}

.insight-content {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.insight-item p {
  margin: 0.5rem 0 0;
  color: rgba(250, 249, 246, 0.9);
}

.fit-score-bar {
  width: 100%;
  height: 0.5rem;
  background: rgba(250, 249, 246, 0.1);
  border-radius: 0.25rem;
  overflow: hidden;
  margin: 0.5rem 0;
}

.fit-score-fill {
  height: 100%;
  background: var(--primary-color);
  transition: width 0.3s ease;
}

/* Matches */
.match-item {
  padding: 0.75rem;
  background: rgba(250, 249, 246, 0.03);
  border-radius: 0.5rem;
  margin-bottom: 0.5rem;
}

.match-text {
  margin: 0 0 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
}

.match-score {
  font-size: 0.75rem;
  color: var(--primary-color);
  font-weight: 500;
}

/* Pagination */
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  margin-top: 3rem;
}

.page-numbers {
  display: flex;
  gap: 0.5rem;
}

.page-btn {
  width: 2.5rem;
  height: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--surface-color);
  border: 1px solid var(--border-color);
  border-radius: 0.5rem;
  color: var(--text-color);
  font-size: 0.875rem;
  cursor: pointer;
  transition: all 0.2s ease;
}

.page-btn:hover:not(:disabled) {
  border-color: var(--primary-color);
  background: var(--hover-color);
}

.page-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.page-btn.active {
  background: var(--primary-color);
  border-color: var(--primary-color);
  color: white;
}

/* Transitions */
.expand-enter-active,
.expand-leave-active {
  transition: all 0.3s ease;
}

.expand-enter-from,
.expand-leave-to {
  opacity: 0;
  transform: translateY(-1rem);
}

/* Responsive */
@media (max-width: 768px) {
  .gallery-header {
    gap: 1rem;
    align-items: start;
  }
  
  .results-grid {
    grid-template-columns: 1fr;
  }
  
  .quick-info {
    flex-wrap: wrap;
    gap: 0.75rem;
  }
  
  .pagination {
    flex-wrap: wrap;
  }
  
  .dropdown-content {
    right: auto;
    left: 0;
  }
}

/* Notification */
.download-notification {
  position: fixed;
  bottom: 2rem;
  right: 2rem;
  padding: 1rem;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  z-index: 1000;
  animation: slide-in 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  max-width: 400px;
}

.download-notification.info {
  background: rgba(41, 128, 185, 0.9);
}

.download-notification.success {
  background: rgba(39, 174, 96, 0.9);
}

.download-notification.error {
  background: rgba(192, 57, 43, 0.9);
}

.close-notification {
  background: transparent;
  border: none;
  color: white;
  opacity: 0.7;
  cursor: pointer;
  margin-left: auto;
}

.close-notification:hover {
  opacity: 1;
}

@keyframes slide-in {
  0% {
    transform: translateX(100%);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}

@media (max-width: 992px) {
  .gallery_grid {
    grid-template-columns: 1fr;
  }
}

/* ADD THESE STYLES to the <style> section of GallerySection_modified2.vue */

/* Card metadata styles */
.card-metadata {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  padding: 0.5rem 0;
  border-bottom: 1px solid rgba(250, 249, 246, 0.1);
  font-size: 0.75rem;
}

.candidate-id, .indexed-date {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  color: rgba(250, 249, 246, 0.6);
}

.candidate-id i, .indexed-date i {
  color: var(--primary-color);
  font-size: 0.875rem;
}

/* Semantic matches styles */
.semantic-matches {
  margin-top: 1.5rem;
  padding-top: 1rem;
  border-top: 1px solid rgba(250, 249, 246, 0.15);
}

.section-header {
  margin-bottom: 1rem;
}

.semantic-matches-title {
  font-size: 1rem;
  font-weight: 600;
  color: var(--primary-color);
  margin: 0;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.semantic-matches-title i {
  font-size: 0.875rem;
}

.match-category {
  margin-bottom: 1rem;
  background: rgba(250, 249, 246, 0.03);
  border-radius: 0.5rem;
  padding: 0.75rem;
  border: 1px solid rgba(250, 249, 246, 0.08);
}

.match-category:last-child {
  margin-bottom: 0;
}

.match-type-heading {
  font-size: 0.875rem;
  font-weight: 500;
  color: rgba(250, 249, 246, 0.9);
  margin-bottom: 0.75rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.match-type-heading i {
  color: var(--primary-color);
  font-size: 0.75rem;
}

.match-item {
  background: rgba(250, 249, 246, 0.05);
  border-radius: 0.375rem;
  padding: 0.75rem;
  margin-bottom: 0.5rem;
  border: 1px solid rgba(250, 249, 246, 0.06);
  transition: all 0.2s ease;
}

.match-item:hover {
  background: rgba(250, 249, 246, 0.08);
  border-color: rgba(250, 249, 246, 0.12);
}

.match-item:last-child {
  margin-bottom: 0;
}

.match-text {
  font-size: 0.875rem;
  line-height: 1.4;
  color: rgba(250, 249, 246, 0.9);
  margin-bottom: 0.5rem;
}

.match-meta {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.match-score {
  background: linear-gradient(135deg, var(--primary-color), #d42f3d);
  color: white;
  padding: 0.125rem 0.5rem;
  border-radius: 1rem;
  font-size: 0.75rem;
  font-weight: 500;
}

.match-type, .match-context {
  font-size: 0.75rem;
  color: rgba(250, 249, 246, 0.6);
  font-style: italic;
}

.toggle-matches-btn {
  width: 100%;
  background: rgba(250, 249, 246, 0.05);
  border: 1px solid rgba(250, 249, 246, 0.1);
  border-radius: 0.375rem;
  color: var(--primary-color);
  padding: 0.5rem;
  font-size: 0.75rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-top: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.375rem;
}

.toggle-matches-btn:hover {
  background: rgba(250, 249, 246, 0.08);
  border-color: rgba(250, 249, 246, 0.2);
  transform: translateY(-1px);
}

.toggle-matches-btn i {
  font-size: 0.75rem;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .card-metadata {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.25rem;
  }
  
  .match-meta {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.25rem;
  }
  
  .semantic-matches-title {
    font-size: 0.875rem;
  }
}

.linkedin-link {
  color: #0077b5; /* LinkedIn brand color */
  text-decoration: none;
  transition: all 0.2s ease;
  padding: 0.25rem;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.linkedin-link:hover {
  color: #005582;
  background-color: rgba(0, 119, 181, 0.1);
  transform: scale(1.1);
}

.linkedin-link i {
  font-size: 1rem;
}
.card-header-content {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 8px 0px 4px;
}

.card-top-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 28px;
}

.card-top-left {
  display: flex;
  align-items: center;
  gap: 6px;
  flex: 1;
  min-width: 0;
  overflow: hidden;
}

.card-top-right {
  display: flex;
  align-items: center;
  gap: 2px;
  flex-shrink: 0;
}
.card-actions {
  margin-bottom: 0.8rem; /* space between info and buttons */
  display: flex;
  gap: 0.5rem; /* spacing between buttons */
  justify-content: flex-end;

}
.candidate-tags {
  margin-top: 0.75rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.predefined-tags, .custom-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem;
}

.tag-btn {
  padding: 0.25rem 0.5rem;
  border: 1px solid rgba(234, 94, 19, 0.3);
  background: transparent;
  color: rgba(255, 255, 255, 0.7);
  border-radius: 12px;
  font-size: 0.75rem;
  cursor: pointer;
  transition: all 0.2s;
}

.tag-btn.active {
  background: rgba(234, 94, 19, 0.8);
  color: white;
}

.custom-tag {
  padding: 0.25rem 0.5rem;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  font-size: 0.75rem;
  cursor: pointer;
  color: rgba(255, 255, 255, 0.9);
}

.custom-tag-input {
  padding: 0.25rem 0.5rem;
  border: 1px solid var(--primary-color);
  background: rgba(0, 0, 0, 0.3);
  color: white;
  border-radius: 12px;
  font-size: 0.75rem;
  width: 80px;
}

.add-tag-btn {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 1px solid rgba(234, 94, 19, 0.5);
  background: transparent;
  color: var(--primary-color);
  cursor: pointer;
  font-size: 0.875rem;
}



.tag-filter-group {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  max-width: 100px;
}


.tag-filter-select {
  flex: 1;
  min-width: 150px;
  max-width: 200px;
  padding: 0.5rem 0.75rem;
  background: var(--surface-color);
  border: 1px solid var(--border-color);
  border-radius: 0.5rem;
  color: var(--text-color);
  font-size: 0.875rem;
  cursor: pointer;
  transition: all 0.2s ease;
}
.tag-filter-select:hover {
  border-color: var(--primary-color);
  background: var(--hover-color);
}

.clear-tag-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  padding: 0;
  background: var(--surface-color);
  border: 1px solid var(--border-color);
  border-radius: 0.5rem;
  color: var(--text-color);
  cursor: pointer;
  transition: all 0.2s ease;
}

.clear-tag-btn:hover {
  border-color: #dc3545;
  background: rgba(220, 53, 69, 0.1);
  color: #dc3545;
}
.tag-filter-select option {
  background: var(--card-background, #2a2a3a);
  color: white;
}

 
.clear-filter-btn {
  padding: 0.25rem 0.5rem;
  background: rgba(234, 94, 19, 0.8);
  border: none;
  border-radius: 4px;
  color: white;
  cursor: pointer;
}



/* Download section container */
.download-section {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 0.5rem;
  background: var(--surface-color);
  border: 1px solid var(--border-color);
  border-radius: 0.75rem;
  min-width: 200px; /* Reduced from 320px */
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  z-index: 1000;
  overflow: hidden;
}
.download-options {
  padding: 0;
}

/* Options header */
.options-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.25rem;
  background: rgba(212, 47, 61, 0.1);
  border-bottom: 1px solid var(--border-color);
}

.options-header h4 {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  color: var(--primary-color);
}

.close-btn {
  background: none;
  border: none;
  color: var(--text-color);
  cursor: pointer;
  padding: 0.25rem;
  border-radius: 0.25rem;
  opacity: 0.7;
  transition: all 0.2s ease;
}

.close-btn:hover {
  opacity: 1;
  background: var(--hover-color);
}

/* Checkbox group */
.checkbox-group {
  padding: 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

/* Individual checkbox item */
.checkbox-item {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  cursor: pointer;
  padding: 0.75rem;
  border-radius: 0.5rem;
  transition: all 0.2s ease;
  position: relative;
}

.checkbox-item:hover {
  background: var(--hover-color);
}

/* Hidden native checkbox */
.checkbox-input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Custom checkmark */
.checkmark {
  height: 1.25rem;
  width: 1.25rem;
  background: var(--surface-color);
  border: 2px solid var(--border-color);
  border-radius: 0.25rem;
  position: relative;
  transition: all 0.2s ease;
  flex-shrink: 0;
  margin-top: 0.125rem;
}

/* Checkmark when checked */
.checkbox-input:checked ~ .checkmark {
  background: var(--primary-color);
  border-color: var(--primary-color);
}

/* Checkmark icon */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
  left: 0.375rem;
  top: 0.125rem;
  width: 0.25rem;
  height: 0.5rem;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.checkbox-input:checked ~ .checkmark:after {
  display: block;
}

/* Checkbox content */
.checkbox-content {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  flex: 1;
}

.checkbox-label {
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--text-color);
  line-height: 1.2;
}

.checkbox-description {
  font-size: 0.75rem;
  color: rgba(250, 249, 246, 0.6);
  line-height: 1.3;
}

/* Download actions */
.download-actions {
  padding: 1rem 1.25rem;
  border-top: 1px solid var(--border-color);
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.download-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  border-radius: 0.5rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
  width: 100%;
}

.download-btn.primary {
  background: var(--primary-color);
  color: white;
}

.download-btn.primary:hover {
  background: #a91726;
  transform: translateY(-1px);
}

.download-btn.secondary {
  background: var(--surface-color);
  color: var(--text-color);
  border: 1px solid var(--border-color);
}

.download-btn.secondary:hover {
  background: var(--hover-color);
  border-color: var(--primary-color);
}

.download-btn i {
  font-size: 0.875rem;
}

/* Focus states for accessibility */
.checkbox-input:focus ~ .checkmark {
  box-shadow: 0 0 0 2px rgba(212, 47, 61, 0.2);
}

.download-btn:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(212, 47, 61, 0.2);
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .download-section {
    min-width: 280px;
    right: auto;
    left: 0;
  }
  
  .checkbox-group {
    padding: 1rem;
  }
  
  .download-actions {
    padding: 0.75rem 1rem;
  }
}
.project-context {
  color: var(--text-secondary, #666);
  font-style: italic;
}

.comments-content {
  padding: 1rem 0;
}

.comments-list {
  margin-bottom: 1rem;
}

.comment-item {
  font-family:'Courier New', Courier, monospace;
  background: rgba(0,0,0,0.2);
  
  position: relative;
  border-radius: 4px;
  padding: 12px;
  margin-bottom: 8px;
  /* Fix text wrapping */
  word-wrap: break-word;
  overflow-wrap: break-word;
  width: 100%;
  box-sizing: border-box;
}

.comment-text {
  color: rgba(255,255,255,0.9);
  margin-bottom: 0.25rem;
}

.comment-meta {
  font-size: 0.75rem;
  color: rgba(255,255,255,0.6);
}

.comment-count {
  font-size: 0.8rem;
  color: rgba(234, 94, 19, 0.8);
}

.add-comment-section {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.comment-textarea {
  width: 100%;
  padding: 0.5rem;
  border-radius: 4px;
  border: 1px solid rgba(255,255,255,0.2);
  background: rgba(0,0,0,0.3);
  color: white;
  resize: vertical;
}

.add-comment-btn {
  align-self: flex-start;
  padding: 0.5rem 1rem;
  background: rgba(234, 94, 19, 0.8);
  border: none;
  border-radius: 4px;
  color: white;
  cursor: pointer;
}

.add-comment-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
 

.comment-header {
  position: absolute;
  top: 4px;
  right: 4px;
}

.delete-x {
  background: none;
  border: none;
  font-size: 18px;
  color: #999;
  cursor: pointer;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

.delete-x:hover {
  background: #f5f5f5;
  color: #ff4444;
}

.delete-x:disabled {
  color: #ccc;
  cursor: not-allowed;
}

.comment-content {
  margin-right: 25px;
  /* Force text to wrap */
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: pre-wrap; /* Preserves line breaks but wraps long lines */
  max-width: 100%;
}



.comments-list {
  margin-bottom: 1rem;
  max-height: 240px;
  overflow-y: auto;
  padding-right: 4px;
  position: relative;
  border-radius: 6px;
  /* Fix horizontal overflow */
  overflow-x: hidden;
  width: 100%;
}

/* Always show fade when there are >3 comments */
.comments-list.has-scrollable-content::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 20px;
  background: linear-gradient(transparent, rgba(0,0,0,0.8));
  pointer-events: none;
  opacity: 1;
}

 
 
/* Rest of your existing scrollbar CSS stays the same */
.comments-list::-webkit-scrollbar {
  width: 8px;
}

.comments-list::-webkit-scrollbar-track {
  background: rgba(255,255,255,0.1);
  border-radius: 4px;
}

.comments-list::-webkit-scrollbar-thumb {
  background: rgba(234, 94, 19, 0.6);
  border-radius: 4px;
  border: 1px solid rgba(255,255,255,0.1);
}

.comments-list::-webkit-scrollbar-thumb:hover {
  background: rgba(234, 94, 19, 0.8);
}

.scroll-hint {
  text-align: center;
  font-size: 0.7rem;
  color: rgba(255,255,255,0.5);
  margin-bottom: 0.5rem;
}

/* Bookmark button styling to match existing icon-btn style */
.bookmark-btn {
  position: relative;
  transition: all 0.2s ease;
}

.bookmark-btn:not(.bookmarked) {
  color: rgba(250, 249, 246, 0.6);
}

.bookmark-btn:not(.bookmarked):hover {
  color: var(--primary-color);
  background: var(--hover-color);
}

.bookmark-btn.bookmarked {
  color: var(--primary-color);
  background: rgba(212, 47, 61, 0.1);
}

.bookmark-btn.bookmarked:hover {
  color: #a91726;
  background: rgba(212, 47, 61, 0.2);
}

/* Add a subtle pulse animation when bookmarked */
.bookmark-btn.bookmarked i {
  animation: bookmarkPulse 0.3s ease-out;
}

@keyframes bookmarkPulse {
  0% { transform: scale(1); }
  50% { transform: scale(1.2); }
  100% { transform: scale(1); }
}


/* box checking logic */

.auto-selected {
  font-style: italic;
  color: var(--primary-color);
  font-size: 0.75rem;
}

.checkbox-input:disabled ~ .checkmark {
  background-color: var(--primary-color);
  border-color: var(--primary-color);
  opacity: 0.7;
}

.checkbox-input:disabled ~ .checkbox-content {
  opacity: 0.7;
}
/* Compact tag groups with minimal spacing */
.candidate-tags-grouped {
  margin-top: 8px;
}

.tag-group {
  margin-bottom: 8px; /* Reduced from default */
}

.tag-group-title {
  font-size: 0.85rem;
  font-weight: 600;
  margin-bottom: 4px;
  color: #e0e0e0;
}

.pipeline-always-visible {
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid #444;
}

.tags-toggle {
  background: #333;
  border: 1px solid #555;
  color: #ccc;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 0.8rem;
  cursor: pointer;
  width: 100%;
  text-align: left;
}

.tags-content {
  margin-top: 8px;
}

/* Timeline tag colors */
.tag-contacted.active { background-color: #4a90e2; }
.tag-responded.active { background-color: #7b68ee; }
.tag-screened.active { background-color: #ffa500; }
.tag-interviewed.active { background-color: #ff6b6b; }
.tag-offered.active { background-color: #4ecdc4; }
.tag-hired.active { background-color: #26d0ce; }

/* Status tag colors */
.tag-blacklisted.active { background-color: #dc3545; }
.tag-off-market.active { background-color: #6c757d; }
.tag-open-work.active { background-color: #28a745; }

/* Other tag colors */
.preference-tag.active { background-color: #17a2b8; }
.restriction-tag.active { background-color: #fd7e14; }
.type-tag.active { background-color: #6f42c1; }

/* Compact tag buttons */
.tag-btn {
  padding: 3px 8px;
  margin: 2px 3px;
  font-size: 0.75rem;
}

/* Custom tags section */
.custom-tags-section {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
}

.custom-tag {
  background: #555;
  padding: 2px 6px;
  border-radius: 3px;
  font-size: 0.7rem;
  cursor: pointer;
}

.add-tag-btn {
  background: #28a745;
  color: white;
  border: none;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  cursor: pointer;
  font-size: 14px;
}

.custom-tag-input {
  background: #333;
  border: 1px solid #555;
  color: white;
  padding: 2px 6px;
  border-radius: 3px;
  font-size: 0.75rem;
  width: 120px;
}
/* Custom tags always visible */
.custom-always-visible {
  margin-bottom: 8px;
  padding-bottom: 8px;
  border-bottom: 1px solid #444;
}

.custom-tags {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
}

.custom-tag {
  background-color: #555;
  color: #fff;
  padding: 3px 8px;
  border-radius: 12px;
  font-size: 0.75rem;
  cursor: pointer;
  transition: background-color 0.2s;
}

.custom-tag:hover {
  background-color: #666;
}

.add-tag-btn {
  background: #28a745;
  color: white;
  border: none;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  cursor: pointer;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.custom-tag-input {
  background: #333;
  border: 1px solid #555;
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 0.75rem;
  width: 120px;
  outline: none;
}

/* Active collapsed tags section */
.active-collapsed-tags {
  margin-bottom: 8px;
  padding: 8px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 4px;
  border: 1px solid #444;
}

.active-tag-section {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 4px;
  gap: 6px;
}

.active-tag-section:last-child {
  margin-bottom: 0;
}

.section-label {
  font-size: 0.8rem;
  font-weight: 600;
  color: #ccc;
  margin-right: 8px;
  min-width: fit-content;
}

.active-tag {
  padding: 2px 6px;
  border-radius: 10px;
  font-size: 0.7rem;
  cursor: pointer;
  transition: opacity 0.2s;
}

.active-tag:hover {
  opacity: 0.8;
}

/* Active tag colors */
.active-tag.status-tag { background-color: #dc3545; color: white; }
.active-tag.preference-tag { background-color: #17a2b8; color: white; }
.active-tag.restriction-tag { background-color: #fd7e14; color: white; }
.active-tag.type-tag { background-color: #6f42c1; color: white; }


.custom-tag.not-mine {
  background-color: #666;
  opacity: 0.8;
  cursor: default;
}

.custom-tag.not-mine:hover {
  background-color: #666; /* Don't change on hover */
}

.active-tag.not-mine {
  opacity: 0.7;
  cursor: default;
}
.timeline-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.timeline-entry {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 8px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 4px;
  font-size: 0.8rem;
}

.timeline-stage {
  font-weight: 600;
  color: var(--primary-color);
}

.timeline-agent {
  color: #ccc;
}

.timeline-date {
  color: #888;
  font-size: 0.7rem;
}

/* Add to your existing CSS */
.tag-btn:disabled {
  cursor: not-allowed;
  opacity: 0.7;
}

.tag-btn.completed-by-other {
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.tag-btn.completed-by-other:hover {
  background-color: inherit; /* Don't change color on hover when disabled */
}


/* Add these new workflow styles to your existing <style scoped> section */

/* Client/Agent Workflow Sections */
.client-workflow-section, .agent-workflow-section {
  background: rgba(250, 249, 246, 0.03);
  border: 1px solid rgba(250, 249, 246, 0.1);
  border-radius: 0.5rem;
  padding: 1rem;
  margin-bottom: 1rem;
}

.client-workflow-section {
  border-left: 3px solid #3498db;
}

.agent-workflow-section {
  border-left: 3px solid #27ae60;
}

.workflow-title {
  color: var(--primary-color);
  font-size: 0.9rem;
  font-weight: 600;
  margin-bottom: 0.75rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.current-status {
  margin-bottom: 1rem;
}

.status-label {
  font-weight: 600;
  color: rgba(250, 249, 246, 0.8);
  margin-right: 0.5rem;
}

.status-badge {
  display: inline-block;
  padding: 0.25rem 0.75rem;
  border-radius: 1rem;
  font-size: 0.75rem;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  background: rgba(52, 152, 219, 0.2);
  color: #3498db;
  border: 1px solid rgba(52, 152, 219, 0.3);
}

.client-actions, .agent-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  align-items: center;
  margin-bottom: 1rem;
}

.action-btn {
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 0.375rem;
}

.action-btn.primary {
  background: var(--primary-color);
  color: white;
}

.action-btn.primary:hover:not(:disabled) {
  background: #b8252f;
}

.action-btn.success {
  background: #198754;
  color: white;
}

.action-btn.success:hover:not(:disabled) {
  background: #157347;
}

.action-btn.info {
  background: #17a2b8;
  color: white;
}

.action-btn.info:hover:not(:disabled) {
  background: #138496;
}

.action-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.status-message {
  padding: 0.75rem;
  border-radius: 0.5rem;
  font-size: 0.875rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 500;
}

.status-message.info {
  background: rgba(13, 110, 253, 0.1);
  color: #0d6efd;
  border: 1px solid rgba(13, 110, 253, 0.2);
}

.status-message.success {
  background: rgba(25, 135, 84, 0.1);
  color: #198754;
  border: 1px solid rgba(25, 135, 84, 0.2);
}

.status-message.priority {
  background: rgba(255, 193, 7, 0.15);
  color: #ffc107;
  border: 1px solid rgba(255, 193, 7, 0.3);
  animation: pulse 2s infinite;
}

.status-message.working {
  background: rgba(13, 110, 253, 0.1);
  color: #0d6efd;
  border: 1px solid rgba(13, 110, 253, 0.2);
}

@keyframes pulse {
  0% { opacity: 1; }
  50% { opacity: 0.7; }
  100% { opacity: 1; }
}

/* All existing CSS remains unchanged */
/* Enhanced Client Workflow Styling */
.client-workflow-enhanced {
  background: linear-gradient(135deg, rgba(52, 152, 219, 0.1), rgba(52, 152, 219, 0.05));
  border: 1px solid rgba(52, 152, 219, 0.3);
  border-radius: 16px;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
  box-shadow: 0 4px 20px rgba(52, 152, 219, 0.1);
}

.workflow-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
  gap: 1rem;
}

.workflow-title {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-size: 1.1rem;
  font-weight: 700;
  color: #3498db;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.status-display {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.status-label {
  font-weight: 600;
  color: rgba(250, 249, 246, 0.8);
}

.status-badge-enhanced {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border-radius: 25px;
  font-size: 0.85rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.status-badge-enhanced.status-updated {
  animation: statusPulse 2s ease-in-out;
  transform: scale(1.05);
}

@keyframes statusPulse {
  0%, 100% { 
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1); 
  }
  50% { 
    box-shadow: 0 4px 20px rgba(46, 204, 113, 0.4);
    transform: scale(1.05);
  }
}

/* Status Badge Colors */
.status-none { background: rgba(108, 117, 125, 0.2); color: #6c757d; }
.status-requested { background: rgba(52, 152, 219, 0.2); color: #3498db; }
.status-in-progress { background: rgba(255, 193, 7, 0.2); color: #ffc107; }
.status-complete { background: rgba(40, 167, 69, 0.2); color: #28a745; }
.status-negotiation { background: rgba(155, 89, 182, 0.2); color: #9b59b6; }
.status-ready { background: rgba(255, 215, 0, 0.2); color: #ffd700; }
.status-approved { background: rgba(46, 204, 113, 0.2); color: #2ecc71; }
.status-rejected { background: rgba(231, 76, 60, 0.2); color: #e74c3c; }

/* Action Area */
.action-area {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.primary-workflow-btn, .secondary-workflow-btn {
  display: flex;
  align-items: center;
  padding: 1.25rem;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  text-align: left;
  width: 100%;
  font-family: inherit;
}

.primary-workflow-btn {
  background: linear-gradient(135deg, #3498db, #2980b9);
  color: white;
  box-shadow: 0 4px 15px rgba(52, 152, 219, 0.3);
}

.primary-workflow-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(52, 152, 219, 0.4);
}

.approve-hire-btn {
  background: linear-gradient(135deg, #27ae60, #2ecc71) !important;
  box-shadow: 0 4px 15px rgba(39, 174, 96, 0.3) !important;
}

.secondary-workflow-btn {
  background: rgba(231, 76, 60, 0.1);
  color: #e74c3c;
  border: 1px solid rgba(231, 76, 60, 0.3);
}

.secondary-workflow-btn:hover:not(:disabled) {
  background: rgba(231, 76, 60, 0.15);
}

.btn-icon {
  font-size: 1.5rem;
  margin-right: 1rem;
  flex-shrink: 0;
}

.btn-content {
  flex: 1;
}

.btn-title {
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 0.25rem;
}

.btn-subtitle {
  font-size: 0.85rem;
  opacity: 0.9;
}

/* Status Feedback Cards */
.status-feedback {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.status-card {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  padding: 1rem;
  border-radius: 12px;
  border-left: 4px solid;
  animation: slideInUp 0.5s ease-out;
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.screening-progress {
  background: rgba(52, 152, 219, 0.1);
  border-left-color: #3498db;
  color: #3498db;
}

.rate-negotiation {
  background: rgba(155, 89, 182, 0.1);
  border-left-color: #9b59b6;
  color: #9b59b6;
}

.ready-decision {
  background: rgba(255, 215, 0, 0.15);
  border-left-color: #ffd700;
  color: #ffd700;
}

.request-submitted {
  background: rgba(46, 204, 113, 0.1);
  border-left-color: #2ecc71;
  color: #2ecc71;
}

.status-icon {
  font-size: 1.5rem;
  flex-shrink: 0;
  margin-top: 0.25rem;
}

.status-content {
  flex: 1;
}

.status-title {
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.status-message {
  font-size: 0.9rem;
  opacity: 0.9;
  line-height: 1.4;
}

/* Responsive Design */
@media (max-width: 768px) {
  .workflow-header {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .btn-icon {
    font-size: 1.25rem;
    margin-right: 0.75rem;
  }
  
  .btn-title {
    font-size: 0.9rem;
  }
  
  .btn-subtitle {
    font-size: 0.8rem;
  }
}

/* All existing CSS remains unchanged */


.status-feedback {
  margin-top: 1rem;
}

.status-card {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  border-radius: 0.5rem;
  border-left: 4px solid;
  margin-bottom: 0.5rem;
}

.status-card.request-submitted {
  background: rgba(52, 152, 219, 0.1);
  border-left-color: #3498db;
}

.status-card.screening-progress {
  background: rgba(255, 193, 7, 0.1);
  border-left-color: #ffc107;
}

.status-icon {
  font-size: 1.5rem;
  color: #3498db;
}

.status-content {
  flex: 1;
}

.status-title {
  font-weight: 600;
  margin-bottom: 0.25rem;
  color: var(--text-color);
}

.status-message {
  font-size: 0.875rem;
  opacity: 0.8;
}
/* Add to the <style> section */
.comment-item {
  transition: all 0.3s ease;
}

.comment-item.new-comment {
  animation: slideInComment 0.5s ease-out;
  border-left: 3px solid #27ae60 !important;
  background: rgba(39, 174, 96, 0.05) !important;
}

@keyframes slideInComment {
  from {
    opacity: 0;
    transform: translateY(-10px) scale(0.95);
    background: rgba(39, 174, 96, 0.2);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
    background: rgba(39, 174, 96, 0.05);
  }
}

/* Fade out the "new" styling after animation */
.comment-item.new-comment {
  animation: slideInComment 0.5s ease-out, fadeNewStyling 2s ease-out 0.5s forwards;
}

@keyframes fadeNewStyling {
  from {
    border-left-color: #27ae60;
    background: rgba(39, 174, 96, 0.05);
  }
  to {
    border-left-color: rgba(250, 249, 246, 0.1);
    background: rgba(250, 249, 246, 0.03);
  }
}

.status-badge.status-updated {
  animation: statusPulse 1s ease-in-out;
  transform: scale(1.05);
}

@keyframes statusPulse {
  0%, 100% { 
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1); 
  }
  50% { 
    box-shadow: 0 4px 20px rgba(46, 204, 113, 0.4);
    transform: scale(1.05);
  }
}



/* Agent Assignment Check */
.agent-check-loading {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 1rem;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 0.5rem;
  margin-bottom: 1rem;
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.9rem;
}

.agent-check-loading .loading-spinner {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top: 2px solid #667eea;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

/* No Agent Overlay */
.no-agent-overlay {
  position: relative;
}

.workflow-disabled {
  position: relative;
  opacity: 0.3;
  pointer-events: none;
  filter: grayscale(100%);
}

.agent-assignment-message {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(26, 32, 44, 0.95);
  border: 2px solid #667eea;
  border-radius: 1rem;
  padding: 2rem;
  text-align: center;
  backdrop-filter: blur(8px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
}

.message-icon {
  font-size: 2.5rem;
  color: #667eea;
  margin-bottom: 1rem;
}

.message-title {
  font-size: 1.2rem;
  font-weight: 600;
  color: white;
  margin-bottom: 0.5rem;
}

.message-subtitle {
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.8);
}

/* Enhanced Notes Section */
.enhanced-notes-section {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 1rem;
  padding: 1.5rem;
  margin-top: 1.5rem;
}

.notes-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.notes-title {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-size: 1.1rem;
  font-weight: 600;
  color: white;
}

.notes-title i {
  color: #fbbf24;
  font-size: 1.2rem;
}

.notes-count {
  background: #667eea;
  color: white;
  padding: 0.25rem 0.75rem;
  border-radius: 1rem;
  font-size: 0.8rem;
  font-weight: 600;
}

/* Prominent Note Input */
.add-note-section.prominent {
  margin-bottom: 1.5rem;
}

.note-input-container {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.prominent-note-textarea {
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.15); /* Reduced from 2px */
  border-radius: 0.75rem;
  padding: 0.75rem; /* Reduced from 1rem */
  font-size: 0.85rem; /* Reduced from 0.95rem */
  line-height: 1.4; /* Reduced from 1.5 */
  resize: vertical;
  transition: all 0.3s ease;
  width: 100%; /* Explicit width to prevent overflow */
  box-sizing: border-box; /* Ensures padding is included in width */
  min-height: 80px; /* Set minimum height to prevent too-short appearance */
  max-width: 100%; /* Prevent horizontal overflow */
}

/* Light theme */
:root[data-theme="light"] .prominent-note-textarea {
  color: black;
  border-color: #fca5a5;
  box-shadow: 0 2px 4px rgba(212, 47, 61, 0.15);
}

/* Dark theme */
:root[data-theme="dark"] .prominent-note-textarea{
  border-color: rgba(212, 47, 61, 0.5);
  color: white;
}

.prominent-note-textarea:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 4px rgba(102, 126, 234, 0.1);
  background: rgba(255, 255, 255, 0.1);
}

.prominent-note-textarea::placeholder {
  color: rgba(255, 255, 255, 0.5);
}

.prominent-add-note-btn {
  align-self: flex-end;
  background: linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%);
  color: #1a202c;
  border: none;
  border-radius: 0.5rem;
  padding: 0.75rem 1.5rem;
  font-weight: 600;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.prominent-add-note-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(251, 191, 36, 0.3);
}

.prominent-add-note-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}

/* Notes List */
.notes-list {
  max-height: 300px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.3) transparent;
}

.notes-list.compact {
  max-height: 200px;
}

.note-item {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 0.5rem;
  padding: 1rem;
  margin-bottom: 0.75rem;
  border-left: 3px solid #667eea;
  transition: all 0.3s ease;
}

.note-item.new-note {
  background: rgba(251, 191, 36, 0.1);
  border-left-color: #fbbf24;
  animation: highlight 2s ease-out;
}

.note-item:hover {
  background: rgba(255, 255, 255, 0.08);
}

.note-content {
  color: white;
  font-size: 0.9rem;
  line-height: 1.4;
  margin-bottom: 0.5rem;
}

.note-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 0.8rem;
  color: rgba(255, 255, 255, 0.6);
}

.note-date {
  font-weight: 500;
}

.note-author {
  color: #667eea;
}

.delete-note-btn {
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.4);
  cursor: pointer;
  padding: 0.25rem;
  border-radius: 0.25rem;
  transition: all 0.2s ease;
}

.delete-note-btn:hover {
  color: #ef4444;
  background: rgba(239, 68, 68, 0.1);
}

/* Workflow with Notes Layout */
.workflow-with-notes {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.5rem;
}

@media (min-width: 1024px) {

}

/* Animations */
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@keyframes highlight {
  0% {
    box-shadow: 0 0 20px rgba(251, 191, 36, 0.5);
  }
  100% {
    box-shadow: none;
  }
}

/* Mobile responsiveness */
@media (max-width: 768px) {
  .enhanced-notes-section {
    padding: 1rem;
  }
  
  .note-input-container {
    gap: 0.5rem;
  }
  
  .prominent-add-note-btn {
    align-self: stretch;
    justify-content: center;
  }
}


.no-notes-message {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 1rem;
  color: rgba(255, 255, 255, 0.5);
  font-style: italic;
  font-size: 0.9rem;
  text-align: center;
  justify-content: center;
}

.no-notes-message i {
  color: #667eea;
}

.custom-tag.new-tag {
  animation: tagHighlight 2s ease-out;
}

@keyframes tagHighlight {
  0% {
    background-color: rgba(102, 126, 234, 0.8);
    transform: scale(1.05);
  }
  100% {
    background-color: #555;
    transform: scale(1);
  }
}


/* ADD THESE STYLES TO YOUR EXISTING CSS */

/* Agent Screening Tools */
.agent-screening-tools {
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}

.screening-tools-btn {
  background: linear-gradient(135deg, #9b59b6, #8e44ad) !important;
  box-shadow: 0 4px 15px rgba(155, 89, 182, 0.3) !important;
}

.existing-reports-btn {
  background: rgba(52, 73, 94, 0.1);
  color: #34495e;
  border: 1px solid rgba(52, 73, 94, 0.3);
}

.existing-reports-btn:hover:not(:disabled) {
  background: rgba(52, 73, 94, 0.15);
}

/* Client Screening View */
.client-screening-view {
  margin-top: 1rem;
}

.screening-completed-card {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  background: rgba(39, 174, 96, 0.1);
  border-left: 4px solid #27ae60;
  border-radius: 8px;
  margin-bottom: 1rem;
  color: #27ae60;
}

.view-report-btn {
  background: linear-gradient(135deg, #f39c12, #e67e22) !important;
  box-shadow: 0 4px 15px rgba(243, 156, 18, 0.3) !important;
}

/* Modal Styles */
.screening-modal {
  max-width: 600px;
  max-height: 90vh;
  overflow-y: auto;
}

.existing-reports-modal {
  max-width: 500px;
  max-height: 70vh;
}

.client-report-modal {
  max-width: 650px;
  max-height: 80vh;
  overflow-y: auto;
}
/* Client feedback section — inside the white report modal */
.client-feedback-section {
  margin-top: 16px;
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid #e8ecf0;
}

.client-report-modal.enhanced .client-feedback-section {
  border-color: #dde6f5;
}

.client-feedback-section-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: rgba(102, 126, 234, 0.07);
  border-bottom: 1px solid #dde6f5;
  font-weight: 600;
  font-size: 0.88rem;
  color: #5a6fd6;
}

.client-feedback-section-body {
  padding: 12px 16px;
  background: #fff;
}

.client-feedback-section-body p {
  margin: 0 0 8px 0;
  color: #2d3748;
  font-size: 0.9rem;
  line-height: 1.6;
  white-space: pre-wrap;
}

.client-feedback-section-body small {
  color: #a0aec0;
  font-size: 0.78rem;
}
/* Form Styles */
.form-group {
  margin-bottom: 1.5rem;
}

.form-group label {
  display: block;
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: #2c3e50;
}

.form-group input,
.form-group textarea,
.form-group select {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-family: inherit;
  font-size: 0.9rem;
}

.form-group textarea {
  resize: vertical;
  min-height: 80px;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

.checkboxes-group {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.checkbox-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.checkbox-item input[type="checkbox"] {
  width: auto;
  margin: 0;
}

.checkbox-item label {
  margin: 0;
  font-weight: normal;
  cursor: pointer;
}

/* Modal Actions */
.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 2rem;
  padding-top: 1rem;
  border-top: 1px solid #eee;
}

.btn-primary, .btn-secondary {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 8px;
  font-family: inherit;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.btn-primary {
  background: linear-gradient(135deg, #27ae60, #2ecc71);
  color: white;
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(39, 174, 96, 0.3);
}

.btn-secondary {
  background: rgba(52, 73, 94, 0.1);
  color: #34495e;
  border: 1px solid rgba(52, 73, 94, 0.3);
}

.btn-secondary:hover {
  background: rgba(52, 73, 94, 0.15);
}

/* Existing Reports List */
.no-reports {
  text-align: center;
  padding: 2rem;
  color: #7f8c8d;
}

.no-reports i {
  font-size: 3rem;
  margin-bottom: 1rem;
  opacity: 0.5;
}

.reports-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  max-height: 400px;
  overflow-y: auto;
}

.report-item {
  padding: 1rem;
  border: 1px solid #eee;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.report-item:hover {
  background: rgba(52, 152, 219, 0.05);
  border-color: #3498db;
  transform: translateY(-1px);
}

.report-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
}

.report-project {
  font-weight: 600;
  color: #2c3e50;
}

.report-date {
  font-size: 0.85rem;
  color: #7f8c8d;
}

.report-summary {
  color: #34495e;
  margin-bottom: 0.75rem;
  font-size: 0.9rem;
}

.rec-badge {
  display: inline-block;
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
}

.rec-pass {
  background: rgba(39, 174, 96, 0.2);
  color: #27ae60;
}

.rec-consider {
  background: rgba(243, 156, 18, 0.2);
  color: #f39c12;
}

.rec-reject {
  background: rgba(231, 76, 60, 0.2);
  color: #e74c3c;
}

/* Client Report View */
.report-section {
  margin-bottom: 2rem;
}

.report-section h4 {
  color: #2c3e50;
  margin-bottom: 1rem;
  font-size: 1.1rem;
  border-bottom: 2px solid #ecf0f1;
  padding-bottom: 0.5rem;
}

.report-section p {
  color: #34495e;
  line-height: 1.6;
}

.report-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  margin-bottom: 2rem;
}

.report-item {
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 8px;
}

.report-item label {
  display: block;
  font-weight: 600;
  color: #7f8c8d;
  margin-bottom: 0.5rem;
  font-size: 0.85rem;
  text-transform: uppercase;
}

.report-item span {
  color: #2c3e50;
  font-weight: 500;
}

.checks-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

.check-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem;
  background: #f8f9fa;
  border-radius: 8px;
  font-weight: 500;
}

.check-pass {
  color: #27ae60;
}

.check-fail {
  color: #e74c3c;
}

.recommendation-badge {
  display: inline-block;
  padding: 0.75rem 1.5rem;
  border-radius: 25px;
  font-weight: 600;
  font-size: 1rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.report-footer {
  margin-top: 2rem;
  padding-top: 1rem;
  border-top: 1px solid #ecf0f1;
  text-align: center;
  color: #7f8c8d;
}

/* Responsive Design */
@media (max-width: 768px) {
  .form-row {
    grid-template-columns: 1fr;
  }
  
  .report-grid {
    grid-template-columns: 1fr;
  }
  
  .checks-grid {
    grid-template-columns: 1fr;
  }
  
  .modal-actions {
    flex-direction: column;
  }
  
  .report-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.25rem;
  }
}

.modal-overlay {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
  background: rgba(0, 0, 0, 0.7) !important;
  backdrop-filter: blur(4px) !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  z-index: 10000 !important; /* Very high z-index */
  padding: 1rem !important;
}

.modal-content {
  position: relative;
  background: white;
  border-radius: 8px;
  max-width: 1400px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  
  /* CRITICAL: Prevent transform interference */
  transform: none !important;
  will-change: auto !important;
}


/* ADD these styles to make all workflow buttons consistent: */

.agent-screening-tools .primary-workflow-btn,
.agent-screening-tools .secondary-workflow-btn {
  /* Match the height and padding of existing workflow buttons */
  min-height: 80px; /* Same as other workflow buttons */
  padding: 1.25rem !important;
  display: flex !important;
  align-items: center !important;
}

.screening-tools-btn {
  background: linear-gradient(135deg, #9b59b6, #8e44ad) !important;
  box-shadow: 0 4px 15px rgba(155, 89, 182, 0.3) !important;
}

.screening-tools-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(155, 89, 182, 0.4);
}

.existing-reports-btn {
  background: rgba(52, 73, 94, 0.1);
  color: #34495e;
  border: 1px solid rgba(52, 73, 94, 0.3);
  min-height: 80px;
}

.existing-reports-btn:hover:not(:disabled) {
  background: rgba(52, 73, 94, 0.15);
  transform: translateY(-2px);
}

/* Make client view report button same height too */
.view-report-btn {
  background: linear-gradient(135deg, #f39c12, #e67e22) !important;
  box-shadow: 0 4px 15px rgba(243, 156, 18, 0.3) !important;
  min-height: 80px !important;
}

.view-report-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(243, 156, 18, 0.4);
}
.modal-header {
  display: flex !important;
  justify-content: space-between !important;
  align-items: center !important;
  padding: 1.5rem 1.5rem 1rem 1.5rem !important;
  border-bottom: 1px solid #eee !important;
  background: #f8f9fa !important;
  border-radius: 12px 12px 0 0 !important;
}

.modal-header h3 {
  margin: 0 !important;
  color: #2c3e50 !important;
  font-size: 1.25rem !important;
  font-weight: 600 !important;
}

.modal-header h3 i {
  margin-right: 0.5rem !important;
  color: #3498db !important;
}

.close-btn {
  background: none !important;
  border: none !important;
  font-size: 2rem !important;
  color: #7f8c8d !important;
  cursor: pointer !important;
  padding: 0 !important;
  width: 2rem !important;
  height: 2rem !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  border-radius: 50% !important;
  transition: all 0.3s ease !important;
}

.close-btn:hover {
  background: rgba(231, 76, 60, 0.1) !important;
  color: #e74c3c !important;
}



.modal-body {
  padding: 1.5rem !important;
  max-height: calc(90vh - 140px) !important; /* Account for header and actions */
  overflow-y: auto !important;
}

/* ===== FIX 5: Specific Modal Sizes ===== */
.screening-modal {
  max-width: 600px !important;
  width: 90vw !important;
}

.existing-reports-modal {
  max-width: 500px !important;
  width: 85vw !important;
}

.client-report-modal {
  max-width: 650px !important;
  width: 90vw !important;
}

/* ===== FIX 6: Ensure modal appears on top of everything ===== */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
  overflow-y: auto;
  
  /* CRITICAL: Prevent flexbox from affecting child coordinate systems */
  transform: none !important;
}

/* Fix for any conflicting positioning */
.candidate-card {
  position: relative !important; /* Don't let this interfere */
  z-index: 1 !important;
}

/* ===== FIX 7: Mobile responsiveness for modals ===== */
@media (max-width: 768px) {
  .modal-overlay {
    padding: 0.5rem !important;
  }
  
  .screening-modal,
  .existing-reports-modal,
  .client-report-modal {
    width: 95vw !important;
    max-width: none !important;
  }
  
  .modal-header {
    padding: 1rem !important;
  }
  
  .modal-body {
    padding: 1rem !important;
    max-height: calc(100vh - 120px) !important;
  }
}

.form-group input:focus,
.form-group textarea:focus,
.form-group select:focus {
  outline: none !important;
  border-color: #3498db !important;
  box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.1) !important;
}



.modal-overlay {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
}

.modal-content * {
  box-sizing: border-box !important;
}

/* ADD this to your existing agent workflow CSS */

.flow-message {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  background: rgba(52, 152, 219, 0.1);
  border: 1px solid rgba(52, 152, 219, 0.2);
  border-radius: 8px;
  color: #3498db;
  font-size: 0.9rem;
  margin-top: 0.5rem;
}

.flow-message i {
  color: #3498db;
}

/* Make action buttons consistent height */
.agent-actions .action-btn {
  min-height: 44px; /* Consistent height */
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}
/* ===== STEP 4: ENHANCED WORKFLOW CSS ===== */
/* ADD these styles to your existing CSS (replaces old workflow styles): */

/* Enhanced Workflow Section */
.agent-workflow-section {
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 1.5rem;
  margin-top: 1rem;
}

.workflow-title {
  color: #ffffff;
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.workflow-title i {
  color: #667eea;
}

/* Enhanced Status Display */
.current-status-enhanced {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1.5rem;
  padding: 0.75rem;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
}

.status-label {
  color: rgba(255, 255, 255, 0.7);
  font-weight: 500;
}

.status-badge-enhanced {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-weight: 600;
  font-size: 0.85rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Workflow Steps */
.workflow-step {
  margin-bottom: 1.5rem;
  padding: 1rem;
  background: rgba(255, 255, 255, 0.03);
  border-radius: 10px;
  border-left: 4px solid #667eea;
}

/* Step Information */
.step-info {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.9rem;
  margin-bottom: 1rem;
}

.step-info i {
  color: #667eea;
}

/* Draft Status Alert */
.draft-status {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #f39c12;
  font-size: 0.9rem;
  margin-bottom: 1rem;
  padding: 0.5rem;
  background: rgba(243, 156, 18, 0.1);
  border-radius: 6px;
}

/* Flow Enforcement Message */
.flow-enforcement {
  margin: 1rem 0;
}

.enforcement-message {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #e74c3c;
  font-size: 0.9rem;
  padding: 0.75rem;
  background: rgba(231, 76, 60, 0.1);
  border-radius: 6px;
  border: 1px solid rgba(231, 76, 60, 0.2);
}

/* Unified Workflow Buttons */
.workflow-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 1rem 1.5rem;
  border: none;
  border-radius: 10px;
  font-family: inherit;
  font-weight: 600;
  font-size: 0.95rem;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-bottom: 0.75rem;
  text-align: center;
}
  /* Light theme */
  :root[data-theme="light"] .workflow-btn  {
    color: white !important;;
    border-color: white;
    box-shadow: 0 2px 4px rgba(212, 47, 61, 0.15);
  }
  
  /* Dark theme */
  :root[data-theme="dark"]  .workflow-btn {
    border-color: rgba(212, 47, 61, 0.5);
    color: white !important;;
  }

.workflow-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none !important;
}

.workflow-btn .btn-content {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.workflow-btn .btn-content i {
  font-size: 1.1rem;
}

/* Primary Action - Start Screening */
.workflow-btn.primary-action {
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
}

.workflow-btn.primary-action:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
}

/* Secondary Action - Manage Report */
.workflow-btn.secondary-action {
  background: linear-gradient(135deg, #9b59b6, #8e44ad);
  color: white;
  box-shadow: 0 4px 15px rgba(155, 89, 182, 0.3);
}

.workflow-btn.secondary-action:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(155, 89, 182, 0.4);
}

/* Tertiary Action - View Past Reports */
.workflow-btn.tertiary-action {
  background: rgba(52, 73, 94, 0.8);
  color: white;
  border: 1px solid rgba(52, 73, 94, 0.3);
  box-shadow: 0 2px 10px rgba(52, 73, 94, 0.2);
}

.workflow-btn.tertiary-action:hover:not(:disabled) {
  background: rgba(52, 73, 94, 0.9);
  transform: translateY(-1px);
  box-shadow: 0 4px 15px rgba(52, 73, 94, 0.3);
}

/* Success Action - Complete Screening */
.workflow-btn.success-action {
  background: linear-gradient(135deg, #27ae60, #2ecc71);
  color: white;
  box-shadow: 0 4px 15px rgba(39, 174, 96, 0.3);
}

.workflow-btn.success-action:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(39, 174, 96, 0.4);
}

/* Workflow Completed State */
.workflow-completed {
  text-align: center;
  padding: 1.5rem;
}

.completion-status {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  color: #2ecc71;
  font-weight: 600;
  font-size: 1rem;
}

.completion-status i {
  font-size: 1.5rem;
}

/* Status Badge Color Variations */
.status-badge-enhanced.status-requested {
  background: rgba(52, 152, 219, 0.2);
  color: #3498db;
}

.status-badge-enhanced.status-progress {
  background: rgba(155, 89, 182, 0.2);
  color: #9b59b6;
}

.status-badge-enhanced.status-completed {
  background: rgba(39, 174, 96, 0.2);
  color: #27ae60;
}

.status-badge-enhanced.status-validated {
  background: rgba(255, 215, 0, 0.2);
  color: #ffd700;
}

.status-badge-enhanced.status-approved {
  background: rgba(46, 204, 113, 0.2);
  color: #2ecc71;
}

.status-badge-enhanced.status-rejected {
  background: rgba(231, 76, 60, 0.2);
  color: #e74c3c;
}

/* Text Color Utilities */
.text-success {
  color: #2ecc71 !important;
}

.text-warning {
  color: #f39c12 !important;
}

.text-danger {
  color: #e74c3c !important;
}

/* Mobile Responsiveness */
@media (max-width: 768px) {
  .agent-workflow-section {
    padding: 1rem;
  }
  
  .workflow-btn {
    padding: 0.875rem 1rem;
    font-size: 0.9rem;
  }
  
  .workflow-btn .btn-content {
    gap: 0.5rem;
  }
  
  .current-status-enhanced {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }
}



/* ===== STEP 7: ENHANCED CLIENT FEATURES CSS ===== */
/* ADD these styles for the improved client experience: */

/* Client Workflow Section */
.client-workflow-section {
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 1.5rem;
  margin-top: 1rem;
}

/* Client Action States */
.client-action-state,
.client-waiting-state,
.client-progress-state,
.client-hired-state,
.client-completed-state {
  margin-bottom: 1rem;
}

/* Status Cards for Different States */
.status-card {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1.25rem;
  border-radius: 10px;
  margin-bottom: 1rem;
}

.status-card.waiting {
  background: rgba(52, 152, 219, 0.1);
  border-left: 4px solid #3498db;
  color: #3498db;
}

.status-card.progress {
  background: rgba(155, 89, 182, 0.1);
  border-left: 4px solid #9b59b6;
  color: #9b59b6;
}

.status-card.completed {
  background: rgba(39, 174, 96, 0.1);
  border-left: 4px solid #27ae60;
  color: #27ae60;
}

.status-card .status-icon {
  font-size: 2rem;
  opacity: 0.8;
}

.status-card .status-content {
  flex: 1;
}

.status-card .status-title {
  font-weight: 600;
  font-size: 1.1rem;
  margin-bottom: 0.25rem;
}

.status-card .status-message {
  opacity: 0.9;
  font-size: 0.95rem;
}

/* Report Preview */
.report-preview {
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  padding: 1rem;
  margin: 1rem 0;
}

.preview-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: rgba(255, 255, 255, 0.8);
  font-weight: 600;
  font-size: 0.9rem;
  margin-bottom: 0.75rem;
}

.preview-header i {
  color: #667eea;
}

.preview-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

.preview-item {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  
}
/* Light theme */
:root[data-theme="light"] .availables{
  color: black;
   
}

/* Dark theme */
:root[data-theme="dark"]  .availables{
  color: white;
}


.preview-item label {
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.85rem;
  font-weight: 500;
}

.preview-item span {
  color: rgba(255, 255, 255, 0.9);
  font-weight: 600;
}

/* Client Decisions Section */
.client-decisions {
  margin-top: 1.5rem;
  padding-top: 1rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.decision-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: rgba(255, 255, 255, 0.8);
  font-weight: 600;
  margin-bottom: 1rem;
}

.decision-header i {
  color: #667eea;
}

.decision-actions {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

/* Enhanced Client Report Modal */
.client-report-modal.enhanced {
  max-width: 750px;
}

/* Report Header Section */
.report-header-section {
  text-align: center;
  padding: 1.5rem;
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.1), rgba(118, 75, 162, 0.1));
  border-radius: 12px;
  margin-bottom: 2rem;
}

.recommendation-badge-large {
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem 2rem;
  border-radius: 50px;
  font-weight: 700;
  font-size: 1.1rem;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 1rem;
}

.recommendation-badge-large i {
  font-size: 1.3rem;
}

.recommendation-badge-large.rec-pass {
  background: linear-gradient(135deg, #27ae60, #2ecc71);
  color: white;
  box-shadow: 0 4px 15px rgba(39, 174, 96, 0.3);
}

.recommendation-badge-large.rec-consider {
  background: linear-gradient(135deg, #f39c12, #e67e22);
  color: white;
  box-shadow: 0 4px 15px rgba(243, 156, 18, 0.3);
}

.recommendation-badge-large.rec-reject {
  background: linear-gradient(135deg, #e74c3c, #c0392b);
  color: white;
  box-shadow: 0 4px 15px rgba(231, 76, 60, 0.3);
}

/* Report Meta Information */
.report-meta {
  display: flex;
  justify-content: center;
  gap: 2rem;
  color: rgba(0, 0, 0, 0.6);
}

.meta-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9rem;
}

/* Report Sections */
.report-section {
  margin-bottom: 2rem;
}

.report-section h4 {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  color: #2c3e50;
  margin-bottom: 1rem;
  font-size: 1.2rem;
  border-bottom: 2px solid #ecf0f1;
  padding-bottom: 0.5rem;
}

.report-section h4 i {
  color: #667eea;
  font-size: 1.1rem;
}

/* Summary Content */
.summary-content {
  background: #f8f9fa;
  padding: 1.5rem;
  border-radius: 8px;
  color: #2c3e50;
  line-height: 1.7;
  font-size: 1rem;
  border-left: 4px solid #667eea;
}

/* Key Details Grid */
.report-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.grid-item {
  background: #f8f9fa;
  padding: 1.5rem;
  border-radius: 10px;
  border: 1px solid #e9ecef;
}

.item-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 0.75rem;
}

.item-header i {
  color: #667eea;
  font-size: 1.2rem;
}

.item-header label {
  font-weight: 600;
  color: #7f8c8d;
  font-size: 0.9rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.item-value {
  color: #2c3e50 ;
  font-weight: 600;
  font-size: 1.1rem;
}

/* Verification Grid */
.verification-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;
}

.verification-item {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

.verification-item i {
  font-size: 1.3rem;
  flex-shrink: 0;
}

.verification-item span {
  flex: 1;
  font-weight: 600;
  color: #2c3e50;
}

.verification-status {
  font-size: 0.85rem;
  color: #7f8c8d;
  font-weight: 500;
}

.check-pass {
  color: #27ae60;
}

.check-fail {
  color: #e74c3c;
}

/* Notes Content */
.notes-content {
  background: #f8f9fa;
  padding: 1.5rem;
  border-radius: 8px;
  color: #2c3e50;
  line-height: 1.6;
  border-left: 4px solid #95a5a6;
}

/* Report Footer Actions */
.report-footer-actions {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  margin-top: 2rem;
  padding-top: 1.5rem;
  border-top: 2px solid #ecf0f1;
}

.btn-secondary,
.btn-primary {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.875rem 1.5rem;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: inherit;
}

.btn-secondary {
  background: #95a5a6;
  color: white;
}

.btn-secondary:hover {
  background: #7f8c8d;
  transform: translateY(-1px);
}

.btn-primary {
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
}

/* Button Subtitle Enhancement */
.workflow-btn .btn-subtitle {
  font-size: 0.8rem;
  opacity: 0.8;
  font-weight: normal;
  margin-top: 0.25rem;
}

/* Mobile Responsiveness */
@media (max-width: 768px) {
  .preview-content {
    grid-template-columns: 1fr;
  }
  
  .report-grid {
    grid-template-columns: 1fr;
  }
  
  .decision-actions {
    grid-template-columns: 1fr;
  }
  
  .report-meta {
    flex-direction: column;
    gap: 0.5rem;
  }
  
  .report-footer-actions {
    flex-direction: column;
  }
  
  .client-report-modal.enhanced {
    max-width: 95vw;
  }
}



/* ===== STEP 10: REPORT SELECTION INTERFACE CSS ===== */
/* ADD these styles for the enhanced report selection: */

/* Enhanced Screening Modal */
.screening-modal.enhanced {
  max-width: 700px;
  max-height: 95vh;
}

/* Report Selection Section */
.report-selection-section {
  margin-bottom: 2rem;
}

.section-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1rem;
  color: #2c3e50;
}

.section-header i {
  color: #667eea;
  font-size: 1.1rem;
}

.section-header h4 {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 600;
}

/* Report Options */
.report-options {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-bottom: 1rem;
}

.report-option {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  border: 2px solid #e9ecef;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  background: white;
}

.report-option:hover {
  border-color: #667eea;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.15);
}

.report-option.active {
  border-color: #667eea;
  background: rgba(102, 126, 234, 0.05);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);
}

.option-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  font-size: 1.2rem;
  flex-shrink: 0;
}

.report-option .option-icon {
  background: rgba(102, 126, 234, 0.1);
  color: #667eea;
}

.report-option.active .option-icon {
  background: #667eea;
  color: white;
}

.draft-option .option-icon {
  background: rgba(243, 156, 18, 0.1);
  color: #f39c12;
}

.draft-option.active .option-icon {
  background: #f39c12;
  color: white;
}

.template-option .option-icon {
  background: rgba(155, 89, 182, 0.1);
  color: #9b59b6;
}

.template-option.active .option-icon {
  background: #9b59b6;
  color: white;
}

/* Option Content */
.option-content {
  flex: 1;
}

.option-title {
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 0.25rem;
  font-size: 1rem;
}

.option-subtitle {
  color: #7f8c8d;
  font-size: 0.9rem;
  margin-bottom: 0.5rem;
}

.option-meta {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-size: 0.85rem;
  color: #95a5a6;
}

.option-meta i {
  color: #bdc3c7;
}

/* Mini Badges */
.rec-badge-mini {
  display: inline-block;
  padding: 0.2rem 0.5rem;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
}

.rec-badge-mini.rec-pass {
  background: rgba(39, 174, 96, 0.2);
  color: #27ae60;
}

.rec-badge-mini.rec-consider {
  background: rgba(243, 156, 18, 0.2);
  color: #f39c12;
}

.rec-badge-mini.rec-reject {
  background: rgba(231, 76, 60, 0.2);
  color: #e74c3c;
}

.age-badge {
  background: rgba(149, 165, 166, 0.2);
  color: #95a5a6;
  padding: 0.2rem 0.5rem;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 500;
}

/* Selection Confirmation */
.selection-confirmation {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.75rem 1rem;
  background: rgba(102, 126, 234, 0.05);
  border: 1px solid rgba(102, 126, 234, 0.2);
  border-radius: 8px;
  margin-top: 0.75rem;
}

.confirmation-content {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex: 1;
  color: #667eea;
  font-size: 0.9rem;
  font-weight: 500;
}

.load-report-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  background: #667eea;
  color: white;
  border: none;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 0.85rem;
}

.load-report-btn:hover:not(:disabled) {
  background: #5a67d8;
  transform: translateY(-1px);
}

.load-report-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

/* Section Divider */
.section-divider {
  height: 2px;
  background: linear-gradient(90deg, transparent, #e9ecef, transparent);
  margin: 1.5rem 0;
}

/* Form Section */
.report-form-section {
  /* Inherits existing form styles */
}

.form-header {
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #e9ecef;
}

.form-header h4 {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin: 0;
  color: #2c3e50;
  font-size: 1.1rem;
  font-weight: 600;
}

.form-header h4 i {
  color: #667eea;
}

/* Form Status */
.form-status {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 1rem;
  border-radius: 8px;
  margin-bottom: 1rem;
  font-weight: 500;
}

.form-status.success {
  background: rgba(39, 174, 96, 0.1);
  color: #27ae60;
  border: 1px solid rgba(39, 174, 96, 0.2);
}

.form-status.info {
  background: rgba(52, 152, 219, 0.1);
  color: #3498db;
  border: 1px solid rgba(52, 152, 219, 0.2);
}

.form-status.warning {
  background: rgba(243, 156, 18, 0.1);
  color: #f39c12;
  border: 1px solid rgba(243, 156, 18, 0.2);
}

.form-status.error {
  background: rgba(231, 76, 60, 0.1);
  color: #e74c3c;
  border: 1px solid rgba(231, 76, 60, 0.2);
}

.form-status i {
  font-size: 1.1rem;
}

/* Enhanced Modal Actions */
.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 2rem;
  padding-top: 1.5rem;
  border-top: 2px solid #e9ecef;
}

/* Mobile Responsiveness */
@media (max-width: 768px) {
  .screening-modal.enhanced {
    max-width: 95vw;
    margin: 0.5rem;
  }
  
  .report-option {
    padding: 0.75rem;
  }
  
  .option-icon {
    width: 2.5rem;
    height: 2.5rem;
    font-size: 1rem;
  }
  
  .option-meta {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.25rem;
  }
  
  .selection-confirmation {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.75rem;
  }
  
  .load-report-btn {
    align-self: stretch;
    justify-content: center;
  }
  
  .modal-actions {
    flex-direction: column;
  }
}
/* ADD these styles to your existing CSS */

/* ===== CLIENT PROMINENT NOTE STYLING ===== */

.client-prominent-note {
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
}

.prominent-note-header {
  margin-bottom: 1rem;
}

.prominent-note-header h4 {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  color: #ffffff;
  margin: 0 0 0.5rem 0;
  font-size: 1.1rem;
}

.prominent-note-header h4 i {
  color: #fbbf24;
}

.note-hint {
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.9rem;
  margin: 0;
}

/* Existing Note Preview */
.existing-note-preview {
  margin-top: 1rem;
  padding: 1rem;
  background: rgba(251, 191, 36, 0.1);
  border: 1px solid rgba(251, 191, 36, 0.3);
  border-radius: 8px;
  overflow: hidden; /* Prevent overflow */
  word-wrap: break-word;
}

.note-preview-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #fbbf24;
  font-weight: 600;
  font-size: 0.9rem;
  margin-bottom: 0.75rem;
}

.note-preview-content {
  color: rgba(255, 255, 255, 0.9);
  font-size: 0.9rem;
  line-height: 1.5;
  margin-bottom: 0.75rem;
  word-wrap: break-word;
  word-break: break-word;
  overflow-wrap: break-word;
  hyphens: auto;
  white-space: pre-wrap; /* Preserves line breaks but allows wrapping */

}

.collapse-note-btn {
  background: transparent;
  border: 1px solid rgba(251, 191, 36, 0.5);
  color: #fbbf24;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  font-size: 0.8rem;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.collapse-note-btn:hover {
  background: rgba(251, 191, 36, 0.1);
  border-color: #fbbf24;
}

/* ===== AGENT PROJECT NOTES STYLING ===== */

.agent-project-notes {
  background: rgba(52, 152, 219, 0.05);
  border: 1px solid rgba(52, 152, 219, 0.2);
  border-radius: 12px;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
}

.project-notes-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;
}

.notes-title {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-size: 1.1rem;
  font-weight: 600;
  color: #3498db;
}

.notes-title i {
  font-size: 1.2rem;
}

.notes-badge {
  background: #3498db;
  color: white;
  padding: 0.25rem 0.75rem;
  border-radius: 1rem;
  font-size: 0.8rem;
  font-weight: 600;
}

.project-notes-content {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.client-note-item {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  padding: 1rem;
  background: rgba(255, 255, 255, 0.03);
  border-radius: 8px;
  border-left: 3px solid #3498db;
}

.note-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.5rem;
  height: 2.5rem;
  background: rgba(52, 152, 219, 0.2);
  border-radius: 50%;
  color: #3498db;
  font-size: 1rem;
  flex-shrink: 0;
}

.note-body {
  flex: 1;
}

.note-text {
  color: rgba(255, 255, 255, 0.9);
  font-size: 0.95rem;
  line-height: 1.5;
  margin-bottom: 0.5rem;
}

.note-attribution {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.8rem;
}

.note-attribution i {
  color: #3498db;
}

.note-disclaimer {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem;
  background: rgba(52, 152, 219, 0.1);
  border-radius: 6px;
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.85rem;
}

.note-disclaimer i {
  color: #3498db;
  flex-shrink: 0;
}

/* ===== MOBILE RESPONSIVENESS ===== */

@media (max-width: 768px) {
  .client-prominent-note,
  .agent-project-notes {
    padding: 1rem;
    margin-bottom: 1rem;
  }
  
  .client-note-item {
    flex-direction: column;
    text-align: center;
  }
  
  .note-icon {
    align-self: center;
  }
}
 
/* Smooth transition when status loads */
.status-badge-enhanced {
  animation: statusFadeIn 0.3s ease-out;
}

@keyframes statusFadeIn {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
 
 

/* Add these styles to your <style scoped> section in GallerySection.vue */
 





.status-display.status-display-loading {
  position: relative;
  overflow: hidden;
  border-radius: 8px;
}

/* Shimmer overlay for status display only */
.status-display-loading::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    90deg,
    transparent 0%,
    rgba(52, 152, 219, 0.4) 50%,
    transparent 100%
  );
  animation: statusDisplayShimmer 2s infinite ease-in-out;
  pointer-events: none;
  z-index: 5;
  border-radius: 8px;
}

/* Background overlay for status display */
.status-display-loading::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(52, 152, 219, 0.15);
  border-radius: 8px;
  z-index: 1;
  pointer-events: none;
}

/* Dim the status content while loading */
.status-display-loading > * {
  opacity: 0.6;
  transition: opacity 0.3s ease;
  position: relative;
  z-index: 2;
}

/* Restore full opacity when loaded */
.status-display:not(.status-display-loading) > * {
  opacity: 1;
  transition: opacity 0.3s ease;
}

/* Shimmer animation */
@keyframes statusDisplayShimmer {
  0% { left: -100%; }
  100% { left: 100%; }
}
.clickable-header {
  cursor: pointer;
  transition: all 0.2s ease;
  margin-bottom: 0;
}

.clickable-header:hover {
  background: rgba(52, 152, 219, 0.05);
  border-radius: 12px;
}

.status-collapsed {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.status-badge-collapsed {
  padding: 0.4rem 0.8rem;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 600;
  background: rgba(108, 117, 125, 0.2);
  color: #6c757d;
}

.status-badge-collapsed.loading {
  background: rgba(52, 152, 219, 0.2);
  color: #3498db;
  animation: loadingPulse 1.5s infinite ease-in-out;
}

.workflow-content {
  margin-top: 1.5rem;
  animation: expandDown 0.3s ease-out;
}

@keyframes expandDown {
  from { opacity: 0; max-height: 0; transform: translateY(-10px); }
  to { opacity: 1; max-height: 1000px; transform: translateY(0); }
}

@keyframes loadingPulse {
  0%, 100% { opacity: 0.7; }
  50% { opacity: 1; }
}





/* Subtle card loading shimmer */
.result-card.card-loading-shimmer {
  position: relative;
  overflow: hidden;
}

.result-card.card-loading-shimmer::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    90deg,
    transparent 0%,
    rgba(255, 255, 255, 0.06) 50%,
    transparent 100%
  );
  animation: cardShimmerSweep 3s infinite ease-in-out;
  pointer-events: none;
  z-index: 0;
}

.result-card.card-loading-shimmer > * {
  opacity: 0.95;
  position: relative;
  z-index: 1;
}

@keyframes cardShimmerSweep {
  0% { left: -100%; }
  100% { left: 100%; }
}

/* Add these styles to GallerySection.vue <style scoped> section */

/* Mark as Hired Button */
.workflow-btn.mark-hired {
  background: linear-gradient(135deg, #4caf50 0%, #66bb6a 100%);
  color: white;
  border: 1px solid #4caf50;
  font-weight: 600;
  box-shadow: 0 2px 8px rgba(76, 175, 80, 0.3);
}

.workflow-btn.mark-hired:hover:not(:disabled) {
  background: linear-gradient(135deg, #388e3c 0%, #4caf50 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.4);
}

.workflow-btn.mark-hired:disabled {
  background: #cccccc;
  border-color: #cccccc;
  opacity: 0.6;
}

/* Hired Status Display */
.hired-status {
  background: linear-gradient(135deg, #4caf50 0%, #66bb6a 100%);
  border: 1px solid #4caf50;
  border-radius: 8px;
  padding: 1rem;
  text-align: center;
  color: white;
  margin: 0.5rem 0;
}

.hired-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.hired-badge i {
  font-size: 1.2rem;
  color: #ffd700; /* Gold trophy color */
}

.hired-message {
  font-size: 0.9rem;
  opacity: 0.9;
  font-style: italic;
}

/* Enhanced workflow button styling */
.workflow-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.6rem 1rem;
  border-radius: 6px;
  border: 1px solid transparent;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  text-decoration: none;
  margin: 0.25rem;
}

.workflow-btn:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.workflow-btn.approve-hire {
  background: #2196f3;
  color: white;
  border-color: #2196f3;
}

.workflow-btn.approve-hire:hover:not(:disabled) {
  background: #1976d2;
  border-color: #1976d2;
}

.workflow-btn.reject {
  background: #f44336;
  color: white;
  border-color: #f44336;
}

.workflow-btn.reject:hover:not(:disabled) {
  background: #d32f2f;
  border-color: #d32f2f;
}

.workflow-btn.request-screening {
  background: #ff9800;
  color: white;
  border-color: #ff9800;
}

.workflow-btn.request-screening:hover:not(:disabled) {
  background: #f57c00;
  border-color: #f57c00;
}

/* Client workflow section styling */
.client-workflow-section {
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(250, 249, 246, 0.1);
  border-radius: 8px;
  padding: 1rem;
  margin: 1rem 0;
}

.workflow-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  justify-content: center;
}

/* Success animation for newly hired candidates */
@keyframes hireSuccess {
  0% { transform: scale(1); }
  50% { transform: scale(1.05); }
  100% { transform: scale(1); }
}

.hired-status.newly-hired {
  animation: hireSuccess 0.6s ease-in-out;
}
 




/* Add to GallerySection.vue <style scoped> section */

/* Enhanced Hired Status - More Prominent */
.status-badge.status-hired {
  background: linear-gradient(135deg, #27ae60, #2ecc71) !important;
  color: white !important;
  border: 2px solid #27ae60 !important;
  font-weight: 700 !important;
  font-size: 0.9rem !important;
  padding: 0.5rem 1rem !important;
  box-shadow: 0 4px 12px rgba(39, 174, 96, 0.4) !important;
  text-transform: uppercase !important;
  letter-spacing: 1px !important;
  animation: hiredGlow 2s ease-in-out infinite alternate !important;
}

/* Hired glow animation */
@keyframes hiredGlow {
  0% { 
    box-shadow: 0 4px 12px rgba(39, 174, 96, 0.4);
    transform: scale(1);
  }
  100% { 
    box-shadow: 0 6px 20px rgba(39, 174, 96, 0.6);
    transform: scale(1.02);
  }
}

/* Hired Status Card - Extra Prominent */
.hired-status {
  background: linear-gradient(135deg, #27ae60 0%, #2ecc71 100%) !important;
  border: 2px solid #27ae60 !important;
  border-radius: 12px !important;
  padding: 1.5rem !important;
  text-align: center !important;
  color: white !important;
  margin: 1rem 0 !important;
  box-shadow: 0 8px 25px rgba(39, 174, 96, 0.3) !important;
  animation: hiredSuccess 0.8s ease-in-out !important;
}

.hired-badge {
  font-size: 1.3rem !important;
  font-weight: 700 !important;
  margin-bottom: 0.75rem !important;
}

.hired-badge i {
  font-size: 1.8rem !important;
  color: #ffd700 !important;
  filter: drop-shadow(0 2px 4px rgba(0,0,0,0.3)) !important;
}

/* Success animation for hired status */
@keyframes hiredSuccess {
  0% { transform: scale(0.9); opacity: 0; }
  50% { transform: scale(1.05); }
  100% { transform: scale(1); opacity: 1; }
}



.gallery-title-section {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
}

/* Sort Dropdown Styles */
.sort-dropdown-wrapper {
  position: relative;
  z-index: 10;
}

.sort-dropdown-trigger {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  background: var(--surface-color);
  border: 1px solid var(--border-color);
  border-radius: 0.5rem;
  color: var(--text-color);
  font-size: 0.875rem;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 140px;
  white-space: nowrap;
}

.sort-dropdown-trigger:hover {
  border-color: var(--primary-color);
  background: var(--hover-color);
}

.sort-dropdown-trigger.active {
  border-color: var(--primary-color);
  background: var(--hover-color);
}

.sort-dropdown-trigger .chevron {
  margin-left: auto;
  font-size: 0.75rem;
  transition: transform 0.2s ease;
}

.sort-dropdown-trigger .chevron.rotated {
  transform: rotate(180deg);
}

.sort-dropdown-menu {
  position: absolute;
  top: calc(100% + 0.5rem);
  left: 0;
  min-width: 180px;
  background: var(--background-color);
  border: 1px solid var(--border-color);
  border-radius: 0.5rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  overflow: hidden;
  z-index: 100;
}

.sort-option {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  width: 100%;
  padding: 0.75rem 1rem;
  background: transparent;
  border: none;
  color: var(--text-color);
  font-size: 0.875rem;
  cursor: pointer;
  transition: background 0.2s ease;
  text-align: left;
}

.sort-option:hover {
  background: var(--hover-color);
}

.sort-option.selected {
  background: rgba(234, 94, 19, 0.1);
  color: var(--primary-color);
}

.sort-option i:first-child {
  width: 1rem;
  text-align: center;
}

.sort-option span {
  flex: 1;
}

.sort-option .check-icon {
  color: var(--primary-color);
  font-size: 0.75rem;
  margin-left: auto;
}

/* Dropdown transition */
.dropdown-fade-enter-active,
.dropdown-fade-leave-active {
  transition: all 0.2s ease;
}

.dropdown-fade-enter-from {
  opacity: 0;
  transform: translateY(-0.5rem);
}

.dropdown-fade-leave-to {
  opacity: 0;
  transform: translateY(0.5rem);
}

/* Responsive */
@media (max-width: 768px) {
  .sort-dropdown-trigger {
    min-width: 120px;
    padding: 0.375rem 0.75rem;
    font-size: 0.8rem;
  }
  
  .sort-dropdown-menu {
    min-width: 150px;
  }
}


/*   styling for the edit button */
.edit-export-btn {
  background: #28a745 !important;
  color: white;
  border: none;
  padding: 8px 16px;
  width: 100%;
  text-align: left;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
}

.edit-export-btn:hover {
  background: #218838 !important;
}







.resume-actions {
  display: flex;
  gap: 10px;
  margin: 20px 0;
}

.btn-logo {
  background: #4CAF50;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.btn-logo:hover {
  background: #45a049;
}

/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
  overflow-y: auto;
}

.modal-content {
  position: relative;
  background: white;
  border-radius: 8px;
  max-width: 1400px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
}

.modal-close {
  position: absolute;
  top: 10px;
  right: 10px;
  background: #f0f0f0;
  border: none;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  font-size: 24px;
  line-height: 1;
  cursor: pointer;
  z-index: 10;
}

.modal-close:hover {
  background: #e0e0e0;
}
.download-btn.reformat {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.download-btn.reformat:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.download-btn.reformat:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
 
/* Job Offer Input Section */
.job-offer-input-section {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 15px;
  margin-top: 5px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1001;
  min-width: 350px;
}

.job-offer-textarea {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 12px;
  font-family: inherit;
  resize: vertical;
  margin-bottom: 10px;
}

.job-offer-textarea:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.1);
}

.job-offer-actions {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}

.btn-start-reformat {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: all 0.2s;
}

.btn-start-reformat:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.btn-start-reformat:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-cancel {
  background: #f5f5f5;
  color: #666;
  border: 1px solid #ddd;
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-cancel:hover {
  background: #e5e5e5;
}

/* Reformat Button Styling */
.download-btn.reformat {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
}

.download-btn.reformat:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.download-btn.reformat:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Loading Overlay */
.reformat-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.75);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  backdrop-filter: blur(4px);
}

.loading-spinner {
  width: 60px;
  height: 60px;
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-top: 4px solid white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
 
.loading-text {
  color: var(--text-color); /* CHANGE from white only */
  font-size: 18px;
  font-weight: 600;
  margin-top: 20px;
  margin-bottom: 5px;
}

.loading-subtext {
  color: rgba(255, 255, 255, 0.8);
  font-size: 14px;
  margin: 0;
}

.candidate-resumes-link {
  margin-top: 0.75rem;
  padding-top: 0.75rem;
  border-top: 1px solid #f0f0f0;
}

.view-resumes-btn {
  background: none;
  border: none;
  color: #667eea;
  font-size: 0.85rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0;
  transition: all 0.2s;
}

.view-resumes-btn:hover {
  color: #764ba2;
  gap: 0.75rem; /* Slight animation effect */
}

.view-resumes-btn i {
  font-size: 1rem;
}


.candidate-resumes-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 0.5rem;
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 0.5rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 300px;
  max-width: 400px;
  z-index: 1000;
}

.dropdown-header {
  padding: 0.75rem 1rem;
  border-bottom: 1px solid #f0f0f0;
  font-weight: 600;
  font-size: 0.875rem;
  color: #333;
}

.dropdown-item {
  padding: 0.75rem 1rem;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  cursor: pointer;
  transition: background 0.2s;
}

.dropdown-item:hover {
  background: #f8f9fa;
}

.dropdown-item.current {
  background: #e8f5e9;
}

.dropdown-item i.fa-file-pdf {
  color: #667eea;
  font-size: 1.25rem;
}

.resume-info {
  flex: 1;
  min-width: 0;
}

.resume-id {
  font-weight: 500;
  font-size: 0.875rem;
  color: #333;
}

.resume-name {
  font-size: 0.75rem;
  color: #666;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.current-badge {
  color: #4caf50;
  font-size: 1rem;
}

.dropdown-loading {
  padding: 2rem;
  text-align: center;
  color: #666;
}
/* Loading card - collapsed height */
.loading-card {
  max-height: 120px;
  overflow: hidden;
  transition: max-height 0.4s ease-out;
}

/* Loaded card - full height */
.candidate-card:not(.loading-card) {
  max-height: none;
  transition: max-height 0.4s ease-in;
}

/* Soft blur overlay */
.card-loading-blur {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  background: rgba(255, 255, 255, 0.4);
  z-index: 10;
  border-radius: inherit;
  /* Soft edges */
  mask-image: radial-gradient(ellipse at center, black 60%, transparent 100%);
  -webkit-mask-image: radial-gradient(ellipse at center, black 60%, transparent 100%);
}

/* Remove old loading styles if they exist */
.card-loading-overlay,
.loading-spinner {
  display: none;
}

/* Disable buttons during loading */
button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}



/* Match Score Breakdown Styles */
.match-score-item.clickable {
  cursor: pointer;
  transition: all 0.2s ease;
}

.match-score-item.clickable:hover {
  background: rgba(59, 130, 246, 0.1);
  transform: translateY(-1px);
}

.match-score-text {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.breakdown-chevron {
  font-size: 0.7rem;
  transition: transform 0.2s ease;
}

.breakdown-chevron.rotated {
  transform: rotate(180deg);
}

/* Breakdown Panel */
.match-breakdown-panel {
  margin: 1rem 0;
  padding: 1rem;
  background: linear-gradient(135deg, #ff6b6b 0%, #ff8c42 100%);
  border-radius: 8px;
  border: 1px solid rgba(59, 130, 246, 0.2);
}

.breakdown-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1rem;
  flex-wrap: wrap;
}

.source-badge {
  padding: 0.25rem 0.75rem;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.source-badge.source-hybrid {
  background: linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%);
  color: white;
}

.source-badge.source-keyword {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
}

.source-badge.source-semantic {
  background: linear-gradient(135deg, #8b5cf6 0%, #a855f7 100%);
  color: white;
}

.breakdown-reason {
  color: #64748b;
  font-size: 0.85rem;
  font-style: italic;
}

/* Score Composition */
.score-composition {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-bottom: 1rem;
}

.score-bar-container {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.score-label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.85rem;
  color: #475569;
}

.score-label i {
  width: 16px;
  text-align: center;
}

.score-value {
  margin-left: auto;
  font-weight: 600;
  color: #1e293b;
}

.score-bar {
  height: 6px;
  background: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
  overflow: hidden;
}

.score-fill {
  height: 100%;
  transition: width 0.3s ease;
  border-radius: 3px;
}

.keyword-fill {
  background: linear-gradient(90deg, #10b981 0%, #059669 100%);
}

.semantic-fill {
  background: linear-gradient(90deg, #8b5cf6 0%, #a855f7 100%);
}

/* Semantic Breakdown Grid */
.semantic-breakdown {
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}

.breakdown-title {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.85rem;
  font-weight: 600;
  color: #475569;
  margin-bottom: 0.75rem;
}

.breakdown-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 0.5rem;
}

.breakdown-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.8rem;
}

.breakdown-item-label {
  color: #475569;
  white-space: nowrap;
  min-width: 100px;
}

.breakdown-mini-bar {
  flex: 1;
  height: 4px;
  background: rgba(0, 0, 0, 0.05);
  border-radius: 2px;
  overflow: hidden;
}

.breakdown-mini-fill {
  height: 100%;
  background: linear-gradient(90deg, #6366f1 0%, #8b5cf6 100%);
  transition: width 0.3s ease;
}

.breakdown-item-value {
  font-weight: 600;
  color: #475569;
  min-width: 35px;
  text-align: right;
}

/* Slide animation for breakdown panel */
.breakdown-slide-enter-active, .breakdown-slide-leave-active {
  transition: all 0.3s ease;
}

.breakdown-slide-enter, .breakdown-slide-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

.hot-list-score {
  background: linear-gradient(135deg, #ff6b6b 0%, #ff8c42 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: 600;
}

.hot-list-indicator {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.hot-list-content {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  cursor: pointer;
}

.hide-candidate-btn {
  padding: 4px 8px;
  background: rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
  color: #666;
  font-size: 12px;
}

.hide-candidate-btn:hover {
  background: #ff4444;
  color: white;
  border-color: #ff4444;
  transform: scale(1.05);
}

.hide-candidate-btn i {
  pointer-events: none;
}

/* Panel wide text */
.match-breakdown-panel {
  color: #fff7ed; /* warm off-white */
}

/* Header and titles */
.breakdown-header,
.breakdown-title {
  color: #fff7ed;
}

/* Reason text */
.breakdown-reason {
  color: #ffedd5; /* softer warm white */
}

/* Score labels and values */
.score-label {
  color: #fff7ed;
}

.score-value {
  color: #ffffff;
}

/* Icons inside labels */
.score-label i {
  color: #ffedd5;
}

/* Breakdown grid text */
.breakdown-item-label {
  color: #fff7ed;
}

.breakdown-item-value {
  color: #ffffff;
}

/* Hot list text already uses gradient, just ensure fallback */
.hot-list-score {
  color: #ffffff;
}

/* Buttons */
.hide-candidate-btn {
  color: #1f2933; /* dark text on light button */
}

.hide-candidate-btn:hover {
  color: #ffffff;
}

/* Subtle dividers */
.semantic-breakdown {
  border-top: 1px solid rgba(255, 255, 255, 0.25);
}



/* Match score container with actions */
.match-with-actions {
  display: flex !important;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.match-content {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  min-width: 0;
}

.match-content.clickable {
  cursor: pointer;
}

.match-content.clickable:hover {
  opacity: 0.8;
}

/* Manual add badge */
.manual-add-badge {
  color: #10b981;
  font-weight: 600;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Add to hot list button */
.add-to-hotlist-wrapper {
  position: relative;
}

.add-to-hotlist-btn {
  padding: 4px 8px;
  background: linear-gradient(135deg, #ff6b6b 0%, #ff8c42 100%);
  border: 1px solid rgba(99, 102, 241, 0.3);
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #6366f1;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  width: 24px;
}
.add-to-hotlist-btn-green {
  padding: 4px 8px;
  background: linear-gradient(135deg, #004d40 0%, #00bfa5 100%);
  border: 1px solid rgba(99, 102, 241, 0.3);
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #004d40;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  width: 24px;
}

.add-to-hotlist-btn:hover {
  background: rgba(99, 102, 241, 0.2);
  border-color: #6366f1;
  transform: scale(1.05);
}

.add-to-hotlist-btn-green:hover {
  background: rgba(99, 102, 241, 0.2);
  border-color: #6366f1;
  transform: scale(1.05);
}

.add-to-hotlist-btn i {
  pointer-events: none;
}

/* Dropdown menu */
.hotlist-dropdown {
  position: absolute;
  top: calc(100% + 4px);
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  min-width: 250px;
  max-width: 300px;
}

.hotlist-dropdown-header {
  padding: 12px 16px;
  border-bottom: 1px solid #e5e7eb;
  font-weight: 600;
  font-size: 13px;
  color: #111827;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.close-dropdown {
  padding: 2px 6px;
  background: none;
  border: none;
  cursor: pointer;
  color: #6b7280;
  font-size: 14px;
  transition: color 0.2s;
}

.close-dropdown:hover {
  color: #111827;
}

.dropdown-loading,
.dropdown-empty {
  padding: 24px 16px;
  text-align: center;
  color: #6b7280;
  font-size: 13px;
}

.dropdown-empty i {
  font-size: 32px;
  color: #d1d5db;
  margin-bottom: 8px;
}

.dropdown-empty p {
  margin: 8px 0 4px;
  font-weight: 500;
  color: #374151;
}

.hotlist-options {
  max-height: 300px;
  overflow-y: auto;
}

.hotlist-option {
  width: 100%;
  padding: 10px 16px;
  border: none;
  border-bottom: 1px solid #f3f4f6;
  background: white;
  cursor: pointer;
  transition: background 0.2s;
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: left;
}

.hotlist-option:last-child {
  border-bottom: none;
  border-radius: 0 0 8px 8px;
}

.hotlist-option:hover:not(.already-added):not(:disabled) {
  background: #f9fafb;
}

.hotlist-option.already-added {
  background: #f0fdf4;
  cursor: default;
}

.hotlist-option:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.hotlist-name {
  font-size: 13px;
  font-weight: 500;
  color: #111827;
  flex: 1;
}

.status-badge {
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 12px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 4px;
}

.status-badge.add-badge {
  background: rgba(99, 102, 241, 0.1);
  color: #6366f1;
}

.hotlist-option.already-added .status-badge {
  background: rgba(16, 185, 129, 0.1);
  color: #10b981;
}

/* Dropdown animation */
.dropdown-fade-enter-active,
.dropdown-fade-leave-active {
  transition: opacity 0.2s, transform 0.2s;
}

.dropdown-fade-enter-from,
.dropdown-fade-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}

/* Tags collapse styling */
.tags-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem;
  cursor: pointer;
  user-select: none;
  font-weight: 600;
  font-size: 0.875rem;
  color: var(--text-color);
  transition: all 0.2s ease;
  border-radius: 0.25rem;
}

.tags-header:hover {
  background: var(--hover-color);
}

.tags-header i {
  font-size: 0.75rem;
  transition: transform 0.2s ease;
}

.tags-header.collapsed i {
  transform: rotate(0deg);
}

.tags-content {
  padding-top: 0.5rem;
}
.tags-loading {
  padding: 1rem;
  text-align: center;
  color: var(--text-muted);
  font-size: 0.875rem;
}

.tags-loading i {
  margin-right: 0.5rem;
}


/* ========================================
   FANCY COLLAPSIBLE TAGS SECTION
   ======================================== */

   .candidate-tags-section {
    margin-top: 1rem;
    border-top: 1px solid var(--border-color);
  }
  
  .tags-toggle-btn {
    width: 100%;
    padding: 1rem 1.25rem;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border: none;
    border-radius: 0.5rem;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 2px 8px rgba(102, 126, 234, 0.15);
    margin-top: 0.75rem;
  }
  
  .tags-toggle-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.25);
  }
  
  .tags-toggle-btn:active {
    transform: translateY(0);
  }
  
  .tags-toggle-btn.expanded {
    background: linear-gradient(135deg, #764ba2 0%, #667eea 100%);
    border-radius: 0.5rem 0.5rem 0 0;
  }
  
  .tags-toggle-content {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    color: white;
    font-weight: 600;
    font-size: 0.95rem;
  }
  
  .tags-icon {
    font-size: 1.1rem;
  }
  
  .tags-label {
    flex: 1;
    text-align: left;
    color:white !important;
  }
  
  .expand-icon {
    font-size: 0.9rem;
    color:white !important;
    transition: transform 0.3s ease;
  }
  
  .tags-toggle-btn.expanded .expand-icon {
    transform: rotate(180deg);
  }
  
  .tags-content-wrapper {
    background: var(--card-bg);
    border: 1px solid var(--border-color);
    border-top: none;
    border-radius: 0 0 0.5rem 0.5rem;
    padding: 1.25rem;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  }
  
  .tags-loading-state {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    padding: 2.5rem 1rem;
    color: var(--text-color);
  }
  
  .loading-spinner {
    font-size: 1.5rem;
    color: #667eea;
  }
  
  .loading-text {
    font-size: 0.95rem; 
    font-weight: 500;
    color:white !important;


  }
  

  .slide-fade-enter-active {
    transition: all 0.3s ease-out;
  }
  
  .slide-fade-leave-active {
    transition: all 0.2s ease-in;
  }
  
  .slide-fade-enter-from {
    transform: translateY(-10px);
    opacity: 0;
  }
  
  .slide-fade-leave-to {
    transform: translateY(-5px);
    opacity: 0;
  }
  
  .tags-content {
    animation: fadeIn 0.3s ease-in;
  }
  
  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(5px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  /* Hired state */
.status-card.hired-state {
  background: rgba(46, 204, 113, 0.1);
  border-left-color: #2ecc71;
  color: #2ecc71;
}

/* Rejected state */
.status-card.rejected-state {
  background: rgba(231, 76, 60, 0.1);
  border-left-color: #e74c3c;
  color: #e74c3c;
}

/* Optional: icon color alignment */
.status-card.hired-state .status-icon,
.status-card.rejected-state .status-icon {
  font-size: 1.5rem;
}

 
  .project-completed-notice {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.75rem 1rem;
    background: #e8f5e9;
    color: #2e7d32;
    border-radius: 0.5rem;
    font-size: 0.875rem;
    font-weight: 500;
  }
  
  .project-completed-notice i {
    color: #2e7d32;
  }
 

  /* Character counter */
.char-counter {
  font-size: 12px;
  text-align: right;
  margin-top: 4px;
  font-weight: 500;
  transition: color 0.2s;
}

.char-counter-ok {
  color: #6c757d; /* Gray */
}

.char-counter-warning {
  color: #ff9800; /* Orange - approaching limit */
}

.char-counter-over {
  color: #dc3545; /* Red - over limit */
  font-weight: 600;
}

/* Adjust spacing for existing elements */
.note-input-container {
  position: relative;
}

.prominent-note-textarea {
  /* Your existing styles */
  margin-bottom: 0; /* Remove bottom margin if any */
}

.prominent-add-note-btn {
  margin-top: 8px; /* Add some space after counter */
}
/* Project transition overlay */
.project-transition-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 10;
  border-radius: inherit;
  color: white;
  gap: 0.5rem;
}

.project-transition-overlay i {
  font-size: 1.5rem;
}

.result-card.transitioning {
  pointer-events: none;
  opacity: 0.7;
}

/* Cross-project conflict warning */
.cross-project-warning {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  background: linear-gradient(135deg, #f59e0b, #d97706);
  color: white;
  padding: 0.5rem 1rem;
  font-size: 0.75rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  z-index: 5;
  border-radius: inherit;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.cross-project-warning i {
  color: white;
}
.collapsible.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.loading-indicator {
  font-size: 12px;
  color: #999;
  margin-left: 8px;
}
.project-history-badge {
  display: inline-block;
  margin-left: 8px;
}

.badge-button {
  background: #f0f0f0;
  border: 1px solid #ddd;
  border-radius: 12px;
  padding: 4px 10px;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s;
}

.badge-button:hover {
  background: #e0e0e0;
}

.project-history-modal {
  max-width: 600px;
  max-height: 80vh;
  overflow-y: auto;
}

.history-summary {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #eee;
}

.project-item {
  border: 1px solid #eee;
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 15px;
}

.project-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.project-meta {
  color: #666;
  font-size: 13px;
  margin: 4px 0 0 0;
}

.interactions-timeline {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.interaction-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 10px;
  background: #f9f9f9;
  border-radius: 4px;
  font-size: 13px;
}

.interaction-type {
  padding: 2px 8px;
  border-radius: 4px;
  font-weight: 500;
}

.interaction-type.screened { background: #e8f5e9; color: #2e7d32; }
.interaction-type.consulted { background: #e3f2fd; color: #1565c0; }
.interaction-type.hired { background: #fff3e0; color: #e65100; }
.interaction-type.hidden { background: #f5f5f5; color: #757575; }

.status-badge.active { background: #4caf50; color: white; }
.status-badge.completed { background: #9e9e9e; color: white; }



/* Project History Badge */
.project-history-badge {
  display: inline-flex;
  align-items: center;
  margin-left: 8px;
}

.project-history-badge .badge-button {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(102, 126, 234, 0.2);
}

.project-history-badge .badge-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(102, 126, 234, 0.3);
}

.project-history-badge .badge-button:active {
  transform: translateY(0);
}

.project-history-badge .badge-button i {
  font-size: 11px;
}

.project-history-badge .badge-count {
  font-weight: 600;
  font-size: 11px;
}
/* Project History Section */
.project-history-section {
  margin-top: 12px;
}

.project-history-section .tag-group-title {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 10px;
}

.project-history-section .count-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 600;
}

/* Project Chips Container */
.project-chips {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

/* Individual Project Chip */
.project-chip {
  background: #f8f9fa;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 10px;
  transition: all 0.2s ease;
}

.project-chip:hover {
  border-color: #667eea;
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.1);
}

/* Project Chip Header */
.project-chip-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 8px;
}

.project-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.project-name {
  font-weight: 600;
  font-size: 13px;
  color: #2c3e50;
}

.project-meta {
  font-size: 11px;
  color: #7f8c8d;
}

/* Project Status Pills */
.project-status-pill {
  padding: 3px 8px;
  border-radius: 12px;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  white-space: nowrap;
}

.project-status-pill.active {
  background: #e8f5e9;
  color: #2e7d32;
}

.project-status-pill.completed {
  background: #f5f5f5;
  color: #757575;
}

.project-status-pill.on-hold {
  background: #fff3e0;
  color: #e65100;
}

/* Interactions Timeline */
.project-interactions {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding-top: 8px;
  border-top: 1px solid #e0e0e0;
}

.interaction-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  font-size: 11px;
}

/* Interaction Type Labels */
.interaction-label {
  font-weight: 600;
  padding: 2px 6px;
  border-radius: 4px;
}

.interaction-label.screened {
  background: #e8f5e9;
  color: #2e7d32;
}

.interaction-label.consulted {
  background: #e3f2fd;
  color: #1565c0;
}

.interaction-label.hired {
  background: #fff3e0;
  color: #e65100;
}

.interaction-label.hidden {
  background: #f5f5f5;
  color: #757575;
}

.interaction-date {
  color: #7f8c8d;
  font-size: 10px;
}
.quick-status-badge {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  margin-bottom: 0.5rem;
  border-radius: 6px;
  background: rgba(var(--primary-rgb), 0.1);
  font-size: 0.85rem;
  font-weight: 500;
}

.quick-status-badge i {
  font-size: 0.9rem;
}
.project-workflow-status {
  margin-top: 0.5rem;
}

.workflow-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.25rem 0.6rem;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 500;
}

.workflow-badge i {
  font-size: 0.7rem;
}

.workflow-badge.status-request-screening {
  background: rgba(255, 193, 7, 0.15);
  color: #f59e0b;
}

.workflow-badge.status-screening-in-progress {
  background: rgba(59, 130, 246, 0.15);
  color: #3b82f6;
}

.workflow-badge.status-screened {
  background: rgba(34, 197, 94, 0.15);
  color: #22c55e;
}

.workflow-badge.status-hired {
  background: rgba(168, 85, 247, 0.15);
  color: #a855f7;
}

.workflow-badge.status-rejected {
  background: rgba(239, 68, 68, 0.15);
  color: #ef4444;
}

.workflow-badge.status-none {
  background: rgba(107, 114, 128, 0.1);
  color: #6b7280;
}




/* Step indicator */
.screening-steps {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1.5rem;
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 8px;
}

.step {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-size: 0.85rem;
  font-weight: 600;
  color: #95a5a6;
  background: transparent;
}

.step.active {
  background: linear-gradient(135deg, #9b59b6, #8e44ad);
  color: white;
}

.step.done {
  background: rgba(39, 174, 96, 0.15);
  color: #27ae60;
}

.step-arrow { color: #bdc3c7; }

/* Score pips */
.score-input {
  display: flex;
  gap: 0.5rem;
}

.score-pip {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 2px solid #ddd;
  background: white;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  color: #7f8c8d;
}

.score-pip.active {
  background: linear-gradient(135deg, #9b59b6, #8e44ad);
  border-color: #9b59b6;
  color: white;
}

/* HR readonly summary */
.hr-summary-readonly {
  background: #f8f9fa;
  border-left: 3px solid #9b59b6;
  border-radius: 4px;
  padding: 1rem;
  margin-bottom: 1.5rem;
}

.readonly-field {
  display: flex;
  gap: 0.5rem;
  padding: 0.3rem 0;
  font-size: 0.88rem;
  border-bottom: 1px solid #eee;
}

.readonly-field:last-child { border-bottom: none; }

.field-label { font-weight: 600; color: #7f8c8d; min-width: 160px; }
.field-value { color: #2c3e50; }



.modular-fields-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

.modular-field-item {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 0.75rem 1rem;
}
.modular-field-item--full {
  grid-column: 1 / -1;
}
.field-label-client {
  font-size: 0.78rem;
  font-weight: 600;
  color: #7f8c8d;
  text-transform: uppercase;
  margin-bottom: 0.3rem;
}

.field-value-client {
  color: #2c3e50;
  font-weight: 500;
  font-size: 0.95rem;
}

.score-display { display: flex; gap: 4px; }

.score-pip-display {
  width: 28px; height: 28px;
  border-radius: 50%;
  border: 2px solid #ddd;
  display: flex; align-items: center; justify-content: center;
  font-size: 0.75rem; font-weight: 600;
  color: #bdc3c7;
}

.score-pip-display.active {
  background: linear-gradient(135deg, #9b59b6, #8e44ad);
  border-color: #9b59b6;
  color: white;
}

.screening-status-banner {
  padding: 0.75rem 1rem;
  border-radius: 8px;
  margin-bottom: 1.25rem;
  font-weight: 600;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.screening-status-banner.edit-mode {
  background: rgba(52, 152, 219, 0.1);
  color: #2980b9;
  border-left: 3px solid #3498db;
}
.screening-status-banner.tech-mode {
  background: rgba(155, 89, 182, 0.1);
  color: #8e44ad;
  border-left: 3px solid #9b59b6;
}
.client-report-top {
  display: flex;
  gap: 1rem;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
}
.recommendation-badge-large {
  padding: 0.5rem 1.25rem;
  border-radius: 20px;
  font-weight: 600;
  font-size: 0.88rem;
}
.modal-loading-overlay {
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0.75);
  backdrop-filter: blur(3px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  border-radius: inherit;
  font-size: 2rem;
  color: #666;
}
.field-label-with-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.client-visibility-toggle {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 0.8rem;
  padding: 0 4px;
}
.client-visibility-toggle.visible { color: #27ae60; }
.client-visibility-toggle.hidden  { color: #bbb; }


.legacy-report-banner {
  background: rgba(243, 156, 18, 0.1);
  border: 1px solid rgba(243, 156, 18, 0.3);
  border-radius: 8px;
  padding: 8px 14px;
  font-size: 0.8rem;
  color: #f39c12;
  margin-bottom: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.legacy-summary {
  white-space: pre-wrap;
  font-family: inherit;
  font-size: 0.82rem;
  color: #cbd5e0;
  line-height: 1.7;
  margin: 0;
  background: rgba(255,255,255,0.03);
  border-radius: 8px;
  padding: 12px;
}
.legacy-notes { font-size: 0.85rem; color: #a0aec0; }
.key-checks-legacy { display: flex; flex-wrap: wrap; gap: 10px; }
.check-item { font-size: 0.8rem; display: flex; align-items: center; gap: 5px; }
.check-item.ok { color: #48bb78; }
.check-item.no { color: #718096; }


.interview-scheduled-banner {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  background: rgba(167,139,250,0.12);
  border: 1px solid rgba(167,139,250,0.3);
  border-radius: 8px;
  margin-top: 10px;
  font-size: 0.82rem;
  color: #a78bfa;
}
.interview-date { color: rgba(167,139,250,0.7); }
.report-highlights {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding: 14px 0 18px;
  border-bottom: 1px solid rgba(255,255,255,0.07);
  margin-bottom: 18px;
}
.highlight-chip {
  background: rgba(255,255,255,0.06);
  border: 1px solid rgba(255,255,255,0.12);
  border-radius: 10px;
  padding: 8px 14px;
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 110px;
}
.chip-label {
  font-size: 0.68rem;
  color: rgba(255,255,255,0.4);
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.chip-value {
  font-size: 0.92rem;
  color: #e2e8f0;
  font-weight: 600;
}
.certs-chip { min-width: 200px; }
.cert-tags { display: flex; flex-wrap: wrap; gap: 5px; margin-top: 4px; }
.cert-tag {
  background: rgba(102,126,234,0.2);
  color: #a3b4ff;
  border-radius: 12px;
  padding: 2px 9px;
  font-size: 0.72rem;
  font-weight: 500;
}

.report-section-block {
  margin-bottom: 20px;
  border: 1px solid rgba(255,255,255,0.08);
  border-radius: 12px;
  overflow: hidden;
}
.section-block-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
}
.hr-header  { background: rgba(102,126,234,0.1); }
.tech-header{ background: rgba(72,187,120,0.1);  }
.section-block-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  font-size: 0.88rem;
  color: #e2e8f0;
}
.hr-header .section-block-title i  { color: #a3b4ff; }
.tech-header .section-block-title i{ color: #68d391; }
.section-rec-pill {
  font-size: 0.72rem;
  font-weight: 600;
  padding: 3px 10px;
  border-radius: 10px;
}
.section-rec-pill.rec-pass    { background: rgba(72,187,120,0.2);  color: #68d391; }
.section-rec-pill.rec-consider{ background: rgba(237,137,54,0.2);  color: #f6ad55; }
.section-rec-pill.rec-reject  { background: rgba(245,101,101,0.2); color: #fc8181; }
.report-section-block .modular-fields-grid { padding: 12px 16px; }
.pending-tech {
  padding: 14px 16px;
  color: #f6ad55;
  font-size: 0.85rem;
  display: flex;
  align-items: center;
  gap: 8px;
}
/* ── Client Report Modal: white background overrides ── */
.client-report-modal.enhanced .modal-header {
  background: #f8f9fb;
  border-bottom: 1px solid #e8ecf0;
}
.client-report-modal.enhanced .modal-header h3 {
  color: #1a202c;
}
.client-report-modal.enhanced .close-btn {
  color: #4a5568;
}
.client-report-modal.enhanced .modal-body {
  background: #ffffff;
  color: #2d3748;
}

/* Highlights strip */
.client-report-modal.enhanced .report-highlights {
  border-bottom: 1px solid #e8ecf0;
}
.client-report-modal.enhanced .highlight-chip {
  background: #f4f6f9;
  border: 1px solid #dde1e8;
}
.client-report-modal.enhanced .chip-label {
  color: #718096;
}
.client-report-modal.enhanced .chip-value {
  color: #1a202c;
}
.client-report-modal.enhanced .cert-tag {
  background: rgba(102, 126, 234, 0.12);
  color: #4c63d2;
}

/* Section blocks */
.client-report-modal.enhanced .report-section-block {
  border: 1px solid #e8ecf0;
}
.client-report-modal.enhanced .hr-header {
  background: rgba(102, 126, 234, 0.07);
  border-bottom: 1px solid #dde6f5;
}
.client-report-modal.enhanced .tech-header {
  background: rgba(56, 161, 105, 0.07);
  border-bottom: 1px solid #c6f0d8;
}
.client-report-modal.enhanced .section-block-title {
  color: #2d3748;
}
.client-report-modal.enhanced .hr-header .section-block-title i {
  color: #5a6fd6;
}
.client-report-modal.enhanced .tech-header .section-block-title i {
  color: #38a169;
}

/* Fields */
.client-report-modal.enhanced .field-label-client {
  color: #718096;
}
.client-report-modal.enhanced .field-value-client {
  color: #1a202c;
}

/* Score pips on white */
.client-report-modal.enhanced .score-pip-display {
  background: #e2e8f0;
  color: #a0aec0;
  border: 1px solid #cbd5e0;
}
.client-report-modal.enhanced .score-pip-display.active {
  background: #5a6fd6;
  color: white;
  border-color: #5a6fd6;
}

/* Recommendation pills in section headers */
.client-report-modal.enhanced .section-rec-pill.rec-pass {
  background: rgba(56, 161, 105, 0.15);
  color: #276749;
}
.client-report-modal.enhanced .section-rec-pill.rec-consider {
  background: rgba(221, 107, 32, 0.12);
  color: #c05621;
}
.client-report-modal.enhanced .section-rec-pill.rec-reject {
  background: rgba(229, 62, 62, 0.12);
  color: #c53030;
}

/* Pending tech notice */
.client-report-modal.enhanced .pending-tech {
  color: #c05621;
  background: rgba(221, 107, 32, 0.06);
}

/* Legacy banner */
.client-report-modal.enhanced .legacy-report-banner {
  background: rgba(221, 107, 32, 0.08);
  border: 1px solid rgba(221, 107, 32, 0.25);
  color: #c05621;
}
.client-report-modal.enhanced .legacy-summary {
  color: #4a5568;
}

/* Footer */
.client-report-modal.enhanced .report-footer {
  color: #a0aec0;
  border-top: 1px solid #e8ecf0;
}

.client-report-modal.enhanced .chip-score {
  display: flex;
  flex-direction: row;
  gap: 4px;
}
.score-chip {
  min-width: fit-content;
}
.status-card.tech-planned {
  background: rgba(99, 179, 237, 0.1);
  border-color: rgba(99, 179, 237, 0.3);
}
.status-card.tech-planned .status-icon { color: #63b3ed; }
.status-card.tech-planned .status-title { color: #63b3ed; }

.modal-hint {
  font-size: 0.82rem;
  color: rgba(255,255,255,0.45);
  margin-bottom: 14px;
}
.modal-hint-black {
  font-size: 0.82rem;
  color: rgba(0,0,0,0.88);
  margin-bottom: 14px;
}
.date-slot { position: relative; }
.remove-date { color: #fc8181; cursor: pointer; font-size: 0.75rem; margin-left: 8px; }
.btn-add-date {
  border: 1px dashed rgba(255,255,255,0.2);
  color: rgba(255,255,255,0.5);
  padding: 6px 14px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.8rem;
  width: 100%;
  margin-top: 4px;
}
.btn-add-date:hover { border-color: rgba(255,255,255,0.4); color: #e2e8f0; }
.date-option {
  padding: 10px 14px;
  border: 1px solid rgb(28 26 26 / 61%);
  border-radius: 8px;
  margin-bottom: 8px;
  cursor: pointer;
  font-size: 0.85rem;
  color: black;
  transition: all 0.15s;
}
.date-option:hover { background: rgba(255,255,255,0.07); }
.date-option.selected { border-color: #68d391; background: rgba(72,187,120,0.1); }
.proposed-dates-preview { margin-top: 10px; }
.proposed-label { font-size: 0.75rem; color: rgba(255,255,255,0.4); margin-bottom: 6px; }
.proposed-date-item {
  padding: 6px 10px;
  background: rgba(255,255,255,0.05);
  border-radius: 6px;
  font-size: 0.82rem;
  color: #e2e8f0;
  margin-bottom: 4px;
}
.expired-dates-warning {
  margin-top: 10px;
  padding: 8px 12px;
  background: rgba(245,101,101,0.08);
  border: 1px solid rgba(245,101,101,0.25);
  border-radius: 8px;
  font-size: 0.8rem;
  color: #fc8181;
}
.btn-link-inline {
  background: none; border: none; color: #a3b4ff;
  cursor: pointer; text-decoration: underline;
  font-size: 0.8rem; padding: 0; margin-left: 6px;
}
.status-card.interview-requested {
  background: rgba(251,191,36,0.08);
  border-color: rgba(251,191,36,0.3);
}
.status-card.interview-requested .status-icon,
.status-card.interview-requested .status-title { color: #fbbf24; }
.status-card.interview-done {
  background: rgba(99,179,237,0.08);
  border-color: rgba(99,179,237,0.3);
}
.status-card.interview-done .status-icon,
.status-card.interview-done .status-title { color: #63b3ed; }
.agent-confirm-interview {
  padding: 10px 0;
  border-top: 1px solid rgba(255,255,255,0.07);
  margin-top: 10px;
}

.cancel-interview-btn {
  background: none;
  border: 1px solid rgba(245,101,101,0.4);
  color: #fc8181;
  padding: 2px 8px;
  border-radius: 5px;
  font-size: 0.75rem;
  cursor: pointer;
  margin-left: 10px;
  transition: all 0.15s;
}
.cancel-interview-btn:hover {
  background: rgba(245,101,101,0.1);
  border-color: #fc8181;
}
.modal-footer {
  display: flex;
  justify-content: flex-end; /* align buttons to the right */
  align-items: center;
  gap: 12px; /* space between buttons */
  padding: 16px 20px;
  border-top: 1px solid #e5e5e5;
  background-color: #fff;
}

.modal-footer .btn {
  min-width: 160px;
}

.agent-views-row {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  padding: 2px 0;
}

.agent-view-chip {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  font-size: 0.6rem;
  font-weight: 600;
  color: rgba(250,249,246,0.4);
  background: rgba(250,249,246,0.03);
  border: 1px solid rgba(250,249,246,0.07);
  padding: 1px 6px;
  border-radius: 5px;
  white-space: nowrap;
}
.agent-view-chip i { font-size: 0.5rem; opacity: 0.5; }
.agent-view-chip.more {
  color: rgba(250,249,246,0.3);
  background: none;
  border: 1px dashed rgba(250,249,246,0.1);
  cursor: pointer;
  padding: 1px 6px;
}
.agent-view-chip.more:hover {
  color: rgba(250,249,246,0.5);
  border-color: rgba(250,249,246,0.2);
}
 
.agent-view-chip.chip-client-view {
  color: #f59e0b;
  background: rgba(245,158,11,0.06);
  border-color: rgba(245,158,11,0.15);
}
.agent-view-chip.chip-client-view i { color: #f59e0b; opacity: 0.7; }
.start-screening-btn {
  width: fit-content;
  background: rgb(89 83 255 / 10%);
  color: #1110b9;

  font-size: 11px;
  padding: 2px 8px;
  border-radius: 12px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 4px;
}
.start-screening-btn:hover {
  background: rgba(212,47,61,0.15);
}
.hotlist-option-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 10px;
  border-bottom: 1px solid rgba(0,0,0,0.05);
}
.hotlist-option-wrapper .hotlist-name {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 0.88rem;
  font-weight: 600;
  color: black;
}
.hotlist-actions-col {
  display: flex;
  flex-direction: column;
  gap: 3px;
  flex-shrink: 0;
}
.hotlist-action-btn {
  padding: 3px 10px;
  border-radius: 5px;
  font-size: 0.65rem;
  font-weight: 700;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
  transition: all 0.2s;
  background: rgba(34,197,94,0.1);
  color: #22c55e;
}
.hotlist-action-btn.already-added {
  background: rgba(239,68,68,0.08);
  color: #f87171;
}
.hotlist-action-btn.screening-btn {
  background: rgba(59,130,246,0.1);
  color: #60a5fa;
}
.hotlist-action-btn:hover { filter: brightness(1.2); }
.hotlist-action-btn i { font-size: 0.6rem; }


/* Select mode */
.select-checkbox { position: absolute; top: 8px; left: 8px; z-index: 5; cursor: pointer; font-size: 1.1rem; color: #93c5fd; transition: transform 0.1s; }
.select-checkbox:hover { transform: scale(1.15); }
.select-checkbox .fa-check-square { color: #3b82f6; }
.select-active { background: rgba(59,130,246,0.15) !important; border-color: rgba(59,130,246,0.3) !important; color: #93c5fd !important; }

/* Floating batch bar */
.batch-float-bar { position: fixed; bottom: 24px; left: 50%; transform: translateX(-50%); display: flex; align-items: center; gap: 8px; padding: 10px 18px; background: var(--surface-color); border: 1px solid var(--border-color); border-radius: 12px; box-shadow: 0 8px 32px rgba(0,0,0,0.3); z-index: 1000; }
.batch-count { font-size: 0.75rem; font-weight: 700; color: #93c5fd; margin-right: 4px; }
.batch-btn { padding: 6px 12px; border-radius: 6px; border: 1px solid var(--border-color); background: var(--background-color); color: var(--text-color); font-size: 0.7rem; font-weight: 600; cursor: pointer; display: flex; align-items: center; gap: 5px; transition: all 0.15s; }
.batch-btn:hover { background: var(--hover-color); }
.batch-add-board { border-color: rgba(59,130,246,0.25); color: #93c5fd; }
.batch-add-board:hover { background: rgba(59,130,246,0.1); }
.batch-cancel { border-color: rgba(239,68,68,0.15); color: #f87171; }
.batch-cancel:hover { background: rgba(239,68,68,0.06); }
.batch-select-all { border-color: rgba(34,197,94,0.15); color: #22c55e; }

/* Board picker in float bar */
.batch-board-picker { position: absolute; bottom: 100%; left: 50%; transform: translateX(-50%); margin-bottom: 8px; background: var(--background-color); border: 1px solid var(--border-color); border-radius: 10px; min-width: 220px; max-height: 280px; overflow-y: auto; padding: 4px 0; box-shadow: 0 8px 24px rgba(0,0,0,0.4); }
.bbp-loading { padding: 12px; text-align: center; color: #93c5fd; font-size: 0.7rem; }
.bbp-option { display: flex; align-items: center; gap: 8px; width: 100%; padding: 8px 14px; border: none; background: none; color: var(--text-color); font-size: 0.72rem; font-weight: 600; cursor: pointer; text-align: left; }
.bbp-option:hover { background: var(--surface-color); }
.bbp-dot { width: 8px; height: 8px; border-radius: 3px; flex-shrink: 0; }

.float-bar-enter-active, .float-bar-leave-active { transition: all 0.25s ease; }
.float-bar-enter-from, .float-bar-leave-to { transform: translateX(-50%) translateY(20px); opacity: 0; }
</style>